/* VIVIDSTORM Screen Finder editorial rebuild — generated; edit screen-finder/src/* */
(function (root, factory) {
  var mapping = factory();
  if (typeof module === 'object' && module.exports) module.exports = mapping;
  root.ScreenFinderShopifyMapping = mapping;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  // Read-only Shopify Admin snapshot captured 2026-09-02. Numeric IDs are
  // public storefront handoff identities; no prices or inventory quantities are stored.
  return Object.freeze({
  "s_pro": {
    "shopifyProductId": "5131217600652",
    "productPath": "/products/vividstorm-s-pro-motorized-tension-floor-rising-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": "34087705018508",
        "housingVariants": {
          "Black": "34087705018508",
          "White": "34196095926412"
        },
        "variantIds": [
          "34087705018508",
          "34196095926412"
        ]
      },
      "84": {
        "defaultVariantId": "34087705084044",
        "housingVariants": {
          "Black": "34087705084044",
          "White": "34196096123020"
        },
        "variantIds": [
          "34087705084044",
          "34196096123020"
        ]
      },
      "92": {
        "defaultVariantId": "34087705149580",
        "housingVariants": {
          "Black": "34087705149580",
          "White": "34196096155788"
        },
        "variantIds": [
          "34087705149580",
          "34196096155788"
        ]
      },
      "100": {
        "defaultVariantId": "34087705215116",
        "housingVariants": {
          "Black": "34087705215116",
          "White": "34196096254092"
        },
        "variantIds": [
          "34087705215116",
          "34196096254092"
        ]
      },
      "110": {
        "defaultVariantId": "34087705280652",
        "housingVariants": {
          "Black": "34087705280652",
          "White": "34196097433740"
        },
        "variantIds": [
          "34087705280652",
          "34196097433740"
        ]
      },
      "120": {
        "defaultVariantId": "34087705346188",
        "housingVariants": {
          "Black": "34087705346188",
          "White": "34196097499276"
        },
        "variantIds": [
          "34087705346188",
          "34196097499276"
        ]
      },
      "130": {
        "defaultVariantId": "42702727381132",
        "housingVariants": {
          "Black": "42702727381132",
          "White": "42702727413900"
        },
        "variantIds": [
          "42702727381132",
          "42702727413900"
        ]
      }
    }
  },
  "s_pro_p": {
    "shopifyProductId": "5205807562892",
    "productPath": "/products/vividstorm-s-pro-p-motorized-tension-floor-rising-ust-alr-perforated-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": "34332407857292",
        "housingVariants": {
          "Black": "34332407857292",
          "White": "34332408053900"
        },
        "variantIds": [
          "34332407857292",
          "34332408053900"
        ]
      },
      "84": {
        "defaultVariantId": "34332407890060",
        "housingVariants": {
          "Black": "34332407890060",
          "White": "34332408086668"
        },
        "variantIds": [
          "34332407890060",
          "34332408086668"
        ]
      },
      "92": {
        "defaultVariantId": "34332407922828",
        "housingVariants": {
          "Black": "34332407922828",
          "White": "34332408119436"
        },
        "variantIds": [
          "34332407922828",
          "34332408119436"
        ]
      },
      "100": {
        "defaultVariantId": "34332407955596",
        "housingVariants": {
          "Black": "34332407955596",
          "White": "34332408152204"
        },
        "variantIds": [
          "34332407955596",
          "34332408152204"
        ]
      },
      "110": {
        "defaultVariantId": "34332407988364",
        "housingVariants": {
          "Black": "34332407988364",
          "White": "34332408184972"
        },
        "variantIds": [
          "34332407988364",
          "34332408184972"
        ]
      },
      "120": {
        "defaultVariantId": "34332408021132",
        "housingVariants": {
          "Black": "34332408021132",
          "White": "34332408217740"
        },
        "variantIds": [
          "34332408021132",
          "34332408217740"
        ]
      },
      "130": {
        "defaultVariantId": "42702743306380",
        "housingVariants": {
          "Black": "42702743306380",
          "White": "42702743339148"
        },
        "variantIds": [
          "42702743306380",
          "42702743339148"
        ]
      }
    }
  },
  "s_lite": {
    "shopifyProductId": "8000906395788",
    "productPath": "/products/vividstorm-s-lite-hyper-motorized-tension-floor-rising-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color:",
      "Screen type"
    ],
    "shopifyOptionValues": [
      "S Lite"
    ],
    "bySize": {
      "72": {
        "defaultVariantId": "43781633409164",
        "housingVariants": {
          "White": "43781633409164",
          "Black": "43781633474700"
        },
        "variantIds": [
          "43781633409164",
          "43781633474700"
        ]
      },
      "84": {
        "defaultVariantId": "43781633540236",
        "housingVariants": {
          "White": "43781633540236",
          "Black": "43781633605772"
        },
        "variantIds": [
          "43781633540236",
          "43781633605772"
        ]
      },
      "92": {
        "defaultVariantId": "43781633671308",
        "housingVariants": {
          "White": "43781633671308",
          "Black": "43781633736844"
        },
        "variantIds": [
          "43781633671308",
          "43781633736844"
        ]
      },
      "100": {
        "defaultVariantId": "43781633802380",
        "housingVariants": {
          "White": "43781633802380",
          "Black": "43781633867916"
        },
        "variantIds": [
          "43781633802380",
          "43781633867916"
        ]
      },
      "110": {
        "defaultVariantId": "43781633933452",
        "housingVariants": {
          "White": "43781633933452",
          "Black": "43781633998988"
        },
        "variantIds": [
          "43781633933452",
          "43781633998988"
        ]
      },
      "120": {
        "defaultVariantId": "43781634064524",
        "housingVariants": {
          "White": "43781634064524",
          "Black": "43781634130060"
        },
        "variantIds": [
          "43781634064524",
          "43781634130060"
        ]
      },
      "130": {
        "defaultVariantId": "43781634195596",
        "housingVariants": {
          "White": "43781634195596",
          "Black": "43781634261132"
        },
        "variantIds": [
          "43781634195596",
          "43781634261132"
        ]
      },
      "150": {
        "defaultVariantId": "43533455556748",
        "housingVariants": {
          "White": "43533455556748",
          "Black": "43533455589516"
        },
        "variantIds": [
          "43533455556748",
          "43533455589516"
        ]
      }
    }
  },
  "s_lite_p": {
    "shopifyProductId": "8000906395788",
    "productPath": "/products/vividstorm-s-lite-hyper-motorized-tension-floor-rising-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color:",
      "Screen type"
    ],
    "shopifyOptionValues": [
      "S Lite P"
    ],
    "bySize": {
      "72": {
        "defaultVariantId": "43781633441932",
        "housingVariants": {
          "White": "43781633441932",
          "Black": "43781633507468"
        },
        "variantIds": [
          "43781633441932",
          "43781633507468"
        ]
      },
      "84": {
        "defaultVariantId": "43781633573004",
        "housingVariants": {
          "White": "43781633573004",
          "Black": "43781633638540"
        },
        "variantIds": [
          "43781633573004",
          "43781633638540"
        ]
      },
      "92": {
        "defaultVariantId": "43781633704076",
        "housingVariants": {
          "White": "43781633704076",
          "Black": "43781633769612"
        },
        "variantIds": [
          "43781633704076",
          "43781633769612"
        ]
      },
      "100": {
        "defaultVariantId": "43781633835148",
        "housingVariants": {
          "White": "43781633835148",
          "Black": "43781633900684"
        },
        "variantIds": [
          "43781633835148",
          "43781633900684"
        ]
      },
      "110": {
        "defaultVariantId": "43781633966220",
        "housingVariants": {
          "White": "43781633966220",
          "Black": "43781634031756"
        },
        "variantIds": [
          "43781633966220",
          "43781634031756"
        ]
      },
      "120": {
        "defaultVariantId": "43781634097292",
        "housingVariants": {
          "White": "43781634097292",
          "Black": "43781634162828"
        },
        "variantIds": [
          "43781634097292",
          "43781634162828"
        ]
      },
      "130": {
        "defaultVariantId": "43781634228364",
        "housingVariants": {
          "White": "43781634228364",
          "Black": "43781634293900"
        },
        "variantIds": [
          "43781634228364",
          "43781634293900"
        ]
      },
      "150": {
        "defaultVariantId": "43628485574796",
        "housingVariants": {
          "White": "43628485574796",
          "Black": "43628485607564"
        },
        "variantIds": [
          "43628485574796",
          "43628485607564"
        ]
      }
    }
  },
  "s_white": {
    "shopifyProductId": "6676981645452",
    "productPath": "/products/vividstorm-s-white-cinema-motorized-tension-floor-rising-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Screen Material Design"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": "39524276142220",
        "housingVariants": {
          "Black": "39524276142220",
          "White": "39524276207756"
        },
        "variantIds": [
          "39524276142220",
          "39524276174988",
          "39524276207756",
          "39524276240524"
        ]
      },
      "84": {
        "defaultVariantId": "39524276273292",
        "housingVariants": {
          "Black": "39524276273292",
          "White": "39524276338828"
        },
        "variantIds": [
          "39524276273292",
          "39524276306060",
          "39524276338828",
          "39524276371596"
        ]
      },
      "92": {
        "defaultVariantId": "39524276404364",
        "housingVariants": {
          "Black": "39524276404364",
          "White": "39524276469900"
        },
        "variantIds": [
          "39524276404364",
          "39524276437132",
          "39524276469900",
          "39524276502668"
        ]
      },
      "100": {
        "defaultVariantId": "39524276535436",
        "housingVariants": {
          "Black": "39524276535436",
          "White": "39524276600972"
        },
        "variantIds": [
          "39524276535436",
          "39524276568204",
          "39524276600972",
          "39524276633740"
        ]
      },
      "110": {
        "defaultVariantId": "39524276666508",
        "housingVariants": {
          "Black": "39524276666508",
          "White": "39524276732044"
        },
        "variantIds": [
          "39524276666508",
          "39524276699276",
          "39524276732044",
          "39524276764812"
        ]
      },
      "120": {
        "defaultVariantId": "39524276797580",
        "housingVariants": {
          "Black": "39524276797580",
          "White": "39524276863116"
        },
        "variantIds": [
          "39524276797580",
          "39524276830348",
          "39524276863116",
          "39524276895884"
        ]
      },
      "135": {
        "defaultVariantId": "39524276928652",
        "housingVariants": {
          "Black": "39524276928652",
          "White": "39524276994188"
        },
        "variantIds": [
          "39524276928652",
          "39524276961420",
          "39524276994188",
          "39524277026956"
        ]
      },
      "150": {
        "defaultVariantId": "39524277059724",
        "housingVariants": {
          "Black": "39524277059724",
          "White": "39524277125260"
        },
        "variantIds": [
          "39524277059724",
          "39524277092492",
          "39524277125260",
          "39524277158028"
        ]
      }
    }
  },
  "s_white_p": {
    "shopifyProductId": "6677538111628",
    "productPath": "/products/vividstorm-s-white-cinema-p-motorized-tension-floor-rising-white-cinema-perforated-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Screen Material Design"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": "39525571362956",
        "housingVariants": {
          "White": "39525571362956",
          "Black": "39525571428492"
        },
        "variantIds": [
          "39525571362956",
          "39525571395724",
          "39525571428492",
          "39525571461260"
        ]
      },
      "84": {
        "defaultVariantId": "39525571494028",
        "housingVariants": {
          "White": "39525571494028",
          "Black": "39525571559564"
        },
        "variantIds": [
          "39525571494028",
          "39525571526796",
          "39525571559564",
          "39525571592332"
        ]
      },
      "92": {
        "defaultVariantId": "39525571625100",
        "housingVariants": {
          "White": "39525571625100",
          "Black": "39525571690636"
        },
        "variantIds": [
          "39525571625100",
          "39525571657868",
          "39525571690636",
          "39525571723404"
        ]
      },
      "100": {
        "defaultVariantId": "39525571756172",
        "housingVariants": {
          "White": "39525571756172",
          "Black": "39525571821708"
        },
        "variantIds": [
          "39525571756172",
          "39525571788940",
          "39525571821708",
          "39525571854476"
        ]
      },
      "110": {
        "defaultVariantId": "39525571887244",
        "housingVariants": {
          "White": "39525571887244",
          "Black": "39525571952780"
        },
        "variantIds": [
          "39525571887244",
          "39525571920012",
          "39525571952780",
          "39525571985548"
        ]
      },
      "120": {
        "defaultVariantId": "39525572018316",
        "housingVariants": {
          "White": "39525572018316",
          "Black": "39525572083852"
        },
        "variantIds": [
          "39525572018316",
          "39525572051084",
          "39525572083852",
          "39525572116620"
        ]
      },
      "135": {
        "defaultVariantId": "43857842471052",
        "housingVariants": {
          "White": "43857842471052",
          "Black": "43857842536588"
        },
        "variantIds": [
          "43857842471052",
          "43857842503820",
          "43857842536588",
          "43857842569356"
        ]
      },
      "150": {
        "defaultVariantId": "43857842602124",
        "housingVariants": {
          "White": "43857842602124",
          "Black": "43857842667660"
        },
        "variantIds": [
          "43857842602124",
          "43857842634892",
          "43857842667660",
          "43857842700428"
        ]
      }
    }
  },
  "pearl_white": {
    "shopifyProductId": "7002670858380",
    "productPath": "/products/vividstorm-pearl-white-cinema-plus-motorized-tension-floor-rising-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Screen Material Design"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": "40526914912396",
        "housingVariants": {
          "White": "40526914912396",
          "Black": "40526914977932"
        },
        "variantIds": [
          "40526914912396",
          "40526914977932"
        ]
      },
      "84": {
        "defaultVariantId": "40526915043468",
        "housingVariants": {
          "White": "40526915043468",
          "Black": "40526915109004"
        },
        "variantIds": [
          "40526915043468",
          "40526915109004"
        ]
      },
      "92": {
        "defaultVariantId": "40526915174540",
        "housingVariants": {
          "White": "40526915174540",
          "Black": "40526915240076"
        },
        "variantIds": [
          "40526915174540",
          "40526915240076"
        ]
      },
      "100": {
        "defaultVariantId": "40526915305612",
        "housingVariants": {
          "White": "40526915305612",
          "Black": "40526915371148"
        },
        "variantIds": [
          "40526915305612",
          "40526915371148"
        ]
      },
      "110": {
        "defaultVariantId": "40526915436684",
        "housingVariants": {
          "White": "40526915436684",
          "Black": "40526915502220"
        },
        "variantIds": [
          "40526915436684",
          "40526915502220"
        ]
      },
      "120": {
        "defaultVariantId": "40526915567756",
        "housingVariants": {
          "White": "40526915567756",
          "Black": "40526915633292"
        },
        "variantIds": [
          "40526915567756",
          "40526915633292"
        ]
      }
    }
  },
  "pro": {
    "shopifyProductId": "5159954677900",
    "productPath": "/products/vividstorm-pro-motorized-drop-down-screen-ust-projector-ultra-short-throw-ambient-light-rejecting-4k-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Top Border Type"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "84": {
        "defaultVariantId": "34208586891404",
        "housingVariants": {
          "Black": "34208586891404",
          "White": "34208586924172"
        },
        "variantIds": [
          "34208586891404",
          "44425300181132",
          "34208586924172",
          "44425300213900"
        ]
      },
      "92": {
        "defaultVariantId": "34208586825868",
        "housingVariants": {
          "Black": "34208586825868",
          "White": "34208586858636"
        },
        "variantIds": [
          "34208586825868",
          "44425300115596",
          "34208586858636",
          "44425300148364"
        ]
      },
      "100": {
        "defaultVariantId": "34208586760332",
        "housingVariants": {
          "Black": "34208586760332",
          "White": "34208586793100"
        },
        "variantIds": [
          "34208586760332",
          "44425300050060",
          "34208586793100",
          "44425300082828"
        ]
      },
      "110": {
        "defaultVariantId": "34208586694796",
        "housingVariants": {
          "Black": "34208586694796",
          "White": "34208586727564"
        },
        "variantIds": [
          "34208586694796",
          "44425299984524",
          "34208586727564",
          "44425300017292"
        ]
      },
      "120": {
        "defaultVariantId": "34208586629260",
        "housingVariants": {
          "Black": "34208586629260",
          "White": "34208586662028"
        },
        "variantIds": [
          "34208586629260",
          "44425299918988",
          "34208586662028",
          "44425299951756"
        ]
      },
      "130": {
        "defaultVariantId": "42702968389772",
        "housingVariants": {
          "Black": "42702968389772",
          "White": "42702968422540"
        },
        "variantIds": [
          "42702968389772",
          "44425299853452",
          "42702968422540",
          "44425299886220"
        ]
      }
    }
  },
  "pro_a": {
    "shopifyProductId": "5257243787404",
    "productPath": "/products/vividstorm-pro-a-slimline-motorized-tension-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Top Border Type"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "84": {
        "defaultVariantId": "34416713629836",
        "housingVariants": {
          "Black": "34416713629836",
          "White": "34416713662604"
        },
        "variantIds": [
          "34416713629836",
          "44425345433740",
          "34416713662604",
          "44425345466508"
        ]
      },
      "92": {
        "defaultVariantId": "34416713695372",
        "housingVariants": {
          "Black": "34416713695372",
          "White": "34416713728140"
        },
        "variantIds": [
          "34416713695372",
          "44425345499276",
          "34416713728140",
          "44425345532044"
        ]
      },
      "100": {
        "defaultVariantId": "34416713760908",
        "housingVariants": {
          "Black": "34416713760908",
          "White": "34416713793676"
        },
        "variantIds": [
          "34416713760908",
          "44425345564812",
          "34416713793676",
          "44425345597580"
        ]
      },
      "110": {
        "defaultVariantId": "34416713826444",
        "housingVariants": {
          "Black": "34416713826444",
          "White": "34416713859212"
        },
        "variantIds": [
          "34416713826444",
          "44425345630348",
          "34416713859212",
          "44425345663116"
        ]
      },
      "120": {
        "defaultVariantId": "34416713891980",
        "housingVariants": {
          "Black": "34416713891980",
          "White": "34416713924748"
        },
        "variantIds": [
          "34416713891980",
          "44425345695884",
          "34416713924748",
          "44425345728652"
        ]
      },
      "130": {
        "defaultVariantId": "42703004663948",
        "housingVariants": {
          "Black": "42703004663948",
          "White": "42703004696716"
        },
        "variantIds": [
          "42703004663948",
          "44425345761420",
          "42703004696716",
          "44425345794188"
        ]
      }
    }
  },
  "pro_p": {
    "shopifyProductId": "5211392835724",
    "productPath": "/products/vividstorm-pro-p-slimline-motorized-tension-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Top Border Type"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "84": {
        "defaultVariantId": "34345215688844",
        "housingVariants": {
          "Black": "34345215688844",
          "White": "34345215721612"
        },
        "variantIds": [
          "34345215688844",
          "34345215721612"
        ]
      },
      "92": {
        "defaultVariantId": "34345215623308",
        "housingVariants": {
          "Black": "34345215623308",
          "White": "34345215656076"
        },
        "variantIds": [
          "34345215623308",
          "34345215656076"
        ]
      },
      "100": {
        "defaultVariantId": "34345215557772",
        "housingVariants": {
          "Black": "34345215557772",
          "White": "34345215590540"
        },
        "variantIds": [
          "34345215557772",
          "34345215590540"
        ]
      },
      "110": {
        "defaultVariantId": "34345215492236",
        "housingVariants": {
          "Black": "34345215492236",
          "White": "34345215525004"
        },
        "variantIds": [
          "34345215492236",
          "34345215525004"
        ]
      },
      "120": {
        "defaultVariantId": "34345215426700",
        "housingVariants": {
          "Black": "34345215426700",
          "White": "34345215459468"
        },
        "variantIds": [
          "34345215426700",
          "34345215459468"
        ]
      },
      "130": {
        "defaultVariantId": "42702997356684",
        "housingVariants": {
          "Black": "42702997356684",
          "White": "42702997389452"
        },
        "variantIds": [
          "42702997356684",
          "42702997389452"
        ]
      }
    }
  },
  "pro_pa": {
    "shopifyProductId": "6679072997516",
    "productPath": "/products/vividstorm-pro-pa-slimline-motorized-tension-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Top Border Type"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "84": {
        "defaultVariantId": "39528995520652",
        "housingVariants": {
          "Black": "39528995520652",
          "White": "39528995553420"
        },
        "variantIds": [
          "39528995520652",
          "44425428926604",
          "39528995553420",
          "44425428959372"
        ]
      },
      "92": {
        "defaultVariantId": "39528995586188",
        "housingVariants": {
          "Black": "39528995586188",
          "White": "39528995618956"
        },
        "variantIds": [
          "39528995586188",
          "44425428992140",
          "39528995618956",
          "44425429024908"
        ]
      },
      "100": {
        "defaultVariantId": "39528995651724",
        "housingVariants": {
          "Black": "39528995651724",
          "White": "39528995684492"
        },
        "variantIds": [
          "39528995651724",
          "44425429057676",
          "39528995684492",
          "44425429090444"
        ]
      },
      "110": {
        "defaultVariantId": "39528995717260",
        "housingVariants": {
          "Black": "39528995717260",
          "White": "39528995750028"
        },
        "variantIds": [
          "39528995717260",
          "44425429123212",
          "39528995750028",
          "44425429155980"
        ]
      },
      "120": {
        "defaultVariantId": "39528995782796",
        "housingVariants": {
          "Black": "39528995782796",
          "White": "39528995815564"
        },
        "variantIds": [
          "39528995782796",
          "44425429188748",
          "39528995815564",
          "44425429221516"
        ]
      },
      "130": {
        "defaultVariantId": "42702978777228",
        "housingVariants": {
          "Black": "42702978777228",
          "White": "42702978809996"
        },
        "variantIds": [
          "42702978777228",
          "44425429254284",
          "42702978809996",
          "44425429287052"
        ]
      }
    }
  },
  "lite_slimline": {
    "shopifyProductId": "8031368183948",
    "productPath": "/products/vividstorm-150-lite-hyper-plus-slimline-motorized-tension-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color",
      "Screen type"
    ],
    "shopifyOptionValues": [
      "Lite Hyper"
    ],
    "bySize": {
      "84": {
        "defaultVariantId": "43784375533708",
        "housingVariants": {
          "White": "43784375533708",
          "Black": "43784375664780"
        },
        "variantIds": [
          "43784375533708",
          "43784375664780"
        ]
      },
      "92": {
        "defaultVariantId": "43784375271564",
        "housingVariants": {
          "White": "43784375271564",
          "Black": "43784375402636"
        },
        "variantIds": [
          "43784375271564",
          "43784375402636"
        ]
      },
      "100": {
        "defaultVariantId": "43784375009420",
        "housingVariants": {
          "White": "43784375009420",
          "Black": "43784375140492"
        },
        "variantIds": [
          "43784375009420",
          "43784375140492"
        ]
      },
      "110": {
        "defaultVariantId": "43784374747276",
        "housingVariants": {
          "White": "43784374747276",
          "Black": "43784374878348"
        },
        "variantIds": [
          "43784374747276",
          "43784374878348"
        ]
      },
      "120": {
        "defaultVariantId": "43784374485132",
        "housingVariants": {
          "White": "43784374485132",
          "Black": "43784374616204"
        },
        "variantIds": [
          "43784374485132",
          "43784374616204"
        ]
      },
      "130": {
        "defaultVariantId": "43784374222988",
        "housingVariants": {
          "White": "43784374222988",
          "Black": "43784374354060"
        },
        "variantIds": [
          "43784374222988",
          "43784374354060"
        ]
      },
      "150": {
        "defaultVariantId": "43628431474828",
        "housingVariants": {
          "White": "43628431474828",
          "Black": "43628431605900"
        },
        "variantIds": [
          "43628431474828",
          "43628431605900"
        ]
      }
    }
  },
  "lite_slimline_a": {
    "shopifyProductId": "8031368183948",
    "productPath": "/products/vividstorm-150-lite-hyper-plus-slimline-motorized-tension-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color",
      "Screen type"
    ],
    "shopifyOptionValues": [
      "Lite Hyper A"
    ],
    "bySize": {
      "84": {
        "defaultVariantId": "43784375566476",
        "housingVariants": {
          "White": "43784375566476",
          "Black": "43784375697548"
        },
        "variantIds": [
          "43784375566476",
          "43784375697548"
        ]
      },
      "92": {
        "defaultVariantId": "43784375304332",
        "housingVariants": {
          "White": "43784375304332",
          "Black": "43784375435404"
        },
        "variantIds": [
          "43784375304332",
          "43784375435404"
        ]
      },
      "100": {
        "defaultVariantId": "43784375042188",
        "housingVariants": {
          "White": "43784375042188",
          "Black": "43784375173260"
        },
        "variantIds": [
          "43784375042188",
          "43784375173260"
        ]
      },
      "110": {
        "defaultVariantId": "43784374780044",
        "housingVariants": {
          "White": "43784374780044",
          "Black": "43784374911116"
        },
        "variantIds": [
          "43784374780044",
          "43784374911116"
        ]
      },
      "120": {
        "defaultVariantId": "43784374517900",
        "housingVariants": {
          "White": "43784374517900",
          "Black": "43784374648972"
        },
        "variantIds": [
          "43784374517900",
          "43784374648972"
        ]
      },
      "130": {
        "defaultVariantId": "43784374255756",
        "housingVariants": {
          "White": "43784374255756",
          "Black": "43784374386828"
        },
        "variantIds": [
          "43784374255756",
          "43784374386828"
        ]
      },
      "150": {
        "defaultVariantId": "43628431507596",
        "housingVariants": {
          "White": "43628431507596",
          "Black": "43628431638668"
        },
        "variantIds": [
          "43628431507596",
          "43628431638668"
        ]
      }
    }
  },
  "lite_slimline_p": {
    "shopifyProductId": "8031368183948",
    "productPath": "/products/vividstorm-150-lite-hyper-plus-slimline-motorized-tension-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color",
      "Screen type"
    ],
    "shopifyOptionValues": [
      "Lite Hyper P"
    ],
    "bySize": {
      "84": {
        "defaultVariantId": "43784375599244",
        "housingVariants": {
          "White": "43784375599244",
          "Black": "43784375730316"
        },
        "variantIds": [
          "43784375599244",
          "43784375730316"
        ]
      },
      "92": {
        "defaultVariantId": "43784375337100",
        "housingVariants": {
          "White": "43784375337100",
          "Black": "43784375468172"
        },
        "variantIds": [
          "43784375337100",
          "43784375468172"
        ]
      },
      "100": {
        "defaultVariantId": "43784375074956",
        "housingVariants": {
          "White": "43784375074956",
          "Black": "43784375206028"
        },
        "variantIds": [
          "43784375074956",
          "43784375206028"
        ]
      },
      "110": {
        "defaultVariantId": "43784374812812",
        "housingVariants": {
          "White": "43784374812812",
          "Black": "43784374943884"
        },
        "variantIds": [
          "43784374812812",
          "43784374943884"
        ]
      },
      "120": {
        "defaultVariantId": "43784374550668",
        "housingVariants": {
          "White": "43784374550668",
          "Black": "43784374681740"
        },
        "variantIds": [
          "43784374550668",
          "43784374681740"
        ]
      },
      "130": {
        "defaultVariantId": "43784374288524",
        "housingVariants": {
          "White": "43784374288524",
          "Black": "43784374419596"
        },
        "variantIds": [
          "43784374288524",
          "43784374419596"
        ]
      },
      "150": {
        "defaultVariantId": "43628431540364",
        "housingVariants": {
          "White": "43628431540364",
          "Black": "43628431671436"
        },
        "variantIds": [
          "43628431540364",
          "43628431671436"
        ]
      }
    }
  },
  "lite_slimline_pa": {
    "shopifyProductId": "8031368183948",
    "productPath": "/products/vividstorm-150-lite-hyper-plus-slimline-motorized-tension-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color",
      "Screen type"
    ],
    "shopifyOptionValues": [
      "Lite Hyper PA"
    ],
    "bySize": {
      "84": {
        "defaultVariantId": "43784375632012",
        "housingVariants": {
          "White": "43784375632012",
          "Black": "43784375763084"
        },
        "variantIds": [
          "43784375632012",
          "43784375763084"
        ]
      },
      "92": {
        "defaultVariantId": "43784375369868",
        "housingVariants": {
          "White": "43784375369868",
          "Black": "43784375500940"
        },
        "variantIds": [
          "43784375369868",
          "43784375500940"
        ]
      },
      "100": {
        "defaultVariantId": "43784375107724",
        "housingVariants": {
          "White": "43784375107724",
          "Black": "43784375238796"
        },
        "variantIds": [
          "43784375107724",
          "43784375238796"
        ]
      },
      "110": {
        "defaultVariantId": "43784374845580",
        "housingVariants": {
          "White": "43784374845580",
          "Black": "43784374976652"
        },
        "variantIds": [
          "43784374845580",
          "43784374976652"
        ]
      },
      "120": {
        "defaultVariantId": "43784374583436",
        "housingVariants": {
          "White": "43784374583436",
          "Black": "43784374714508"
        },
        "variantIds": [
          "43784374583436",
          "43784374714508"
        ]
      },
      "130": {
        "defaultVariantId": "43784374321292",
        "housingVariants": {
          "White": "43784374321292",
          "Black": "43784374452364"
        },
        "variantIds": [
          "43784374321292",
          "43784374452364"
        ]
      },
      "150": {
        "defaultVariantId": "43628431573132",
        "housingVariants": {
          "White": "43628431573132",
          "Black": "43628431704204"
        },
        "variantIds": [
          "43628431573132",
          "43628431704204"
        ]
      }
    }
  },
  "white_slimline": {
    "shopifyProductId": "6677542437004",
    "productPath": "/products/vividstorm-white-cinema-slimline-motorized-tension-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Screen Material Design"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "84": {
        "defaultVariantId": "39525586665612",
        "housingVariants": {
          "Black": "39525586665612",
          "White": "39525586731148"
        },
        "variantIds": [
          "39525586665612",
          "39525586698380",
          "39525586731148",
          "39525586763916"
        ]
      },
      "92": {
        "defaultVariantId": "39525586796684",
        "housingVariants": {
          "Black": "39525586796684",
          "White": "39525586862220"
        },
        "variantIds": [
          "39525586796684",
          "39525586829452",
          "39525586862220",
          "39525586894988"
        ]
      },
      "100": {
        "defaultVariantId": "39525586927756",
        "housingVariants": {
          "Black": "39525586927756",
          "White": "39525586993292"
        },
        "variantIds": [
          "39525586927756",
          "39525586960524",
          "39525586993292",
          "39525587026060"
        ]
      },
      "110": {
        "defaultVariantId": "39525587058828",
        "housingVariants": {
          "Black": "39525587058828",
          "White": "39525587124364"
        },
        "variantIds": [
          "39525587058828",
          "39525587091596",
          "39525587124364",
          "39525587157132"
        ]
      },
      "120": {
        "defaultVariantId": "39525587189900",
        "housingVariants": {
          "Black": "39525587189900",
          "White": "39525587255436"
        },
        "variantIds": [
          "39525587189900",
          "39525587222668",
          "39525587255436",
          "39525587288204"
        ]
      },
      "135": {
        "defaultVariantId": "42657756774540",
        "housingVariants": {
          "Black": "42657756774540",
          "White": "42657756840076"
        },
        "variantIds": [
          "42657756774540",
          "42657756807308",
          "42657756840076",
          "42657756872844"
        ]
      },
      "150": {
        "defaultVariantId": "43857728635020",
        "housingVariants": {
          "Black": "43857728635020",
          "White": "43857728700556"
        },
        "variantIds": [
          "43857728635020",
          "43857728667788",
          "43857728700556",
          "43857728733324"
        ]
      },
      "160": {
        "defaultVariantId": "44323467591820",
        "housingVariants": {
          "Black": "44323467591820",
          "White": "44323467657356"
        },
        "variantIds": [
          "44323467591820",
          "44323467624588",
          "44323467657356",
          "44323467690124"
        ]
      },
      "170": {
        "defaultVariantId": "44323467722892",
        "housingVariants": {
          "Black": "44323467722892",
          "White": "44323467788428"
        },
        "variantIds": [
          "44323467722892",
          "44323467755660",
          "44323467788428",
          "44323467821196"
        ]
      },
      "180": {
        "defaultVariantId": "44323467853964",
        "housingVariants": {
          "Black": "44323467853964",
          "White": "44323467919500"
        },
        "variantIds": [
          "44323467853964",
          "44323467886732",
          "44323467919500",
          "44323467952268"
        ]
      }
    }
  },
  "white_p_slimline": {
    "shopifyProductId": "6677543714956",
    "productPath": "/products/vividstorm-white-cinema-perforated-slimline-motorized-tension-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Screen Material Design"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "84": {
        "defaultVariantId": "39525589549196",
        "housingVariants": {
          "Balck": "39525589549196",
          "White": "39525589614732"
        },
        "variantIds": [
          "39525589549196",
          "39525589581964",
          "39525589614732",
          "39525589647500"
        ]
      },
      "92": {
        "defaultVariantId": "39525589680268",
        "housingVariants": {
          "Balck": "39525589680268",
          "White": "39525589745804"
        },
        "variantIds": [
          "39525589680268",
          "39525589713036",
          "39525589745804",
          "39525589778572"
        ]
      },
      "100": {
        "defaultVariantId": "39525589811340",
        "housingVariants": {
          "Balck": "39525589811340",
          "White": "39525589876876"
        },
        "variantIds": [
          "39525589811340",
          "39525589844108",
          "39525589876876",
          "39525589909644"
        ]
      },
      "110": {
        "defaultVariantId": "39525589942412",
        "housingVariants": {
          "Balck": "39525589942412",
          "White": "39525590007948"
        },
        "variantIds": [
          "39525589942412",
          "39525589975180",
          "39525590007948",
          "39525590040716"
        ]
      },
      "120": {
        "defaultVariantId": "39525590073484",
        "housingVariants": {
          "Balck": "39525590073484",
          "White": "39525590139020"
        },
        "variantIds": [
          "39525590073484",
          "39525590106252",
          "39525590139020",
          "39525590171788"
        ]
      }
    }
  },
  "phantom_pro": {
    "shopifyProductId": "7296550437004",
    "productPath": "/products/vividstorm-phantom-recessed-in-ceiling-motorized-tension-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Viewing Digonal Size",
      "Housing Color",
      "Material Type"
    ],
    "shopifyOptionValues": [
      "Black Border-PRO",
      "Clear Border-PRO"
    ],
    "bySize": {
      "72": {
        "defaultVariantId": "41502379868300",
        "housingVariants": {
          "White": "41502379868300",
          "Black": "42346945544332"
        },
        "variantIds": [
          "41502379868300",
          "44429978337420",
          "42346945544332",
          "44429978402956"
        ]
      },
      "84": {
        "defaultVariantId": "41502379933836",
        "housingVariants": {
          "White": "41502379933836",
          "Black": "42346945609868"
        },
        "variantIds": [
          "41502379933836",
          "44429978468492",
          "42346945609868",
          "44429978534028"
        ]
      },
      "92": {
        "defaultVariantId": "41502379999372",
        "housingVariants": {
          "White": "41502379999372",
          "Black": "42346945675404"
        },
        "variantIds": [
          "41502379999372",
          "44429978599564",
          "42346945675404",
          "44429978665100"
        ]
      },
      "100": {
        "defaultVariantId": "41502380064908",
        "housingVariants": {
          "White": "41502380064908",
          "Black": "42346945740940"
        },
        "variantIds": [
          "41502380064908",
          "44429978730636",
          "42346945740940",
          "44429978796172"
        ]
      },
      "110": {
        "defaultVariantId": "41502380130444",
        "housingVariants": {
          "White": "41502380130444",
          "Black": "42346945806476"
        },
        "variantIds": [
          "41502380130444",
          "44429978861708",
          "42346945806476",
          "44429978927244"
        ]
      },
      "120": {
        "defaultVariantId": "41502380195980",
        "housingVariants": {
          "White": "41502380195980",
          "Black": "42346945872012"
        },
        "variantIds": [
          "41502380195980",
          "44429978992780",
          "42346945872012",
          "44429979058316"
        ]
      },
      "130": {
        "defaultVariantId": "42703009611916",
        "housingVariants": {
          "White": "42703009611916",
          "Black": "42703009677452"
        },
        "variantIds": [
          "42703009611916",
          "44429979123852",
          "42703009677452",
          "44429979189388"
        ]
      }
    }
  },
  "phantom_pro_a": {
    "shopifyProductId": "7296550437004",
    "productPath": "/products/vividstorm-phantom-recessed-in-ceiling-motorized-tension-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Viewing Digonal Size",
      "Housing Color",
      "Material Type"
    ],
    "shopifyOptionValues": [
      "Black Border-PRO A",
      "Clear Border-PRO A"
    ],
    "bySize": {
      "72": {
        "defaultVariantId": "41508708089996",
        "housingVariants": {
          "White": "41508708089996",
          "Black": "42346945577100"
        },
        "variantIds": [
          "41508708089996",
          "44429978370188",
          "42346945577100",
          "44429978435724"
        ]
      },
      "84": {
        "defaultVariantId": "41508708286604",
        "housingVariants": {
          "White": "41508708286604",
          "Black": "42346945642636"
        },
        "variantIds": [
          "41508708286604",
          "44429978501260",
          "42346945642636",
          "44429978566796"
        ]
      },
      "92": {
        "defaultVariantId": "41508708483212",
        "housingVariants": {
          "White": "41508708483212",
          "Black": "42346945708172"
        },
        "variantIds": [
          "41508708483212",
          "44429978632332",
          "42346945708172",
          "44429978697868"
        ]
      },
      "100": {
        "defaultVariantId": "41508708679820",
        "housingVariants": {
          "White": "41508708679820",
          "Black": "42346945773708"
        },
        "variantIds": [
          "41508708679820",
          "44429978763404",
          "42346945773708",
          "44429978828940"
        ]
      },
      "110": {
        "defaultVariantId": "41508708876428",
        "housingVariants": {
          "White": "41508708876428",
          "Black": "42346945839244"
        },
        "variantIds": [
          "41508708876428",
          "44429978894476",
          "42346945839244",
          "44429978960012"
        ]
      },
      "120": {
        "defaultVariantId": "41508709073036",
        "housingVariants": {
          "White": "41508709073036",
          "Black": "42346945904780"
        },
        "variantIds": [
          "41508709073036",
          "44429979025548",
          "42346945904780",
          "44429979091084"
        ]
      },
      "130": {
        "defaultVariantId": "42703009644684",
        "housingVariants": {
          "White": "42703009644684",
          "Black": "42703009710220"
        },
        "variantIds": [
          "42703009644684",
          "44429979156620",
          "42703009710220",
          "44429979222156"
        ]
      }
    }
  },
  "phantom_lite": {
    "shopifyProductId": "8031488901260",
    "productPath": "/products/vividstorm-150-lite-hyper-plus-phantom-recessed-in-ceiling-motorized-tension-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color",
      "Screen type"
    ],
    "shopifyOptionValues": [
      "Lite"
    ],
    "bySize": {
      "150": {
        "defaultVariantId": "43628563759244",
        "housingVariants": {
          "White": "43628563759244",
          "Black": "43628563890316"
        },
        "variantIds": [
          "43628563759244",
          "43628563890316"
        ]
      }
    }
  },
  "phantom_lite_a": {
    "shopifyProductId": "8031488901260",
    "productPath": "/products/vividstorm-150-lite-hyper-plus-phantom-recessed-in-ceiling-motorized-tension-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color",
      "Screen type"
    ],
    "shopifyOptionValues": [
      "Lite A"
    ],
    "bySize": {
      "150": {
        "defaultVariantId": "43628563792012",
        "housingVariants": {
          "White": "43628563792012",
          "Black": "43628563923084"
        },
        "variantIds": [
          "43628563792012",
          "43628563923084"
        ]
      }
    }
  },
  "phantom_lite_p": {
    "shopifyProductId": "8031488901260",
    "productPath": "/products/vividstorm-150-lite-hyper-plus-phantom-recessed-in-ceiling-motorized-tension-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color",
      "Screen type"
    ],
    "shopifyOptionValues": [
      "Lite P"
    ],
    "bySize": {
      "150": {
        "defaultVariantId": "43628563824780",
        "housingVariants": {
          "White": "43628563824780",
          "Black": "43628563955852"
        },
        "variantIds": [
          "43628563824780",
          "43628563955852"
        ]
      }
    }
  },
  "phantom_lite_pa": {
    "shopifyProductId": "8031488901260",
    "productPath": "/products/vividstorm-150-lite-hyper-plus-phantom-recessed-in-ceiling-motorized-tension-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color",
      "Screen type"
    ],
    "shopifyOptionValues": [
      "Lite PA"
    ],
    "bySize": {
      "150": {
        "defaultVariantId": "43628563857548",
        "housingVariants": {
          "White": "43628563857548",
          "Black": "43628563988620"
        },
        "variantIds": [
          "43628563857548",
          "43628563988620"
        ]
      }
    }
  },
  "phantom_white": {
    "shopifyProductId": "7348051116172",
    "productPath": "/products/vividstorm-phantom-recessed-in-ceiling-motorized-tension-white-cinema-projector-screen",
    "shopifyOptionNames": [
      "Viewing Digonal Size",
      "Housing color "
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": "41657219481740",
        "housingVariants": {
          "White": "41657219481740",
          "Black": "42346936893580"
        },
        "variantIds": [
          "41657219481740",
          "42346936893580"
        ]
      },
      "84": {
        "defaultVariantId": "41657219514508",
        "housingVariants": {
          "White": "41657219514508",
          "Black": "42346936926348"
        },
        "variantIds": [
          "41657219514508",
          "42346936926348"
        ]
      },
      "92": {
        "defaultVariantId": "41657219547276",
        "housingVariants": {
          "White": "41657219547276",
          "Black": "42346936959116"
        },
        "variantIds": [
          "41657219547276",
          "42346936959116"
        ]
      },
      "100": {
        "defaultVariantId": "41657219580044",
        "housingVariants": {
          "White": "41657219580044",
          "Black": "42346936991884"
        },
        "variantIds": [
          "41657219580044",
          "42346936991884"
        ]
      },
      "110": {
        "defaultVariantId": "41657219612812",
        "housingVariants": {
          "White": "41657219612812",
          "Black": "42346937024652"
        },
        "variantIds": [
          "41657219612812",
          "42346937024652"
        ]
      },
      "120": {
        "defaultVariantId": "41657219645580",
        "housingVariants": {
          "White": "41657219645580",
          "Black": "42346937057420"
        },
        "variantIds": [
          "41657219645580",
          "42346937057420"
        ]
      },
      "135": {
        "defaultVariantId": "41827013066892",
        "housingVariants": {
          "White": "41827013066892",
          "Black": "42346937090188"
        },
        "variantIds": [
          "41827013066892",
          "42346937090188"
        ]
      },
      "150": {
        "defaultVariantId": "41827013099660",
        "housingVariants": {
          "White": "41827013099660",
          "Black": "42346937122956"
        },
        "variantIds": [
          "41827013099660",
          "42346937122956"
        ]
      },
      "160": {
        "defaultVariantId": "44287500451980",
        "housingVariants": {
          "White": "44287500451980",
          "Black": "44287500484748"
        },
        "variantIds": [
          "44287500451980",
          "44287500484748"
        ]
      },
      "170": {
        "defaultVariantId": "44287500517516",
        "housingVariants": {
          "White": "44287500517516",
          "Black": "44287500550284"
        },
        "variantIds": [
          "44287500517516",
          "44287500550284"
        ]
      },
      "180": {
        "defaultVariantId": "44287500583052",
        "housingVariants": {
          "White": "44287500583052",
          "Black": "44287500615820"
        },
        "variantIds": [
          "44287500583052",
          "44287500615820"
        ]
      }
    }
  },
  "cinevision": {
    "shopifyProductId": "7316499726476",
    "productPath": "/products/vividstorm-cinevision-pro-fixed-frame-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "41571962323084",
        "housingVariants": {},
        "variantIds": [
          "41571962323084"
        ]
      },
      "120": {
        "defaultVariantId": "41571962355852",
        "housingVariants": {},
        "variantIds": [
          "41571962355852"
        ]
      },
      "130": {
        "defaultVariantId": "42648081203340",
        "housingVariants": {},
        "variantIds": [
          "42648081203340"
        ]
      }
    }
  },
  "cinevision_fresnel": {
    "shopifyProductId": "7314962022540",
    "productPath": "/products/vividstorm-cinevision-pro-fixed-frame-fresnel-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "41568025968780",
        "housingVariants": {},
        "variantIds": [
          "41568025968780"
        ]
      },
      "120": {
        "defaultVariantId": "41568026001548",
        "housingVariants": {},
        "variantIds": [
          "41568026001548"
        ]
      },
      "130": {
        "defaultVariantId": "41568026034316",
        "housingVariants": {},
        "variantIds": [
          "41568026034316"
        ]
      },
      "150": {
        "defaultVariantId": "41568026067084",
        "housingVariants": {},
        "variantIds": [
          "41568026067084"
        ]
      }
    }
  },
  "lite_frame": {
    "shopifyProductId": "8164997955724",
    "productPath": "/products/vividstorm-lite-hyper-fixed-frame-lenticular-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "45552497885324",
        "housingVariants": {},
        "variantIds": [
          "45552497885324"
        ]
      },
      "120": {
        "defaultVariantId": "45552497918092",
        "housingVariants": {},
        "variantIds": [
          "45552497918092"
        ]
      },
      "130": {
        "defaultVariantId": "44133249810572",
        "housingVariants": {},
        "variantIds": [
          "44133249810572"
        ]
      },
      "150": {
        "defaultVariantId": "44133249843340",
        "housingVariants": {},
        "variantIds": [
          "44133249843340"
        ]
      }
    }
  },
  "aeris_pro": {
    "shopifyProductId": "9918269456524",
    "productPath": "/products/vividstorm-aeris-pro-fixed-frame-fresnel-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Shipping Options"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "54347186602124",
        "housingVariants": {},
        "variantIds": [
          "54347186602124",
          "54347186634892"
        ]
      },
      "120": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "54347186667660",
          "54347186700428"
        ]
      }
    }
  },
  "s_alr": {
    "shopifyProductId": "6676944781452",
    "productPath": "/products/vividstorm-s-alr-motorized-tension-floor-rising-obsidian-long-throw-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": "39524233642124",
        "housingVariants": {
          "Black": "39524233642124",
          "White": "39524233707660"
        },
        "variantIds": [
          "39524233642124",
          "39524233707660"
        ]
      },
      "84": {
        "defaultVariantId": "39524233773196",
        "housingVariants": {
          "Black": "39524233773196",
          "White": "39524233838732"
        },
        "variantIds": [
          "39524233773196",
          "39524233838732"
        ]
      },
      "92": {
        "defaultVariantId": "39524233904268",
        "housingVariants": {
          "Black": "39524233904268",
          "White": "39524233969804"
        },
        "variantIds": [
          "39524233904268",
          "39524233969804"
        ]
      },
      "100": {
        "defaultVariantId": "39524234035340",
        "housingVariants": {
          "Black": "39524234035340",
          "White": "39524234100876"
        },
        "variantIds": [
          "39524234035340",
          "39524234100876"
        ]
      },
      "110": {
        "defaultVariantId": "39524234166412",
        "housingVariants": {
          "Black": "39524234166412",
          "White": "39524234231948"
        },
        "variantIds": [
          "39524234166412",
          "39524234231948"
        ]
      },
      "120": {
        "defaultVariantId": "39524234297484",
        "housingVariants": {
          "Black": "39524234297484",
          "White": "39524234363020"
        },
        "variantIds": [
          "39524234297484",
          "39524234363020"
        ]
      },
      "135": {
        "defaultVariantId": "39524234428556",
        "housingVariants": {
          "Black": "39524234428556",
          "White": "39524234494092"
        },
        "variantIds": [
          "39524234428556",
          "39524234494092"
        ]
      },
      "150": {
        "defaultVariantId": "39524234559628",
        "housingVariants": {
          "Black": "39524234559628",
          "White": "39524234657932"
        },
        "variantIds": [
          "39524234559628",
          "39524234657932"
        ]
      }
    }
  },
  "s_alr_p": {
    "shopifyProductId": "5229373063308",
    "productPath": "/products/vividstorm-s-alr-p-motorized-tension-floor-rising-obsidian-long-throw-alr-perforated-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": "34378551689356",
        "housingVariants": {
          "Black": "34378551689356",
          "White": "34378551722124"
        },
        "variantIds": [
          "34378551689356",
          "34378551722124"
        ]
      },
      "84": {
        "defaultVariantId": "34378551754892",
        "housingVariants": {
          "Black": "34378551754892",
          "White": "34378551787660"
        },
        "variantIds": [
          "34378551754892",
          "34378551787660"
        ]
      },
      "92": {
        "defaultVariantId": "34378551820428",
        "housingVariants": {
          "Black": "34378551820428",
          "White": "34378551853196"
        },
        "variantIds": [
          "34378551820428",
          "34378551853196"
        ]
      },
      "100": {
        "defaultVariantId": "34378551885964",
        "housingVariants": {
          "Black": "34378551885964",
          "White": "34378551918732"
        },
        "variantIds": [
          "34378551885964",
          "34378551918732"
        ]
      },
      "110": {
        "defaultVariantId": "34378551951500",
        "housingVariants": {
          "Black": "34378551951500",
          "White": "34378551984268"
        },
        "variantIds": [
          "34378551951500",
          "34378551984268"
        ]
      },
      "120": {
        "defaultVariantId": "34378552017036",
        "housingVariants": {
          "Black": "34378552017036",
          "White": "34378552049804"
        },
        "variantIds": [
          "34378552017036",
          "34378552049804"
        ]
      },
      "135": {
        "defaultVariantId": "42473468461196",
        "housingVariants": {
          "Black": "42473468461196",
          "White": "42473468493964"
        },
        "variantIds": [
          "42473468461196",
          "42473468493964"
        ]
      },
      "150": {
        "defaultVariantId": "43847770669196",
        "housingVariants": {
          "Black": "43847770669196",
          "White": "43847770701964"
        },
        "variantIds": [
          "43847770669196",
          "43847770701964"
        ]
      }
    }
  },
  "s_3d": {
    "shopifyProductId": "6941468819596",
    "productPath": "/products/vividstorm-s-3d-alr-motorized-tension-floor-rising-3d-obsidian-long-throw-alrhigh-gain-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Screen Material"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": "40353359364236",
        "housingVariants": {
          "Black": "40353359364236",
          "White": "40353359429772"
        },
        "variantIds": [
          "40353359364236",
          "40353359429772"
        ]
      },
      "84": {
        "defaultVariantId": "40353359495308",
        "housingVariants": {
          "Black": "40353359495308",
          "White": "40353359560844"
        },
        "variantIds": [
          "40353359495308",
          "40353359560844"
        ]
      },
      "92": {
        "defaultVariantId": "40353359626380",
        "housingVariants": {
          "Black": "40353359626380",
          "White": "40353359691916"
        },
        "variantIds": [
          "40353359626380",
          "40353359691916"
        ]
      },
      "100": {
        "defaultVariantId": "40353359757452",
        "housingVariants": {
          "Black": "40353359757452",
          "White": "40353359822988"
        },
        "variantIds": [
          "40353359757452",
          "40353359822988"
        ]
      },
      "110": {
        "defaultVariantId": "40353359888524",
        "housingVariants": {
          "Black": "40353359888524",
          "White": "40353359954060"
        },
        "variantIds": [
          "40353359888524",
          "40353359954060"
        ]
      },
      "120": {
        "defaultVariantId": "40353360019596",
        "housingVariants": {
          "Black": "40353360019596",
          "White": "40353360085132"
        },
        "variantIds": [
          "40353360019596",
          "40353360085132"
        ]
      },
      "135": {
        "defaultVariantId": "40353360150668",
        "housingVariants": {
          "Black": "40353360150668",
          "White": "40353360216204"
        },
        "variantIds": [
          "40353360150668",
          "40353360216204"
        ]
      },
      "150": {
        "defaultVariantId": "40353360281740",
        "housingVariants": {
          "Black": "40353360281740",
          "White": "40353360347276"
        },
        "variantIds": [
          "40353360281740",
          "40353360347276"
        ]
      }
    }
  },
  "titan_obsidian": {
    "shopifyProductId": "7309422067852",
    "productPath": "/products/vividstorm-titan-motorized-tension-floor-rising-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Material",
      "Screen Housing Color"
    ],
    "shopifyOptionValues": [
      "Obsidian Long-Throw ALR"
    ],
    "bySize": {
      "160": {
        "defaultVariantId": "41558508732556",
        "housingVariants": {
          "White": "41558508732556",
          "Black": "41558508765324"
        },
        "variantIds": [
          "41558508732556",
          "41558508765324"
        ]
      },
      "170": {
        "defaultVariantId": "41558508863628",
        "housingVariants": {
          "White": "41558508863628",
          "Black": "41558508896396"
        },
        "variantIds": [
          "41558508863628",
          "41558508896396"
        ]
      },
      "180": {
        "defaultVariantId": "41558508994700",
        "housingVariants": {
          "White": "41558508994700",
          "Black": "41558509027468"
        },
        "variantIds": [
          "41558508994700",
          "41558509027468"
        ]
      },
      "200": {
        "defaultVariantId": "41558509256844",
        "housingVariants": {
          "White": "41558509256844",
          "Black": "41558509289612"
        },
        "variantIds": [
          "41558509256844",
          "41558509289612"
        ]
      }
    }
  },
  "titan_white": {
    "shopifyProductId": "7309422067852",
    "productPath": "/products/vividstorm-titan-motorized-tension-floor-rising-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Material",
      "Screen Housing Color"
    ],
    "shopifyOptionValues": [
      "White Cinema"
    ],
    "bySize": {
      "160": {
        "defaultVariantId": "41558508798092",
        "housingVariants": {
          "White": "41558508798092",
          "Black": "41558508830860"
        },
        "variantIds": [
          "41558508798092",
          "41558508830860"
        ]
      },
      "170": {
        "defaultVariantId": "41558508929164",
        "housingVariants": {
          "White": "41558508929164",
          "Black": "41558508961932"
        },
        "variantIds": [
          "41558508929164",
          "41558508961932"
        ]
      },
      "180": {
        "defaultVariantId": "41558509060236",
        "housingVariants": {
          "White": "41558509060236",
          "Black": "41558509093004"
        },
        "variantIds": [
          "41558509060236",
          "41558509093004"
        ]
      },
      "200": {
        "defaultVariantId": "41558509322380",
        "housingVariants": {
          "White": "41558509322380",
          "Black": "41558509355148"
        },
        "variantIds": [
          "41558509322380",
          "41558509355148"
        ]
      }
    }
  },
  "alr_slimline": {
    "shopifyProductId": "6676977516684",
    "productPath": "/products/vividstorm-alr-slimline-motorized-tension-obsidian-long-throw-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Screen Material Design"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "84": {
        "defaultVariantId": "39524270538892",
        "housingVariants": {
          "Black": "39524270538892",
          "White": "39524270604428"
        },
        "variantIds": [
          "39524270538892",
          "39524270604428"
        ]
      },
      "92": {
        "defaultVariantId": "39524270669964",
        "housingVariants": {
          "Black": "39524270669964",
          "White": "39524270735500"
        },
        "variantIds": [
          "39524270669964",
          "39524270735500"
        ]
      },
      "100": {
        "defaultVariantId": "39524270801036",
        "housingVariants": {
          "Black": "39524270801036",
          "White": "39524270866572"
        },
        "variantIds": [
          "39524270801036",
          "39524270866572"
        ]
      },
      "110": {
        "defaultVariantId": "39524270932108",
        "housingVariants": {
          "Black": "39524270932108",
          "White": "39524270997644"
        },
        "variantIds": [
          "39524270932108",
          "39524270997644"
        ]
      },
      "120": {
        "defaultVariantId": "39524271063180",
        "housingVariants": {
          "Black": "39524271063180",
          "White": "39524271128716"
        },
        "variantIds": [
          "39524271063180",
          "39524271128716"
        ]
      },
      "135": {
        "defaultVariantId": "40545904394380",
        "housingVariants": {
          "Black": "40545904394380",
          "White": "40545904427148"
        },
        "variantIds": [
          "40545904394380",
          "40545904427148"
        ]
      },
      "150": {
        "defaultVariantId": "40545904459916",
        "housingVariants": {
          "Black": "40545904459916",
          "White": "40545904492684"
        },
        "variantIds": [
          "40545904459916",
          "40545904492684"
        ]
      },
      "160": {
        "defaultVariantId": "44323393929356",
        "housingVariants": {
          "Black": "44323393929356",
          "White": "44323393962124"
        },
        "variantIds": [
          "44323393929356",
          "44323393962124"
        ]
      },
      "170": {
        "defaultVariantId": "44323393994892",
        "housingVariants": {
          "Black": "44323393994892",
          "White": "44323394027660"
        },
        "variantIds": [
          "44323393994892",
          "44323394027660"
        ]
      },
      "180": {
        "defaultVariantId": "44323394060428",
        "housingVariants": {
          "Black": "44323394060428",
          "White": "44323394093196"
        },
        "variantIds": [
          "44323394060428",
          "44323394093196"
        ]
      }
    }
  },
  "alr_p_slimline": {
    "shopifyProductId": "5250238087308",
    "productPath": "/products/vividstorm-alr-p-slimline-motorized-tension-obsidian-long-throw-alr-perforated-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "84": {
        "defaultVariantId": "34401610236044",
        "housingVariants": {
          "Black": "34401610236044",
          "White": "34401610268812"
        },
        "variantIds": [
          "34401610236044",
          "34401610268812"
        ]
      },
      "92": {
        "defaultVariantId": "34401610301580",
        "housingVariants": {
          "Black": "34401610301580",
          "White": "34401610334348"
        },
        "variantIds": [
          "34401610301580",
          "34401610334348"
        ]
      },
      "100": {
        "defaultVariantId": "34401610367116",
        "housingVariants": {
          "Black": "34401610367116",
          "White": "34401610399884"
        },
        "variantIds": [
          "34401610367116",
          "34401610399884"
        ]
      },
      "110": {
        "defaultVariantId": "34401610432652",
        "housingVariants": {
          "Black": "34401610432652",
          "White": "34401610465420"
        },
        "variantIds": [
          "34401610432652",
          "34401610465420"
        ]
      },
      "120": {
        "defaultVariantId": "34401610498188",
        "housingVariants": {
          "Black": "34401610498188",
          "White": "34401610530956"
        },
        "variantIds": [
          "34401610498188",
          "34401610530956"
        ]
      }
    }
  },
  "phantom_long": {
    "shopifyProductId": "7347996164236",
    "productPath": "/products/vividstorm-phantom-recessed-in-ceiling-motorized-tension-obsidian-long-throw-alr-projector-screen",
    "shopifyOptionNames": [
      "Viewing Digonal Size",
      "Housing Color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": "41657085558924",
        "housingVariants": {
          "White": "41657085558924",
          "Black": "42346918969484"
        },
        "variantIds": [
          "41657085558924",
          "42346918969484"
        ]
      },
      "84": {
        "defaultVariantId": "41657085591692",
        "housingVariants": {
          "White": "41657085591692",
          "Black": "42346919002252"
        },
        "variantIds": [
          "41657085591692",
          "42346919002252"
        ]
      },
      "92": {
        "defaultVariantId": "41657085624460",
        "housingVariants": {
          "White": "41657085624460",
          "Black": "42346919035020"
        },
        "variantIds": [
          "41657085624460",
          "42346919035020"
        ]
      },
      "100": {
        "defaultVariantId": "41657085657228",
        "housingVariants": {
          "White": "41657085657228",
          "Black": "42346919067788"
        },
        "variantIds": [
          "41657085657228",
          "42346919067788"
        ]
      },
      "110": {
        "defaultVariantId": "41657085689996",
        "housingVariants": {
          "White": "41657085689996",
          "Black": "42346919100556"
        },
        "variantIds": [
          "41657085689996",
          "42346919100556"
        ]
      },
      "120": {
        "defaultVariantId": "41657085722764",
        "housingVariants": {
          "White": "41657085722764",
          "Black": "42346919133324"
        },
        "variantIds": [
          "41657085722764",
          "42346919133324"
        ]
      },
      "135": {
        "defaultVariantId": "41827008807052",
        "housingVariants": {
          "White": "41827008807052",
          "Black": "42346919166092"
        },
        "variantIds": [
          "41827008807052",
          "42346919166092"
        ]
      },
      "150": {
        "defaultVariantId": "41827008839820",
        "housingVariants": {
          "White": "41827008839820",
          "Black": "42346919198860"
        },
        "variantIds": [
          "41827008839820",
          "42346919198860"
        ]
      },
      "160": {
        "defaultVariantId": "44287507988620",
        "housingVariants": {
          "White": "44287507988620",
          "Black": "44287508021388"
        },
        "variantIds": [
          "44287507988620",
          "44287508021388"
        ]
      },
      "170": {
        "defaultVariantId": "44287508054156",
        "housingVariants": {
          "White": "44287508054156",
          "Black": "44287508086924"
        },
        "variantIds": [
          "44287508054156",
          "44287508086924"
        ]
      },
      "180": {
        "defaultVariantId": "44287508119692",
        "housingVariants": {
          "White": "44287508119692",
          "Black": "44287508152460"
        },
        "variantIds": [
          "44287508119692",
          "44287508152460"
        ]
      }
    }
  },
  "s_fusion": {
    "shopifyProductId": "7943375913100",
    "productPath": "/products/vividstorm-s-fusion-alr-motorized-tension-floor-rising-enhanced-long-throw-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Screen Material"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43323783118988",
          "43323783151756"
        ]
      },
      "84": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43323783184524",
          "43323783217292"
        ]
      },
      "92": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43323783250060",
          "43323783282828"
        ]
      },
      "100": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43323783315596",
          "43323783348364"
        ]
      },
      "110": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43323783381132",
          "43323783413900"
        ]
      },
      "120": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43323783446668",
          "43323783479436"
        ]
      }
    }
  },
  "fusion_slimline": {
    "shopifyProductId": "7943497875596",
    "productPath": "/products/vividstorm-fusion-alr-slimline-motorized-tension-enhanced-long-throw-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing color",
      "Screen Material Design"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "72": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43324199927948",
          "43324199960716"
        ]
      },
      "84": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43324166766732",
          "43324166799500"
        ]
      },
      "92": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43324166832268",
          "43324166865036"
        ]
      },
      "100": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43324166897804",
          "43324166930572"
        ]
      },
      "110": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43324166963340",
          "43324166996108"
        ]
      },
      "120": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "43324167028876",
          "43324167061644"
        ]
      }
    }
  },
  "fusion_fixed": {
    "shopifyProductId": "7944011186316",
    "productPath": "/products/vividstorm-fusion-alr-fixed-frame-enhanced-long-throw-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "43325888725132",
        "housingVariants": {},
        "variantIds": [
          "43325888725132"
        ]
      },
      "120": {
        "defaultVariantId": "43325888757900",
        "housingVariants": {},
        "variantIds": [
          "43325888757900"
        ]
      },
      "130": {
        "defaultVariantId": "43325888790668",
        "housingVariants": {},
        "variantIds": [
          "43325888790668"
        ]
      }
    }
  },
  "obsidian_fixed": {
    "shopifyProductId": "9146456768652",
    "productPath": "/products/vividstorm-alr-fixed-frame-obsidian-long-throw-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen material"
    ],
    "shopifyOptionValues": [
      "Obsidian ALR"
    ],
    "bySize": {
      "100": {
        "defaultVariantId": "47648100515980",
        "housingVariants": {},
        "variantIds": [
          "47648100515980"
        ]
      },
      "120": {
        "defaultVariantId": "47648100548748",
        "housingVariants": {},
        "variantIds": [
          "47648100548748"
        ]
      },
      "130": {
        "defaultVariantId": "47648100581516",
        "housingVariants": {},
        "variantIds": [
          "47648100581516"
        ]
      },
      "150": {
        "defaultVariantId": "47648100614284",
        "housingVariants": {},
        "variantIds": [
          "47648100614284"
        ]
      },
      "170": {
        "defaultVariantId": "51935236325516",
        "housingVariants": {},
        "variantIds": [
          "51935236325516"
        ]
      },
      "180": {
        "defaultVariantId": "51935236391052",
        "housingVariants": {},
        "variantIds": [
          "51935236391052"
        ]
      },
      "200": {
        "defaultVariantId": "51935236456588",
        "housingVariants": {},
        "variantIds": [
          "51935236456588"
        ]
      }
    }
  },
  "obsidian_fixed_p": {
    "shopifyProductId": "9146456768652",
    "productPath": "/products/vividstorm-alr-fixed-frame-obsidian-long-throw-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen material"
    ],
    "shopifyOptionValues": [
      "Perforated Obsidian ALR"
    ],
    "bySize": {
      "100": {
        "defaultVariantId": "47648126304396",
        "housingVariants": {},
        "variantIds": [
          "47648126304396"
        ]
      },
      "120": {
        "defaultVariantId": "47648126337164",
        "housingVariants": {},
        "variantIds": [
          "47648126337164"
        ]
      },
      "130": {
        "defaultVariantId": "47648126369932",
        "housingVariants": {},
        "variantIds": [
          "47648126369932"
        ]
      },
      "150": {
        "defaultVariantId": "47648126402700",
        "housingVariants": {},
        "variantIds": [
          "47648126402700"
        ]
      },
      "170": {
        "defaultVariantId": "51935236358284",
        "housingVariants": {},
        "variantIds": [
          "51935236358284"
        ]
      },
      "180": {
        "defaultVariantId": "51935236423820",
        "housingVariants": {},
        "variantIds": [
          "51935236423820"
        ]
      },
      "200": {
        "defaultVariantId": "51935236489356",
        "housingVariants": {},
        "variantIds": [
          "51935236489356"
        ]
      }
    }
  },
  "lumiere": {
    "shopifyProductId": "9918291017868",
    "productPath": "/products/vividstorm-lumiere-fixed-frame-fresnel-long-throw-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Shipping options"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "54364694085772",
        "housingVariants": {},
        "variantIds": [
          "54364694085772",
          "54364694118540"
        ]
      },
      "120": {
        "defaultVariantId": null,
        "housingVariants": {},
        "variantIds": [
          "54364694151308",
          "54364694184076"
        ]
      }
    }
  },
  "duraplus": {
    "shopifyProductId": "8121065439372",
    "productPath": "/products/vividstorm-duraplus-weatherproof-motorized-outdoor-projector-screen",
    "shopifyOptionNames": [
      "Size",
      "Color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "44133257511052",
        "housingVariants": {
          "Dark Gray": "44133257511052",
          "White": "44140647612556",
          "Coffee Brown": "44140647645324"
        },
        "variantIds": [
          "44133257511052",
          "44140647612556",
          "44140647645324"
        ]
      },
      "120": {
        "defaultVariantId": "44133257543820",
        "housingVariants": {
          "Dark Gray": "44133257543820",
          "White": "44140647678092",
          "Coffee Brown": "44140647710860"
        },
        "variantIds": [
          "44133257543820",
          "44140647678092",
          "44140647710860"
        ]
      },
      "135": {
        "defaultVariantId": "44133257576588",
        "housingVariants": {
          "Dark Gray": "44133257576588",
          "White": "44140647743628",
          "Coffee Brown": "44140647776396"
        },
        "variantIds": [
          "44133257576588",
          "44140647743628",
          "44140647776396"
        ]
      },
      "150": {
        "defaultVariantId": "44133257609356",
        "housingVariants": {
          "Dark Gray": "44133257609356",
          "White": "44140647809164",
          "Coffee Brown": "44140647841932"
        },
        "variantIds": [
          "44133257609356",
          "44140647809164",
          "44140647841932"
        ]
      },
      "180": {
        "defaultVariantId": "44133257642124",
        "housingVariants": {
          "Dark Gray": "44133257642124",
          "White": "44140647874700",
          "Coffee Brown": "44140647907468"
        },
        "variantIds": [
          "44133257642124",
          "44140647874700",
          "44140647907468"
        ]
      },
      "200": {
        "defaultVariantId": "44133257674892",
        "housingVariants": {
          "Dark Gray": "44133257674892",
          "White": "44140647940236",
          "Coffee Brown": "44140647973004"
        },
        "variantIds": [
          "44133257674892",
          "44140647940236",
          "44140647973004"
        ]
      }
    }
  },
  "silux_floor": {
    "shopifyProductId": "9909875998860",
    "productPath": "/products/vividstorm-silux-pro-motorized-floor-rising-fresnel-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "54245840519308",
        "housingVariants": {
          "Black": "54245840519308",
          "White": "54245840552076"
        },
        "variantIds": [
          "54245840519308",
          "54245840552076"
        ]
      },
      "120": {
        "defaultVariantId": "54245840584844",
        "housingVariants": {
          "Black": "54245840584844",
          "White": "54245840617612"
        },
        "variantIds": [
          "54245840584844",
          "54245840617612"
        ]
      }
    }
  },
  "silicaflex_floor": {
    "shopifyProductId": "9912027480204",
    "productPath": "/products/vividstorm-silicaflex-motorized-floor-rising-fresnel-long-throw-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "54267078049932",
        "housingVariants": {
          "Black": "54267078049932",
          "White": "54267078082700"
        },
        "variantIds": [
          "54267078049932",
          "54267078082700"
        ]
      },
      "120": {
        "defaultVariantId": "54267078115468",
        "housingVariants": {
          "Black": "54267078115468",
          "White": "54267078148236"
        },
        "variantIds": [
          "54267078115468",
          "54267078148236"
        ]
      }
    }
  },
  "silux_slimline": {
    "shopifyProductId": "9914238795916",
    "productPath": "/products/vividstorm-slimline-silux-pro-motorized-fresnel-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "54297506840716",
        "housingVariants": {
          "White": "54297506840716",
          "Black": "54302885937292"
        },
        "variantIds": [
          "54297506840716",
          "54302885937292"
        ]
      },
      "120": {
        "defaultVariantId": "54297506873484",
        "housingVariants": {
          "White": "54297506873484",
          "Black": "54302885970060"
        },
        "variantIds": [
          "54297506873484",
          "54302885970060"
        ]
      }
    }
  },
  "silicaflex_slimline": {
    "shopifyProductId": "9916486189196",
    "productPath": "/products/vividstorm-slimline-silicaflex-motorized-fresnel-long-throw-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "54309389303948",
        "housingVariants": {
          "White": "54309389303948",
          "Black": "54309389336716"
        },
        "variantIds": [
          "54309389303948",
          "54309389336716"
        ]
      },
      "120": {
        "defaultVariantId": "54309389369484",
        "housingVariants": {
          "White": "54309389369484",
          "Black": "54309389402252"
        },
        "variantIds": [
          "54309389369484",
          "54309389402252"
        ]
      }
    }
  },
  "silux_phantom": {
    "shopifyProductId": "9916907880588",
    "productPath": "/products/vividstorm-phantom-recessed-in-ceiling-silux-pro-motorized-fresnel-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "54313327198348",
        "housingVariants": {
          "White": "54313327198348",
          "Black": "54313327231116"
        },
        "variantIds": [
          "54313327198348",
          "54313327231116"
        ]
      },
      "120": {
        "defaultVariantId": "54313327263884",
        "housingVariants": {
          "White": "54313327263884",
          "Black": "54313327296652"
        },
        "variantIds": [
          "54313327263884",
          "54313327296652"
        ]
      }
    }
  },
  "silicaflex_phantom": {
    "shopifyProductId": "9917327999116",
    "productPath": "/products/vividstorm-phantom-recessed-in-ceiling-silicaflex-motorized-fresnel-long-throw-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size",
      "Screen Housing Color"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "100": {
        "defaultVariantId": "54321565237388",
        "housingVariants": {
          "White": "54321565237388",
          "Black": "54321565270156"
        },
        "variantIds": [
          "54321565237388",
          "54321565270156"
        ]
      },
      "120": {
        "defaultVariantId": "54321565302924",
        "housingVariants": {
          "White": "54321565302924",
          "Black": "54321565335692"
        },
        "variantIds": [
          "54321565302924",
          "54321565335692"
        ]
      }
    }
  },
  "s_pro_plus": {
    "shopifyProductId": "7645265133708",
    "productPath": "/products/presale-vividstorm-130-s-pro-plus-motorized-tension-floor-rising-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size: ",
      "Screen Housing Color:"
    ],
    "shopifyOptionValues": [],
    "bySize": {
      "130": {
        "defaultVariantId": "42599693811852",
        "housingVariants": {
          "White": "42599693811852",
          "Black": "42599693844620"
        },
        "variantIds": [
          "42599693811852",
          "42599693844620"
        ]
      }
    }
  },
  "pro_plus": {
    "shopifyProductId": "7963209859212",
    "productPath": "/products/presale-vividstorm-130-pro-pro-a-pro-p-pro-pa-plus-slimline-motorized-tension-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size:",
      "Screen Housing Color:",
      " Screen type: "
    ],
    "shopifyOptionValues": [
      "PRO"
    ],
    "bySize": {
      "130": {
        "defaultVariantId": "43397596610700",
        "housingVariants": {
          "White": "43397596610700",
          "Black": "43397596643468"
        },
        "variantIds": [
          "43397596610700",
          "43397596643468"
        ]
      }
    }
  },
  "pro_a_plus": {
    "shopifyProductId": "7963209859212",
    "productPath": "/products/presale-vividstorm-130-pro-pro-a-pro-p-pro-pa-plus-slimline-motorized-tension-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size:",
      "Screen Housing Color:",
      " Screen type: "
    ],
    "shopifyOptionValues": [
      "PRO A"
    ],
    "bySize": {
      "130": {
        "defaultVariantId": "43397633048716",
        "housingVariants": {
          "White": "43397633048716",
          "Black": "43397633147020"
        },
        "variantIds": [
          "43397633048716",
          "43397633147020"
        ]
      }
    }
  },
  "pro_p_plus": {
    "shopifyProductId": "7963209859212",
    "productPath": "/products/presale-vividstorm-130-pro-pro-a-pro-p-pro-pa-plus-slimline-motorized-tension-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size:",
      "Screen Housing Color:",
      " Screen type: "
    ],
    "shopifyOptionValues": [
      "PRO P"
    ],
    "bySize": {
      "130": {
        "defaultVariantId": "43397633081484",
        "housingVariants": {
          "White": "43397633081484",
          "Black": "43397633179788"
        },
        "variantIds": [
          "43397633081484",
          "43397633179788"
        ]
      }
    }
  },
  "pro_pa_plus": {
    "shopifyProductId": "7963209859212",
    "productPath": "/products/presale-vividstorm-130-pro-pro-a-pro-p-pro-pa-plus-slimline-motorized-tension-ust-alr-projector-screen",
    "shopifyOptionNames": [
      "Screen Diagonal Size:",
      "Screen Housing Color:",
      " Screen type: "
    ],
    "shopifyOptionValues": [
      "PRO PA"
    ],
    "bySize": {
      "130": {
        "defaultVariantId": "43397633114252",
        "housingVariants": {
          "White": "43397633114252",
          "Black": "43397633212556"
        },
        "variantIds": [
          "43397633114252",
          "43397633212556"
        ]
      }
    }
  }
});
});

(function (root, factory) {
  var catalog = factory(root.ScreenFinderShopifyMapping || (typeof require === 'function' ? require('./shopify-variant-map.js') : null));
  if (typeof module === 'object' && module.exports) module.exports = catalog;
  root.ScreenFinderCatalog = catalog;
})(typeof globalThis !== 'undefined' ? globalThis : this, function (shopifyMapping) {
  'use strict';

  var VERIFIED_AT = '2026-09-02';
  var SOURCE = 'Shopify Admin read-only product and variant snapshot · 2026-09-02';

  if (!shopifyMapping) throw new Error('ScreenFinderShopifyMapping is required');

  var FAMILY_LABELS = Object.freeze({
    s_pro: 'S PRO Floor Rising',
    s_lite_hyper: 'S Lite Hyper Floor Rising',
    s_white: 'S White Cinema Floor Rising',
    pearl_white: 'Pearl White Cinema Plus Floor Rising',
    pro_slimline: 'PRO Slimline',
    lite_hyper_slimline: 'Lite Hyper Slimline',
    white_slimline: 'White Cinema Slimline',
    phantom_ust: 'PHANTOM PRO In-Ceiling',
    phantom_lite_hyper: 'PHANTOM Lite Hyper In-Ceiling',
    phantom_white: 'PHANTOM White Cinema In-Ceiling',
    cinevision: 'CineVision Fixed Frame',
    lite_hyper_frame: 'Lite Hyper Fixed Frame',
    aeris_pro: 'AERIS Pro Fixed Frame',
    s_alr: 'S ALR Floor Rising',
    s_3d_alr: 'S 3D ALR Floor Rising',
    titan: 'TITAN Floor Rising',
    alr_slimline: 'ALR Slimline',
    alr_3d_slimline: '3D ALR Slimline',
    phantom_long: 'PHANTOM Long-Throw In-Ceiling',
    fusion_fixed: 'Fusion ALR Fixed Frame',
    s_fusion: 'S Fusion ALR Floor Rising',
    fusion_slimline: 'Fusion ALR Slimline',
    obsidian_fixed: 'Obsidian ALR Fixed Frame',
    lumiere: 'LUMIERE Fixed Frame',
    duraplus: 'DuraPlus Outdoor · Between-Post Installation',
    silux_pro: 'Silux Pro',
    silicaflex: 'SilicaFlex',
    s_pro_plus: 'S PRO Plus Floor Rising',
    pro_plus: 'PRO Plus Slimline',
    clearance_phantom: 'PHANTOM / Slimline Clearance'
  });

  function materialClassFor(item) {
    var material = String(item.material || '');
    if (item.materialType === 'white' || item.materialType === 'outdoor_white') return 'whiteCinema';
    if (/Lite Hyper|Lenticular/i.test(material)) return 'liteHyperDomesticGrid';
    if (/3D Obsidian/i.test(material)) return 'longThrow3dAlr';
    if (/Obsidian|Enhanced Long-Throw/i.test(material)) return 'longThrowAlr';
    if (/Fresnel/i.test(material)) return 'fresnel';
    if (/Black Grid/i.test(material) || item.id === 'cinevision') return 'blackGrid';
    return 'whiteCinema';
  }

  function perforationAreaFor(item) {
    if (!item.acousticTransparent) return 'none';
    if (item.materialType === 'white' || /Obsidian Long-Throw/i.test(item.material)) return 'imageArea';
    if (/Black Grid/i.test(item.material)) return 'lowerBorder';
    return 'unverified';
  }

  function product(id, familyId, displayName, handle, options) {
    var live = shopifyMapping[id] || {};
    var item = Object.assign({
      id: id, familyId: familyId, familyDisplayName: FAMILY_LABELS[familyId] || displayName,
      displayName: displayName, technicalVariant: displayName,
      canonicalUrl: handle ? '/products/' + handle : null, productPath: live.productPath || (handle ? '/products/' + handle : null),
      shopifyProductId: live.shopifyProductId || null,
      shopifyOptionNames: live.shopifyOptionNames || [],
      shopifyOptionValues: live.shopifyOptionValues || [],
      variantMap: live.bySize || {},
      purchasableIdentity: (live.shopifyProductId || handle) + ':' + id,
      installation: 'floor', projectorTypes: ['ust'], locations: ['indoor'],
      viewingConditions: ['bright', 'controlled', 'dark', 'not_sure'],
      material: 'UST ALR', materialType: 'alr', direction: 'below_upright',
      acousticTransparent: false, sizes: [], supportedAspectRatios: ['16:9'],
      alignmentMethods: ['centered'], laserGuidance: 'unverified',
      status: 'active', availabilityLabel: 'Available', availability: 'published',
      preorder: false, clearance: false, region: 'global',
      recommendationEligible: true, customerVisible: true, intentionalExclusion: null, plus: false,
      source: SOURCE, verifiedAt: VERIFIED_AT
    }, options || {});
    item.materialClass = item.materialClass || materialClassFor(item);
    item.projectorClass = item.projectorTypes.slice();
    item.maxSize = item.materialClass === 'blackGrid' ? 130 : Math.max.apply(Math, item.sizes);
    item.maxSizeRule = item.materialClass === 'blackGrid' ? 'rawMaterialHardLimit' : 'verifiedProductSizes';
    item.exactSizes = item.exactSizes || item.sizes.slice();
    item.orientation = item.direction === 'above_inverted' ? 'aboveInverted' :
      (item.direction === 'below_upright' ? 'belowUpright' : 'nonDirectional');
    item.perforationArea = item.perforationArea || perforationAreaFor(item);
    item.availabilityMode = item.availabilityMode || 'standardVariant';
    item.standardOrCustom = item.availabilityMode;
    item.ambientLightUse = item.ambientLightUse || (item.materialClass === 'whiteCinema' ? 'darkRoomPreferred' : 'ambientLightCapable');
    item.brightnessPreference = item.brightnessPreference ||
      (item.materialClass === 'longThrow3dAlr' ? 'higherGain' : (item.materialClass === 'whiteCinema' ? 'highestBrightness' : 'balanced'));
    item.colorPriority = item.colorPriority || (item.materialClass === 'longThrowAlr' ? 'strongerBlackAndColor' : 'balanced');
    item.sideViewingSuitability = item.sideViewingSuitability || (item.materialClass === 'fresnel' ? 'limited' : 'suitable');
    item.sideProjectionSuitability = item.sideProjectionSuitability ||
      (item.materialClass === 'whiteCinema' ? 'safeDefault' : (item.materialClass === 'fresnel' ? 'unverified' : 'directionalRisk'));
    item.pricePosition = item.pricePosition ||
      (item.materialClass === 'whiteCinema' ? 'lower' : (item.materialClass === 'liteHyperDomesticGrid' ? 'valueAlternative' : 'higher'));
    item.verifiedSource = item.verifiedSource || item.source;
    item.verificationStatus = item.verificationStatus || 'verified';
    item.overheadLightRejection = item.materialClass === 'blackGrid' && item.orientation !== 'aboveInverted';
    return Object.freeze(item);
  }

  var PRODUCTS = Object.freeze([
    product('s_pro', 's_pro', 'S PRO Floor Rising · UST ALR', 'vividstorm-s-pro-motorized-tension-floor-rising-ust-alr-projector-screen', { sizes: [72,84,92,100,110,120], material: 'Black Grid UST ALR', laserGuidance: 'moderate_risk' }),
    product('s_pro_p', 's_pro', 'S PRO P Floor Rising · Acoustic UST ALR', 'vividstorm-s-pro-p-motorized-tension-floor-rising-ust-alr-perforated-projector-screen', { sizes: [72,84,92,100,110,120,130], material: 'Perforated Black Grid UST ALR', acousticTransparent: true, laserGuidance: 'moderate_risk' }),
    product('s_lite', 's_lite_hyper', 'S Lite Hyper Floor Rising · UST ALR', 'vividstorm-s-lite-hyper-motorized-tension-floor-rising-lenticular-alr-projector-screen', { sizes: [72,84,92,100,110,120,130,150], material: 'Lenticular UST ALR', laserGuidance: 'lower_risk' }),
    product('s_lite_p', 's_lite_hyper', 'S Lite Hyper P Floor Rising · Acoustic UST ALR', 'vividstorm-s-lite-hyper-motorized-tension-floor-rising-lenticular-alr-projector-screen', { sizes: [72,84,92,100,110,120,130,150], material: 'Perforated Lenticular UST ALR', acousticTransparent: true, laserGuidance: 'lower_risk', purchasableIdentity: 's-lite-hyper:p' }),
    product('s_white', 's_white', 'S White Cinema Floor Rising', 'vividstorm-s-white-cinema-motorized-tension-floor-rising-projector-screen', { projectorTypes: ['ust','long'], sizes: [72,84,92,100,110,120,135,150], material: 'White Cinema', materialType: 'white', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'], laserGuidance: 'lower_risk' }),
    product('s_white_p', 's_white', 'S White Cinema P Floor Rising · Acoustic', 'vividstorm-s-white-cinema-p-motorized-tension-floor-rising-white-cinema-perforated-projector-screen', { projectorTypes: ['ust','long'], sizes: [72,84,92,100,110,120,135,150], material: 'Perforated White Cinema', materialType: 'white', direction: 'non_directional', acousticTransparent: true, alignmentMethods: ['centered','optical_shift'], laserGuidance: 'lower_risk' }),
    product('pearl_white', 'pearl_white', 'Pearl White Cinema Plus Floor Rising', 'vividstorm-pearl-white-cinema-plus-motorized-tension-floor-rising-projector-screen', { projectorTypes: ['long'], sizes: [72,84,92,100,110,120], material: 'Pearl White Cinema Plus', materialType: 'white', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'], laserGuidance: 'lower_risk' }),

    product('pro', 'pro_slimline', 'PRO Slimline · UST ALR', 'vividstorm-pro-motorized-drop-down-screen-ust-projector-ultra-short-throw-ambient-light-rejecting-4k-projector-screen', { installation: 'drop', sizes: [84,92,100,110,120], material: 'Black Grid UST ALR', laserGuidance: 'moderate_risk' }),
    product('pro_a', 'pro_slimline', 'PRO A Slimline · Reverse UST ALR', 'vividstorm-pro-a-slimline-motorized-tension-ust-alr-projector-screen', { installation: 'drop', sizes: [84,92,100,110,120], material: 'Reverse Black Grid UST ALR', direction: 'above_inverted', laserGuidance: 'moderate_risk' }),
    product('pro_p', 'pro_slimline', 'PRO P Slimline · Acoustic UST ALR', 'vividstorm-pro-p-slimline-motorized-tension-ust-alr-projector-screen', { installation: 'drop', sizes: [84,92,100,110,120], material: 'Perforated Black Grid UST ALR', acousticTransparent: true, laserGuidance: 'moderate_risk' }),
    product('pro_pa', 'pro_slimline', 'PRO PA Slimline · Reverse Acoustic UST ALR', 'vividstorm-pro-pa-slimline-motorized-tension-ust-alr-projector-screen', { installation: 'drop', sizes: [84,92,100,110,120], material: 'Perforated Reverse Black Grid UST ALR', direction: 'above_inverted', acousticTransparent: true, laserGuidance: 'moderate_risk' }),
    product('lite_slimline', 'lite_hyper_slimline', 'Lite Hyper Slimline · UST ALR', 'vividstorm-150-lite-hyper-plus-slimline-motorized-tension-lenticular-alr-projector-screen', { installation: 'drop', sizes: [84,92,100,110,120,130,150], material: 'Lenticular UST ALR', laserGuidance: 'lower_risk' }),
    product('lite_slimline_a', 'lite_hyper_slimline', 'Lite Hyper A Slimline · Reverse UST ALR', 'vividstorm-150-lite-hyper-plus-slimline-motorized-tension-lenticular-alr-projector-screen', { installation: 'drop', sizes: [84,92,100,110,120,130,150], material: 'Reverse Lenticular UST ALR', direction: 'above_inverted', laserGuidance: 'lower_risk', purchasableIdentity: 'lite-hyper-slimline:a' }),
    product('lite_slimline_p', 'lite_hyper_slimline', 'Lite Hyper P Slimline · Acoustic UST ALR', 'vividstorm-150-lite-hyper-plus-slimline-motorized-tension-lenticular-alr-projector-screen', { installation: 'drop', sizes: [84,92,100,110,120,130,150], material: 'Perforated Lenticular UST ALR', acousticTransparent: true, laserGuidance: 'lower_risk', purchasableIdentity: 'lite-hyper-slimline:p' }),
    product('lite_slimline_pa', 'lite_hyper_slimline', 'Lite Hyper PA Slimline · Reverse Acoustic UST ALR', 'vividstorm-150-lite-hyper-plus-slimline-motorized-tension-lenticular-alr-projector-screen', { installation: 'drop', sizes: [84,92,100,110,120,130,150], material: 'Perforated Reverse Lenticular UST ALR', direction: 'above_inverted', acousticTransparent: true, laserGuidance: 'lower_risk', purchasableIdentity: 'lite-hyper-slimline:pa' }),
    product('white_slimline', 'white_slimline', 'White Cinema Slimline', 'vividstorm-white-cinema-slimline-motorized-tension-projector-screen', { installation: 'drop', projectorTypes: ['ust','long'], sizes: [84,92,100,110,120,135,150,160,170,180], material: 'White Cinema', materialType: 'white', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'], laserGuidance: 'lower_risk' }),
    product('white_p_slimline', 'white_slimline', 'White Cinema P Slimline · Acoustic', 'vividstorm-white-cinema-perforated-slimline-motorized-tension-projector-screen', { installation: 'drop', projectorTypes: ['ust','long'], sizes: [84,92,100,110,120], material: 'Perforated White Cinema', materialType: 'white', direction: 'non_directional', acousticTransparent: true, alignmentMethods: ['centered','optical_shift'], laserGuidance: 'lower_risk' }),

    product('phantom_pro', 'phantom_ust', 'PHANTOM PRO In-Ceiling · UST ALR', 'vividstorm-phantom-recessed-in-ceiling-motorized-tension-ust-alr-projector-screen', { installation: 'ceiling', sizes: [72,84,92,100,110,120,130], material: 'Black Grid UST ALR', laserGuidance: 'moderate_risk' }),
    product('phantom_pro_a', 'phantom_ust', 'PHANTOM PRO A In-Ceiling · Reverse UST ALR', 'vividstorm-phantom-recessed-in-ceiling-motorized-tension-ust-alr-projector-screen', { installation: 'ceiling', sizes: [72,84,92,100,110,120,130], material: 'Reverse Black Grid UST ALR', direction: 'above_inverted', laserGuidance: 'moderate_risk', purchasableIdentity: 'phantom-pro:a' }),
    product('phantom_lite', 'phantom_lite_hyper', 'PHANTOM Lite Hyper In-Ceiling · UST ALR', 'vividstorm-150-lite-hyper-plus-phantom-recessed-in-ceiling-motorized-tension-lenticular-alr-projector-screen', { installation: 'ceiling', sizes: [150], material: 'Lenticular UST ALR', laserGuidance: 'lower_risk' }),
    product('phantom_lite_a', 'phantom_lite_hyper', 'PHANTOM Lite Hyper A · Reverse UST ALR', 'vividstorm-150-lite-hyper-plus-phantom-recessed-in-ceiling-motorized-tension-lenticular-alr-projector-screen', { installation: 'ceiling', sizes: [150], material: 'Reverse Lenticular UST ALR', direction: 'above_inverted', laserGuidance: 'lower_risk', purchasableIdentity: 'phantom-lite:a' }),
    product('phantom_lite_p', 'phantom_lite_hyper', 'PHANTOM Lite Hyper P · Perforation Unverified', 'vividstorm-150-lite-hyper-plus-phantom-recessed-in-ceiling-motorized-tension-lenticular-alr-projector-screen', { installation: 'ceiling', sizes: [150], material: 'Perforated Lite Hyper UST ALR', acousticTransparent: true, perforationArea: 'unverified', availabilityMode: 'unverified', verificationStatus: 'ownerReviewRequired', recommendationEligible: false, intentionalExclusion: 'phantom_perforation_standard_or_custom_unresolved', laserGuidance: 'lower_risk', purchasableIdentity: 'phantom-lite:p' }),
    product('phantom_lite_pa', 'phantom_lite_hyper', 'PHANTOM Lite Hyper PA · Perforation Unverified', 'vividstorm-150-lite-hyper-plus-phantom-recessed-in-ceiling-motorized-tension-lenticular-alr-projector-screen', { installation: 'ceiling', sizes: [150], material: 'Perforated Reverse Lite Hyper UST ALR', direction: 'above_inverted', acousticTransparent: true, perforationArea: 'unverified', availabilityMode: 'unverified', verificationStatus: 'ownerReviewRequired', recommendationEligible: false, intentionalExclusion: 'phantom_perforation_standard_or_custom_unresolved', laserGuidance: 'lower_risk', purchasableIdentity: 'phantom-lite:pa' }),
    product('phantom_perforated_custom', 'phantom_ust', 'Perforated PHANTOM custom configuration', null, { installation: 'ceiling', sizes: [72,84,92,100,110,120,130], exactSizes: [], material: 'Perforated Black Grid UST ALR', acousticTransparent: true, perforationArea: 'lowerBorder', availabilityMode: 'customRequest', availability: 'mapping_unresolved_custom_request', availabilityLabel: 'Custom configuration · product mapping to confirm', verificationStatus: 'commercialMappingUnresolved', shopifyProductId: null, variantMap: {}, purchasableIdentity: 'custom:phantom-perforated-black-grid', laserGuidance: 'moderate_risk' }),
    product('phantom_white', 'phantom_white', 'PHANTOM White Cinema In-Ceiling', 'vividstorm-phantom-recessed-in-ceiling-motorized-tension-white-cinema-projector-screen', { installation: 'ceiling', projectorTypes: ['ust','long'], sizes: [72,84,92,100,110,120,135,150,160,170,180], material: 'White Cinema', materialType: 'white', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'], laserGuidance: 'lower_risk' }),

    product('cinevision', 'cinevision', 'CineVision Pro Fixed Frame · UST ALR', 'vividstorm-cinevision-pro-fixed-frame-ust-alr-projector-screen', { installation: 'frame', sizes: [100,120,130], material: 'UST ALR', direction: 'non_directional', laserGuidance: 'moderate_risk' }),
    product('cinevision_fresnel', 'cinevision', 'CineVision Pro Fresnel Fixed Frame · UST ALR', 'vividstorm-cinevision-pro-fixed-frame-fresnel-ust-alr-projector-screen', { installation: 'frame', sizes: [100,120,130,150], material: 'Fresnel UST ALR', direction: 'non_directional', laserGuidance: 'lower_risk' }),
    product('lite_frame', 'lite_hyper_frame', 'Lite Hyper Fixed Frame · UST ALR', 'vividstorm-lite-hyper-fixed-frame-lenticular-alr-projector-screen', { installation: 'frame', sizes: [100,120,130,150], material: 'Lenticular UST ALR', direction: 'non_directional', laserGuidance: 'lower_risk' }),
    product('aeris_pro', 'aeris_pro', 'AERIS Pro Fresnel Fixed Frame · UST ALR', 'vividstorm-aeris-pro-fixed-frame-fresnel-ust-alr-projector-screen', { installation: 'frame', sizes: [100], material: 'Fresnel UST ALR', direction: 'non_directional', status: 'preorder', availabilityLabel: 'Pre-order · 100-inch currently selectable', availability: 'published_preorder_partial', preorder: true, laserGuidance: 'lower_risk' }),

    product('s_alr', 's_alr', 'S ALR Floor Rising · Long-Throw ALR', 'vividstorm-s-alr-motorized-tension-floor-rising-obsidian-long-throw-alr-projector-screen', { projectorTypes: ['long'], sizes: [72,84,92,100,110,120,135,150], material: 'Obsidian Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'] }),
    product('s_alr_p', 's_alr', 'S ALR P Floor Rising · Acoustic Long-Throw ALR', 'vividstorm-s-alr-p-motorized-tension-floor-rising-obsidian-long-throw-alr-perforated-projector-screen', { projectorTypes: ['long'], sizes: [72,84,92,100,110,120,135,150], material: 'Perforated Obsidian Long-Throw ALR', direction: 'non_directional', acousticTransparent: true, alignmentMethods: ['centered','optical_shift'] }),
    product('s_3d', 's_3d_alr', 'S 3D ALR Floor Rising · High-Gain Long-Throw ALR', 'vividstorm-s-3d-alr-motorized-tension-floor-rising-3d-obsidian-long-throw-alrhigh-gain-projector-screen', { projectorTypes: ['long'], sizes: [72,84,92,100,110,120,135,150], material: '3D Obsidian Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'], recommendationEligible: true, intentionalExclusion: null }),
    product('titan_obsidian', 'titan', 'TITAN Floor Rising · Obsidian Long-Throw ALR', 'vividstorm-titan-motorized-tension-floor-rising-projector-screen', { projectorTypes: ['long'], sizes: [160,170,180,200], material: 'Obsidian Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered'], purchasableIdentity: 'titan:obsidian' }),
    product('titan_white', 'titan', 'TITAN Floor Rising · White Cinema', 'vividstorm-titan-motorized-tension-floor-rising-projector-screen', { projectorTypes: ['long'], sizes: [160,170,180,200], material: 'White Cinema', materialType: 'white', direction: 'non_directional', alignmentMethods: ['centered'], laserGuidance: 'lower_risk', purchasableIdentity: 'titan:white' }),
    product('alr_slimline', 'alr_slimline', 'ALR Slimline · Long-Throw ALR', 'vividstorm-alr-slimline-motorized-tension-obsidian-long-throw-alr-projector-screen', { installation: 'drop', projectorTypes: ['long'], sizes: [84,92,100,110,120,135,150,160,170,180], material: 'Obsidian Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'] }),
    product('alr_p_slimline', 'alr_slimline', 'ALR P Slimline · Acoustic Long-Throw ALR', 'vividstorm-alr-p-slimline-motorized-tension-obsidian-long-throw-alr-perforated-projector-screen', { installation: 'drop', projectorTypes: ['long'], sizes: [84,92,100,110,120], material: 'Perforated Obsidian Long-Throw ALR', direction: 'non_directional', acousticTransparent: true, alignmentMethods: ['centered','optical_shift'] }),
    product('alr_3d_slimline', 'alr_3d_slimline', '3D ALR Slimline · Long-Throw ALR', 'vividstorm-3d-alr-slimline-motorized-tension-3d-obsidian-long-throw-alr-projector-screen', { installation: 'drop', projectorTypes: ['long'], sizes: [84,92,100,110,120,135,150], material: '3D Obsidian Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'], status: 'unverified', availabilityLabel: 'Not found in current official catalog', availability: 'not_found_in_current_official_feed', recommendationEligible: false, intentionalExclusion: 'official_product_source_not_currently_available' }),
    product('phantom_long', 'phantom_long', 'PHANTOM Obsidian In-Ceiling · Long-Throw ALR', 'vividstorm-phantom-recessed-in-ceiling-motorized-tension-obsidian-long-throw-alr-projector-screen', { installation: 'ceiling', projectorTypes: ['long'], sizes: [72,84,92,100,110,120,135,150,160,170,180], material: 'Obsidian Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'] }),
    product('s_fusion', 's_fusion', 'S Fusion ALR Floor Rising · Enhanced Long-Throw ALR', 'vividstorm-s-fusion-alr-motorized-tension-floor-rising-enhanced-long-throw-alr-projector-screen', { projectorTypes: ['long'], sizes: [72,84,92,100,110,120], material: 'Enhanced Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'], availability: 'published_zero_sellable_variants', recommendationEligible: false, intentionalExclusion: 'no_sellable_variants_in_shopify_admin' }),
    product('fusion_slimline', 'fusion_slimline', 'Fusion ALR Slimline · Enhanced Long-Throw ALR', 'vividstorm-fusion-alr-slimline-motorized-tension-enhanced-long-throw-alr-projector-screen', { installation: 'drop', projectorTypes: ['long'], sizes: [72,84,92,100,110,120], material: 'Enhanced Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered','optical_shift'], availability: 'published_zero_sellable_variants', recommendationEligible: false, intentionalExclusion: 'no_sellable_variants_in_shopify_admin' }),
    product('fusion_fixed', 'fusion_fixed', 'Fusion ALR Fixed Frame · Long-Throw ALR', 'vividstorm-fusion-alr-fixed-frame-enhanced-long-throw-alr-projector-screen', { installation: 'frame', projectorTypes: ['long'], sizes: [100,120,130], material: 'Enhanced Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered'] }),
    product('obsidian_fixed', 'obsidian_fixed', 'Obsidian ALR Fixed Frame · Long-Throw ALR', 'vividstorm-alr-fixed-frame-obsidian-long-throw-projector-screen', { installation: 'frame', projectorTypes: ['long'], sizes: [100,120,130,150,170,180,200], material: 'Obsidian Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered'] }),
    product('obsidian_fixed_p', 'obsidian_fixed', 'Obsidian ALR Fixed Frame · Acoustic Long-Throw ALR', 'vividstorm-alr-fixed-frame-obsidian-long-throw-projector-screen', { installation: 'frame', projectorTypes: ['long'], sizes: [100,120,130,150,170,180,200], material: 'Perforated Obsidian Long-Throw ALR', direction: 'non_directional', acousticTransparent: true, alignmentMethods: ['centered'], purchasableIdentity: 'obsidian-fixed:perforated' }),
    product('lumiere', 'lumiere', 'LUMIERE Fresnel Fixed Frame · Long-Throw ALR', 'vividstorm-lumiere-fixed-frame-fresnel-long-throw-alr-projector-screen', { installation: 'frame', projectorTypes: ['long'], sizes: [100], material: 'Fresnel Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered'], status: 'preorder', availabilityLabel: 'Pre-order · 100-inch currently selectable', availability: 'published_preorder_partial', preorder: true }),

    product('duraplus', 'duraplus', 'DuraPlus Motorized Outdoor Screen', 'vividstorm-duraplus-weatherproof-motorized-outdoor-projector-screen', { installation:'drop', projectorTypes: ['ust','long'], locations: ['covered_outdoor'], outdoorUseRequirements: Object.freeze({ shelterRequired:true, mountingRequirement:'betweenPosts' }), viewingConditions: ['outdoor_night'], sizes: [100,120,135,150,180,200], material: 'Outdoor White', materialType: 'outdoor_white', direction: 'non_directional', alignmentMethods: ['centered'], laserGuidance: 'unverified' }),

    product('silux_floor', 'silux_pro', 'Silux Pro Floor Rising · Fresnel UST ALR', 'vividstorm-silux-pro-motorized-floor-rising-fresnel-ust-alr-projector-screen', { sizes: [100,120], material: 'Fresnel UST ALR', status: 'preorder', availabilityLabel: 'Pre-order', availability: 'published_preorder', preorder: true, recommendationEligible: false, customerVisible: false, intentionalExclusion: 'pending_product_validation', laserGuidance: 'lower_risk' }),
    product('silicaflex_floor', 'silicaflex', 'SilicaFlex Floor Rising · Fresnel Long-Throw ALR', 'vividstorm-silicaflex-motorized-floor-rising-fresnel-long-throw-alr-projector-screen', { projectorTypes: ['long'], sizes: [100,120], material: 'Fresnel Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered'], status: 'preorder', availabilityLabel: 'Pre-order', availability: 'published_preorder', preorder: true, recommendationEligible: false, customerVisible: false, intentionalExclusion: 'pending_product_validation' }),
    product('silux_slimline', 'silux_pro', 'Slimline Silux Pro · Fresnel UST ALR', 'vividstorm-slimline-silux-pro-motorized-fresnel-ust-alr-projector-screen', { installation: 'drop', sizes: [100,120], material: 'Fresnel UST ALR', status: 'preorder', availabilityLabel: 'Pre-order', availability: 'published_preorder', preorder: true, recommendationEligible: false, customerVisible: false, intentionalExclusion: 'pending_product_validation', laserGuidance: 'lower_risk' }),
    product('silicaflex_slimline', 'silicaflex', 'Slimline SilicaFlex · Fresnel Long-Throw ALR', 'vividstorm-slimline-silicaflex-motorized-fresnel-long-throw-alr-projector-screen', { installation: 'drop', projectorTypes: ['long'], sizes: [100,120], material: 'Fresnel Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered'], status: 'preorder', availabilityLabel: 'Pre-order', availability: 'published_preorder', preorder: true, recommendationEligible: false, customerVisible: false, intentionalExclusion: 'pending_product_validation' }),
    product('silux_phantom', 'silux_pro', 'PHANTOM Silux Pro · Fresnel UST ALR', 'vividstorm-phantom-recessed-in-ceiling-silux-pro-motorized-fresnel-ust-alr-projector-screen', { installation: 'ceiling', sizes: [100,120], material: 'Fresnel UST ALR', status: 'preorder', availabilityLabel: 'Pre-order', availability: 'published_preorder', preorder: true, recommendationEligible: false, customerVisible: false, intentionalExclusion: 'pending_product_validation', laserGuidance: 'lower_risk' }),
    product('silicaflex_phantom', 'silicaflex', 'PHANTOM SilicaFlex · Fresnel Long-Throw ALR', 'vividstorm-phantom-recessed-in-ceiling-silicaflex-motorized-fresnel-long-throw-alr-projector-screen', { installation: 'ceiling', projectorTypes: ['long'], sizes: [100,120], material: 'Fresnel Long-Throw ALR', direction: 'non_directional', alignmentMethods: ['centered'], status: 'preorder', availabilityLabel: 'Pre-order', availability: 'published_preorder', preorder: true, recommendationEligible: false, customerVisible: false, intentionalExclusion: 'pending_product_validation' }),

    product('s_pro_plus', 's_pro_plus', 'S PRO Plus Floor Rising · 130-inch UST ALR', 'presale-vividstorm-130-s-pro-plus-motorized-tension-floor-rising-ust-alr-projector-screen', { sizes: [130], material: 'Black Grid UST ALR', plus: true, laserGuidance: 'moderate_risk' }),
    product('pro_plus', 'pro_plus', 'PRO Plus Slimline · 130-inch UST ALR', 'presale-vividstorm-130-pro-pro-a-pro-p-pro-pa-plus-slimline-motorized-tension-ust-alr-projector-screen', { installation: 'drop', sizes: [130], material: 'Black Grid UST ALR', plus: true, laserGuidance: 'moderate_risk' }),
    product('pro_a_plus', 'pro_plus', 'PRO A Plus Slimline · Reverse 130-inch UST ALR', 'presale-vividstorm-130-pro-pro-a-pro-p-pro-pa-plus-slimline-motorized-tension-ust-alr-projector-screen', { installation: 'drop', sizes: [130], material: 'Reverse Black Grid UST ALR', direction: 'above_inverted', plus: true, laserGuidance: 'moderate_risk', purchasableIdentity: 'pro-plus:a' }),
    product('pro_p_plus', 'pro_plus', 'PRO P Plus Slimline · Acoustic 130-inch UST ALR', 'presale-vividstorm-130-pro-pro-a-pro-p-pro-pa-plus-slimline-motorized-tension-ust-alr-projector-screen', { installation: 'drop', sizes: [130], material: 'Perforated Black Grid UST ALR', acousticTransparent: true, plus: true, laserGuidance: 'moderate_risk', purchasableIdentity: 'pro-plus:p' }),
    product('pro_pa_plus', 'pro_plus', 'PRO PA Plus Slimline · Reverse Acoustic 130-inch UST ALR', 'presale-vividstorm-130-pro-pro-a-pro-p-pro-pa-plus-slimline-motorized-tension-ust-alr-projector-screen', { installation: 'drop', sizes: [130], material: 'Perforated Reverse Black Grid UST ALR', direction: 'above_inverted', acousticTransparent: true, plus: true, laserGuidance: 'moderate_risk', purchasableIdentity: 'pro-plus:pa' }),
    product('clearance_phantom_pro_a_us', 'clearance_phantom', 'Clearance PHANTOM PRO A · US stock', 'duty-free-clearance-30-50-off-ships-from-arizona-warehouse-vividstorm-phantom-recessed-in-ceiling-slimline-motorized-tension-ust-projector-screen-classic-version-clearance', { installation: 'ceiling', sizes: [100], material: 'Reverse Black Grid UST ALR', direction: 'above_inverted', status: 'clearance', availabilityLabel: 'Clearance · US stock only', availability: 'limited_stock', clearance: true, region: 'US', recommendationEligible: false, intentionalExclusion: 'clearance_region_limited_not_default_eligible', laserGuidance: 'unverified' })
  ]);

  return Object.freeze({ products: PRODUCTS, legacyEntryCount: 28, officialSource: SOURCE, verifiedAt: VERIFIED_AT });
});

(function (root, factory) {
  var translations = factory();
  if (typeof module === 'object' && module.exports) module.exports = translations;
  root.ScreenFinderTranslations = translations;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var translations = {
    en: {
      langName:'English', finderLabel:'VIVIDSTORM SCREEN FINDER',
      introTitle:'Find the right screen for your projector and room.',
      introBody:'Tell us how your projector will be used. We’ll narrow the options to compatible VIVIDSTORM screens.',
      estimate:'Search your projector first, or use the clear manual path if you are not sure.',
      progress:'Step {current} of {total} · {label}',
      stepProjector:'Projector', stepLocation:'Location', stepViewingLight:'Viewing conditions', stepInstallation:'Installation',
      stepOrientation:'Projector position', stepAlignment:'Lens alignment', stepOffsetMethod:'Image alignment',
      stepSideViewing:'Seating angle', stepAudio:'Audio requirement', stepSize:'Target size', stepReview:'Review',
      projectorKicker:'01 / PROJECTOR', projectorTitle:'Which projector are you using?',
      projectorBody:'Search by brand or model. If you do not know it, choose the closest projector type below.',
      projectorLabel:'Projector model', projectorPlaceholder:'Try “AWOL 3500”', noProjector:'No verified model found. Check the spelling or continue with a manual choice.',
      chooseManual:'OR CONTINUE WITHOUT A MODEL', ust:'Ultra Short Throw / Laser TV', ustDesc:'Placed very close to the screen.',
      long:'Standard or Long-Throw Projector', longDesc:'Mounted or placed farther from the screen.',
      unknownProjector:'Portable, Short-Throw or Not Sure', unknownProjectorDesc:'We’ll identify what still needs confirmation.',
      verifiedModel:'Verified model record', typeOnly:'Projector type only', throwRatio:'Throw ratio', brightness:'Recorded brightness',
      brightnessSource:'The finder does not compare this number until its measurement unit and source are verified.', edit:'Edit', clear:'Clear',
      locationKicker:'LOCATION', locationTitle:'Where will you use the screen?', locationBody:'Location changes weather exposure and which product families are eligible.',
      indoor:'Indoor', indoorDesc:'Inside a home, office or other enclosed room.',
      coveredOutdoor:'Covered outdoor', coveredOutdoorDesc:'Outside, with a roof or reliable shelter from direct weather.',
      exposedOutdoor:'Exposed outdoor', exposedOutdoorDesc:'Outside where the screen may face direct weather.',
      notSureLocation:'Not sure', notSureLocationDesc:'Choose this if the final location or weather exposure is not decided.',
      viewingKicker:'VIEWING CONDITIONS', viewingTitle:'What lighting will you usually watch in?', viewingBody:'Choose the condition that best represents normal viewing. This is separate from location.',
      bright:'Daylight or room lights usually on', brightDesc:'Choose this when you often watch without fully darkening the room.',
      controlled:'Some ambient light, but controllable', controlledDesc:'You can dim lights or close shades for most viewing.',
      dark:'Mostly dark', darkDesc:'The room is usually darkened while the projector is in use.',
      outdoorNight:'Outdoor after sunset', outdoorNightDesc:'Viewing begins after daylight has faded.',
      outdoorMixed:'Mixed outdoor daylight and evening use', outdoorMixedDesc:'You expect both brighter daytime and evening viewing.',
      outdoorDaylight:'Outdoor during daylight', outdoorDaylightDesc:'Meaningful daylight requires a No Exact Match result rather than a normal compatibility claim.',
      notSureLight:'Not sure', notSureLightDesc:'We’ll keep the result provisional until the usual light level is known.',
      viewingNote:'Ambient light influences material guidance, but it does not override hard compatibility.',
      installationKicker:'INSTALLATION', installationTitle:'How should the screen be installed?', installationBody:'Choose the housing or frame style you actually plan to use.',
      floor:'Floor Rising', floorDesc:'Retracts into a low cabinet and rises when needed.',
      drop:'Wall / Ceiling Drop-Down', dropDesc:'Descends from a surface-mounted housing.',
      ceiling:'Recessed In-Ceiling', ceilingDesc:'The housing is concealed within the ceiling.',
      frame:'Fixed Frame', frameDesc:'A permanently tensioned screen mounted on the wall.',
      notSureInstallation:'Not sure', notSureInstallationDesc:'The result will show which installation detail still needs a decision.',
      orientationKicker:'PROJECTOR POSITION', orientationTitle:'Where is the UST projector relative to the screen?',
      orientationBody:'Directional UST material must face the projector correctly.',
      belowUpright:'Projector below the screen · upright', belowUprightDesc:'The projector sits below the image in its normal upright position.',
      aboveInverted:'Projector above the screen · ceiling-mounted and inverted', aboveInvertedDesc:'The projector is above the image and physically inverted.',
      notSureOrientation:'Not sure', notSureOrientationDesc:'We will not choose a directional technical variant until this is confirmed.',
      orientationNote:'Projector position changes the required material direction. Do not rotate directional material without product confirmation.',
      alignmentKicker:'LENS ALIGNMENT', alignmentTitle:'Will the projector lens be horizontally centered with the screen?',
      alignmentBody:'Off-center projection can change which materials are supported.',
      centered:'Yes, centered', centeredDesc:'The center of the lens lines up with the horizontal center of the image.',
      offCenter:'No', offCenterDesc:'The lens sits to the left or right of the screen center.',
      notSureAlignment:'Not sure', notSureAlignmentDesc:'Choose this if you have not confirmed the final projector position.',
      offsetKicker:'IMAGE ALIGNMENT', offsetTitle:'How is the off-center image aligned?', offsetBody:'Optical lens shift and digital keystone change the image in different ways.',
      opticalShift:'Optical horizontal lens shift', opticalShiftDesc:'The projector moves the image through its lens system without digitally reshaping it.',
      digitalKeystone:'Digital keystone or angled side projection', digitalKeystoneDesc:'The projector digitally reshapes the image or points toward the screen at an angle.',
      notSureOffset:'Not sure', notSureOffsetDesc:'A specialist should confirm the projector and material geometry.',
      offsetNote:'This answer matters because side-projection support is material- and product-specific.',
      sideViewingKicker:'SEATING ANGLE', sideViewingTitle:'How widely will people sit around the screen?', sideViewingBody:'Wide side viewing can rule out directional Fresnel materials.',
      sideViewingStandard:'Mostly near the center', sideViewingStandardDesc:'Most seats face the screen from a normal central viewing area.',
      sideViewingWide:'Frequent wide side viewing', sideViewingWideDesc:'People often watch from seats far to the left or right.',
      audioKicker:'OPTIONAL AUDIO REQUIREMENT', audioTitle:'Do you need a perforated screen configuration?', audioBody:'UST lower-border perforation and image-area perforation are different capabilities.',
      speakerNone:'No special speaker requirement', speakerNoneDesc:'Speakers are already outside the screen area, or audio placement does not affect the screen choice.',
      speakerLowerBorder:'Speakers behind the lower black-border area', speakerLowerBorderDesc:'For supported UST products, P refers to perforation associated with the lower black border—not the projected image area.',
      speakerImageArea:'Speakers behind the projected image area', speakerImageAreaDesc:'Requires verified image-area perforation. A lower-border-only UST P screen does not satisfy this requirement.',
      speakerMovable:'Speakers can be moved outside the screen area', speakerMovableDesc:'A non-perforated screen is compatible only if the speakers are moved before installation.',
      speakerAesthetic:'I prefer the perforated appearance', speakerAestheticDesc:'Perforated options may remain eligible even without a functional speaker requirement.',
      visible:'Outside the image area', visibleDesc:'Speakers remain visible beside, below or elsewhere in the room.',
      behind:'Behind the screen', behindDesc:'Only perforated or verified acoustically transparent variants are eligible.',
      notSureAudio:'Not sure', notSureAudioDesc:'We will not assume a standard or acoustic screen.',
      sizeKicker:'TARGET SIZE', sizeTitle:'What screen size are you considering?', sizeBody:'Choose the target diagonal. The choices below come from verified current product variants.',
      sizeUnit:'in', sizeOptionDesc:'Verified in at least one current product variant.',
      sizeUnknown:'Not sure yet', sizeUnknownDesc:'We’ll recommend a family only and ask you to confirm the exact variant.',
      reviewKicker:'REVIEW SETUP', reviewTitle:'Review your setup', reviewBody:'Nothing is submitted yet. Edit any answer, then request compatible screens.',
      projector:'Projector', projectorType:'Projector type', location:'Location', viewingLight:'Viewing conditions',
      installation:'Installation', orientation:'Projector position', alignment:'Lens alignment', offsetMethod:'Image alignment',
      sideViewing:'Seating angle', speakerRequirement:'Audio / perforation', audio:'Speakers', size:'Target size', reviewGuidance:'Unknown or unverified details remain visible and will lower confidence.',
      seeMatches:'SEE COMPATIBLE SCREENS',
      resultKicker:'YOUR SCREEN OPTIONS', resultTitle:'Recommendations based on your setup.',
      bestMatch:'Best Match', recommendedOption:'Recommended Option', compatibleAlternative:'Compatible Alternative', differentTradeoff:'Different Trade-off',
      betterBrightnessLowerCost:'Better for brightness and lower cost', betterOccasionalAmbientLight:'Better for occasional ambient light', betterAmbientLight:'Better for ambient light',
      betterLargerSizes:'Better for larger sizes', betterBrightnessGain:'Better for brightness gain', betterBlackLevelColor:'Better for black level and color',
      betterFrontalViewing:'Better for frontal viewing', requiresCustomConfiguration:'Requires a custom configuration', compatibleForSetup:'Compatible for this setup',
      quickCheckRole:'A Quick Compatibility Check Is Needed', noExact:'A quick compatibility check is needed',
      noExactBody:'Your confirmed answers do not map to an exact current variant. Review the details below or ask a screen specialist before ordering.',
      checkKnown:'What we already know', checkMissing:'What still needs confirmation', checkWhy:'Why it matters',
      confidence:'Confidence', confidenceHigh:'High · exact technical path confirmed', confidenceMedium:'Medium · one or more details still need confirmation',
      confidenceCheck:'Compatibility check required',
      confidenceProjectorModel:'Projector model not selected.', confidenceBrightnessUnit:'Projector brightness unit not verified.',
      confidenceAvailability:'Current availability needs confirmation.', confidenceCustomConfiguration:'Exact custom configuration needs confirmation.',
      confidenceTargetSize:'Target size needs confirmation.',
      family:'Screen family', technicalVariant:'Recommended configuration', compatibleSize:'Selected size', availability:'Availability',
      familyOnly:'Family-level recommendation · exact variant pending', variantPending:'To be confirmed after the target size is chosen',
      whyFits:'Why it fits', mainTradeoff:'Main trade-off', confirmBefore:'Confirm before ordering',
      viewProduct:'View Product', askSpecialist:'Ask a Screen Specialist', editSetup:'Edit Setup', startOver:'Start Over', viewOption:'View option',
      otherOptions:'Other compatible options', selectedSetup:'Your setup',
      whyBlackGridBelow:'Black Grid accepts UST projector light from below.', whyBlackGridAbove:'The inverted Black Grid configuration accepts UST projector light from above.',
      whyBlackGridAmbient:'Black Grid is suited to meaningful room light in its normal orientation.',
      whyWhiteCinema:'White Cinema prioritizes brightness and a lower price for lights-off viewing.',
      whyLiteHyper:'Lite Hyper is the verified domestic-grid family with its own size range.',
      whyLongThrowAlr:'Directional long-throw ALR supports stronger black level and color when the projector geometry is compatible.',
      whyLongThrow3dAlr:'High-gain 3D long-throw ALR supports brightness when the projector geometry is compatible.',
      whyFresnel:'Fresnel prioritizes frontal viewing performance.', whyOutdoor:'This screen family matches the selected outdoor exposure.',
      whySelectedSize:'The selected {size} size is available in this configuration.', whyTargetSizePending:'The exact size still needs confirmation.',
      whyInstallation:'The {installation} family matches the requested installation.',
      tradeoffBlackGridChoice:'S PRO has stronger performance positioning at a higher price. Lite Hyper is the domestic-grid alternative. White Cinema is brighter and lower cost, but intended for lights-off viewing.',
      status_active:'Available', status_preorder:'Pre-order', status_clearance:'Clearance', status_discontinued:'Discontinued',
      status_region_limited:'Region-limited', status_unverified:'Availability unverified', customConfiguration:'Custom configuration',
      warning_size_confirmation_required:'Choose a target size before ordering so the exact purchasable variant can be confirmed.',
      warning_brightness_units_unverified:'The projector database has a brightness number, but its measurement unit and source are not verified, so it was not used for comparison.',
      warning_brightness_units_incompatible:'The recorded brightness is not in verified ANSI lumens, so it was not compared with the approximate 2400 ANSI guidance.',
      warning_laser_material_confirmation:'RGB triple-laser behavior varies by material. Consider a material sample or ask a specialist about possible speckle.',
      warning_optical_shift_confirmation:'Confirm the planned lens-shift amount against the selected material and projector manual.',
      warning_side_projection_brightness_imbalance:'Side projection can create visible left-to-right brightness imbalance on directional ALR materials: the projector side may look brighter and the far side darker.',
      warning_digital_keystone_confirmation:'Digital keystone or angled side projection needs a geometry check; no material was assumed compatible.',
      warning_inverted_black_grid_no_overhead_rejection:'Inverted Black Grid accepts projector light from above, but inversion removes the material’s normal top-light rejection. Do not claim overhead ambient-light rejection for this orientation.',
      warning_outdoor_daylight_confirmation:'Outdoor daylight performance depends on image size, projector output and actual light exposure. Evening use is the safer confirmed condition.',
      outdoorAfterSunsetCheck:'Confirm whether viewing will be mainly after sunset',
      warning_preorder_status:'One or more compatible options are currently shown as pre-order.',
      changedNotice:'A changed answer cleared only the later answers that depended on it.',
      selectionRequired:'Choose an option before continuing.', resultsChanged:'Your setup changed. Review it again before generating results.',
      back:'Back', continue:'Continue', changeLanguage:'Change finder language', clearProjector:'Clear selected projector',
      editAnswer:'Edit {label}', openProductSearch:'Verified projector suggestions', selected:'Selected', contactFallback:'Contact a screen specialist',
      type_ust:'Ultra short throw / Laser TV', type_long:'Standard / long throw', type_unknown:'Portable, short-throw or not sure',
      loc_indoor:'Indoor', loc_covered_outdoor:'Covered outdoor', loc_exposed_outdoor:'Exposed outdoor', loc_not_sure:'Not sure',
      light_bright:'Daylight or room lights usually on', light_controlled:'Some ambient light, but controllable', light_dark:'Mostly dark',
      light_outdoor_night:'Outdoor after sunset', light_outdoor_mixed:'Mixed outdoor daylight and evening use', light_outdoor_daylight:'Outdoor during daylight', light_not_sure:'Not sure',
      install_floor:'Floor Rising', install_drop:'Wall / Ceiling Drop-Down', install_ceiling:'Recessed In-Ceiling', install_frame:'Fixed Frame', install_not_sure:'Not sure',
      orientation_below_upright:'Below the screen · upright', orientation_above_inverted:'Above the screen · inverted', orientation_not_sure:'Not sure',
      alignment_centered:'Centered', alignment_off_center:'Off-center', alignment_not_sure:'Not sure',
      offset_optical_shift:'Optical horizontal lens shift', offset_digital_keystone:'Digital keystone / angled projection', offset_not_sure:'Not sure',
      orientation_belowUpright:'Below the screen · upright', orientation_aboveInverted:'Above the screen · ceiling-mounted and inverted',
      side_viewing_standard:'Mostly near the center', side_viewing_wide:'Frequent wide side viewing',
      speaker_none:'No special speaker requirement', speaker_lowerBorderBehind:'Behind the lower black border', speaker_imageAreaBehind:'Behind the projected image area',
      speaker_movable:'Speakers can be moved outside the screen area', speaker_aestheticPreference:'Perforated appearance preferred', speaker_unknown:'Not sure',
      audio_visible:'Outside the image area', audio_behind:'Behind the screen', audio_not_sure:'Not sure',
      tradeoff_alr:'ALR performance depends on verified projector geometry and real room light.',
      tradeoff_white:'White material preserves a neutral path but needs stronger light control.',
      tradeoff_acoustic:'Acoustic transparency adds a perforated material layer and should be confirmed with your audio layout.',
      tradeoff_outdoor:'Outdoor compatibility does not guarantee a bright daytime image.',
      tradeoff_preorder:'This option is not regular in-stock inventory and may have a longer fulfillment window.',
      tradeoff_white_cinema:'Highest brightness and lower price in a dark room; it is not the normal choice when meaningful ambient light is present.',
      tradeoff_black_grid:'Stronger black level and color with light-on flexibility, at a higher price and with a 130-inch raw-material limit.',
      tradeoff_lite_hyper:'Lite Hyper has its own verified size range and can cover sizes where Black Grid is unavailable; compare its image and price role for the room.',
      tradeoff_long_throw_alr:'Stronger black level and color reproduction than White Cinema, while sacrificing some brightness.',
      tradeoff_long_throw_3d_alr:'Higher gain supports brightness, while the lighter gray base gives weaker color saturation and black level than standard long-throw ALR.',
      tradeoff_fresnel:'Strong frontal performance, but the narrower viewing behavior is not suitable for frequent wide side seating.',
      resultDisclaimer:'Recommendations are based on the details provided. Please confirm screen size, projector placement and speaker position before ordering.',
      confirm_availability:'Confirm the selected size and current availability on the product page.',
      confirm_size:'Confirm the exact diagonal size before choosing a purchasable variant.',
      confirm_laser:'Ask about a material sample or laser-speckle guidance for this projector.',
      confirm_alignment:'Confirm the lens position and supported shift with the projector manual.',
      confirm_preorder:'Confirm the current pre-order lead time before purchase.',
      humanReviewNote:'Chinese and Japanese copy is complete for functional review and still requires final review by a native-language product specialist.'
    },
    'zh-CN': {
      langName:'简体中文', finderLabel:'VIVIDSTORM 幕布选择器',
      introTitle:'为你的投影机和房间找到合适的幕布。',
      introBody:'告诉我们投影机的使用方式，我们会把范围缩小到兼容的 VIVIDSTORM 幕布。',
      estimate:'先搜索投影机；如果不确定，也可以使用清晰的手动路径继续。',
      progress:'第 {current} 步，共 {total} 步 · {label}',
      stepProjector:'投影机', stepLocation:'使用地点', stepViewingLight:'观看光线', stepInstallation:'安装方式',
      stepOrientation:'投影机位置', stepAlignment:'镜头对位', stepOffsetMethod:'画面对位', stepSideViewing:'观看角度', stepAudio:'音响需求', stepSize:'目标尺寸', stepReview:'确认',
      projectorKicker:'01 / 投影机', projectorTitle:'你使用哪一台投影机？', projectorBody:'按品牌或型号搜索。如果不知道，请在下方选择最接近的投影类型。',
      projectorLabel:'投影机型号', projectorPlaceholder:'例如“AWOL 3500”', noProjector:'没有找到已核验型号。请检查拼写，或使用手动选项继续。',
      chooseManual:'没有型号也可以继续', ust:'超短焦 / 激光电视', ustDesc:'放置在非常靠近幕布的位置。',
      long:'标准焦距或长焦投影机', longDesc:'吊装或放置在离幕布较远的位置。',
      unknownProjector:'便携式、短焦或不确定', unknownProjectorDesc:'我们会指出仍需确认的内容。',
      verifiedModel:'已核验型号记录', typeOnly:'仅确认投影类型', throwRatio:'投射比', brightness:'记录的亮度',
      brightnessSource:'在测量单位和来源得到核验前，选择器不会比较该数值。', edit:'修改', clear:'清除',
      locationKicker:'使用地点', locationTitle:'幕布将在哪里使用？', locationBody:'地点决定天气暴露程度以及哪些产品系列可选。',
      indoor:'室内', indoorDesc:'在住宅、办公室或其他封闭空间内。',
      coveredOutdoor:'有遮挡的户外', coveredOutdoorDesc:'在室外，但有屋顶或可靠遮挡，避免直接天气影响。',
      exposedOutdoor:'无遮挡的户外', exposedOutdoorDesc:'在室外，幕布可能直接面对天气影响。',
      notSureLocation:'不确定', notSureLocationDesc:'如果最终地点或天气暴露程度尚未决定，请选择此项。',
      viewingKicker:'观看光线', viewingTitle:'你通常在什么光线下观看？', viewingBody:'请选择最接近日常观看的条件。光线和地点是两个独立问题。',
      bright:'通常有日光或开着室内灯', brightDesc:'经常无法把房间完全变暗时请选择此项。',
      controlled:'有一些环境光，但可以控制', controlledDesc:'大多数时候可以调暗灯光或拉上窗帘。',
      dark:'大多较暗', darkDesc:'使用投影机时，房间通常会变暗。',
      outdoorNight:'日落后的户外', outdoorNightDesc:'在自然光减弱后开始观看。',
      outdoorMixed:'户外白天与夜晚混合使用', outdoorMixedDesc:'预计会在较亮的白天和夜晚都使用。',
      outdoorDaylight:'户外白天使用', outdoorDaylightDesc:'存在明显日光时应显示“无完全匹配”，而不是作出常规兼容承诺。',
      notSureLight:'不确定', notSureLightDesc:'在常用光线明确前，结果将保持为待确认。',
      viewingNote:'环境光会影响幕料建议，但不会覆盖硬性兼容条件。',
      installationKicker:'安装方式', installationTitle:'幕布计划怎样安装？', installationBody:'请选择你实际计划使用的外壳或框架形式。',
      floor:'地升式', floorDesc:'收纳在低位外壳中，需要时向上升起。',
      drop:'壁挂 / 吊装降落式', dropDesc:'从表面安装的外壳向下降落。',
      ceiling:'嵌入式天花幕', ceilingDesc:'外壳隐藏在天花内。',
      frame:'固定框架幕', frameDesc:'长期张紧并安装在墙面。',
      notSureInstallation:'不确定', notSureInstallationDesc:'结果会明确指出仍需决定的安装信息。',
      orientationKicker:'投影机位置', orientationTitle:'超短焦投影机位于幕布的什么位置？', orientationBody:'有方向性的超短焦幕料必须正确朝向投影机。',
      belowUpright:'投影机在幕布下方 · 正装', belowUprightDesc:'投影机位于画面下方，并保持正常正装姿态。',
      aboveInverted:'投影机在幕布上方 · 吊装并倒置', aboveInvertedDesc:'投影机位于画面上方，并且机身实际倒置。',
      notSureOrientation:'不确定', notSureOrientationDesc:'在位置明确前，我们不会选择有方向性的技术版本。',
      orientationNote:'投影机位置会改变所需的幕料方向。未经产品确认，请勿自行翻转有方向性的幕料。',
      alignmentKicker:'镜头对位', alignmentTitle:'投影机镜头会与幕布水平居中吗？', alignmentBody:'侧向偏移会改变部分幕料是否适用。',
      centered:'是，居中', centeredDesc:'镜头中心与画面水平方向的中心对齐。',
      offCenter:'不会居中', offCenterDesc:'镜头位于幕布中心的左侧或右侧。',
      notSureAlignment:'不确定', notSureAlignmentDesc:'如果最终投影机位置尚未确认，请选择此项。',
      offsetKicker:'画面对位', offsetTitle:'偏离中心的画面怎样对齐？', offsetBody:'光学镜头位移与数字梯形校正对画面的处理不同。',
      opticalShift:'光学水平镜头位移', opticalShiftDesc:'通过镜头系统移动画面，不以数字方式重塑画面。',
      digitalKeystone:'数字梯形校正或斜向侧投', digitalKeystoneDesc:'投影机以数字方式重塑画面，或以斜角朝向幕布。',
      notSureOffset:'不确定', notSureOffsetDesc:'需要由专家核对投影机与幕料的几何关系。',
      offsetNote:'该答案很重要，因为侧投支持取决于具体幕料和产品。',
      sideViewingKicker:'观看角度', sideViewingTitle:'观看座位会分布得多宽？', sideViewingBody:'经常从大侧角观看时，需要排除方向性较强的菲涅尔幕料。',
      sideViewingStandard:'主要在中间区域观看', sideViewingStandardDesc:'大多数座位从正常的中央观看区域面向幕布。',
      sideViewingWide:'经常从较大侧角观看', sideViewingWideDesc:'观看者经常坐在幕布明显偏左或偏右的位置。',
      audioKicker:'可选音响需求', audioTitle:'你是否需要打孔幕布配置？', audioBody:'超短焦下黑边打孔与画面区域打孔是两种不同能力。',
      speakerNone:'没有特殊音响需求', speakerNoneDesc:'音响已在幕布区域之外，或音响位置不会影响幕布选择。',
      speakerLowerBorder:'音响在下方黑边区域后面', speakerLowerBorderDesc:'对支持的超短焦产品，P 指与下方黑边相关的打孔，而不是整个投影画面区域。',
      speakerImageArea:'音响在投影画面区域后面', speakerImageAreaDesc:'需要已核验的画面区域打孔；仅下黑边打孔的超短焦 P 幕不满足此需求。',
      speakerMovable:'音响可以移到幕布区域之外', speakerMovableDesc:'只有在安装前把音响移出画面区域时，非打孔幕布才兼容。',
      speakerAesthetic:'我偏好打孔外观', speakerAestheticDesc:'即使没有功能性音响需求，打孔版本仍可作为外观偏好保留。',
      visible:'在画面区域之外', visibleDesc:'音响保持在幕布侧面、下方或房间其他位置。',
      behind:'在幕布后方', behindDesc:'只有打孔或已核验为声学透声的版本才可选。',
      notSureAudio:'不确定', notSureAudioDesc:'我们不会擅自假设标准幕或透声幕。',
      sizeKicker:'目标尺寸', sizeTitle:'你正在考虑多大的幕布？', sizeBody:'请选择对角线尺寸。以下选项来自已核验的当前商品版本。',
      sizeUnit:'英寸', sizeOptionDesc:'至少有一个当前商品版本支持该尺寸。',
      sizeUnknown:'暂不确定', sizeUnknownDesc:'我们只会推荐产品系列，并要求你确认具体版本。',
      reviewKicker:'确认配置', reviewTitle:'检查你的配置', reviewBody:'目前尚未提交。你可以修改任何答案，然后查看兼容幕布。',
      projector:'投影机', projectorType:'投影类型', location:'使用地点', viewingLight:'观看光线', installation:'安装方式',
      orientation:'投影机位置', alignment:'镜头对位', offsetMethod:'画面对位', sideViewing:'观看角度', speakerRequirement:'音响 / 打孔需求', audio:'音响', size:'目标尺寸',
      reviewGuidance:'未知或未经核验的细节会保持可见，并降低结果置信度。', seeMatches:'查看兼容幕布',
      resultKicker:'你的幕布选项', resultTitle:'根据你的配置给出的建议。',
      bestMatch:'最佳匹配', recommendedOption:'推荐选项', compatibleAlternative:'兼容替代', differentTradeoff:'不同取舍',
      betterBrightnessLowerCost:'更适合追求亮度和较低价格', betterOccasionalAmbientLight:'更适合偶尔开灯观看', betterAmbientLight:'更适合有环境光的房间',
      betterLargerSizes:'更适合较大尺寸', betterBrightnessGain:'更适合提升亮度', betterBlackLevelColor:'更适合黑位和色彩表现',
      betterFrontalViewing:'更适合正面观看', requiresCustomConfiguration:'需要定制配置', compatibleForSetup:'兼容当前配置',
      quickCheckRole:'需要快速检查兼容性', noExact:'需要快速检查兼容性',
      noExactBody:'已确认的答案暂时无法对应到一个精确的当前版本。下单前请检查下列细节或咨询幕布专家。',
      checkKnown:'已经确认', checkMissing:'仍需确认', checkWhy:'为什么重要',
      confidence:'置信度', confidenceHigh:'高 · 已确认精确技术路径', confidenceMedium:'中 · 仍有一项或多项需要确认', confidenceCheck:'需要检查兼容性',
      confidenceProjectorModel:'尚未选择投影机型号。', confidenceBrightnessUnit:'投影机亮度单位尚未核验。', confidenceAvailability:'当前可售状态需要确认。',
      confidenceCustomConfiguration:'具体定制配置需要确认。', confidenceTargetSize:'目标尺寸需要确认。',
      family:'屏幕系列', technicalVariant:'推荐配置', compatibleSize:'已选尺寸', availability:'可售状态',
      familyOnly:'系列级建议 · 具体版本待确认', variantPending:'选择目标尺寸后再确认具体技术版本',
      whyFits:'为什么合适', mainTradeoff:'主要取舍', confirmBefore:'下单前确认',
      viewProduct:'查看商品', askSpecialist:'咨询幕布专家', editSetup:'修改配置', startOver:'重新开始', viewOption:'查看选项',
      otherOptions:'其他兼容选项', selectedSetup:'你的配置',
      whyBlackGridBelow:'Black Grid 可接收来自下方的超短焦投影光。', whyBlackGridAbove:'倒装 Black Grid 配置可接收来自上方的超短焦投影光。',
      whyBlackGridAmbient:'正常方向的 Black Grid 适合有明显室内环境光的场景。',
      whyWhiteCinema:'White Cinema 以更高亮度和较低价格服务于关灯观看。', whyLiteHyper:'Lite Hyper 是已核验的国产格栅系列，并使用其独立尺寸范围。',
      whyLongThrowAlr:'在投影几何条件兼容时，方向性长焦 ALR 可提供更强的黑位和色彩表现。',
      whyLongThrow3dAlr:'在投影几何条件兼容时，高增益 3D 长焦 ALR 可提升画面亮度。',
      whyFresnel:'Fresnel 更重视正面观看表现。', whyOutdoor:'该屏幕系列符合所选户外暴露条件。',
      whySelectedSize:'此配置提供已选的 {size} 尺寸。', whyTargetSizePending:'具体目标尺寸仍需确认。', whyInstallation:'{installation} 系列符合所选安装方式。',
      tradeoffBlackGridChoice:'S PRO 定位于更强画面表现，价格也更高；Lite Hyper 是国产格栅替代方案；White Cinema 更亮、价格更低，但主要面向关灯观看。',
      status_active:'可购买', status_preorder:'预订', status_clearance:'清仓', status_discontinued:'已停产',
      status_region_limited:'地区限定', status_unverified:'可售状态未核验', customConfiguration:'定制配置',
      warning_size_confirmation_required:'下单前请选择目标尺寸，以便确认具体可购买版本。',
      warning_brightness_units_unverified:'投影机数据库含有亮度数值，但测量单位与来源尚未核验，因此本次没有进行数值比较。',
      warning_brightness_units_incompatible:'记录的亮度不是已核验的 ANSI 流明，因此没有与约 2400 ANSI 的经验参考比较。',
      warning_laser_material_confirmation:'三色激光在不同幕料上的表现不同。建议索取幕料样品，或向专家确认可能的散斑。',
      warning_optical_shift_confirmation:'请结合投影机说明书，确认计划的镜头位移量以及幕料是否支持。',
      warning_side_projection_brightness_imbalance:'侧投会让方向性抗光幕出现明显的左右亮度不均：靠近投影机的一侧可能更亮，远侧可能更暗。',
      warning_digital_keystone_confirmation:'数字梯形校正或斜向侧投需要检查几何关系；系统没有假设任何幕料兼容。',
      warning_inverted_black_grid_no_overhead_rejection:'倒装 Black Grid 可接收来自上方的投影光，但倒装会完全失去材料原本的顶部环境光抑制功能；此方向不能宣称可抑制顶部环境光。',
      warning_outdoor_daylight_confirmation:'户外白天效果取决于画面尺寸、投影输出与实际光照；日落后使用是更稳妥的已确认条件。',
      outdoorAfterSunsetCheck:'请确认是否主要在日落后观看',
      warning_preorder_status:'一个或多个兼容选项目前标记为预订。',
      changedNotice:'修改答案后，系统只清除了依赖它的后续答案。',
      selectionRequired:'请先选择一个选项再继续。', resultsChanged:'配置已变化，请再次检查后生成结果。',
      back:'返回', continue:'继续', changeLanguage:'切换选择器语言', clearProjector:'清除已选投影机',
      editAnswer:'修改{label}', openProductSearch:'已核验投影机建议', selected:'已选择', contactFallback:'联系幕布专家',
      type_ust:'超短焦 / 激光电视', type_long:'标准焦距 / 长焦', type_unknown:'便携式、短焦或不确定',
      loc_indoor:'室内', loc_covered_outdoor:'有遮挡的户外', loc_exposed_outdoor:'无遮挡的户外', loc_not_sure:'不确定',
      light_bright:'通常有日光或开灯', light_controlled:'有一些可控环境光', light_dark:'大多较暗',
      light_outdoor_night:'日落后的户外', light_outdoor_mixed:'户外白天与夜晚混合使用', light_outdoor_daylight:'户外白天使用', light_not_sure:'不确定',
      install_floor:'地升式', install_drop:'壁挂 / 吊装降落式', install_ceiling:'嵌入式天花幕', install_frame:'固定框架幕', install_not_sure:'不确定',
      orientation_below_upright:'幕布下方 · 正装', orientation_above_inverted:'幕布上方 · 倒装', orientation_not_sure:'不确定',
      alignment_centered:'居中', alignment_off_center:'不居中', alignment_not_sure:'不确定',
      offset_optical_shift:'光学水平镜头位移', offset_digital_keystone:'数字梯形校正 / 斜向侧投', offset_not_sure:'不确定',
      orientation_belowUpright:'幕布下方 · 正装', orientation_aboveInverted:'幕布上方 · 吊装并倒置',
      side_viewing_standard:'主要在中间区域观看', side_viewing_wide:'经常从较大侧角观看',
      speaker_none:'没有特殊音响需求', speaker_lowerBorderBehind:'音响在下方黑边区域后面', speaker_imageAreaBehind:'音响在投影画面区域后面',
      speaker_movable:'音响可以移到幕布区域之外', speaker_aestheticPreference:'偏好打孔外观', speaker_unknown:'不确定',
      audio_visible:'画面区域之外', audio_behind:'幕布后方', audio_not_sure:'不确定',
      tradeoff_alr:'抗光效果取决于已核验的投影几何关系与真实房间光线。',
      tradeoff_white:'白幕提供中性显示路径，但需要更好的环境光控制。',
      tradeoff_acoustic:'透声版本增加了打孔幕料层，需要结合音响布局确认。',
      tradeoff_outdoor:'户外兼容并不等同于保证明亮的白天画面。',
      tradeoff_preorder:'该选项并非常规现货，交付时间可能更长。',
      tradeoff_white_cinema:'在暗室中亮度最高、价格较低；存在明显环境光时，它不是常规首选。',
      tradeoff_black_grid:'以更高价格换取更强黑位、色彩和开灯灵活性，同时受 130 英寸原材料硬上限限制。',
      tradeoff_lite_hyper:'Lite Hyper 使用独立的已核验尺寸范围，可覆盖 Black Grid 不可用的尺寸；仍需结合房间比较画质和价格定位。',
      tradeoff_long_throw_alr:'相较白幕提供更强黑位和色彩表现，但会牺牲一部分亮度。',
      tradeoff_long_throw_3d_alr:'更高增益有助于亮度，但较浅灰的幕基使色彩饱和度和黑位通常弱于标准长焦抗光幕。',
      tradeoff_fresnel:'正面观看表现强，但较窄的观看特性不适合经常从大侧角观看。',
      resultDisclaimer:'建议基于你提供的信息。下单前请确认幕布尺寸、投影机位置和音响位置。',
      confirm_availability:'请在商品页确认所选尺寸与当前可售状态。', confirm_size:'请先确认精确对角线尺寸，再选择可购买版本。',
      confirm_laser:'请为该投影机确认幕料样品或激光散斑指导。', confirm_alignment:'请结合投影机说明书确认镜头位置与支持的位移范围。',
      confirm_preorder:'购买前请确认当前预订交期。',
      humanReviewNote:'中文与日文文案已完成，可以进行功能审核，最终仍需由母语产品专家复核。'
    },
    ja: {
      langName:'日本語', finderLabel:'VIVIDSTORM スクリーンファインダー',
      introTitle:'プロジェクターとお部屋に合うスクリーンを見つけます。',
      introBody:'プロジェクターの使用条件を教えてください。適合する VIVIDSTORM スクリーンに候補を絞ります。',
      estimate:'まずプロジェクターを検索してください。不明な場合は、分かりやすい手動ルートで続行できます。',
      progress:'ステップ {current} / {total} · {label}',
      stepProjector:'プロジェクター', stepLocation:'使用場所', stepViewingLight:'視聴時の明るさ', stepInstallation:'設置方式',
      stepOrientation:'プロジェクター位置', stepAlignment:'レンズ位置', stepOffsetMethod:'画像位置調整', stepSideViewing:'視聴角度', stepAudio:'音響要件', stepSize:'希望サイズ', stepReview:'確認',
      projectorKicker:'01 / プロジェクター', projectorTitle:'どのプロジェクターを使用しますか？', projectorBody:'ブランド名またはモデル名で検索してください。不明な場合は、下の最も近い方式を選んでください。',
      projectorLabel:'プロジェクターモデル', projectorPlaceholder:'例：「AWOL 3500」', noProjector:'確認済みモデルが見つかりません。入力を確認するか、手動選択で続行してください。',
      chooseManual:'モデルが不明でも続行', ust:'超短焦点 / レーザーテレビ', ustDesc:'スクリーンのすぐ近くに設置します。',
      long:'標準焦点またはロングスロー', longDesc:'スクリーンから離して設置、または天吊りします。',
      unknownProjector:'ポータブル、短焦点、または不明', unknownProjectorDesc:'追加確認が必要な項目を明示します。',
      verifiedModel:'確認済みモデル記録', typeOnly:'投写方式のみ確認', throwRatio:'投写比', brightness:'記録された明るさ',
      brightnessSource:'測定単位と出典を確認するまで、この数値は比較に使用しません。', edit:'編集', clear:'クリア',
      locationKicker:'使用場所', locationTitle:'スクリーンはどこで使用しますか？', locationBody:'使用場所によって、天候への露出と対象製品が変わります。',
      indoor:'屋内', indoorDesc:'住宅、オフィス、その他の屋内空間。',
      coveredOutdoor:'屋根のある屋外', coveredOutdoorDesc:'屋外ですが、屋根などで直接の天候から保護されます。',
      exposedOutdoor:'露出した屋外', exposedOutdoorDesc:'スクリーンが直接天候の影響を受ける可能性があります。',
      notSureLocation:'不明', notSureLocationDesc:'最終的な場所や天候への露出が未定の場合に選択します。',
      viewingKicker:'視聴時の明るさ', viewingTitle:'通常はどのような明るさで視聴しますか？', viewingBody:'普段の視聴条件に最も近いものを選択してください。使用場所とは別の質問です。',
      bright:'昼光または室内照明が通常点灯', brightDesc:'部屋を完全に暗くせずに視聴することが多い場合。',
      controlled:'周囲光はあるが調整可能', controlledDesc:'多くの場合、照明を落としたりカーテンを閉めたりできます。',
      dark:'ほぼ暗い', darkDesc:'プロジェクター使用中は通常、部屋を暗くします。',
      outdoorNight:'日没後の屋外', outdoorNightDesc:'自然光が弱くなってから視聴します。',
      outdoorMixed:'屋外の昼間と夜間の両方', outdoorMixedDesc:'明るい昼間と夜間の両方で使用する予定です。',
      outdoorDaylight:'屋外の昼間', outdoorDaylightDesc:'明確な昼光がある場合は通常の適合案内ではなく「完全一致なし」と表示します。',
      notSureLight:'不明', notSureLightDesc:'通常の明るさが分かるまで、結果は暫定扱いになります。',
      viewingNote:'周囲光は素材の案内に影響しますが、必須の適合条件を上書きしません。',
      installationKicker:'設置方式', installationTitle:'スクリーンをどのように設置しますか？', installationBody:'実際に予定しているケースまたはフレーム方式を選択してください。',
      floor:'フロアライジング', floorDesc:'低いケースに収納し、使用時に上昇します。',
      drop:'壁掛け / 天吊りドロップダウン', dropDesc:'表面設置ケースから下降します。',
      ceiling:'天井埋込型', ceilingDesc:'ケースを天井内に隠します。',
      frame:'固定フレーム', frameDesc:'壁面に常設するテンションスクリーンです。',
      notSureInstallation:'不明', notSureInstallationDesc:'未決定の設置条件を結果で明示します。',
      orientationKicker:'プロジェクター位置', orientationTitle:'USTプロジェクターはスクリーンのどこにありますか？', orientationBody:'方向性のあるUST素材は、プロジェクターへ正しく向ける必要があります。',
      belowUpright:'スクリーン下部 · 正立', belowUprightDesc:'プロジェクターは映像の下にあり、通常の向きで設置します。',
      aboveInverted:'スクリーン上部 · 天吊り反転', aboveInvertedDesc:'プロジェクターは映像の上にあり、本体を反転して設置します。',
      notSureOrientation:'不明', notSureOrientationDesc:'位置を確認するまで、方向性のある技術バリエーションは選びません。',
      orientationNote:'プロジェクター位置によって必要な素材方向が変わります。製品確認なしに方向性素材を反転しないでください。',
      alignmentKicker:'レンズ位置', alignmentTitle:'プロジェクターレンズはスクリーンの左右中央にありますか？', alignmentBody:'中心から外れた投写では、対応素材が変わる場合があります。',
      centered:'はい、中央', centeredDesc:'レンズ中心が映像の左右中央に合っています。',
      offCenter:'いいえ', offCenterDesc:'レンズがスクリーン中央より左または右にあります。',
      notSureAlignment:'不明', notSureAlignmentDesc:'最終的なプロジェクター位置が未確認の場合。',
      offsetKicker:'画像位置調整', offsetTitle:'中心から外れた画像をどのように合わせますか？', offsetBody:'光学レンズシフトとデジタル台形補正は、異なる方法で画像を調整します。',
      opticalShift:'光学水平レンズシフト', opticalShiftDesc:'デジタル変形を使わず、レンズ機構で画像を移動します。',
      digitalKeystone:'デジタル台形補正または斜め投写', digitalKeystoneDesc:'画像をデジタル変形するか、スクリーンへ斜めに投写します。',
      notSureOffset:'不明', notSureOffsetDesc:'プロジェクターと素材の投写条件を専門スタッフが確認する必要があります。',
      offsetNote:'側方投写への対応は素材と製品ごとに異なるため、この回答が重要です。',
      sideViewingKicker:'視聴角度', sideViewingTitle:'座席はスクリーンに対してどの程度広く配置されますか？', sideViewingBody:'大きな横角度から頻繁に見る場合、指向性の強いフレネル素材は除外されます。',
      sideViewingStandard:'主に中央付近から視聴', sideViewingStandardDesc:'ほとんどの座席は通常の中央視聴範囲にあります。',
      sideViewingWide:'広い横角度から頻繁に視聴', sideViewingWideDesc:'スクリーンの左右に大きく外れた座席から頻繁に見ます。',
      audioKicker:'任意の音響要件', audioTitle:'パンチング仕様が必要ですか？', audioBody:'USTの下部黒枠パンチングと映像エリアのパンチングは異なる機能です。',
      speakerNone:'特別なスピーカー要件はない', speakerNoneDesc:'スピーカーはスクリーン外にあるか、配置がスクリーン選択に影響しません。',
      speakerLowerBorder:'下部黒枠エリアの背後にスピーカー', speakerLowerBorderDesc:'対応UST製品のPは下部黒枠に関連するパンチングで、投写映像エリア全体ではありません。',
      speakerImageArea:'投写映像エリアの背後にスピーカー', speakerImageAreaDesc:'確認済みの映像エリアパンチングが必要です。下部黒枠のみのUST Pでは満たせません。',
      speakerMovable:'スピーカーをスクリーン外へ移動できる', speakerMovableDesc:'設置前にスピーカーを映像エリア外へ移動する場合のみ、非パンチング素材が適合します。',
      speakerAesthetic:'パンチング外観を希望', speakerAestheticDesc:'機能的な音響要件がなくても、外観の好みとしてパンチング仕様を選べます。',
      visible:'映像エリアの外', visibleDesc:'スピーカーはスクリーン横、下、または別の位置に置きます。',
      behind:'スクリーン背面', behindDesc:'パンチングまたは音響透過が確認済みのバリエーションのみ対象です。',
      notSureAudio:'不明', notSureAudioDesc:'標準素材か音響透過素材かを推測しません。',
      sizeKicker:'希望サイズ', sizeTitle:'検討中のスクリーンサイズは？', sizeBody:'対角サイズを選択してください。以下は確認済みの現行商品バリエーションに基づきます。',
      sizeUnit:'インチ', sizeOptionDesc:'少なくとも1つの現行商品バリエーションで確認済みです。',
      sizeUnknown:'まだ不明', sizeUnknownDesc:'製品ファミリーのみ案内し、正確なバリエーションの確認をお願いします。',
      reviewKicker:'設定確認', reviewTitle:'設定を確認', reviewBody:'まだ送信されていません。回答を編集してから適合スクリーンを表示してください。',
      projector:'プロジェクター', projectorType:'投写方式', location:'使用場所', viewingLight:'視聴時の明るさ', installation:'設置方式',
      orientation:'プロジェクター位置', alignment:'レンズ位置', offsetMethod:'画像位置調整', sideViewing:'視聴角度', speakerRequirement:'音響 / パンチング要件', audio:'スピーカー', size:'希望サイズ',
      reviewGuidance:'不明または未確認の項目は表示されたままとなり、信頼度が下がります。', seeMatches:'適合スクリーンを見る',
      resultKicker:'スクリーン候補', resultTitle:'設定内容に基づく候補です。',
      bestMatch:'最適候補', recommendedOption:'推奨候補', compatibleAlternative:'適合する代替', differentTradeoff:'異なるトレードオフ',
      betterBrightnessLowerCost:'明るさと低価格を重視', betterOccasionalAmbientLight:'時々照明を点ける用途に適する', betterAmbientLight:'周囲光のある部屋に適する',
      betterLargerSizes:'大画面サイズに適する', betterBrightnessGain:'明るさのゲインを重視', betterBlackLevelColor:'黒表現と色再現を重視',
      betterFrontalViewing:'正面視聴を重視', requiresCustomConfiguration:'カスタム構成が必要', compatibleForSetup:'この構成に適合',
      quickCheckRole:'簡単な適合確認が必要です', noExact:'簡単な適合確認が必要です',
      noExactBody:'確認済みの回答から、現行の正確なバリエーションを特定できません。注文前に以下を確認するか、専門スタッフへご相談ください。',
      checkKnown:'確認済みの内容', checkMissing:'追加確認が必要な内容', checkWhy:'確認が必要な理由',
      confidence:'信頼度', confidenceHigh:'高 · 正確な技術条件を確認済み', confidenceMedium:'中 · 1項目以上の確認が必要', confidenceCheck:'適合確認が必要',
      confidenceProjectorModel:'プロジェクター型番が選択されていません。', confidenceBrightnessUnit:'プロジェクターの明るさ単位が未確認です。',
      confidenceAvailability:'現在の販売状況を確認してください。', confidenceCustomConfiguration:'正確なカスタム構成の確認が必要です。', confidenceTargetSize:'希望サイズの確認が必要です。',
      family:'スクリーンファミリー', technicalVariant:'推奨構成', compatibleSize:'選択サイズ', availability:'販売状況',
      familyOnly:'ファミリー単位の候補 · 正確なバリエーションは未確定', variantPending:'希望サイズを選択した後に技術バリエーションを確定',
      whyFits:'適合する理由', mainTradeoff:'主なトレードオフ', confirmBefore:'注文前の確認',
      viewProduct:'商品を見る', askSpecialist:'専門スタッフに相談', editSetup:'設定を編集', startOver:'最初からやり直す', viewOption:'候補を見る',
      otherOptions:'その他の適合候補', selectedSetup:'設定内容',
      whyBlackGridBelow:'Black Gridは下方からの超短焦プロジェクター光を受けます。', whyBlackGridAbove:'反転したBlack Grid構成は上方からの超短焦プロジェクター光を受けます。',
      whyBlackGridAmbient:'通常向きのBlack Gridは、室内光がある環境に適しています。',
      whyWhiteCinema:'White Cinemaは消灯視聴での明るさと低価格を優先します。', whyLiteHyper:'Lite Hyperは、独自のサイズ範囲を持つ確認済みの国内グリッド製品です。',
      whyLongThrowAlr:'投写条件が適合する場合、指向性の長焦点ALRはより深い黒と色再現を提供します。',
      whyLongThrow3dAlr:'投写条件が適合する場合、高ゲイン3D長焦点ALRは明るさを補います。',
      whyFresnel:'Fresnelは正面視聴性能を優先します。', whyOutdoor:'このスクリーンファミリーは選択した屋外環境に適合します。',
      whySelectedSize:'選択した{size}サイズはこの構成で利用できます。', whyTargetSizePending:'正確な希望サイズの確認が必要です。', whyInstallation:'{installation}ファミリーは希望する設置方式に適合します。',
      tradeoffBlackGridChoice:'S PROは高性能で価格も高めです。Lite Hyperは国内グリッドの代替候補です。White Cinemaはより明るく低価格ですが、消灯視聴向けです。',
      status_active:'購入可能', status_preorder:'予約注文', status_clearance:'クリアランス', status_discontinued:'販売終了',
      status_region_limited:'地域限定', status_unverified:'販売状況未確認', customConfiguration:'カスタム構成',
      warning_size_confirmation_required:'注文前に希望サイズを選び、正確な購入可能バリエーションを確認してください。',
      warning_brightness_units_unverified:'データベースに明るさの数値がありますが、測定単位と出典が未確認のため、比較には使用していません。',
      warning_brightness_units_incompatible:'記録値は確認済みのANSIルーメンではないため、約2400 ANSIの経験的目安とは比較していません。',
      warning_laser_material_confirmation:'RGB三色レーザーの挙動は素材によって異なります。素材サンプルまたはスペックルの可能性を専門スタッフにご確認ください。',
      warning_optical_shift_confirmation:'予定しているレンズシフト量を、選択素材とプロジェクター取扱説明書で確認してください。',
      warning_side_projection_brightness_imbalance:'横方向から投写すると、指向性ALR素材で左右の明るさに目立つ差が生じ、プロジェクター側が明るく、反対側が暗く見えることがあります。',
      warning_digital_keystone_confirmation:'デジタル台形補正または斜め投写は投写条件の確認が必要です。対応素材を推測していません。',
      warning_inverted_black_grid_no_overhead_rejection:'Black Gridを反転すると上方からの投写光を受けられますが、通常の上方光除去機能は完全に失われます。この向きでは天井側の環境光を除去できるとは案内しません。',
      warning_outdoor_daylight_confirmation:'屋外昼間の見え方は画面サイズ、プロジェクター出力、実際の明るさに左右されます。日没後の使用がより確実な条件です。',
      outdoorAfterSunsetCheck:'視聴が主に日没後かどうかを確認してください',
      warning_preorder_status:'1つ以上の適合候補が予約注文として表示されています。',
      changedNotice:'回答の変更により、その回答に依存する後続項目のみクリアしました。',
      selectionRequired:'続行する前に選択してください。', resultsChanged:'設定が変更されました。候補を表示する前に再確認してください。',
      back:'戻る', continue:'次へ', changeLanguage:'ファインダーの言語を変更', clearProjector:'選択したプロジェクターをクリア',
      editAnswer:'{label}を編集', openProductSearch:'確認済みプロジェクター候補', selected:'選択済み', contactFallback:'専門スタッフに連絡',
      type_ust:'超短焦点 / レーザーテレビ', type_long:'標準焦点 / ロングスロー', type_unknown:'ポータブル、短焦点、または不明',
      loc_indoor:'屋内', loc_covered_outdoor:'屋根のある屋外', loc_exposed_outdoor:'露出した屋外', loc_not_sure:'不明',
      light_bright:'昼光または室内照明あり', light_controlled:'調整可能な周囲光あり', light_dark:'ほぼ暗い',
      light_outdoor_night:'日没後の屋外', light_outdoor_mixed:'屋外の昼間と夜間の両方', light_outdoor_daylight:'屋外の昼間', light_not_sure:'不明',
      install_floor:'フロアライジング', install_drop:'壁掛け / 天吊りドロップダウン', install_ceiling:'天井埋込型', install_frame:'固定フレーム', install_not_sure:'不明',
      orientation_below_upright:'下部 · 正立', orientation_above_inverted:'上部 · 反転', orientation_not_sure:'不明',
      alignment_centered:'中央', alignment_off_center:'中心から外れる', alignment_not_sure:'不明',
      offset_optical_shift:'光学水平レンズシフト', offset_digital_keystone:'デジタル台形補正 / 斜め投写', offset_not_sure:'不明',
      orientation_belowUpright:'スクリーン下部 · 正立', orientation_aboveInverted:'スクリーン上部 · 天吊り反転',
      side_viewing_standard:'主に中央付近から視聴', side_viewing_wide:'広い横角度から頻繁に視聴',
      speaker_none:'特別なスピーカー要件はない', speaker_lowerBorderBehind:'下部黒枠エリアの背後', speaker_imageAreaBehind:'投写映像エリアの背後',
      speaker_movable:'スピーカーをスクリーン外へ移動可能', speaker_aestheticPreference:'パンチング外観を希望', speaker_unknown:'不明',
      audio_visible:'映像エリアの外', audio_behind:'スクリーン背面', audio_not_sure:'不明',
      tradeoff_alr:'ALR性能は、確認済みの投写条件と実際の室内光に左右されます。',
      tradeoff_white:'ホワイト素材はニュートラルな表示経路ですが、より強い遮光が必要です。',
      tradeoff_acoustic:'音響透過素材にはパンチング層があり、スピーカー配置との確認が必要です。',
      tradeoff_outdoor:'屋外対応は、明るい昼間の映像を保証するものではありません。',
      tradeoff_preorder:'通常在庫ではないため、納期が長くなる場合があります。',
      tradeoff_white_cinema:'暗室では最も高い明るさと低価格が利点ですが、意味のある周囲光がある場合の通常候補ではありません。',
      tradeoff_black_grid:'高価格と130インチの素材上限との引き換えに、黒表現、色、照明点灯時の柔軟性を高めます。',
      tradeoff_lite_hyper:'Lite Hyperは独自の確認済みサイズ範囲を持ち、Black Gridがないサイズを補えます。部屋に応じて画質と価格の役割を比較してください。',
      tradeoff_long_throw_alr:'ホワイトシネマより黒表現と色再現に優れますが、一部の明るさを犠牲にします。',
      tradeoff_long_throw_3d_alr:'高ゲインは明るさを補いますが、明るいグレー基材のため色の彩度と黒表現は標準ロングスローALRより弱くなります。',
      tradeoff_fresnel:'正面性能は高い一方、視野特性が狭く、広い横角度から頻繁に見る用途には適しません。',
      resultDisclaimer:'推奨は入力内容に基づきます。注文前にスクリーンサイズ、プロジェクター位置、スピーカー位置をご確認ください。',
      confirm_availability:'商品ページで選択サイズと現在の販売状況を確認してください。', confirm_size:'購入可能バリエーションを選ぶ前に、正確な対角サイズを確認してください。',
      confirm_laser:'このプロジェクター向けの素材サンプルまたはスペックル案内を確認してください。',
      confirm_alignment:'プロジェクター取扱説明書でレンズ位置と対応シフト量を確認してください。',
      confirm_preorder:'購入前に現在の予約納期を確認してください。',
      humanReviewNote:'中国語と日本語の文言は機能レビュー用に完備していますが、最終的には各言語の製品専門家による確認が必要です。'
    }
  };
  Object.assign(translations["en"], {"sizeHelper": "Help me choose a size", "viewingDistance": "Eyes to screen", "roomWidth": "Available width", "measurementUnit": "Units", "metres": "Metres", "feet": "Feet", "calculateSize": "Calculate guide", "clearMeasurements": "Clear measurements", "measureHelp": "Optional: enter your seated viewing distance and the clear width available for the screen. Leave either blank if unknown.", "measureInvalid": "Enter a positive measurement up to 30 m / 98 ft, or leave it blank.", "sizeSuggested": "Suggested starting point: {size} inches", "sizeReference": "A 36° viewing angle is a comfort reference, not a requirement. Choose smaller for a calmer view or larger for more immersion.", "sizeNoSpace": "No listed screen size fits the entered width. Check your measurement or ask our team.", "imageWidth": "Image width (W)", "overallWidth": "Overall width (L)", "widthPending": "Confirm the housing and mounting width before ordering.", "widthNote": "W is the picture width. The housing is wider; space for the projector and installation must also be checked.", "currentPrice": "Current configuration price", "priceLoading": "Checking current price and availability…", "priceUnavailable": "Live price could not be verified. Confirm this configuration with our team or on the product page.", "priceScope": "Price for this size and housing in the current store currency. Discounts, shipping and tax are confirmed at checkout.", "liveAvailable": "Available to order", "liveSoldOut": "Currently unavailable to order", "housing": "Housing colour", "housing_Black": "Black", "housing_White": "White", "viewConfiguration": "View this configuration", "viewProductDetails": "View product details", "retryPrice": "Refresh prices", "comparison": "Compare the same size", "comparisonNote": "Prices use the selected size and housing shown on each card. Materials and features differ.", "priceDifference": "{amount} {direction} than {product} · same size and housing", "priceLess": "less", "priceMore": "more", "priceEqual": "Same price as {product} · same size and housing", "copySetup": "Copy my setup", "copiedSetup": "Setup copied. Paste it into chat or email.", "copyFailed": "Copy unavailable. Your setup is shown above; you can select and copy it.", "emailSupport": "Email our team", "supportHelp": "Need help? Copy your setup for chat, or open an email draft with your answers.", "noExactTitle": "No exact match for this setup", "checkTitle": "Let’s confirm your setup", "possibleOptions": "Possible options to confirm", "explain_outdoor_daylight": "We do not recommend these screens for outdoor daylight viewing.", "explain_room_width": "The selected size exceeds the available width for the matching screens.", "explain_constraints_no_match": "No verified option meets all of these requirements. Our team can check the alternatives with you.", "warning_white_room_light_sensitive": "Room lighting affects white-screen picture quality. Dim the lights while watching; ask our team if your room needs a closer check.", "warning_live_product_confirmation": "Current price and availability are checked separately for your exact configuration.", "warning_width_confirmation": "Housing width is not verified for every option. Check the installation dimensions before ordering.", "resultTitle": "Your screen options.", "recommendedOption": "A suitable option", "introTitle": "A screen that fits your projector. And your room.", "introBody": "Start with your projector. Choose your viewing conditions and size, then compare suitable options and their current prices.", "sizeBody": "Choose a diagonal size, or use the distance and width guide below. You can change it before ordering."});
  Object.assign(translations["zh-CN"], {"sizeHelper": "帮我选尺寸", "viewingDistance": "眼睛到幕面的距离", "roomWidth": "可用宽度", "measurementUnit": "单位", "metres": "米", "feet": "英尺", "calculateSize": "计算尺寸参考", "clearMeasurements": "清除测量", "measureHelp": "可选：填写坐着观看时眼睛到幕面的距离，以及可放置幕布的净宽度。不确定的项可以留空。", "measureInvalid": "请输入大于 0 且不超过 30 米／98 英尺的数值，或留空。", "sizeSuggested": "建议从 {size} 英寸开始考虑", "sizeReference": "36° 视角仅作舒适度参考，不是硬性要求。喜欢轻松观看可选小一点，喜欢沉浸感可选大一点。", "sizeNoSpace": "当前可选尺寸均超出填写的宽度。请核对测量值，或让我们协助确认。", "imageWidth": "画面宽度（W）", "overallWidth": "机身总宽度（L）", "widthPending": "下单前请确认机身及安装所需宽度。", "widthNote": "W 是画面宽度，机身通常更宽；还需确认投影机位置及安装空间。", "currentPrice": "当前所选配置售价", "priceLoading": "正在核验当前价格和可售状态…", "priceUnavailable": "暂时无法核验实时价格。请在商品页或向客服确认这套配置。", "priceScope": "此价格对应所选尺寸和外壳，并使用当前商店币种。优惠、运费和税费以结账计算为准。", "liveAvailable": "当前可下单", "liveSoldOut": "当前暂不可下单", "housing": "外壳颜色", "housing_Black": "黑色", "housing_White": "白色", "viewConfiguration": "查看这套配置", "viewProductDetails": "查看商品详情", "retryPrice": "刷新价格", "comparison": "比较相同尺寸的选项", "comparisonNote": "每张卡片的价格对应所选尺寸及显示的外壳。材料和功能存在差异。", "priceDifference": "比 {product} {direction} {amount} · 同尺寸、同外壳", "priceLess": "低", "priceMore": "高", "priceEqual": "与 {product} 价格相同 · 同尺寸、同外壳", "copySetup": "复制我的配置", "copiedSetup": "配置已复制，可粘贴到聊天或邮件。", "copyFailed": "无法自动复制。可选中上方配置文字自行复制。", "emailSupport": "通过邮件咨询", "supportHelp": "需要协助？复制配置后粘贴到聊天，或打开包含已选信息的邮件草稿。", "noExactTitle": "当前条件下没有准确匹配", "checkTitle": "再确认一下你的配置", "possibleOptions": "需要确认的可能选项", "explain_outdoor_daylight": "不建议将这些幕布用于户外白天观看。", "explain_room_width": "所选尺寸超出了匹配产品所需的可用宽度。", "explain_constraints_no_match": "暂无已核验产品同时满足这些要求，我们可以协助检查其他方案。", "warning_white_room_light_sensitive": "灯光会影响白幕的画面表现，观看时建议调暗灯光。如果房间条件较复杂，请让客服协助确认。", "warning_live_product_confirmation": "价格和可售状态会按准确配置单独实时核验。", "warning_width_confirmation": "部分选项尚无已核验的机身宽度，下单前请确认安装尺寸。", "resultTitle": "适合你的幕布选项。", "recommendedOption": "一个适合的选项", "introTitle": "适合投影机，也适合你的房间。", "introBody": "从你的投影机开始，选择观看条件和尺寸，再比较适合的产品及当前价格。", "sizeBody": "选择对角线尺寸，也可用下方距离和宽度辅助判断。下单前仍可调整。"});
  Object.assign(translations["ja"], {"sizeHelper": "サイズ選びを手伝ってほしい", "viewingDistance": "目からスクリーンまで", "roomWidth": "設置できる幅", "measurementUnit": "単位", "metres": "メートル", "feet": "フィート", "calculateSize": "サイズの目安を見る", "clearMeasurements": "測定値をクリア", "measureHelp": "任意：着席時の目からスクリーンまでの距離と、設置できる幅を入力してください。不明な項目は空欄にできます。", "measureInvalid": "0より大きく30m／98ft以下の値を入力するか、空欄にしてください。", "sizeSuggested": "最初の目安：{size}インチ", "sizeReference": "36°の視野角は快適さの参考であり、必須条件ではありません。落ち着いた視聴には小さめ、没入感には大きめを選べます。", "sizeNoSpace": "入力した幅に収まる掲載サイズがありません。測定値を確認するか、ご相談ください。", "imageWidth": "映像幅（W）", "overallWidth": "本体全幅（L）", "widthPending": "注文前に本体と取付に必要な幅をご確認ください。", "widthNote": "Wは映像の幅です。本体はより広く、プロジェクターの位置と設置スペースも確認が必要です。", "currentPrice": "選択した構成の現在価格", "priceLoading": "現在の価格と販売状況を確認中…", "priceUnavailable": "現在価格を確認できませんでした。商品ページまたはサポートでこの構成をご確認ください。", "priceScope": "選択サイズと本体色に対応する現在のストア通貨の価格です。割引・送料・税額はチェックアウトで確定します。", "liveAvailable": "現在注文可能", "liveSoldOut": "現在注文できません", "housing": "本体カラー", "housing_Black": "ブラック", "housing_White": "ホワイト", "viewConfiguration": "この構成を見る", "viewProductDetails": "商品詳細を見る", "retryPrice": "価格を更新", "comparison": "同じサイズで比較", "comparisonNote": "各カードは選択サイズと表示された本体色の価格です。素材と機能は異なります。", "priceDifference": "{product}より{amount}{direction} · 同サイズ・同本体色", "priceLess": "安い", "priceMore": "高い", "priceEqual": "{product}と同価格 · 同サイズ・同本体色", "copySetup": "構成をコピー", "copiedSetup": "構成をコピーしました。チャットやメールに貼り付けられます。", "copyFailed": "自動コピーできません。上の構成を選択してコピーしてください。", "emailSupport": "メールで相談", "supportHelp": "お困りですか？構成をコピーしてチャットに貼り付けるか、回答を含むメール下書きを開けます。", "noExactTitle": "この条件に完全一致する製品はありません", "checkTitle": "構成を確認しましょう", "possibleOptions": "確認が必要な候補", "explain_outdoor_daylight": "これらのスクリーンは屋外の昼間視聴にはおすすめしません。", "explain_room_width": "選択サイズは適合製品の設置に必要な幅を超えています。", "explain_constraints_no_match": "すべての条件を満たす確認済み製品がありません。他の選択肢をサポートで確認できます。", "warning_white_room_light_sensitive": "室内の照明は白いスクリーンの映像に影響します。視聴時は照明を暗くし、複雑な環境はサポートにご相談ください。", "warning_live_product_confirmation": "価格と販売状況は選択した構成に合わせて別途確認します。", "warning_width_confirmation": "一部候補の本体幅は未確認です。注文前に設置寸法をご確認ください。", "resultTitle": "あなたに合うスクリーン。", "recommendedOption": "適合する選択肢", "introTitle": "プロジェクターにも、部屋にも合うスクリーン。", "introBody": "プロジェクターから始め、視聴条件とサイズを選び、適合する製品と現在価格を比較します。", "sizeBody": "対角サイズを選択するか、距離と幅のガイドをご利用ください。注文前に変更できます。"});
  Object.assign(translations.en,{betterBrightnessLowerCost:'White-screen viewing',betterLargerSizes:'A wider size range',betterAmbientLight:'Room-light control',tradeoffBlackGridChoice:'Black Grid handles room light in its normal orientation. Lite Hyper offers a wider size range. White Cinema is sensitive to room lighting, so dim the lights while watching. Compare the current configuration prices below.'});
  Object.assign(translations['zh-CN'],{betterBrightnessLowerCost:'白幕观看方案',betterLargerSizes:'更宽的尺寸范围',betterAmbientLight:'环境光控制',tradeoffBlackGridChoice:'Black Grid 在正常方向下可应对室内环境光。Lite Hyper 提供更宽的尺寸范围。白幕对灯光敏感，观看时建议调暗灯光；具体价格请比较下方当前配置售价。'});
  Object.assign(translations.ja,{betterBrightnessLowerCost:'白いスクリーンの選択肢',betterLargerSizes:'幅広いサイズ展開',betterAmbientLight:'室内光への対応',tradeoffBlackGridChoice:'Black Gridは通常の向きで室内光に対応します。Lite Hyperは幅広いサイズを提供します。白いスクリーンは照明に敏感なため、視聴時は照明を暗くしてください。現在の構成価格は下で比較できます。'});

  // R05: concise configuration workspace copy; compatibility explanations remain available in details.
  Object.assign(translations["en"], {"widthUnverified": "To confirm", "sizesUpdated": "Your width changes the available sizes. Choose from the updated options below.", "finderName": "Product Recommender 2.0", "groupProjector": "Projector", "groupRoom": "Room & setup", "groupSize": "Size & price", "yourSetup": "Your configuration", "allChoices": "All choices · edit", "progressShort": "{current} of {total}", "setupComplete": "Ready to compare", "needHelp": "Need help?", "detailsAndFit": "Details & fit", "projectorTitle": "Start with your projector.", "projectorBody": "Search your model, or choose a type below.", "projectorLabel": "Brand or model", "chooseManual": "Or choose a projector type", "ust": "Ultra short throw / Laser TV", "ustDesc": "Placed close to the screen.", "long": "Standard / long throw", "longDesc": "Placed farther back or ceiling-mounted.", "unknownProjector": "Other / not sure", "unknownProjectorDesc": "Portable, short throw, or an unknown model.", "locationTitle": "Where will you watch?", "locationBody": "", "indoorDesc": "Living room or home cinema.", "coveredOutdoor": "Sheltered outdoor", "coveredOutdoorDesc": "Under cover, between two posts.", "exposedOutdoor": "Fully exposed outdoor · unsupported", "exposedOutdoorDesc": "We do not offer a screen for this setup.", "notSureLocation": "I haven’t decided yet", "notSureLocationDesc": "", "viewingTitle": "How bright is your room?", "viewingBody": "", "bright": "Lights on", "brightDesc": "Daylight or room lights usually stay on.", "controlled": "I can dim the room", "controlledDesc": "Blinds closed, lights turned down.", "dark": "A dark room", "darkDesc": "Usually dark while watching.", "notSureLight": "Not sure yet", "notSureLightDesc": "Our team can help confirm.", "outdoorNight": "After sunset", "outdoorNightDesc": "Viewing starts once daylight has faded.", "outdoorMixed": "Day & evening", "outdoorMixedDesc": "Both daytime and evening viewing.", "outdoorDaylight": "During daylight", "outdoorDaylightDesc": "Outdoor daylight is not a supported match.", "installationTitle": "How would you like it to open?", "installationBody": "", "floor": "Floor rising", "floorDesc": "Rises from a housing near the floor.", "drop": "Drop-down", "dropDesc": "Lowers from a wall or ceiling housing.", "ceiling": "Recessed in-ceiling", "ceilingDesc": "The housing is hidden in the ceiling.", "frame": "Fixed frame", "frameDesc": "Always on display, mounted to the wall.", "notSureInstallationDesc": "We can help you decide.", "orientationTitle": "Where is your UST projector?", "orientationBody": "Choose its actual position.", "belowUpright": "Below the screen", "belowUprightDesc": "Standing upright, below the picture.", "aboveInverted": "Above the screen", "aboveInvertedDesc": "Ceiling-mounted and physically upside down.", "notSureOrientationDesc": "The screen direction needs confirmation.", "alignmentTitle": "Is the lens centred?", "alignmentBody": "", "centeredDesc": "Lens aligned with the screen’s horizontal centre.", "offCenter": "Off to one side", "offCenterDesc": "The lens sits left or right of centre.", "notSureAlignmentDesc": "The final position is still undecided.", "offsetTitle": "How do you align the picture?", "offsetBody": "", "opticalShiftDesc": "The lens moves the image optically.", "digitalKeystoneDesc": "Digital correction or a projector aimed sideways.", "notSureOffsetDesc": "Our team will check the geometry.", "sideViewingTitle": "Where will people sit?", "sideViewingBody": "", "sideViewingStandard": "Mostly in front", "sideViewingStandardDesc": "Most seats are near the centre.", "sideViewingWide": "Often to the sides", "sideViewingWideDesc": "People often sit far left or right.", "audioTitle": "Where are your speakers?", "audioBody": "", "speakerNone": "Outside the screen", "speakerNoneDesc": "No speakers behind the screen.", "speakerLowerBorder": "Behind the lower black border", "speakerLowerBorderDesc": "Needs perforation in the lower border.", "speakerImageArea": "Behind the picture", "speakerImageAreaDesc": "Needs perforation across the image area.", "speakerMovable": "I can move the speakers", "speakerMovableDesc": "They can sit outside the screen.", "speakerAesthetic": "I prefer a perforated finish", "speakerAestheticDesc": "For appearance, rather than speaker placement.", "notSureAudioDesc": "Our team can check your audio layout.", "sizeTitle": "Find your size.", "sizeBody": "Know your size? Choose it below.", "sizeHelper": "Use distance & width", "measureHelp": "Optional. Measure from your eyes to the screen, and the clear width available.", "calculateSize": "Get a size guide", "clearMeasurements": "Clear", "sizeReference": "36° is a viewing comfort reference. Go smaller for a calmer view, larger for immersion.", "sizeUnknown": "Help me choose a size", "resultTitle": "Your screen options.", "recommendedOption": "Matches your setup", "comparisonNote": "Compare the same size. Each price uses the housing colour shown.", "currentPrice": "Current price", "tradeoff_black_grid": "Higher price, with a 130-inch size limit.", "tradeoff_lite_hyper": "A wider verified size range. Compare prices at the same size.", "tradeoff_white_cinema": "Room lights affect the picture. Dim the room while watching.", "tradeoff_long_throw_alr": "Richer blacks and colour, with some brightness lost.", "tradeoff_long_throw_3d_alr": "More brightness, with lighter blacks than standard ALR.", "tradeoff_fresnel": "Strong frontal viewing. Frequent side seating needs care.", "warning_inverted_black_grid_no_overhead_rejection": "Inverted Black Grid receives projector light from above. It loses its normal rejection of overhead room light.", "supportHelp": "Need a closer check? Chat with our team or email your setup.", "priceScope": "Current price for the size and housing shown, in the store currency. Discounts, shipping and tax are confirmed at checkout.", "reviewTitle": "Your configuration", "reviewBody": "Edit any detail below.", "reviewGuidance": "Unknown details stay visible and may need our team’s confirmation.", "loc_covered_outdoor": "Sheltered outdoor · between posts", "loc_exposed_outdoor": "Fully exposed outdoor · unsupported", "outdoorScopeNote": "Our screens are not suitable for fully exposed outdoor use. Other installation conditions need our team’s advice.", "outdoorMountingTitle": "Confirm your outdoor installation.", "outdoorMounting": "Between two posts", "outdoorMountingDesc": "Under cover, secured between two fixed posts.", "outdoor_installation": "Shelter and installation between two posts", "outdoorSetupCheck": "Confirm that the screen will be under cover and installed between two fixed posts. Our team can help check other conditions.", "explain_unsupported_outdoor_exposure": "We do not offer a screen for fully exposed outdoor use. Choose a sheltered installation between posts, or ask our team about your space.", "whyOutdoor": "DuraPlus matches the sheltered installation between posts for after-sunset viewing.", "tradeoff_outdoor": "Requires shelter and mounting between posts. Outdoor daylight is not a supported match.", "housing_Dark Gray": "Dark gray", "outdoorViewingTitle": "When will you watch outdoors?", "warning_outdoor_light_sensitive": "Ambient light affects the picture outdoors. Plan to watch after sunset and turn down nearby lighting. Ask our team about your installation.", "confirm_outdoor_mounting": "Confirm post spacing, mounting and support details with our team before ordering."});
  Object.assign(translations["zh-CN"], {"widthUnverified": "待确认", "sizesUpdated": "填写的宽度改变了可选尺寸，请从下方更新后的选项选择。", "finderName": "幕布选择器", "groupProjector": "投影机", "groupRoom": "房间设置", "groupSize": "尺寸与价格", "yourSetup": "你的配置", "allChoices": "全部选择 · 修改", "progressShort": "{current} / {total}", "setupComplete": "可以开始比较", "needHelp": "需要帮助？", "detailsAndFit": "详情与适配说明", "projectorTitle": "从你的投影机开始。", "projectorBody": "搜索型号，或直接选择下方类型。", "projectorLabel": "品牌或型号", "chooseManual": "或选择投影机类型", "ust": "超短焦 / 激光电视", "ustDesc": "紧靠幕布放置。", "long": "标准焦距 / 长焦", "longDesc": "放在较远处，或吊装使用。", "unknownProjector": "其他 / 不确定", "unknownProjectorDesc": "便携式、短焦，或还不知道型号。", "locationTitle": "你准备在哪里观看？", "locationBody": "", "indoorDesc": "客厅或家庭影院。", "coveredOutdoor": "有遮护的户外", "coveredOutdoorDesc": "有遮护，安装于两根立柱之间。", "exposedOutdoor": "完全露天户外 · 不支持", "exposedOutdoorDesc": "我们没有适用于这种环境的幕布。", "notSureLocation": "还没决定", "notSureLocationDesc": "", "viewingTitle": "观看时，房间有多亮？", "viewingBody": "", "bright": "日常开着灯", "brightDesc": "通常有日光，或室内灯光。", "controlled": "可以调暗房间", "controlledDesc": "关上窗帘，调暗灯光。", "dark": "房间较暗", "darkDesc": "观看时，房间通常是暗的。", "notSureLight": "还不确定", "notSureLightDesc": "可以让我们协助确认。", "outdoorNight": "日落以后", "outdoorNightDesc": "等自然光减弱后开始观看。", "outdoorMixed": "白天和夜晚都用", "outdoorMixedDesc": "白天与晚间混合观看。", "outdoorDaylight": "户外白天", "outdoorDaylightDesc": "不支持作出户外日光下的匹配推荐。", "installationTitle": "你希望幕布怎么展开？", "installationBody": "", "floor": "地升幕", "floorDesc": "从地面附近的机身升起。", "drop": "壁挂 / 吊装下降幕", "dropDesc": "从墙面或天花板的机身下降。", "ceiling": "嵌入式天花幕", "ceilingDesc": "机身藏在天花板内。", "frame": "固定框架幕", "frameDesc": "固定在墙面，随时可用。", "notSureInstallationDesc": "我们可以帮你判断。", "orientationTitle": "超短焦投影机放在哪里？", "orientationBody": "请选择实际放置方向。", "belowUpright": "幕布下方", "belowUprightDesc": "投影机正放，位于画面下方。", "aboveInverted": "幕布上方", "aboveInvertedDesc": "投影机吊装，机身倒置。", "notSureOrientationDesc": "需要先确认幕布方向。", "alignmentTitle": "镜头在幕布的正中间吗？", "alignmentBody": "", "centeredDesc": "镜头与画面的水平中心对齐。", "offCenter": "偏左或偏右", "offCenterDesc": "镜头不在水平中心。", "notSureAlignmentDesc": "还没有确定最终位置。", "offsetTitle": "偏离中心后，怎么对齐画面？", "offsetBody": "", "opticalShiftDesc": "通过镜头进行光学位移。", "digitalKeystoneDesc": "数字校正，或投影机斜着投射。", "notSureOffsetDesc": "由我们协助确认投射条件。", "sideViewingTitle": "大家主要坐在哪里？", "sideViewingBody": "", "sideViewingStandard": "主要坐在正前方", "sideViewingStandardDesc": "大多数座位靠近中心。", "sideViewingWide": "经常坐在两侧", "sideViewingWideDesc": "经常从偏左或偏右的座位观看。", "audioTitle": "你的音箱放在哪里？", "audioBody": "", "speakerNone": "幕布外侧", "speakerNoneDesc": "幕布后方没有音箱。", "speakerLowerBorder": "下方黑边后面", "speakerLowerBorderDesc": "需要下黑边打孔。", "speakerImageArea": "投影画面后面", "speakerImageAreaDesc": "需要画面区域打孔。", "speakerMovable": "音箱可以移动", "speakerMovableDesc": "可以放到幕布外侧。", "speakerAesthetic": "希望外观有打孔", "speakerAestheticDesc": "出于外观偏好，而非音箱位置。", "notSureAudioDesc": "可以让我们确认音响布局。", "sizeTitle": "找到合适的尺寸。", "sizeBody": "已有目标尺寸？直接在下方选择。", "sizeHelper": "用距离和宽度帮我选", "measureHelp": "可选：填写眼睛到幕面的距离，以及可放幕布的净宽度。", "calculateSize": "查看尺寸参考", "clearMeasurements": "清除", "sizeReference": "36° 视角仅作舒适度参考。想轻松观看可选小一点，想更沉浸可选大一点。", "sizeUnknown": "让我们帮你选尺寸", "resultTitle": "适合你的幕布选项。", "recommendedOption": "符合你的配置", "comparisonNote": "比较同尺寸产品，价格对应各卡片显示的外壳颜色。", "currentPrice": "当前售价", "tradeoff_black_grid": "价格较高，最大尺寸为 130 英寸。", "tradeoff_lite_hyper": "有更宽的已核验尺寸范围，可比较同尺寸价格。", "tradeoff_white_cinema": "灯光会影响画面，观看时请把房间调暗。", "tradeoff_long_throw_alr": "黑位和色彩更好，但会损失一些亮度。", "tradeoff_long_throw_3d_alr": "亮度更高，黑位比标准长焦 ALR 更浅。", "tradeoff_fresnel": "正面观看表现好，经常侧坐需要留意。", "warning_inverted_black_grid_no_overhead_rejection": "倒装 Black Grid 接收上方投影光，但会失去正常方向下的顶部环境光抑制能力。", "supportHelp": "还需要确认？与我们聊天，或通过邮件咨询你的配置。", "priceScope": "当前售价对应所示尺寸与外壳，使用商店币种。优惠、运费及税费以结账计算为准。", "reviewTitle": "你的配置", "reviewBody": "可以修改下方任意信息。", "reviewGuidance": "不确定的内容会保留，必要时由我们协助确认。", "loc_covered_outdoor": "有遮护的户外 · 柱间安装", "loc_exposed_outdoor": "完全露天户外 · 不支持", "outdoorScopeNote": "我们没有适用于完全露天环境的幕布。其他安装条件请先联系专员确认。", "outdoorMountingTitle": "确认户外安装条件。", "outdoorMounting": "两根立柱之间", "outdoorMountingDesc": "有遮护，并固定在两根立柱之间。", "outdoor_installation": "遮护条件与两根立柱之间的安装", "outdoorSetupCheck": "请确认幕布有遮护，并安装在两根固定立柱之间。其他条件请联系专员确认。", "explain_unsupported_outdoor_exposure": "我们没有适用于完全露天环境的幕布。请改用有遮护的柱间安装，或联系专员确认场地条件。", "whyOutdoor": "DuraPlus 对应有遮护的柱间安装，适合日落后观看。", "tradeoff_outdoor": "需要遮护并安装于立柱之间。户外白天观看不属于已支持的匹配。", "housing_Dark Gray": "深灰色", "outdoorViewingTitle": "户外准备什么时候观看？", "warning_outdoor_light_sensitive": "环境光会影响户外画面。建议日落后观看，并调暗附近灯光。安装条件请联系专员确认。", "confirm_outdoor_mounting": "下单前请联系专员确认柱距、固定方式与支撑条件。"});
  Object.assign(translations["ja"], {"widthUnverified": "要確認", "sizesUpdated": "入力した幅に合わせてサイズを更新しました。下の候補から選んでください。", "finderName": "スクリーン選び", "groupProjector": "投写機", "groupRoom": "部屋・設置", "groupSize": "サイズ・価格", "yourSetup": "あなたの構成", "allChoices": "すべての選択・編集", "progressShort": "{current} / {total}", "setupComplete": "比較の準備ができました", "needHelp": "お困りですか？", "detailsAndFit": "詳細と適合条件", "projectorTitle": "プロジェクターから始めましょう。", "projectorBody": "型番を検索するか、下から方式を選んでください。", "projectorLabel": "メーカーまたは型番", "chooseManual": "または投写方式を選択", "ust": "超短焦点 / レーザーTV", "ustDesc": "スクリーンのすぐ近くに設置。", "long": "標準 / 長焦点", "longDesc": "離れた位置や天井に設置。", "unknownProjector": "その他 / わからない", "unknownProjectorDesc": "ポータブル、短焦点、型番不明。", "locationTitle": "どこで視聴しますか？", "locationBody": "", "indoorDesc": "リビングやホームシアター。", "coveredOutdoor": "保護された屋外", "coveredOutdoorDesc": "屋根などの下で、2本の支柱の間に設置。", "exposedOutdoor": "完全に露出した屋外 · 非対応", "exposedOutdoorDesc": "この環境に対応する製品はありません。", "notSureLocation": "まだ決めていない", "notSureLocationDesc": "", "viewingTitle": "視聴時の部屋は明るいですか？", "viewingBody": "", "bright": "明かりを点けて視聴", "brightDesc": "日光や室内照明がある。", "controlled": "部屋を暗くできる", "controlledDesc": "カーテンを閉め、照明を落とせる。", "dark": "暗い部屋", "darkDesc": "視聴時は通常暗くする。", "notSureLight": "まだわからない", "notSureLightDesc": "サポートで確認できます。", "outdoorNight": "日没後", "outdoorNightDesc": "日光が弱まってから視聴。", "outdoorMixed": "昼も夜も", "outdoorMixedDesc": "昼間と夕方・夜に視聴。", "outdoorDaylight": "屋外の昼間", "outdoorDaylightDesc": "昼間の屋外は適合推奨できません。", "installationTitle": "どの設置方式を希望しますか？", "installationBody": "", "floor": "床から立ち上がる", "floorDesc": "床近くの本体から上昇。", "drop": "壁・天井から下降", "dropDesc": "壁や天井の本体から下降。", "ceiling": "天井埋め込み", "ceilingDesc": "本体を天井内に収納。", "frame": "固定フレーム", "frameDesc": "壁に固定し、常に表示。", "notSureInstallationDesc": "サポートで選べます。", "orientationTitle": "超短焦点機はどこにありますか？", "orientationBody": "実際の設置位置を選んでください。", "belowUpright": "スクリーンの下", "belowUprightDesc": "映像の下に正立で設置。", "aboveInverted": "スクリーンの上", "aboveInvertedDesc": "天井に上下反転で取り付け。", "notSureOrientationDesc": "素材の向きを確認する必要があります。", "alignmentTitle": "レンズは中央にありますか？", "alignmentBody": "", "centeredDesc": "映像の水平方向の中心に一致。", "offCenter": "左右にずれている", "offCenterDesc": "レンズが中央の左右にある。", "notSureAlignmentDesc": "最終位置がまだ未定。", "offsetTitle": "映像をどう調整しますか？", "offsetBody": "", "opticalShiftDesc": "レンズで光学的に映像を移動。", "digitalKeystoneDesc": "デジタル補正や斜めからの投写。", "notSureOffsetDesc": "サポートで投写条件を確認。", "sideViewingTitle": "どこに座って視聴しますか？", "sideViewingBody": "", "sideViewingStandard": "主に正面", "sideViewingStandardDesc": "座席は中央付近。", "sideViewingWide": "左右からも頻繁に", "sideViewingWideDesc": "左右に離れた席からよく視聴。", "audioTitle": "スピーカーはどこにありますか？", "audioBody": "", "speakerNone": "スクリーンの外側", "speakerNoneDesc": "スクリーンの裏には置かない。", "speakerLowerBorder": "下の黒い縁の裏", "speakerLowerBorderDesc": "下部黒縁のパンチングが必要。", "speakerImageArea": "映像部分の裏", "speakerImageAreaDesc": "映像面のパンチングが必要。", "speakerMovable": "スピーカーを移動できる", "speakerMovableDesc": "スクリーン外に設置できる。", "speakerAesthetic": "パンチング仕上げを希望", "speakerAestheticDesc": "スピーカー配置ではなく外観の好み。", "notSureAudioDesc": "サポートで音響配置を確認。", "sizeTitle": "サイズを選びましょう。", "sizeBody": "希望サイズがあれば、下から選択。", "sizeHelper": "距離と幅から選ぶ", "measureHelp": "任意：目から映像までの距離と、設置できる幅を入力。", "calculateSize": "サイズの目安を見る", "clearMeasurements": "クリア", "sizeReference": "36°は快適さの目安です。落ち着いた視聴には小さめ、没入感には大きめを。", "sizeUnknown": "サイズを相談する", "resultTitle": "あなたに合うスクリーン。", "recommendedOption": "この構成に適合", "comparisonNote": "同じサイズで比較。価格は各カードの本体カラーに対応します。", "currentPrice": "現在価格", "tradeoff_black_grid": "価格は高めで、最大サイズは130インチ。", "tradeoff_lite_hyper": "幅広い確認済みサイズ展開。同サイズで価格を比較できます。", "tradeoff_white_cinema": "照明は映像に影響します。視聴時は部屋を暗くしてください。", "tradeoff_long_throw_alr": "黒と色を深める一方、明るさはやや低下。", "tradeoff_long_throw_3d_alr": "高い明るさ。黒表現は標準ALRより浅め。", "tradeoff_fresnel": "正面視聴に適します。頻繁な側方視聴には注意。", "warning_inverted_black_grid_no_overhead_rejection": "反転Black Gridは上方からの投写光を受けますが、通常向きの上方室内光を抑える機能を失います。", "supportHelp": "追加確認が必要ですか？チャットやメールでご相談ください。", "priceScope": "表示サイズと本体色に対応するストア通貨の現在価格。割引・送料・税額はチェックアウトで確定します。", "reviewTitle": "あなたの構成", "reviewBody": "下の項目を編集できます。", "reviewGuidance": "不明な項目はそのまま残り、必要に応じてサポートで確認します。", "loc_covered_outdoor": "保護された屋外 · 支柱間に設置", "loc_exposed_outdoor": "完全に露出した屋外 · 非対応", "outdoorScopeNote": "完全に露出した屋外に対応する製品はありません。その他の設置条件はサポートにご相談ください。", "outdoorMountingTitle": "屋外の設置条件を確認。", "outdoorMounting": "2本の支柱の間", "outdoorMountingDesc": "屋根などの下で、固定された2本の支柱の間に設置。", "outdoor_installation": "保護と2本の支柱の間への設置", "outdoorSetupCheck": "屋根などで保護され、固定された2本の支柱の間に設置することをご確認ください。その他の条件はサポートにご相談ください。", "explain_unsupported_outdoor_exposure": "完全に露出した屋外に対応する製品はありません。保護された支柱間への設置をご検討いただくか、サポートにご相談ください。", "whyOutdoor": "DuraPlusは保護された支柱間への設置で、日没後の視聴に適します。", "tradeoff_outdoor": "保護と支柱間への設置が必要です。屋外の昼間は適合推奨できません。", "housing_Dark Gray": "ダークグレー", "outdoorViewingTitle": "屋外ではいつ視聴しますか？", "warning_outdoor_light_sensitive": "屋外の環境光は映像に影響します。日没後に視聴し、周辺の照明を落としてください。設置条件はサポートにご相談ください。", "confirm_outdoor_mounting": "ご注文前に、支柱の間隔、固定方法、支えの条件をサポートにご確認ください。"});
  // R05.3: concise customer decisions, width evidence and support handoff.
  Object.assign(translations.en, {
    progressStages: 'Stage {current} of 3',
    speakerBehindTitle: 'Speakers behind the screen',
    speakerBehindDesc: 'Next, choose where they sit behind it.',
    speakerPositionTitle: 'Which part are the speakers behind?',
    speakerPositionBody: 'Perforation must match the speaker position.',
    speakerChange: 'Change speaker needs',
    speakerNone: 'Built-in audio / speakers outside',
    speakerNoneDesc: 'Projector speakers or a soundbar outside the screen.',
    widthFitsTitle: 'Fits the entered width',
    widthRecheckTitle: 'Remeasure the width',
    widthUnverifiedTitle: 'Confirm the space first',
    widthFitsDetail: 'Verified overall width: {overall}, plus {tolerance} allowance. Height, depth and projector placement still need checking.',
    widthRecheckDetail: 'Your clear width of {room} is close to the overall width of {overall}. Remeasure or ask our team before ordering.',
    widthUnverifiedDetail: 'Image width reference: {image}. Overall width is unverified; ask our team to confirm the space.',
    room_width: 'Available installation width',
    priceNeedsSize: 'Choose a numeric size to see its exact configuration price.',
    compareQuickTitle: 'Compare price and space first',
    compareQuickBody: 'Same diagonal size. Price differences are calculated only for the same housing colour.',
    comparePending: 'Waiting for verified prices',
    compareDetails: 'View {product}',
    compareHousing: 'Compare housing colours',
    compareDifferentHousing: 'Different housing colours · no price difference calculated',
    practical_blackGrid: 'Black Grid for considering room lighting. Check the required screen orientation.',
    practical_liteHyperDomesticGrid: 'A different material from Black Grid. Compare its price and available sizes.',
    practical_whiteCinema: 'Compare for a lower budget. Room lights affect the picture.',
    practical_other: 'Compare the price, installation and viewing conditions.',
    referencePhoto: 'Official product reference photo; it may show a different size or colour. Check the configuration you choose.',
    photoAlt: '{product} official product reference photo',
    viewNamedConfiguration: 'View {product} · {size} in',
    widthConfirmAction: 'Confirm the space first',
    purchaseChecking: 'Refreshing this configuration’s price. Its product page will open after verification.',
    purchaseFailed: 'We could not verify this configuration. Try again or ask our team.',
    purchaseCancelled: 'Opening cancelled. Your choices are saved.',
    cancelOpening: 'Cancel opening',
    earlyHelpTitle: 'Let us help you confirm',
    earlyHelpBody: 'Share your choices and projector model or an installation photo. You can contact us before answering everything.',
    continueChoosing: 'Continue choosing',
    helpMissingTitle: 'Confirm these first',
    helpProjector: 'Projector model and projection type',
    helpOutdoor: 'Shelter, mounting between posts and mainly after-sunset viewing',
    helpRoom: 'Installation position and lighting while watching',
    helpAudio: 'Speakers behind the lower border or behind the picture',
    helpSpace: 'Numeric diagonal size and available clear width',
    projectorInput: 'Entered projector model',
    projectorInputPending: 'Customer-provided · not yet verified',
    copyReady: 'Copied. Paste this into your support chat.',
    copyFailedVisible: 'Copy failed. Open your setup below and copy it manually.',
    yourSetupText: 'View setup to share',
    possibleOptions: 'Screen families for our team to confirm',
    whyFits: 'Material and viewing conditions',
    controlled: 'A little light remains',
    controlledDesc: 'Curtains closed, with some dim lamps still on.',
    dark: 'Almost fully dark',
    darkDesc: 'Curtains closed and room lights off while watching.',
    light_controlled: 'Some dim lighting remains',
    light_dark: 'Almost fully dark while watching',
    priceScope: 'Current selling price for the selected variant in the store currency. Unconfirmed discounts, shipping and tax are not included; the checkout total may differ.',
    sizeTitle: 'Choose your diagonal size.',
    sizeBody: 'Sizes are measured diagonally in inches. Choose one, or use distance and clear width for a starting point.',
    widthCheckBody: 'The overall width needs verification, or your measurement needs a recheck. We cannot confirm the space yet; ask our team before ordering.',
    noSizesForSetup: 'We cannot confirm a numeric size for the current viewing and installation conditions. Ask our team to check your setup.',
    explain_room_width: 'The current choice does not fit the clear width you entered. Check your measurement, choose another size or ask our team to review the space.',
    warning_width_confirmation: 'Some options need a width recheck or verified overall dimensions. Confirm the marked options before ordering.'
  });
  Object.assign(translations['zh-CN'], {
    progressStages: '{current} / 3 阶段',
    speakerBehindTitle: '音箱在幕布后方',
    speakerBehindDesc: '下一步确认在黑边还是画面后方。',
    speakerPositionTitle: '音箱在幕布的哪个区域后方？',
    speakerPositionBody: '打孔位置需要与音箱位置对应。',
    speakerChange: '重新选择音响需求',
    speakerNone: '自带音响 / 幕布外音箱',
    speakerNoneDesc: '使用投影机音响，或放在幕布外的 soundbar。',
    widthFitsTitle: '净宽可容纳',
    widthRecheckTitle: '需要复测净宽',
    widthUnverifiedTitle: '空间需先确认',
    widthFitsDetail: '已核验总宽 {overall}，另预留 {tolerance}。仍需检查高度、深度及投影机位置。',
    widthRecheckDetail: '净宽 {room} 接近机身总宽 {overall}。请复测，或让客服确认后再下单。',
    widthUnverifiedDetail: '画面宽度参考 {image}，机身总宽待核验。请先让客服确认空间。',
    room_width: '安装可用净宽',
    priceNeedsSize: '选择数字尺寸后，查看准确配置售价。',
    compareQuickTitle: '先比较价格和空间',
    compareQuickBody: '均为相同对角线尺寸，只有外壳颜色相同时才计算差价。',
    comparePending: '等待价格核验',
    compareDetails: '查看 {product}',
    compareHousing: '对比外壳颜色',
    compareDifferentHousing: '外壳颜色不同，不计算差价',
    practical_blackGrid: '黑栅适合重点考虑室内灯光影响的客户，需核对幕料方向。',
    practical_liteHyperDomesticGrid: '与黑栅不同的幕料，可比较价格和可选尺寸。',
    practical_whiteCinema: '可作为较低预算的对比项，灯光会影响画面。',
    practical_other: '比较价格、安装方式和观看条件。',
    referencePhoto: '官网产品参考图，可能展示不同颜色或尺寸，以所选配置为准。',
    photoAlt: '{product} 官网产品参考图',
    viewNamedConfiguration: '查看 {product} · {size} 英寸',
    widthConfirmAction: '先确认空间',
    purchaseChecking: '正在刷新所选配置的价格，核验通过后打开商品页。',
    purchaseFailed: '未能核验所选配置，请重试或让客服确认。',
    purchaseCancelled: '已取消打开商品页，所选配置已保留。',
    cancelOpening: '取消打开',
    earlyHelpTitle: '让我们帮你确认',
    earlyHelpBody: '发送已选配置，以及投影机型号或安装照片。可以先联系，不必填完。',
    continueChoosing: '继续选择',
    helpMissingTitle: '优先确认',
    helpProjector: '投影机型号与投影类型',
    helpOutdoor: '有遮护的柱间安装，以及是否主要日落后观看',
    helpRoom: '安装位置和观看时的灯光',
    helpAudio: '音箱在下黑边还是画面后方',
    helpSpace: '数字对角线尺寸及可用净宽',
    projectorInput: '输入的投影机型号',
    projectorInputPending: '客户输入，尚未核验',
    copyReady: '已复制，可粘贴给客服。',
    copyFailedVisible: '复制失败，可展开下方配置手动复制。',
    yourSetupText: '查看可发送的配置',
    possibleOptions: '待人工确认的系列',
    whyFits: '幕料与使用条件',
    controlled: '观看时保留少量灯光',
    controlledDesc: '关上窗帘，仍开着调暗的小灯。',
    dark: '观看时基本全暗',
    darkDesc: '关上窗帘，并关闭房间灯光。',
    light_controlled: '观看时保留少量灯光',
    light_dark: '观看时基本全暗',
    priceScope: '商店币种下所选变体的当前售价，不含尚未确认的优惠、运费和税费；最终结算金额可能不同。',
    sizeTitle: '选择对角线尺寸。',
    sizeBody: '尺寸按对角线英寸标注。直接选择，或用观看距离和净宽获取参考。',
    widthCheckBody: '机身总宽尚需核验，或净宽需要复测，暂不能确认空间是否足够。请让客服确认后再下单。',
    noSizesForSetup: '当前观看和安装条件下，暂无可确认的数字尺寸。请让客服协助检查配置。',
    explain_room_width: '当前选择与填写的净宽不匹配。请核对测量值、重新选尺寸，或让客服检查空间。',
    warning_width_confirmation: '部分选项需要复测净宽，或核验机身总宽。请先确认卡片上标注的选项，再下单。'
  });
  Object.assign(translations.ja, {
    progressStages: '全3段階中 {current} 段階目',
    speakerBehindTitle: 'スクリーンの裏にスピーカー',
    speakerBehindDesc: '次に黒い縁か映像面の裏かを選びます。',
    speakerPositionTitle: 'スピーカーはどの部分の裏ですか？',
    speakerPositionBody: 'パンチングの位置をスピーカーの位置に合わせます。',
    speakerChange: '音響条件を選び直す',
    speakerNone: '内蔵音響 / スクリーンの外側',
    speakerNoneDesc: '投写機の内蔵音響や、スクリーン外のサウンドバー。',
    widthFitsTitle: '入力した幅に収まります',
    widthRecheckTitle: '幅を再測定してください',
    widthUnverifiedTitle: '先にスペースを確認',
    widthFitsDetail: '確認済みの全幅 {overall} に、{tolerance} の余裕を加えています。高さ・奥行き・投写機の位置は別途確認が必要です。',
    widthRecheckDetail: '設置できる幅 {room} が全幅 {overall} に近いため、再測定するか、ご注文前にサポートへご確認ください。',
    widthUnverifiedDetail: '映像幅の参考値：{image}。本体全幅は未確認です。先にスペースをサポートへご確認ください。',
    room_width: '設置できる有効幅',
    priceNeedsSize: '数値のサイズを選ぶと、その構成の正確な価格を表示します。',
    compareQuickTitle: 'まず価格とスペースを比較',
    compareQuickBody: '対角サイズは同一です。価格差は本体カラーが同じ場合にのみ計算します。',
    comparePending: '価格の確認待ち',
    compareDetails: '{product}を見る',
    compareHousing: '本体カラーを比較',
    compareDifferentHousing: '本体カラーが異なるため価格差は計算しません',
    practical_blackGrid: '室内照明の影響を重視する場合のBlack Grid。素材の向きを確認してください。',
    practical_liteHyperDomesticGrid: 'Black Gridとは異なる素材です。価格と選べるサイズを比較できます。',
    practical_whiteCinema: '低予算向けの比較候補。照明は映像に影響します。',
    practical_other: '価格、設置方式、視聴条件を比較してください。',
    referencePhoto: '公式の商品参考写真です。異なる色やサイズが写っている場合があります。選択した構成をご確認ください。',
    photoAlt: '{product} 公式の商品参考写真',
    viewNamedConfiguration: '{product} · {size}インチを見る',
    widthConfirmAction: '先にスペースを確認',
    purchaseChecking: 'この構成の価格を更新しています。確認でき次第、商品ページを開きます。',
    purchaseFailed: 'この構成を確認できませんでした。再試行するか、サポートへご相談ください。',
    purchaseCancelled: '商品ページを開く操作を取り消しました。選択内容は保存されています。',
    cancelOpening: '開く操作を取り消す',
    earlyHelpTitle: '確認をお手伝いします',
    earlyHelpBody: '選択内容と、投写機の型番または設置写真を共有してください。すべての回答前でもご相談いただけます。',
    continueChoosing: '選択を続ける',
    helpMissingTitle: '先に確認する内容',
    helpProjector: 'プロジェクターの型番と投写方式',
    helpOutdoor: '保護された支柱間の設置と、主に日没後の視聴かどうか',
    helpRoom: '設置位置と視聴中の照明',
    helpAudio: 'スピーカーが下部黒縁の裏か、映像面の裏か',
    helpSpace: '数値の対角サイズと設置できる有効幅',
    projectorInput: '入力したプロジェクター型番',
    projectorInputPending: 'お客様の入力 · 未確認',
    copyReady: 'コピーしました。サポートチャットに貼り付けられます。',
    copyFailedVisible: 'コピーできませんでした。下の構成を開き、手動でコピーしてください。',
    yourSetupText: '共有する構成を表示',
    possibleOptions: 'サポートで確認する製品シリーズ',
    whyFits: '素材と使用条件',
    controlled: '少し明かりを残して視聴',
    controlledDesc: 'カーテンを閉め、暗めの照明を残す。',
    dark: 'ほぼ完全に暗くして視聴',
    darkDesc: 'カーテンを閉め、室内照明を消す。',
    light_controlled: '視聴時に少し照明を残す',
    light_dark: '視聴時はほぼ完全に暗い',
    priceScope: '選択バリエーションのストア通貨での現在販売価格です。未確定の割引・送料・税額は含まず、最終決済額は異なる場合があります。',
    sizeTitle: '対角サイズを選びましょう。',
    sizeBody: 'サイズは対角のインチ数です。直接選ぶか、視聴距離と有効幅から目安を確認できます。',
    widthCheckBody: '本体全幅の確認、または有効幅の再測定が必要です。スペースが十分かはまだ確認できません。ご注文前にサポートへご確認ください。',
    noSizesForSetup: '現在の視聴・設置条件では数値のサイズを確認できません。構成をサポートへご相談ください。',
    explain_room_width: '現在の選択内容は入力した有効幅に収まりません。測定値を確認し、別のサイズを選ぶか、スペースをサポートへご相談ください。',
    warning_width_confirmation: '一部候補は幅の再測定や本体全幅の確認が必要です。カードに表示された項目を、ご注文前にご確認ください。'
  });
  return Object.freeze(translations);
});

window.ScreenFinderProjectors=[
  {
    "brand": "Epson",
    "model": "LS800",
    "fullName": "Epson LS800",
    "type": "ust",
    "ratio": "0.27",
    "lumens": "4000",
    "keywords": [
      "epson",
      "ls800",
      "ls 800"
    ]
  },
  {
    "brand": "Epson",
    "model": "LS12000",
    "fullName": "Epson LS12000",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "2700",
    "keywords": [
      "epson",
      "ls12000",
      "ls 12000",
      "ls12k"
    ]
  },
  {
    "brand": "Epson",
    "model": "LS11000",
    "fullName": "Epson LS11000",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "2500",
    "keywords": [
      "epson",
      "ls11000",
      "ls 11000",
      "ls11k"
    ]
  },
  {
    "brand": "Epson",
    "model": "EH-LS650",
    "fullName": "Epson EH-LS650",
    "type": "ust",
    "ratio": "0.27",
    "lumens": "3600",
    "keywords": [
      "epson",
      "eh-ls650",
      "ehls650",
      "ls650"
    ]
  },
  {
    "brand": "Epson",
    "model": "EH-LS500",
    "fullName": "Epson EH-LS500",
    "type": "ust",
    "ratio": "0.27",
    "lumens": "4000",
    "keywords": [
      "epson",
      "eh-ls500",
      "ehls500",
      "ls500"
    ]
  },
  {
    "brand": "Epson",
    "model": "4010",
    "fullName": "Epson Home Cinema 4010",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "2400",
    "keywords": [
      "epson",
      "4010",
      "home cinema"
    ]
  },
  {
    "brand": "Epson",
    "model": "3800",
    "fullName": "Epson Home Cinema 3800",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "3000",
    "keywords": [
      "epson",
      "3800",
      "home cinema"
    ]
  },
  {
    "brand": "Formovie",
    "model": "Cinema Pro",
    "fullName": "Formovie Cinema Pro",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "3000",
    "keywords": [
      "formovie",
      "cinema pro",
      "cinemapro"
    ]
  },
  {
    "brand": "Formovie",
    "model": "S5",
    "fullName": "Formovie S5",
    "type": "ust",
    "ratio": "0.233",
    "lumens": "2500",
    "keywords": [
      "formovie",
      "s5"
    ]
  },
  {
    "brand": "BenQ",
    "model": "V7050i",
    "fullName": "BenQ V7050i",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2500",
    "keywords": [
      "benq",
      "v7050i",
      "v7050",
      "v 7050"
    ]
  },
  {
    "brand": "BenQ",
    "model": "V7000i",
    "fullName": "BenQ V7000i",
    "type": "ust",
    "ratio": "0.252",
    "lumens": "2500",
    "keywords": [
      "benq",
      "v7000i",
      "v7000",
      "v 7000"
    ]
  },
  {
    "brand": "BenQ",
    "model": "V6050",
    "fullName": "BenQ V6050",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3000",
    "keywords": [
      "benq",
      "v6050",
      "v 6050"
    ]
  },
  {
    "brand": "BenQ",
    "model": "V6000",
    "fullName": "BenQ V6000",
    "type": "ust",
    "ratio": "0.252",
    "lumens": "3000",
    "keywords": [
      "benq",
      "v6000",
      "v 6000"
    ]
  },
  {
    "brand": "BenQ",
    "model": "W2700i",
    "fullName": "BenQ W2700i",
    "type": "long",
    "ratio": "1.13-1.47",
    "lumens": "2000",
    "keywords": [
      "benq",
      "w2700i",
      "w2700",
      "w 2700"
    ]
  },
  {
    "brand": "BenQ",
    "model": "HT3550i",
    "fullName": "BenQ HT3550i",
    "type": "long",
    "ratio": "1.13-1.47",
    "lumens": "2000",
    "keywords": [
      "benq",
      "ht3550i",
      "ht3550",
      "ht 3550"
    ]
  },
  {
    "brand": "Optoma",
    "model": "P2",
    "fullName": "Optoma CinemaX P2",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3000",
    "keywords": [
      "optoma",
      "cinemax",
      "p2",
      "cinema x"
    ]
  },
  {
    "brand": "Optoma",
    "model": "P1",
    "fullName": "Optoma CinemaX P1",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3000",
    "keywords": [
      "optoma",
      "cinemax",
      "p1",
      "cinema x"
    ]
  },
  {
    "brand": "Optoma",
    "model": "UHD55",
    "fullName": "Optoma UHD55",
    "type": "long",
    "ratio": "1.21-1.59",
    "lumens": "3600",
    "keywords": [
      "optoma",
      "uhd55",
      "uhd 55"
    ]
  },
  {
    "brand": "Optoma",
    "model": "UHD38",
    "fullName": "Optoma UHD38",
    "type": "long",
    "ratio": "1.21-1.59",
    "lumens": "4000",
    "keywords": [
      "optoma",
      "uhd38",
      "uhd 38"
    ]
  },
  {
    "brand": "Optoma",
    "model": "UHZ50",
    "fullName": "Optoma UHZ50",
    "type": "long",
    "ratio": "1.21-1.59",
    "lumens": "3000",
    "keywords": [
      "optoma",
      "uhz50",
      "uhz 50"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "Aura",
    "fullName": "XGIMI Aura",
    "type": "ust",
    "ratio": "0.233",
    "lumens": "2400",
    "keywords": [
      "xgimi",
      "aura"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "Horizon Pro",
    "fullName": "XGIMI Horizon Pro",
    "type": "long",
    "ratio": "1.2",
    "lumens": "2200",
    "keywords": [
      "xgimi",
      "horizon pro",
      "horizonpro"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "Elfin",
    "fullName": "XGIMI Elfin",
    "type": "long",
    "ratio": "1.2",
    "lumens": "800",
    "keywords": [
      "xgimi",
      "elfin"
    ]
  },
  {
    "brand": "Samsung",
    "model": "The Premiere LSP9T",
    "fullName": "Samsung The Premiere LSP9T",
    "type": "ust",
    "ratio": "0.19",
    "lumens": "2800",
    "laser3": true,
    "keywords": [
      "samsung",
      "premiere",
      "lsp9t",
      "lsp 9t"
    ]
  },
  {
    "brand": "Samsung",
    "model": "The Premiere LSP7T",
    "fullName": "Samsung The Premiere LSP7T",
    "type": "ust",
    "ratio": "0.19",
    "lumens": "2200",
    "keywords": [
      "samsung",
      "premiere",
      "lsp7t",
      "lsp 7t"
    ]
  },
  {
    "brand": "LG",
    "model": "HU810P",
    "fullName": "LG HU810P",
    "type": "long",
    "ratio": "1.3-2.08",
    "lumens": "2700",
    "keywords": [
      "lg",
      "hu810p",
      "hu810",
      "hu 810"
    ]
  },
  {
    "brand": "LG",
    "model": "HU915QE",
    "fullName": "LG HU915QE",
    "type": "ust",
    "ratio": "0.19",
    "lumens": "3700",
    "keywords": [
      "lg",
      "hu915qe",
      "hu915",
      "hu 915",
      "cinebeam"
    ]
  },
  {
    "brand": "LG",
    "model": "HU85LA",
    "fullName": "LG CineBeam HU85LA",
    "type": "ust",
    "ratio": "0.19",
    "lumens": "2700",
    "keywords": [
      "lg",
      "hu85la",
      "hu85",
      "cinebeam"
    ]
  },
  {
    "brand": "Sony",
    "model": "VPL-XW5000ES",
    "fullName": "Sony VPL-XW5000ES",
    "type": "long",
    "ratio": "1.27-2.73",
    "lumens": "2000",
    "keywords": [
      "sony",
      "vpl-xw5000es",
      "xw5000",
      "vpl"
    ]
  },
  {
    "brand": "Sony",
    "model": "VPL-VW325ES",
    "fullName": "Sony VPL-VW325ES",
    "type": "long",
    "ratio": "1.38-2.83",
    "lumens": "1500",
    "keywords": [
      "sony",
      "vpl-vw325es",
      "vw325",
      "vpl"
    ]
  },
  {
    "brand": "Sony",
    "model": "VPL-VW598",
    "fullName": "Sony VPL-VW598",
    "type": "long",
    "ratio": "1.38-2.83",
    "lumens": "1800",
    "keywords": [
      "sony",
      "vpl-vw598",
      "vw598",
      "vpl"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-NZ8",
    "fullName": "JVC DLA-NZ8",
    "type": "long",
    "ratio": "1.35-2.70",
    "lumens": "2500",
    "keywords": [
      "jvc",
      "dla-nz8",
      "nz8",
      "dla"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-NZ9",
    "fullName": "JVC DLA-NZ9",
    "type": "long",
    "ratio": "1.35-2.70",
    "lumens": "3000",
    "keywords": [
      "jvc",
      "dla-nz9",
      "nz9",
      "dla"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-NX7",
    "fullName": "JVC DLA-NX7",
    "type": "long",
    "ratio": "1.35-2.70",
    "lumens": "1900",
    "keywords": [
      "jvc",
      "dla-nx7",
      "nx7",
      "dla"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-NX9",
    "fullName": "JVC DLA-NX9",
    "type": "long",
    "ratio": "1.35-2.70",
    "lumens": "2200",
    "keywords": [
      "jvc",
      "dla-nx9",
      "nx9",
      "dla"
    ]
  },
  {
    "brand": "Hisense",
    "model": "L9G",
    "fullName": "Hisense L9G TriChroma",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3000",
    "laser3": true,
    "keywords": [
      "hisense",
      "l9g",
      "trichroma",
      "laser tv"
    ]
  },
  {
    "brand": "Hisense",
    "model": "L5G",
    "fullName": "Hisense L5G",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2700",
    "keywords": [
      "hisense",
      "l5g"
    ]
  },
  {
    "brand": "Hisense",
    "model": "PX1-PRO",
    "fullName": "Hisense PX1-PRO",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2200",
    "keywords": [
      "hisense",
      "px1-pro",
      "px1 pro",
      "px1"
    ]
  },
  {
    "brand": "Dangbei",
    "model": "Mars Pro",
    "fullName": "Dangbei Mars Pro",
    "type": "long",
    "ratio": "1.27",
    "lumens": "3200",
    "keywords": [
      "dangbei",
      "mars pro",
      "marspro"
    ]
  },
  {
    "brand": "Dangbei",
    "model": "Neo",
    "fullName": "Dangbei Neo",
    "type": "long",
    "ratio": "1.2",
    "lumens": "540",
    "keywords": [
      "dangbei",
      "neo"
    ]
  },
  {
    "brand": "Nebula",
    "model": "Cosmos Laser 4K",
    "fullName": "Anker Nebula Cosmos Laser 4K",
    "type": "long",
    "ratio": "1.27",
    "lumens": "2200",
    "keywords": [
      "nebula",
      "cosmos",
      "laser 4k",
      "anker"
    ]
  },
  {
    "brand": "Awol Vision",
    "model": "LTV-3000",
    "fullName": "Awol Vision LTV-3000",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3000",
    "keywords": [
      "awol",
      "ltv-3000",
      "ltv3000",
      "awol vision"
    ]
  },
  {
    "brand": "Awol Vision",
    "model": "LTV-3500",
    "fullName": "Awol Vision LTV-3500",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3500",
    "keywords": [
      "awol",
      "ltv-3500",
      "ltv3500",
      "awol vision"
    ]
  },
  {
    "brand": "Epson",
    "model": "EH-TW7100",
    "fullName": "Epson EH-TW7100",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "3000",
    "keywords": [
      "epson",
      "eh-tw7100",
      "tw7100",
      "tw 7100"
    ]
  },
  {
    "brand": "Epson",
    "model": "EH-TW9400",
    "fullName": "Epson EH-TW9400",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "2600",
    "keywords": [
      "epson",
      "eh-tw9400",
      "tw9400",
      "tw 9400"
    ]
  },
  {
    "brand": "Epson",
    "model": "LS300",
    "fullName": "Epson EpiqVision LS300",
    "type": "ust",
    "ratio": "0.27",
    "lumens": "3600",
    "keywords": [
      "epson",
      "ls300",
      "ls 300",
      "epiqvision"
    ]
  },
  {
    "brand": "Epson",
    "model": "LS500",
    "fullName": "Epson EpiqVision LS500",
    "type": "ust",
    "ratio": "0.27",
    "lumens": "4000",
    "keywords": [
      "epson",
      "ls500",
      "ls 500",
      "epiqvision"
    ]
  },
  {
    "brand": "Epson",
    "model": "2250",
    "fullName": "Epson Home Cinema 2250",
    "type": "long",
    "ratio": "1.02-1.23",
    "lumens": "2700",
    "keywords": [
      "epson",
      "2250",
      "home cinema"
    ]
  },
  {
    "brand": "BenQ",
    "model": "TK700STi",
    "fullName": "BenQ TK700STi",
    "type": "long",
    "ratio": "0.9-1.08",
    "lumens": "3000",
    "keywords": [
      "benq",
      "tk700sti",
      "tk700",
      "tk 700"
    ]
  },
  {
    "brand": "BenQ",
    "model": "TK850i",
    "fullName": "BenQ TK850i",
    "type": "long",
    "ratio": "1.13-1.47",
    "lumens": "3000",
    "keywords": [
      "benq",
      "tk850i",
      "tk850",
      "tk 850"
    ]
  },
  {
    "brand": "BenQ",
    "model": "W1800i",
    "fullName": "BenQ W1800i",
    "type": "long",
    "ratio": "1.13-1.47",
    "lumens": "2000",
    "keywords": [
      "benq",
      "w1800i",
      "w1800",
      "w 1800"
    ]
  },
  {
    "brand": "BenQ",
    "model": "HT2050A",
    "fullName": "BenQ HT2050A",
    "type": "long",
    "ratio": "1.15-1.5",
    "lumens": "2200",
    "keywords": [
      "benq",
      "ht2050a",
      "ht2050",
      "ht 2050"
    ]
  },
  {
    "brand": "BenQ",
    "model": "HT3550",
    "fullName": "BenQ HT3550",
    "type": "long",
    "ratio": "1.13-1.47",
    "lumens": "2000",
    "keywords": [
      "benq",
      "ht3550",
      "ht 3550"
    ]
  },
  {
    "brand": "BenQ",
    "model": "X3000i",
    "fullName": "BenQ X3000i",
    "type": "long",
    "ratio": "1.127-1.46",
    "lumens": "3000",
    "keywords": [
      "benq",
      "x3000i",
      "x3000",
      "x 3000"
    ]
  },
  {
    "brand": "Optoma",
    "model": "UHD35",
    "fullName": "Optoma UHD35",
    "type": "long",
    "ratio": "1.21-1.59",
    "lumens": "3600",
    "keywords": [
      "optoma",
      "uhd35",
      "uhd 35"
    ]
  },
  {
    "brand": "Optoma",
    "model": "UHD50X",
    "fullName": "Optoma UHD50X",
    "type": "long",
    "ratio": "1.21-1.59",
    "lumens": "3400",
    "keywords": [
      "optoma",
      "uhd50x",
      "uhd 50x",
      "uhd50"
    ]
  },
  {
    "brand": "Optoma",
    "model": "GT1080HDR",
    "fullName": "Optoma GT1080HDR",
    "type": "long",
    "ratio": "0.49",
    "lumens": "3800",
    "keywords": [
      "optoma",
      "gt1080hdr",
      "gt1080",
      "gt 1080"
    ]
  },
  {
    "brand": "Optoma",
    "model": "HD146X",
    "fullName": "Optoma HD146X",
    "type": "long",
    "ratio": "1.47-1.62",
    "lumens": "3600",
    "keywords": [
      "optoma",
      "hd146x",
      "hd146",
      "hd 146"
    ]
  },
  {
    "brand": "Optoma",
    "model": "UHD52ALV",
    "fullName": "Optoma UHD52ALV",
    "type": "long",
    "ratio": "1.21-1.59",
    "lumens": "3500",
    "keywords": [
      "optoma",
      "uhd52alv",
      "uhd52",
      "uhd 52"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "MoGo 2 Pro",
    "fullName": "XGIMI MoGo 2 Pro",
    "type": "long",
    "ratio": "1.2",
    "lumens": "400",
    "keywords": [
      "xgimi",
      "mogo 2 pro",
      "mogo2pro",
      "mogo"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "Halo+",
    "fullName": "XGIMI Halo+",
    "type": "long",
    "ratio": "1.2",
    "lumens": "900",
    "keywords": [
      "xgimi",
      "halo+",
      "halo plus",
      "halo"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "Horizon",
    "fullName": "XGIMI Horizon",
    "type": "long",
    "ratio": "1.2",
    "lumens": "2200",
    "keywords": [
      "xgimi",
      "horizon"
    ]
  },
  {
    "brand": "Sony",
    "model": "VPL-VW295ES",
    "fullName": "Sony VPL-VW295ES",
    "type": "long",
    "ratio": "1.38-2.83",
    "lumens": "1500",
    "keywords": [
      "sony",
      "vpl-vw295es",
      "vw295",
      "vpl"
    ]
  },
  {
    "brand": "Sony",
    "model": "VPL-VW695ES",
    "fullName": "Sony VPL-VW695ES",
    "type": "long",
    "ratio": "1.38-2.83",
    "lumens": "1800",
    "keywords": [
      "sony",
      "vpl-vw695es",
      "vw695",
      "vpl"
    ]
  },
  {
    "brand": "Sony",
    "model": "VPL-VW898",
    "fullName": "Sony VPL-VW898",
    "type": "long",
    "ratio": "1.38-2.83",
    "lumens": "2200",
    "keywords": [
      "sony",
      "vpl-vw898",
      "vw898",
      "vpl"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-NX5",
    "fullName": "JVC DLA-NX5",
    "type": "long",
    "ratio": "1.35-2.70",
    "lumens": "1800",
    "keywords": [
      "jvc",
      "dla-nx5",
      "nx5",
      "dla"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-RS3100",
    "fullName": "JVC DLA-RS3100",
    "type": "long",
    "ratio": "1.35-2.70",
    "lumens": "2500",
    "keywords": [
      "jvc",
      "dla-rs3100",
      "rs3100",
      "dla"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-RS2100",
    "fullName": "JVC DLA-RS2100",
    "type": "long",
    "ratio": "1.35-2.70",
    "lumens": "2200",
    "keywords": [
      "jvc",
      "dla-rs2100",
      "rs2100",
      "dla"
    ]
  },
  {
    "brand": "Samsung",
    "model": "The Freestyle",
    "fullName": "Samsung The Freestyle",
    "type": "long",
    "ratio": "1.2",
    "lumens": "550",
    "keywords": [
      "samsung",
      "freestyle",
      "the freestyle"
    ]
  },
  {
    "brand": "LG",
    "model": "HU715Q",
    "fullName": "LG CineBeam HU715Q",
    "type": "ust",
    "ratio": "0.22",
    "lumens": "2500",
    "keywords": [
      "lg",
      "hu715q",
      "hu715",
      "cinebeam"
    ]
  },
  {
    "brand": "LG",
    "model": "HU710PW",
    "fullName": "LG CineBeam HU710PW",
    "type": "long",
    "ratio": "1.2",
    "lumens": "2000",
    "keywords": [
      "lg",
      "hu710pw",
      "hu710",
      "cinebeam"
    ]
  },
  {
    "brand": "Hisense",
    "model": "L9H",
    "fullName": "Hisense L9H TriChroma",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3000",
    "laser3": true,
    "keywords": [
      "hisense",
      "l9h",
      "trichroma"
    ]
  },
  {
    "brand": "Hisense",
    "model": "C1",
    "fullName": "Hisense C1",
    "type": "long",
    "ratio": "1.2",
    "lumens": "1600",
    "laser3": true,
    "keywords": [
      "hisense",
      "c1"
    ]
  },
  {
    "brand": "Hisense",
    "model": "PX2-PRO",
    "fullName": "Hisense PX2-PRO",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2700",
    "keywords": [
      "hisense",
      "px2-pro",
      "px2 pro",
      "px2"
    ]
  },
  {
    "brand": "Formovie",
    "model": "THEATER PRO",
    "fullName": "Formovie THEATER PRO",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "2800",
    "keywords": [
      "formovie",
      "theater pro",
      "theaterpro"
    ]
  },
  {
    "brand": "Dangbei",
    "model": "X5",
    "fullName": "Dangbei X5",
    "type": "long",
    "ratio": "1.27",
    "lumens": "2500",
    "keywords": [
      "dangbei",
      "x5"
    ]
  },
  {
    "brand": "Dangbei",
    "model": "X3 Air",
    "fullName": "Dangbei X3 Air",
    "type": "long",
    "ratio": "1.27",
    "lumens": "3050",
    "keywords": [
      "dangbei",
      "x3 air",
      "x3air",
      "x3"
    ]
  },
  {
    "brand": "Vava",
    "model": "Chroma",
    "fullName": "Vava Chroma",
    "type": "ust",
    "ratio": "0.233",
    "lumens": "2500",
    "keywords": [
      "vava",
      "chroma"
    ]
  },
  {
    "brand": "Vava",
    "model": "4K",
    "fullName": "Vava 4K UST",
    "type": "ust",
    "ratio": "0.233",
    "lumens": "2500",
    "keywords": [
      "vava",
      "4k",
      "ust"
    ]
  },
  {
    "brand": "Xiaomi",
    "model": "Mi Laser Projector",
    "fullName": "Xiaomi Mi Laser Projector",
    "type": "ust",
    "ratio": "0.233",
    "lumens": "5000",
    "keywords": [
      "xiaomi",
      "mi laser",
      "laser projector"
    ]
  },
  {
    "brand": "Xiaomi",
    "model": "Mi Smart Projector 2",
    "fullName": "Xiaomi Mi Smart Projector 2",
    "type": "long",
    "ratio": "1.2",
    "lumens": "1300",
    "keywords": [
      "xiaomi",
      "mi smart",
      "smart projector"
    ]
  },
  {
    "brand": "ViewSonic",
    "model": "X10-4K",
    "fullName": "ViewSonic X10-4K",
    "type": "long",
    "ratio": "1.3",
    "lumens": "2400",
    "keywords": [
      "viewsonic",
      "x10-4k",
      "x10",
      "x 10"
    ]
  },
  {
    "brand": "ViewSonic",
    "model": "PX701-4K",
    "fullName": "ViewSonic PX701-4K",
    "type": "long",
    "ratio": "1.5-1.65",
    "lumens": "3200",
    "keywords": [
      "viewsonic",
      "px701-4k",
      "px701",
      "px 701"
    ]
  },
  {
    "brand": "ViewSonic",
    "model": "LS800HD",
    "fullName": "ViewSonic LS800HD",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3500",
    "keywords": [
      "viewsonic",
      "ls800hd",
      "ls800",
      "ls 800"
    ]
  },
  {
    "brand": "Acer",
    "model": "H6810BD",
    "fullName": "Acer H6810BD",
    "type": "long",
    "ratio": "1.13-1.46",
    "lumens": "3500",
    "keywords": [
      "acer",
      "h6810bd",
      "h6810",
      "h 6810"
    ]
  },
  {
    "brand": "Acer",
    "model": "V7850",
    "fullName": "Acer V7850",
    "type": "long",
    "ratio": "1.39-2.22",
    "lumens": "2200",
    "keywords": [
      "acer",
      "v7850",
      "v 7850"
    ]
  },
  {
    "brand": "Nebula",
    "model": "Capsule 3",
    "fullName": "Anker Nebula Capsule 3",
    "type": "long",
    "ratio": "1.2",
    "lumens": "200",
    "keywords": [
      "nebula",
      "capsule 3",
      "capsule3",
      "anker"
    ]
  },
  {
    "brand": "Nebula",
    "model": "Mars 3",
    "fullName": "Anker Nebula Mars 3",
    "type": "long",
    "ratio": "1.2",
    "lumens": "1000",
    "keywords": [
      "nebula",
      "mars 3",
      "mars3",
      "anker"
    ]
  },
  {
    "brand": "Awol Vision",
    "model": "LTV-2500",
    "fullName": "Awol Vision LTV-2500",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2500",
    "keywords": [
      "awol",
      "ltv-2500",
      "ltv2500",
      "awol vision"
    ]
  },
  {
    "brand": "Fengmi",
    "model": "T1",
    "fullName": "Fengmi T1",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "2800",
    "keywords": [
      "fengmi",
      "t1"
    ]
  },
  {
    "brand": "Fengmi",
    "model": "R1 Nano",
    "fullName": "Fengmi R1 Nano",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "1200",
    "keywords": [
      "fengmi",
      "r1 nano",
      "r1nano",
      "r1"
    ]
  },
  {
    "brand": "Wemax",
    "model": "Go Pro",
    "fullName": "Wemax Go Pro",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2100",
    "keywords": [
      "wemax",
      "go pro",
      "gopro"
    ]
  },
  {
    "brand": "Wemax",
    "model": "Nova",
    "fullName": "Wemax Nova",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2100",
    "keywords": [
      "wemax",
      "nova"
    ]
  },
  {
    "brand": "Hisense",
    "model": "PX3 Pro",
    "fullName": "Hisense PX3 Pro",
    "type": "ust",
    "ratio": "0.22",
    "lumens": "3000",
    "laser3": true,
    "keywords": [
      "hisense",
      "px3 pro",
      "px3pro",
      "px3-pro"
    ]
  },
  {
    "brand": "Hisense",
    "model": "C2 Ultra",
    "fullName": "Hisense C2 Ultra",
    "type": "long",
    "ratio": "0.9-1.5",
    "lumens": "3000",
    "laser3": true,
    "keywords": [
      "hisense",
      "c2 ultra",
      "c2ultra"
    ]
  },
  {
    "brand": "Hisense",
    "model": "C2 Pro",
    "fullName": "Hisense C2 Pro",
    "type": "long",
    "ratio": "0.9",
    "lumens": "2400",
    "laser3": true,
    "keywords": [
      "hisense",
      "c2 pro",
      "c2pro"
    ]
  },
  {
    "brand": "Hisense",
    "model": "L9Q",
    "fullName": "Hisense L9Q",
    "type": "ust",
    "ratio": "0.18",
    "lumens": "5000",
    "laser3": true,
    "keywords": [
      "hisense",
      "l9q",
      "l9 q"
    ]
  },
  {
    "brand": "Hisense",
    "model": "XR10",
    "fullName": "Hisense XR10",
    "type": "long",
    "ratio": "0.84-2.0",
    "lumens": "6000",
    "laser3": true,
    "keywords": [
      "hisense",
      "xr10",
      "xr 10"
    ]
  },
  {
    "brand": "Hisense",
    "model": "L5H",
    "fullName": "Hisense L5H",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2500",
    "keywords": [
      "hisense",
      "l5h",
      "l5 h"
    ]
  },
  {
    "brand": "Samsung",
    "model": "LSP3B",
    "fullName": "Samsung The Freestyle Gen 2 (LSP3B)",
    "type": "long",
    "ratio": "1.0-1.55",
    "lumens": "550",
    "keywords": [
      "samsung",
      "lsp3b",
      "freestyle",
      "the freestyle",
      "lsp3"
    ]
  },
  {
    "brand": "Epson",
    "model": "EH-LS830",
    "fullName": "Epson EH-LS830",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "4000",
    "keywords": [
      "epson",
      "eh-ls830",
      "ls830",
      "ls 830"
    ]
  },
  {
    "brand": "Epson",
    "model": "EH-LS800B",
    "fullName": "Epson EH-LS800B",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "4000",
    "keywords": [
      "epson",
      "eh-ls800b",
      "ls800b",
      "ls800",
      "ls 800"
    ]
  },
  {
    "brand": "Epson",
    "model": "EH-TW7000",
    "fullName": "Epson EH-TW7000",
    "type": "long",
    "ratio": "1.32-2.15",
    "lumens": "3000",
    "keywords": [
      "epson",
      "eh-tw7000",
      "tw7000",
      "tw 7000"
    ]
  },
  {
    "brand": "Epson",
    "model": "EH-TW9700",
    "fullName": "Epson EH-TW9700",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "2600",
    "keywords": [
      "epson",
      "eh-tw9700",
      "tw9700",
      "tw 9700"
    ]
  },
  {
    "brand": "Epson",
    "model": "EH-TW6150",
    "fullName": "Epson EH-TW6150",
    "type": "long",
    "ratio": "1.32-2.15",
    "lumens": "2800",
    "keywords": [
      "epson",
      "eh-tw6150",
      "tw6150",
      "tw 6150"
    ]
  },
  {
    "brand": "Epson",
    "model": "LS12000B",
    "fullName": "Epson LS12000B",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "2700",
    "keywords": [
      "epson",
      "ls12000b",
      "ls12000",
      "ls 12000"
    ]
  },
  {
    "brand": "Epson",
    "model": "5050UB",
    "fullName": "Epson Home Cinema 5050UB",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "2600",
    "keywords": [
      "epson",
      "5050ub",
      "5050",
      "home cinema 5050"
    ]
  },
  {
    "brand": "Epson",
    "model": "5080UB",
    "fullName": "Epson Home Cinema 5080UB",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "2600",
    "keywords": [
      "epson",
      "5080ub",
      "5080",
      "home cinema 5080"
    ]
  },
  {
    "brand": "BenQ",
    "model": "W4000i",
    "fullName": "BenQ W4000i",
    "type": "long",
    "ratio": "1.15-1.5",
    "lumens": "3200",
    "keywords": [
      "benq",
      "w4000i",
      "w4000",
      "w 4000"
    ]
  },
  {
    "brand": "BenQ",
    "model": "TK860i",
    "fullName": "BenQ TK860i",
    "type": "long",
    "ratio": "1.13-1.46",
    "lumens": "3300",
    "keywords": [
      "benq",
      "tk860i",
      "tk860",
      "tk 860"
    ]
  },
  {
    "brand": "BenQ",
    "model": "X500i",
    "fullName": "BenQ X500i",
    "type": "long",
    "ratio": "1.1-1.2",
    "lumens": "2200",
    "keywords": [
      "benq",
      "x500i",
      "x500",
      "x 500"
    ]
  },
  {
    "brand": "BenQ",
    "model": "V5000i",
    "fullName": "BenQ V5000i",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2500",
    "keywords": [
      "benq",
      "v5000i",
      "v5000",
      "v 5000"
    ]
  },
  {
    "brand": "BenQ",
    "model": "GP510",
    "fullName": "BenQ GP510",
    "type": "long",
    "ratio": "1.2",
    "lumens": "1000",
    "keywords": [
      "benq",
      "gp510",
      "gp 510"
    ]
  },
  {
    "brand": "BenQ",
    "model": "W5700",
    "fullName": "BenQ W5700",
    "type": "long",
    "ratio": "1.5-1.65",
    "lumens": "1800",
    "keywords": [
      "benq",
      "w5700",
      "w 5700"
    ]
  },
  {
    "brand": "Sony",
    "model": "VPL-XW6000ES",
    "fullName": "Sony VPL-XW6000ES",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "2500",
    "keywords": [
      "sony",
      "vpl-xw6000es",
      "xw6000es",
      "xw6000",
      "xw 6000"
    ]
  },
  {
    "brand": "Sony",
    "model": "VPL-XW7000ES",
    "fullName": "Sony VPL-XW7000ES",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "3200",
    "keywords": [
      "sony",
      "vpl-xw7000es",
      "xw7000es",
      "xw7000",
      "xw 7000"
    ]
  },
  {
    "brand": "Sony",
    "model": "VPL-VW590ES",
    "fullName": "Sony VPL-VW590ES",
    "type": "long",
    "ratio": "1.38-2.21",
    "lumens": "1800",
    "keywords": [
      "sony",
      "vpl-vw590es",
      "vw590es",
      "vw590",
      "vw 590"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-NZ800",
    "fullName": "JVC DLA-NZ800",
    "type": "long",
    "ratio": "1.4-2.8",
    "lumens": "3000",
    "keywords": [
      "jvc",
      "dla-nz800",
      "nz800",
      "nz 800"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-NZ900",
    "fullName": "JVC DLA-NZ900",
    "type": "long",
    "ratio": "1.4-2.8",
    "lumens": "3000",
    "keywords": [
      "jvc",
      "dla-nz900",
      "nz900",
      "nz 900"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-A2",
    "fullName": "JVC DLA-A2",
    "type": "long",
    "ratio": "1.4-2.8",
    "lumens": "2000",
    "keywords": [
      "jvc",
      "dla-a2",
      "a2",
      "dla a2"
    ]
  },
  {
    "brand": "JVC",
    "model": "DLA-NZ7",
    "fullName": "JVC DLA-NZ7",
    "type": "long",
    "ratio": "1.4-2.8",
    "lumens": "2500",
    "keywords": [
      "jvc",
      "dla-nz7",
      "nz7",
      "nz 7"
    ]
  },
  {
    "brand": "Optoma",
    "model": "UHZ66",
    "fullName": "Optoma UHZ66",
    "type": "long",
    "ratio": "1.39-2.22",
    "lumens": "4500",
    "keywords": [
      "optoma",
      "uhz66",
      "uhz 66"
    ]
  },
  {
    "brand": "Optoma",
    "model": "UHZ65",
    "fullName": "Optoma UHZ65",
    "type": "long",
    "ratio": "1.39-2.22",
    "lumens": "3600",
    "keywords": [
      "optoma",
      "uhz65",
      "uhz 65"
    ]
  },
  {
    "brand": "Optoma",
    "model": "P2+",
    "fullName": "Optoma P2+",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3000",
    "keywords": [
      "optoma",
      "p2+",
      "p2 plus",
      "p2plus"
    ]
  },
  {
    "brand": "Optoma",
    "model": "ZU720T",
    "fullName": "Optoma ZU720T",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "7200",
    "keywords": [
      "optoma",
      "zu720t",
      "zu720",
      "zu 720"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "RS Pro 3",
    "fullName": "XGIMI RS Pro 3",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "2200",
    "keywords": [
      "xgimi",
      "rs pro 3",
      "rspro3",
      "rs pro3"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "RS 10X",
    "fullName": "XGIMI RS 10X",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "2400",
    "keywords": [
      "xgimi",
      "rs 10x",
      "rs10x",
      "10x"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "Aura 2",
    "fullName": "XGIMI Aura 2",
    "type": "ust",
    "ratio": "0.177",
    "lumens": "2300",
    "keywords": [
      "xgimi",
      "aura 2",
      "aura2"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "Horizon Ultra",
    "fullName": "XGIMI Horizon Ultra",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "2300",
    "keywords": [
      "xgimi",
      "horizon ultra",
      "horizonultra"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "MoGo 3 Pro",
    "fullName": "XGIMI MoGo 3 Pro",
    "type": "long",
    "ratio": "1.2",
    "lumens": "800",
    "keywords": [
      "xgimi",
      "mogo 3 pro",
      "mogo3pro",
      "mogo 3"
    ]
  },
  {
    "brand": "JMGO",
    "model": "N1 Ultra",
    "fullName": "JMGO N1 Ultra",
    "type": "long",
    "ratio": "1.5",
    "lumens": "4000",
    "laser3": true,
    "keywords": [
      "jmgo",
      "n1 ultra",
      "n1ultra"
    ]
  },
  {
    "brand": "JMGO",
    "model": "N1 Pro",
    "fullName": "JMGO N1 Pro",
    "type": "long",
    "ratio": "1.5",
    "lumens": "2200",
    "laser3": true,
    "keywords": [
      "jmgo",
      "n1 pro",
      "n1pro"
    ]
  },
  {
    "brand": "JMGO",
    "model": "N1S Ultra",
    "fullName": "JMGO N1S Ultra",
    "type": "long",
    "ratio": "1.2",
    "lumens": "2800",
    "laser3": true,
    "keywords": [
      "jmgo",
      "n1s ultra",
      "n1sultra",
      "n1s"
    ]
  },
  {
    "brand": "JMGO",
    "model": "N1S Ultimate 4K",
    "fullName": "JMGO N1S Ultimate 4K",
    "type": "long",
    "ratio": "1.2",
    "lumens": "3300",
    "laser3": true,
    "keywords": [
      "jmgo",
      "n1s ultimate 4k",
      "n1s ultimate",
      "n1sultimate",
      "n1s ultimate"
    ]
  },
  {
    "brand": "JMGO",
    "model": "O2 Ultra",
    "fullName": "JMGO O2 Ultra",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "4000",
    "keywords": [
      "jmgo",
      "o2 ultra",
      "o2ultra"
    ]
  },
  {
    "brand": "JMGO",
    "model": "U2",
    "fullName": "JMGO U2",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "4000",
    "keywords": [
      "jmgo",
      "u2",
      "jmgo u2"
    ]
  },
  {
    "brand": "JMGO",
    "model": "G3",
    "fullName": "JMGO G3",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "2200",
    "keywords": [
      "jmgo",
      "g3",
      "jmgo g3"
    ]
  },
  {
    "brand": "Dangbei",
    "model": "Mars Pro 2",
    "fullName": "Dangbei Mars Pro 2",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "3200",
    "keywords": [
      "dangbei",
      "mars pro 2",
      "marspro2",
      "mars pro2"
    ]
  },
  {
    "brand": "Dangbei",
    "model": "DBOX03",
    "fullName": "Dangbei DBOX03 (MP1 Max)",
    "type": "long",
    "ratio": "1.2",
    "lumens": "3100",
    "keywords": [
      "dangbei",
      "dbox03",
      "dbox 03",
      "mp1 max"
    ]
  },
  {
    "brand": "Dangbei",
    "model": "Atlas Pro",
    "fullName": "Dangbei Atlas Pro",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "2200",
    "keywords": [
      "dangbei",
      "atlas pro",
      "atlaspro"
    ]
  },
  {
    "brand": "Dangbei",
    "model": "Atom",
    "fullName": "Dangbei Atom",
    "type": "long",
    "ratio": "1.2",
    "lumens": "800",
    "keywords": [
      "dangbei",
      "atom",
      "dangbei atom"
    ]
  },
  {
    "brand": "Dangbei",
    "model": "X3 Pro",
    "fullName": "Dangbei X3 Pro",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "2800",
    "keywords": [
      "dangbei",
      "x3 pro",
      "x3pro"
    ]
  },
  {
    "brand": "Awol Vision",
    "model": "LTV-3500 Pro",
    "fullName": "Awol Vision LTV-3500 Pro",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3500",
    "keywords": [
      "awol",
      "ltv-3500 pro",
      "ltv3500pro",
      "ltv-3500",
      "ltv3500"
    ]
  },
  {
    "brand": "Awol Vision",
    "model": "LTV-3000 Pro",
    "fullName": "Awol Vision LTV-3000 Pro",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "3000",
    "keywords": [
      "awol",
      "ltv-3000 pro",
      "ltv3000pro",
      "ltv-3000",
      "ltv3000"
    ]
  },
  {
    "brand": "Vava",
    "model": "Chroma Triple Laser",
    "fullName": "Vava Chroma Triple Laser",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "2500",
    "laser3": true,
    "keywords": [
      "vava",
      "chroma triple laser",
      "chroma",
      "triple laser"
    ]
  },
  {
    "brand": "Vava",
    "model": "4K UST",
    "fullName": "Vava 4K UST Laser Projector",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "6000",
    "keywords": [
      "vava",
      "4k ust",
      "vava 4k"
    ]
  },
  {
    "brand": "Wemax",
    "model": "Dice",
    "fullName": "Wemax Dice",
    "type": "long",
    "ratio": "1.2",
    "lumens": "700",
    "keywords": [
      "wemax",
      "dice",
      "wemax dice"
    ]
  },
  {
    "brand": "Wemax",
    "model": "A300 Pro",
    "fullName": "Wemax A300 Pro",
    "type": "long",
    "ratio": "1.2",
    "lumens": "300",
    "keywords": [
      "wemax",
      "a300 pro",
      "a300pro",
      "a300"
    ]
  },
  {
    "brand": "Wemax",
    "model": "Cosmos Max",
    "fullName": "Wemax Cosmos Max",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2100",
    "keywords": [
      "wemax",
      "cosmos max",
      "cosmos"
    ]
  },
  {
    "brand": "ViewSonic",
    "model": "X2-4K",
    "fullName": "ViewSonic X2-4K",
    "type": "long",
    "ratio": "1.3",
    "lumens": "2000",
    "keywords": [
      "viewsonic",
      "x2-4k",
      "x2 4k",
      "x2"
    ]
  },
  {
    "brand": "ViewSonic",
    "model": "PX748-4K",
    "fullName": "ViewSonic PX748-4K",
    "type": "long",
    "ratio": "1.13-1.46",
    "lumens": "4000",
    "keywords": [
      "viewsonic",
      "px748-4k",
      "px748",
      "px 748"
    ]
  },
  {
    "brand": "ViewSonic",
    "model": "LS831WU",
    "fullName": "ViewSonic LS831WU",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "5000",
    "keywords": [
      "viewsonic",
      "ls831wu",
      "ls831",
      "ls 831"
    ]
  },
  {
    "brand": "Leica",
    "model": "Cine 1",
    "fullName": "Leica Cine 1",
    "type": "ust",
    "ratio": "0.25",
    "lumens": "2500",
    "keywords": [
      "leica",
      "cine 1",
      "cine1",
      "leica cine"
    ]
  },
  {
    "brand": "Leica",
    "model": "Cine Play 1",
    "fullName": "Leica Cine Play 1",
    "type": "long",
    "ratio": "0.9-1.5",
    "lumens": "3000",
    "laser3": true,
    "keywords": [
      "leica",
      "cine play 1",
      "cine play1",
      "play 1",
      "leica play"
    ]
  },
  {
    "brand": "Formovie",
    "model": "Cinema Edge",
    "fullName": "Formovie Cinema Edge",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "2800",
    "keywords": [
      "formovie",
      "cinema edge",
      "cinemaedge"
    ]
  },
  {
    "brand": "Formovie",
    "model": "P1 Pro",
    "fullName": "Formovie P1 Pro",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "1800",
    "keywords": [
      "formovie",
      "p1 pro",
      "p1pro"
    ]
  },
  {
    "brand": "Formovie",
    "model": "Theater",
    "fullName": "Formovie Theater",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "2800",
    "keywords": [
      "formovie",
      "theater",
      "formovie theater"
    ]
  },
  {
    "brand": "Formovie",
    "model": "S5 Ultra",
    "fullName": "Formovie S5 Ultra",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "4000",
    "keywords": [
      "formovie",
      "s5 ultra",
      "s5ultra"
    ]
  },
  {
    "brand": "Fengmi",
    "model": "T1 Pro",
    "fullName": "Fengmi T1 Pro",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "3500",
    "keywords": [
      "fengmi",
      "t1 pro",
      "t1pro"
    ]
  },
  {
    "brand": "Fengmi",
    "model": "C2 Pro",
    "fullName": "Fengmi C2 Pro",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "2000",
    "keywords": [
      "fengmi",
      "c2 pro",
      "c2pro"
    ]
  },
  {
    "brand": "Fengmi",
    "model": "4K Max",
    "fullName": "Fengmi 4K Laser Cinema Max",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "2800",
    "keywords": [
      "fengmi",
      "4k max",
      "4kmax",
      "cinema max"
    ]
  },
  {
    "brand": "Fengmi",
    "model": "S5 Pro",
    "fullName": "Fengmi S5 Pro",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "1700",
    "keywords": [
      "fengmi",
      "s5 pro",
      "s5pro"
    ]
  },
  {
    "brand": "Xiaomi",
    "model": "Laser Projector 4K",
    "fullName": "Xiaomi Laser Projector 4K",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "2000",
    "keywords": [
      "xiaomi",
      "laser projector 4k",
      "laser 4k"
    ]
  },
  {
    "brand": "Xiaomi",
    "model": "Redmi Projector Pro",
    "fullName": "Xiaomi Redmi Projector Pro",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "1500",
    "keywords": [
      "xiaomi",
      "redmi projector pro",
      "redmi pro"
    ]
  },
  {
    "brand": "Xiaomi",
    "model": "Mijia Laser 5000",
    "fullName": "Xiaomi Mijia Laser Cinema 5000",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "5000",
    "keywords": [
      "xiaomi",
      "mijia laser 5000",
      "mijia 5000",
      "laser 5000"
    ]
  },
  {
    "brand": "Xiaomi",
    "model": "Mijia 4K",
    "fullName": "Xiaomi Mijia 4K Laser",
    "type": "ust",
    "ratio": "0.23",
    "lumens": "4000",
    "keywords": [
      "xiaomi",
      "mijia 4k",
      "mijia4k"
    ]
  },
  {
    "brand": "LG",
    "model": "HU916QE",
    "fullName": "LG HU916QE CineBeam Q",
    "type": "ust",
    "ratio": "0.19",
    "lumens": "3700",
    "keywords": [
      "lg",
      "hu916qe",
      "hu916",
      "cinebeam q"
    ]
  },
  {
    "brand": "LG",
    "model": "HU70LA",
    "fullName": "LG HU70LA CineBeam",
    "type": "long",
    "ratio": "1.36-2.18",
    "lumens": "1500",
    "keywords": [
      "lg",
      "hu70la",
      "hu70",
      "cinebeam"
    ]
  },
  {
    "brand": "LG",
    "model": "HU810PW",
    "fullName": "LG HU810PW CineBeam 4K",
    "type": "long",
    "ratio": "1.36-2.18",
    "lumens": "2700",
    "keywords": [
      "lg",
      "hu810pw",
      "hu810",
      "cinebeam 4k"
    ]
  },
  {
    "brand": "Nebula",
    "model": "Capsule 3 Laser",
    "fullName": "Anker Nebula Capsule 3 Laser",
    "type": "long",
    "ratio": "1.2",
    "lumens": "300",
    "keywords": [
      "nebula",
      "capsule 3 laser",
      "capsule3 laser",
      "capsule laser"
    ]
  },
  {
    "brand": "Nebula",
    "model": "Solar",
    "fullName": "Anker Nebula Solar",
    "type": "long",
    "ratio": "1.3",
    "lumens": "400",
    "keywords": [
      "nebula",
      "solar",
      "nebula solar",
      "anker solar"
    ]
  },
  {
    "brand": "Acer",
    "model": "VL7860",
    "fullName": "Acer VL7860",
    "type": "long",
    "ratio": "1.39-2.09",
    "lumens": "2000",
    "keywords": [
      "acer",
      "vl7860",
      "vl 7860"
    ]
  },
  {
    "brand": "Acer",
    "model": "H6810ATV",
    "fullName": "Acer H6810ATV",
    "type": "long",
    "ratio": "1.13-1.46",
    "lumens": "4000",
    "keywords": [
      "acer",
      "h6810atv",
      "h6810",
      "h 6810"
    ]
  },
  {
    "brand": "Acer",
    "model": "4K UHD Laser",
    "fullName": "Acer 4K UHD Laser Projector",
    "type": "long",
    "ratio": "1.5-1.65",
    "lumens": "4000",
    "keywords": [
      "acer",
      "4k uhd laser",
      "uhd laser"
    ]
  },
  {
    "brand": "Anker",
    "model": "Nebula Vega Portable",
    "fullName": "Anker Nebula Vega Portable",
    "type": "long",
    "ratio": "1.2",
    "lumens": "500",
    "keywords": [
      "anker",
      "nebula vega",
      "vega portable",
      "vega"
    ]
  },
  {
    "brand": "Anker",
    "model": "Mars 3 Air",
    "fullName": "Anker Nebula Mars 3 Air",
    "type": "long",
    "ratio": "1.2",
    "lumens": "400",
    "keywords": [
      "anker",
      "mars 3 air",
      "mars3air",
      "nebula mars 3 air"
    ]
  },
  {
    "brand": "Asus",
    "model": "ZenBeam S2",
    "fullName": "Asus ZenBeam S2",
    "type": "long",
    "ratio": "1.2",
    "lumens": "500",
    "keywords": [
      "asus",
      "zenbeam s2",
      "zenbeam s 2",
      "zenbeam"
    ]
  },
  {
    "brand": "Asus",
    "model": "ProArt Projector A1",
    "fullName": "Asus ProArt Projector A1",
    "type": "long",
    "ratio": "1.26-1.51",
    "lumens": "2500",
    "keywords": [
      "asus",
      "proart projector",
      "proart a1",
      "proart"
    ]
  },
  {
    "brand": "Emotn",
    "model": "H1",
    "fullName": "Emotn H1",
    "type": "long",
    "ratio": "1.2",
    "lumens": "800",
    "keywords": [
      "emotn",
      "h1",
      "emotn h1"
    ]
  },
  {
    "brand": "Emotn",
    "model": "N1",
    "fullName": "Emotn N1",
    "type": "long",
    "ratio": "1.2",
    "lumens": "500",
    "keywords": [
      "emotn",
      "n1",
      "emotn n1"
    ]
  },
  {
    "brand": "BenQ",
    "model": "HT3560",
    "fullName": "BenQ HT3560",
    "type": "long",
    "ratio": "1.13-1.47",
    "lumens": "3400",
    "keywords": [
      "benq",
      "ht3560",
      "ht 3560"
    ]
  },
  {
    "brand": "BenQ",
    "model": "X3100i",
    "fullName": "BenQ X3100i",
    "type": "long",
    "ratio": "1.1-1.2",
    "lumens": "4000",
    "keywords": [
      "benq",
      "x3100i",
      "x3100",
      "x 3100"
    ]
  },
  {
    "brand": "BenQ",
    "model": "W11000H",
    "fullName": "BenQ W11000H",
    "type": "long",
    "ratio": "1.35-2.75",
    "lumens": "2200",
    "keywords": [
      "benq",
      "w11000h",
      "w11000",
      "w 11000"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "Horizon 20 Max",
    "fullName": "XGIMI Horizon 20 Max",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "5700",
    "laser3": true,
    "keywords": [
      "xgimi",
      "horizon 20 max",
      "horizon20max",
      "horizon 20max"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "Horizon 20 Pro",
    "fullName": "XGIMI Horizon 20 Pro",
    "type": "long",
    "ratio": "1.2-1.5",
    "lumens": "4100",
    "laser3": true,
    "keywords": [
      "xgimi",
      "horizon 20 pro",
      "horizon20pro",
      "horizon 20pro"
    ]
  },
  {
    "brand": "XGIMI",
    "model": "Titan Noir Max",
    "fullName": "XGIMI Titan Noir Max",
    "type": "long",
    "ratio": "1.3-2.0",
    "lumens": "3000",
    "laser3": false,
    "keywords": [
      "xgimi",
      "titan noir max",
      "titan noir",
      "titannoir"
    ]
  },
  {
    "brand": "Valerion",
    "model": "VisionMaster Pro 2",
    "fullName": "Valerion VisionMaster Pro 2",
    "type": "long",
    "ratio": "0.9-1.5",
    "lumens": "3000",
    "laser3": true,
    "keywords": [
      "valerion",
      "visionmaster pro 2",
      "visionmaster pro2"
    ]
  },
  {
    "brand": "Valerion",
    "model": "VisionMaster Max",
    "fullName": "Valerion VisionMaster Max",
    "type": "long",
    "ratio": "1.3-1.7",
    "lumens": "4000",
    "laser3": true,
    "keywords": [
      "valerion",
      "visionmaster max",
      "visionmastermax"
    ]
  },
  {
    "brand": "Valerion",
    "model": "StreamMaster Plus 2",
    "fullName": "Valerion StreamMaster Plus 2",
    "type": "long",
    "ratio": "1.2",
    "lumens": "2000",
    "laser3": true,
    "keywords": [
      "valerion",
      "streammaster plus 2",
      "streammaster plus2",
      "streammaster"
    ]
  },
  {
    "brand": "AWOL Vision",
    "model": "Aetherion Max",
    "fullName": "AWOL Vision Aetherion Max",
    "type": "ust",
    "ratio": "0.24",
    "lumens": "4000",
    "laser3": true,
    "keywords": [
      "awol",
      "aetherion max",
      "aetherion",
      "awol vision aetherion"
    ]
  },
  {
    "brand": "BenQ",
    "model": "V5010i",
    "fullName": "BenQ V5010i",
    "type": "ust",
    "ratio": "0.253",
    "lumens": "2500",
    "keywords": [
      "benq",
      "v5010i",
      "v5010",
      "v 5010"
    ]
  },
  {
    "brand": "Formovie",
    "model": "Theater Premium",
    "fullName": "Formovie Theater Premium",
    "type": "ust",
    "ratio": "0.21",
    "lumens": "2200",
    "keywords": [
      "formovie",
      "theater premium",
      "theaterpremium"
    ]
  },
  {
    "brand": "Hisense",
    "model": "PL2",
    "fullName": "Hisense Laser Cinema PL2",
    "type": "ust",
    "ratio": "0.22",
    "lumens": "2700",
    "keywords": [
      "hisense",
      "pl2",
      "laser cinema pl2"
    ]
  },
  {
    "brand": "Hisense",
    "model": "PT1",
    "fullName": "Hisense Laser Cinema PT1",
    "type": "ust",
    "ratio": "0.2",
    "lumens": "2500",
    "keywords": [
      "hisense",
      "pt1",
      "laser cinema pt1"
    ]
  },
  {
    "brand": "Hisense",
    "model": "M2 Pro",
    "fullName": "Hisense M2 Pro",
    "type": "long",
    "ratio": "1.0-1.3",
    "lumens": "1300",
    "keywords": [
      "hisense",
      "m2 pro",
      "m2pro"
    ]
  },
  {
    "brand": "JMGO",
    "model": "N1S 4K",
    "fullName": "JMGO N1S 4K",
    "type": "long",
    "ratio": "1.2",
    "lumens": "1100",
    "laser3": true,
    "keywords": [
      "jmgo",
      "n1s 4k",
      "n1s4k"
    ]
  },
  {
    "brand": "JMGO",
    "model": "N1S Pro 4K",
    "fullName": "JMGO N1S Pro 4K",
    "type": "long",
    "ratio": "1.2",
    "lumens": "2250",
    "laser3": true,
    "keywords": [
      "jmgo",
      "n1s pro 4k",
      "n1s pro",
      "n1spro4k"
    ]
  },
  {
    "brand": "JMGO",
    "model": "N1S Infinity 4K",
    "fullName": "JMGO N1S Infinity 4K",
    "type": "long",
    "ratio": "1.2",
    "lumens": "2450",
    "laser3": true,
    "keywords": [
      "jmgo",
      "n1s infinity 4k",
      "n1s infinity",
      "n1sinfinity"
    ]
  },
  {
    "brand": "JMGO",
    "model": "O2S Ultra",
    "fullName": "JMGO O2S Ultra",
    "type": "ust",
    "ratio": "0.16",
    "lumens": "3600",
    "keywords": [
      "jmgo",
      "o2s ultra",
      "o2sultra"
    ]
  },
  {
    "brand": "Nebula",
    "model": "X1 Pro",
    "fullName": "Anker Nebula X1 Pro",
    "type": "long",
    "ratio": "0.9-1.5",
    "lumens": "3500",
    "laser3": true,
    "keywords": [
      "nebula",
      "x1 pro",
      "x1pro",
      "nebula x1",
      "nebula x1 pro",
      "anker x1",
      "anker nebula x1"
    ]
  },
  {
    "brand": "TVS REGZA",
    "model": "RLC-V7R MAX",
    "fullName": "TVS REGZA RLC-V7R MAX",
    "type": "long",
    "ratio": "1.3-2.2",
    "lumens": "3500",
    "laser3": false,
    "keywords": [
      "tvs regza",
      "rlc-v7r max",
      "rlc v7r",
      "regza",
      "toshiba"
    ]
  },
  {
    "brand": "Optoma",
    "model": "UHZ58LV",
    "fullName": "Optoma UHZ58LV",
    "type": "long",
    "ratio": "1.4-2.24",
    "lumens": "5500",
    "laser3": false,
    "keywords": [
      "optoma",
      "uhz58lv",
      "uhz58",
      "uhz 58lv"
    ]
  },
  {
    "brand": "Epson",
    "model": "Home Cinema 3200",
    "fullName": "Epson Home Cinema 3200",
    "type": "long",
    "ratio": "1.35-2.84",
    "lumens": "3000",
    "laser3": false,
    "keywords": [
      "epson",
      "home cinema 3200",
      "hc3200",
      "hc 3200",
      "home cinema3200"
    ]
  },
  {
    "brand": "BenQ",
    "model": "TK710",
    "fullName": "BenQ TK710",
    "type": "long",
    "ratio": "1.3-1.56",
    "lumens": "3200",
    "laser3": false,
    "keywords": [
      "benq",
      "tk710",
      "tk 710"
    ]
  }
];
window.ScreenFinderDimensions={
  "version": "R04",
  "sourceFile": "（已压缩）最新参数图英文毫米单位.pdf",
  "sourceSha256": "afe79bebafc4db0b0ad4a4af9f346ac6303a7bf7546b52087c87a4fe915c4418",
  "verifiedAt": "2026-10-09",
  "units": "mm",
  "aspectRatio": "16:9",
  "manufacturingToleranceMm": 20,
  "families": {
    "sProPlusFloor": {
      "page": 1,
      "productIds": [
        "s_pro_plus"
      ],
      "sizes": {
        "72": {
          "W": 1594,
          "H": 896,
          "overallWidthMm": 1831,
          "upperCoverWidthMm": 1670,
          "overallHeightMm": 1211
        },
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2077,
          "upperCoverWidthMm": 1905,
          "overallHeightMm": 1436
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2257,
          "upperCoverWidthMm": 2081,
          "overallHeightMm": 1535
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2431,
          "upperCoverWidthMm": 2276,
          "overallHeightMm": 1635
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2687,
          "upperCoverWidthMm": 2528,
          "overallHeightMm": 1760
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 2910,
          "upperCoverWidthMm": 2730,
          "overallHeightMm": 1884
        },
        "130": {
          "W": 2878,
          "H": 1619,
          "overallWidthMm": 3105,
          "upperCoverWidthMm": 2988,
          "overallHeightMm": 2090
        }
      }
    },
    "liteHyperFloor": {
      "page": 2,
      "productIds": [
        "s_lite",
        "s_lite_p"
      ],
      "sizes": {
        "72": {
          "W": 1594,
          "H": 896,
          "overallWidthMm": 1831,
          "upperCoverWidthMm": 1670,
          "overallHeightMm": 1211
        },
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2077,
          "upperCoverWidthMm": 1905,
          "overallHeightMm": 1436
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2257,
          "upperCoverWidthMm": 2081,
          "overallHeightMm": 1535
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2431,
          "upperCoverWidthMm": 2276,
          "overallHeightMm": 1635
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2687,
          "upperCoverWidthMm": 2528,
          "overallHeightMm": 1760
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 2910,
          "upperCoverWidthMm": 2730,
          "overallHeightMm": 1884
        },
        "130": {
          "W": 2878,
          "H": 1619,
          "overallWidthMm": 3105,
          "upperCoverWidthMm": 2988,
          "overallHeightMm": 2090
        },
        "150": {
          "W": 3321,
          "H": 1867,
          "overallWidthMm": 3587,
          "upperCoverWidthMm": 3395,
          "overallHeightMm": 2480
        }
      }
    },
    "alrFloor": {
      "page": 3,
      "productIds": [
        "s_alr",
        "s_alr_p",
        "s_3d"
      ],
      "sizes": {
        "72": {
          "W": 1594,
          "H": 896,
          "overallWidthMm": 1831,
          "upperCoverWidthMm": 1670,
          "overallHeightMm": 1211
        },
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2077,
          "upperCoverWidthMm": 1905,
          "overallHeightMm": 1436
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2257,
          "upperCoverWidthMm": 2081,
          "overallHeightMm": 1535
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2431,
          "upperCoverWidthMm": 2276,
          "overallHeightMm": 1635
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2687,
          "upperCoverWidthMm": 2528,
          "overallHeightMm": 1760
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 2910,
          "upperCoverWidthMm": 2730,
          "overallHeightMm": 1884
        },
        "135": {
          "W": 2989,
          "H": 1680,
          "overallWidthMm": 3222,
          "upperCoverWidthMm": 3041,
          "overallHeightMm": 2030
        },
        "150": {
          "W": 3321,
          "H": 1867,
          "overallWidthMm": 3587,
          "upperCoverWidthMm": 3395,
          "overallHeightMm": 2257
        }
      }
    },
    "whiteFloor": {
      "page": 4,
      "productIds": [
        "s_white",
        "s_white_p"
      ],
      "sizes": {
        "72": {
          "W": 1594,
          "H": 896,
          "overallWidthMm": 1855,
          "upperCoverWidthMm": 1660,
          "overallHeightMm": 1206
        },
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2141,
          "upperCoverWidthMm": 1905,
          "overallHeightMm": 1456
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2317,
          "upperCoverWidthMm": 2081,
          "overallHeightMm": 1555
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2495,
          "upperCoverWidthMm": 2276,
          "overallHeightMm": 1655
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2720,
          "upperCoverWidthMm": 2528,
          "overallHeightMm": 1780
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 2940,
          "upperCoverWidthMm": 2734,
          "overallHeightMm": 1904
        },
        "135": {
          "W": 2989,
          "H": 1680,
          "overallWidthMm": 3357,
          "upperCoverWidthMm": 3185,
          "overallHeightMm": 2060
        },
        "150": {
          "W": 3321,
          "H": 1867,
          "overallWidthMm": 3600,
          "upperCoverWidthMm": 3425,
          "overallHeightMm": 2277
        }
      }
    },
    "titanAlrFloor": {
      "page": 5,
      "productIds": [
        "titan_obsidian"
      ],
      "sizes": {
        "160": {
          "W": 3542,
          "H": 1992,
          "overallWidthMm": 3849,
          "upperCoverWidthMm": 3652,
          "overallHeightMm": 2500
        },
        "170": {
          "W": 3763,
          "H": 2116,
          "overallWidthMm": 4070,
          "upperCoverWidthMm": 3960,
          "overallHeightMm": 2600
        },
        "180": {
          "W": 3985,
          "H": 2241,
          "overallWidthMm": 4300,
          "upperCoverWidthMm": 4100,
          "overallHeightMm": 2800
        },
        "200": {
          "W": 4428,
          "H": 2490,
          "overallWidthMm": 4700,
          "upperCoverWidthMm": 4540,
          "overallHeightMm": 3000
        }
      }
    },
    "titanWhiteFloor": {
      "page": 6,
      "productIds": [
        "titan_white"
      ],
      "sizes": {
        "160": {
          "W": 3542,
          "H": 1992,
          "overallWidthMm": 3849,
          "upperCoverWidthMm": 3652,
          "overallHeightMm": 2500
        },
        "170": {
          "W": 3763,
          "H": 2116,
          "overallWidthMm": 4070,
          "upperCoverWidthMm": 3960,
          "overallHeightMm": 2600
        },
        "180": {
          "W": 3985,
          "H": 2241,
          "overallWidthMm": 4300,
          "upperCoverWidthMm": 4100,
          "overallHeightMm": 2800
        },
        "200": {
          "W": 4428,
          "H": 2490,
          "overallWidthMm": 4700,
          "upperCoverWidthMm": 4540,
          "overallHeightMm": 3000
        }
      }
    },
    "proPlusSlimline": {
      "page": 7,
      "productIds": [
        "pro_plus",
        "pro_a_plus",
        "pro_p_plus",
        "pro_pa_plus"
      ],
      "sizes": {
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2120,
          "ringDistanceMm": 1990,
          "overallHeightMm": 1557
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2300,
          "ringDistanceMm": 2170,
          "overallHeightMm": 1656
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2474,
          "ringDistanceMm": 2344,
          "overallHeightMm": 1775
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2730,
          "ringDistanceMm": 2600,
          "overallHeightMm": 1881
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 2953,
          "ringDistanceMm": 2823,
          "overallHeightMm": 2005
        },
        "130": {
          "W": 2878,
          "H": 1618,
          "overallWidthMm": 3113,
          "ringDistanceMm": 2958,
          "overallHeightMm": 2110
        }
      }
    },
    "liteHyperSlimline": {
      "page": 8,
      "productIds": [
        "lite_slimline",
        "lite_slimline_a",
        "lite_slimline_p",
        "lite_slimline_pa"
      ],
      "sizes": {
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2120,
          "ringDistanceMm": 1990,
          "overallHeightMm": 1557
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2300,
          "ringDistanceMm": 2170,
          "overallHeightMm": 1656
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2474,
          "ringDistanceMm": 2344,
          "overallHeightMm": 1775
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2730,
          "ringDistanceMm": 2600,
          "overallHeightMm": 1881
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 2953,
          "ringDistanceMm": 2823,
          "overallHeightMm": 2005
        },
        "130": {
          "W": 2878,
          "H": 1618,
          "overallWidthMm": 3113,
          "ringDistanceMm": 2958,
          "overallHeightMm": 2110
        },
        "150": {
          "W": 3321,
          "H": 1868,
          "overallWidthMm": 3630,
          "ringDistanceMm": 3500,
          "overallHeightMm": 2379
        }
      }
    },
    "alrSlimline": {
      "page": 9,
      "productIds": [
        "alr_slimline",
        "alr_p_slimline",
        "alr_3d_slimline"
      ],
      "sizes": {
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2120,
          "ringDistanceMm": 1990,
          "overallHeightMm": 1557
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2300,
          "ringDistanceMm": 2170,
          "overallHeightMm": 1656
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2474,
          "ringDistanceMm": 2344,
          "overallHeightMm": 1756
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2730,
          "ringDistanceMm": 2600,
          "overallHeightMm": 1881
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 2953,
          "ringDistanceMm": 2823,
          "overallHeightMm": 2005
        },
        "135": {
          "W": 2989,
          "H": 1680,
          "overallWidthMm": 3310,
          "ringDistanceMm": 3180,
          "overallHeightMm": 2191
        },
        "150": {
          "W": 3321,
          "H": 1868,
          "overallWidthMm": 3630,
          "ringDistanceMm": 3500,
          "overallHeightMm": 2379
        },
        "160": {
          "W": 3542,
          "H": 1992,
          "overallWidthMm": 3815,
          "ringDistanceMm": 3685,
          "overallHeightMm": 2503
        },
        "170": {
          "W": 3763,
          "H": 2116,
          "overallWidthMm": 4030,
          "ringDistanceMm": 3900,
          "overallHeightMm": 2627
        },
        "180": {
          "W": 3985,
          "H": 2241,
          "overallWidthMm": 4260,
          "ringDistanceMm": 4130,
          "overallHeightMm": 2752
        }
      }
    },
    "whiteSlimline": {
      "page": 10,
      "productIds": [
        "white_slimline",
        "white_p_slimline"
      ],
      "sizes": {
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2250,
          "ringDistanceMm": 2120,
          "overallHeightMm": 1557
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2425,
          "ringDistanceMm": 2295,
          "overallHeightMm": 1656
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2588,
          "ringDistanceMm": 2458,
          "overallHeightMm": 1756
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2825,
          "ringDistanceMm": 2695,
          "overallHeightMm": 1881
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 2978,
          "ringDistanceMm": 2848,
          "overallHeightMm": 2005
        },
        "135": {
          "W": 2989,
          "H": 1680,
          "overallWidthMm": 3310,
          "ringDistanceMm": 3180,
          "overallHeightMm": 2191
        },
        "150": {
          "W": 3321,
          "H": 1868,
          "overallWidthMm": 3630,
          "ringDistanceMm": 3500,
          "overallHeightMm": 2379
        },
        "160": {
          "W": 3542,
          "H": 1992,
          "overallWidthMm": 3815,
          "ringDistanceMm": 3685,
          "overallHeightMm": 2503
        },
        "170": {
          "W": 3763,
          "H": 2116,
          "overallWidthMm": 4030,
          "ringDistanceMm": 3900,
          "overallHeightMm": 2627
        },
        "180": {
          "W": 3985,
          "H": 2241,
          "overallWidthMm": 4260,
          "ringDistanceMm": 4130,
          "overallHeightMm": 2752
        }
      }
    },
    "proPhantom": {
      "page": 11,
      "productIds": [
        "phantom_pro",
        "phantom_pro_a"
      ],
      "sizes": {
        "72": {
          "W": 1594,
          "H": 896,
          "overallWidthMm": 2034,
          "housingWidthMm": 1864,
          "housingBottomToButtonAxisMm": 1482,
          "recessLengthMm": 1949
        },
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2280,
          "housingWidthMm": 2110,
          "housingBottomToButtonAxisMm": 1532,
          "recessLengthMm": 2195
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2460,
          "housingWidthMm": 2290,
          "housingBottomToButtonAxisMm": 1631,
          "recessLengthMm": 2375
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2624,
          "housingWidthMm": 2454,
          "housingBottomToButtonAxisMm": 1681,
          "recessLengthMm": 2539
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2890,
          "housingWidthMm": 2720,
          "housingBottomToButtonAxisMm": 1806,
          "recessLengthMm": 2805
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 3103,
          "housingWidthMm": 2933,
          "housingBottomToButtonAxisMm": 1930,
          "recessLengthMm": 3018
        },
        "130": {
          "W": 2878,
          "H": 1618,
          "overallWidthMm": 3318,
          "housingWidthMm": 3152,
          "housingBottomToButtonAxisMm": 2004,
          "recessLengthMm": 3237
        }
      }
    },
    "liteHyperPhantom": {
      "page": 12,
      "productIds": [
        "phantom_lite",
        "phantom_lite_a",
        "phantom_lite_p",
        "phantom_lite_pa"
      ],
      "sizes": {
        "72": {
          "W": 1594,
          "H": 896,
          "overallWidthMm": 2034,
          "housingWidthMm": 1864,
          "housingBottomToButtonAxisMm": 1482,
          "recessLengthMm": 1949
        },
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2280,
          "housingWidthMm": 2110,
          "housingBottomToButtonAxisMm": 1532,
          "recessLengthMm": 2195
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2460,
          "housingWidthMm": 2290,
          "housingBottomToButtonAxisMm": 1631,
          "recessLengthMm": 2375
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2624,
          "housingWidthMm": 2454,
          "housingBottomToButtonAxisMm": 1681,
          "recessLengthMm": 2539
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2890,
          "housingWidthMm": 2720,
          "housingBottomToButtonAxisMm": 1806,
          "recessLengthMm": 2805
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 3103,
          "housingWidthMm": 2933,
          "housingBottomToButtonAxisMm": 1930,
          "recessLengthMm": 3018
        },
        "130": {
          "W": 2878,
          "H": 1618,
          "overallWidthMm": 3318,
          "housingWidthMm": 3152,
          "housingBottomToButtonAxisMm": 2004,
          "recessLengthMm": 3237
        },
        "150": {
          "W": 3321,
          "H": 1868,
          "overallWidthMm": 3780,
          "housingWidthMm": 3610,
          "housingBottomToButtonAxisMm": 2267,
          "recessLengthMm": 3695
        }
      }
    },
    "alrPhantom": {
      "page": 13,
      "productIds": [
        "phantom_long"
      ],
      "sizes": {
        "72": {
          "W": 1594,
          "H": 896,
          "overallWidthMm": 2034,
          "housingWidthMm": 1864,
          "housingBottomToButtonAxisMm": 1482,
          "recessLengthMm": 1949
        },
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2280,
          "housingWidthMm": 2110,
          "housingBottomToButtonAxisMm": 1532,
          "recessLengthMm": 2195
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2460,
          "housingWidthMm": 2290,
          "housingBottomToButtonAxisMm": 1631,
          "recessLengthMm": 2375
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2624,
          "housingWidthMm": 2454,
          "housingBottomToButtonAxisMm": 1681,
          "recessLengthMm": 2539
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2890,
          "housingWidthMm": 2720,
          "housingBottomToButtonAxisMm": 1806,
          "recessLengthMm": 2805
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 3103,
          "housingWidthMm": 2933,
          "housingBottomToButtonAxisMm": 1930,
          "recessLengthMm": 3018
        },
        "135": {
          "W": 2989,
          "H": 1680,
          "overallWidthMm": 3420,
          "housingWidthMm": 3250,
          "housingBottomToButtonAxisMm": 2080,
          "recessLengthMm": 3335
        },
        "150": {
          "W": 3321,
          "H": 1868,
          "overallWidthMm": 3780,
          "housingWidthMm": 3610,
          "housingBottomToButtonAxisMm": 2267,
          "recessLengthMm": 3695
        },
        "160": {
          "W": 3542,
          "H": 1992,
          "overallWidthMm": 3951,
          "housingWidthMm": 3859,
          "housingBottomToButtonAxisMm": 2342,
          "recessLengthMm": 3944
        },
        "170": {
          "W": 3763,
          "H": 2116,
          "overallWidthMm": 4166,
          "housingWidthMm": 4074,
          "housingBottomToButtonAxisMm": 2466,
          "recessLengthMm": 4159
        },
        "180": {
          "W": 3985,
          "H": 2241,
          "overallWidthMm": 4396,
          "housingWidthMm": 4304,
          "housingBottomToButtonAxisMm": 2591,
          "recessLengthMm": 4389
        }
      }
    },
    "whitePhantom": {
      "page": 14,
      "productIds": [
        "phantom_white"
      ],
      "sizes": {
        "72": {
          "W": 1594,
          "H": 896,
          "overallWidthMm": 2100,
          "housingWidthMm": 1930,
          "housingBottomToButtonAxisMm": 1482,
          "recessLengthMm": 2015
        },
        "84": {
          "W": 1860,
          "H": 1046,
          "overallWidthMm": 2410,
          "housingWidthMm": 2240,
          "housingBottomToButtonAxisMm": 1532,
          "recessLengthMm": 2325
        },
        "92": {
          "W": 2037,
          "H": 1145,
          "overallWidthMm": 2585,
          "housingWidthMm": 2415,
          "housingBottomToButtonAxisMm": 1631,
          "recessLengthMm": 2500
        },
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2755,
          "housingWidthMm": 2585,
          "housingBottomToButtonAxisMm": 1681,
          "recessLengthMm": 2670
        },
        "110": {
          "W": 2435,
          "H": 1370,
          "overallWidthMm": 2985,
          "housingWidthMm": 2815,
          "housingBottomToButtonAxisMm": 1806,
          "recessLengthMm": 2900
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 3103,
          "housingWidthMm": 2933,
          "housingBottomToButtonAxisMm": 1930,
          "recessLengthMm": 3018
        },
        "135": {
          "W": 2989,
          "H": 1680,
          "overallWidthMm": 3560,
          "housingWidthMm": 3390,
          "housingBottomToButtonAxisMm": 2080,
          "recessLengthMm": 3475
        },
        "150": {
          "W": 3321,
          "H": 1868,
          "overallWidthMm": 3860,
          "housingWidthMm": 3690,
          "housingBottomToButtonAxisMm": 2267,
          "recessLengthMm": 3775
        },
        "160": {
          "W": 3542,
          "H": 1992,
          "overallWidthMm": 3951,
          "housingWidthMm": 3859,
          "housingBottomToButtonAxisMm": 2342,
          "recessLengthMm": 3944
        },
        "170": {
          "W": 3763,
          "H": 2116,
          "overallWidthMm": 4166,
          "housingWidthMm": 4074,
          "housingBottomToButtonAxisMm": 2466,
          "recessLengthMm": 4159
        },
        "180": {
          "W": 3985,
          "H": 2241,
          "overallWidthMm": 4396,
          "housingWidthMm": 4304,
          "housingBottomToButtonAxisMm": 2591,
          "recessLengthMm": 4389
        }
      }
    },
    "duraplus": {
      "page": 16,
      "productIds": [
        "duraplus"
      ],
      "sizes": {
        "100": {
          "W": 2214,
          "H": 1245,
          "overallWidthMm": 2304,
          "housingWidthMm": 2234,
          "housingBottomToButtonAxisMm": 2217
        },
        "120": {
          "W": 2656,
          "H": 1494,
          "overallWidthMm": 2746,
          "housingWidthMm": 2676,
          "housingBottomToButtonAxisMm": 2466
        },
        "135": {
          "W": 2989,
          "H": 1680,
          "overallWidthMm": 3079,
          "housingWidthMm": 3009,
          "housingBottomToButtonAxisMm": 2652
        },
        "150": {
          "W": 3321,
          "H": 1868,
          "overallWidthMm": 3411,
          "housingWidthMm": 3341,
          "housingBottomToButtonAxisMm": 2700
        },
        "180": {
          "W": 3985,
          "H": 2241,
          "overallWidthMm": 4075,
          "housingWidthMm": 4005,
          "housingBottomToButtonAxisMm": 2700
        },
        "200": {
          "W": 4428,
          "H": 2490,
          "overallWidthMm": 4518,
          "housingWidthMm": 4448,
          "housingBottomToButtonAxisMm": 2801
        }
      }
    }
  }
};
(function (root, factory) {
  var data = root.ScreenFinderDimensions || (typeof require === 'function' ? require('../data/dimensions-r04.json') : null);
  var api = factory(data);
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.ScreenFinderSizeGuide = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function (data) {
  'use strict';

  // Seating guidance is separate from projector throw distance and compatibility.
  var VIEWING_ANGLE = 36;
  var VIEWING_SOURCE = 'https://www.thx.com/questions/thx-certified-screen-placement/';
  var TOLERANCE = data && data.manufacturingToleranceMm || 20;
  var byProduct = Object.create(null);
  var referenceWidths = Object.create(null);
  Object.keys(data && data.families || {}).forEach(function (key) {
    var family = data.families[key];
    family.productIds.forEach(function (id) { byProduct[id] = family; });
    Object.keys(family.sizes).forEach(function (size) {
      referenceWidths[size] = family.sizes[size].W;
    });
  });

  function positiveNumber(value) {
    return typeof value === 'number' && isFinite(value) && value > 0;
  }

  function imageGeometry(size) {
    var diagonalMm = size * 25.4;
    return { width: Math.round(diagonalMm * 16 / Math.sqrt(337)), height: Math.round(diagonalMm * 9 / Math.sqrt(337)) };
  }

  function dimensions(product, size) {
    if (!positiveNumber(size)) return null;
    if (product && typeof product === 'object') {
      if (Array.isArray(product.sizes) && product.sizes.indexOf(size) < 0) return null;
      if (Array.isArray(product.supportedAspectRatios) && product.supportedAspectRatios.indexOf('16:9') < 0) return null;
    }
    var id = typeof product === 'string' ? product : product && product.id;
    var family = typeof id === 'string' && byProduct[id];
    var row = family && family.sizes[String(size)];
    var geometry = imageGeometry(size);
    var result = {
      size: size, aspectRatio: '16:9', imageWidthMm: row ? row.W : geometry.width,
      imageHeightMm: row ? row.H : geometry.height, imageApproximate: !row,
      overallWidthMm: row ? row.overallWidthMm : null,
      requiredWidthMm: row ? row.overallWidthMm + TOLERANCE : null,
      housingWidthMm: row && row.housingWidthMm || null,
      upperCoverWidthMm: row && row.upperCoverWidthMm || null,
      ringDistanceMm: row && row.ringDistanceMm || null,
      overallHeightMm: row && row.overallHeightMm || null,
      housingBottomToButtonAxisMm: row && row.housingBottomToButtonAxisMm || null,
      recessLengthMm: row && row.recessLengthMm || null,
      toleranceMm: row ? TOLERANCE : null,
      verified: !!row, pdfPage: row ? family.page : null,
      source: row ? data.sourceFile : 'Calculated 16:9 image geometry; housing dimensions unverified',
      installationFitConfirmed: false
    };
    return Object.freeze(result);
  }

  // A fit confirms only the published overall WIDTH plus the stated tolerance.
  // It never confirms height, depth, bracket clearances or projector throw.
  function widthAssessment(product, size, widthMm) {
    var d = dimensions(product, size);
    var result = {
      status: 'unverified', reason: !positiveNumber(widthMm) ? 'width_not_provided' : 'size_needed',
      roomWidthMm: positiveNumber(widthMm) ? widthMm : null,
      imageWidthMm: d ? d.imageWidthMm : null,
      overallWidthMm: d ? d.overallWidthMm : null,
      requiredWidthMm: d ? d.requiredWidthMm : null,
      toleranceMm: d ? d.toleranceMm : null,
      installationFitConfirmed: false
    };
    if (!positiveNumber(widthMm) || !d) return Object.freeze(result);
    if (d.imageWidthMm > widthMm) {
      result.status = 'exceeds';
      result.reason = 'image_exceeds_width';
    } else if (!d.verified || d.overallWidthMm === null) {
      result.reason = 'housing_unverified';
    } else if (widthMm >= d.requiredWidthMm) {
      result.status = 'fits';
      result.reason = 'verified_width_fit';
    } else if (widthMm < d.overallWidthMm - TOLERANCE) {
      result.status = 'exceeds';
      result.reason = 'overall_width_exceeds';
    } else {
      result.status = 'recheck';
      result.reason = 'width_tolerance';
    }
    return Object.freeze(result);
  }

  function widthFits(product, size, widthMm) {
    var assessment = widthAssessment(product, size, widthMm);
    if (assessment.status === 'fits') return true;
    if (assessment.status === 'exceeds') return false;
    return null;
  }

  function recommend(availableSizes, distanceMm, widthMm) {
    var distanceValid = positiveNumber(distanceMm);
    var widthValid = positiveNumber(widthMm);
    var seen = Object.create(null);
    var options = (Array.isArray(availableSizes) ? availableSizes : []).filter(function (size) {
      if (!positiveNumber(size) || seen[size]) return false;
      seen[size] = true;
      return true;
    }).sort(function (a, b) { return a - b; }).map(function (size) {
      var image = imageGeometry(size);
      // Preserve the user's published nominal W instead of rounding it up by 1 mm.
      // This reference still does not verify an unmapped product's housing.
      if (referenceWidths[String(size)]) image.width = referenceWidths[String(size)];
      var angle = distanceValid ? 2 * Math.atan(image.width / (2 * distanceMm)) * 180 / Math.PI : null;
      return Object.freeze({
        size: size, imageWidthMm: image.width, imageHeightMm: image.height, imageApproximate: true,
        fitsImageWidth: widthValid ? image.width <= widthMm : null,
        viewingAngleDegrees: angle === null ? null : Math.round(angle * 100) / 100,
        distanceReferenceMm: Math.round(image.width / (2 * Math.tan(VIEWING_ANGLE / 2 * Math.PI / 180))),
        installationFitConfirmed: false
      });
    });
    var eligible = options.filter(function (option) { return option.fitsImageWidth !== false; });
    var best = null;
    if (distanceValid) {
      eligible.forEach(function (option) {
        var angle = 2 * Math.atan(option.imageWidthMm / (2 * distanceMm)) * 180 / Math.PI;
        if (!best || Math.abs(angle - VIEWING_ANGLE) < best.deviation) {
          best = { size: option.size, deviation: Math.abs(angle - VIEWING_ANGLE) };
        }
      });
    }
    var status = !options.length ? 'no_available_sizes' : !eligible.length ? 'no_image_width_fit' : !distanceValid ? 'distance_needed' : 'suggestion';
    return Object.freeze({
      suggestedSize: best ? best.size : null, status: status, options: Object.freeze(options),
      referenceViewingAngleDegrees: VIEWING_ANGLE, referenceSource: VIEWING_SOURCE,
      hardCompatibilityRule: false, installationFitConfirmed: false,
      validation: Object.freeze({ distanceValid: distanceValid, widthValid: widthValid })
    });
  }

  return Object.freeze({ dimensions: dimensions, widthAssessment: widthAssessment, widthFits: widthFits, recommend: recommend });
});

window.ScreenFinderVariantOptions={
  "43397596610700": [
    "130inch",
    "White",
    "PRO"
  ],
  "43397633048716": [
    "130inch",
    "White",
    "PRO A"
  ],
  "43397633081484": [
    "130inch",
    "White",
    "PRO P"
  ],
  "43397633114252": [
    "130inch",
    "White",
    "PRO PA"
  ],
  "43397596643468": [
    "130inch",
    "Black",
    "PRO"
  ],
  "43397633147020": [
    "130inch",
    "Black",
    "PRO A"
  ],
  "43397633179788": [
    "130inch",
    "Black",
    "PRO P"
  ],
  "43397633212556": [
    "130inch",
    "Black",
    "PRO PA"
  ],
  "42599693811852": [
    "130inch",
    "White"
  ],
  "42599693844620": [
    "130inch",
    "Black"
  ],
  "43628563759244": [
    "150inch",
    "White",
    "Lite"
  ],
  "43628563792012": [
    "150inch",
    "White",
    "Lite A"
  ],
  "43628563824780": [
    "150inch",
    "White",
    "Lite P"
  ],
  "43628563857548": [
    "150inch",
    "White",
    "Lite PA"
  ],
  "43628563890316": [
    "150inch",
    "Black",
    "Lite"
  ],
  "43628563923084": [
    "150inch",
    "Black",
    "Lite A"
  ],
  "43628563955852": [
    "150inch",
    "Black",
    "Lite P"
  ],
  "43628563988620": [
    "150inch",
    "Black",
    "Lite PA"
  ],
  "43784375533708": [
    "84inch",
    "White",
    "Lite Hyper"
  ],
  "43784375566476": [
    "84inch",
    "White",
    "Lite Hyper A"
  ],
  "43784375599244": [
    "84inch",
    "White",
    "Lite Hyper P"
  ],
  "43784375632012": [
    "84inch",
    "White",
    "Lite Hyper PA"
  ],
  "43784375664780": [
    "84inch",
    "Black",
    "Lite Hyper"
  ],
  "43784375697548": [
    "84inch",
    "Black",
    "Lite Hyper A"
  ],
  "43784375730316": [
    "84inch",
    "Black",
    "Lite Hyper P"
  ],
  "43784375763084": [
    "84inch",
    "Black",
    "Lite Hyper PA"
  ],
  "43784375271564": [
    "92inch",
    "White",
    "Lite Hyper"
  ],
  "43784375304332": [
    "92inch",
    "White",
    "Lite Hyper A"
  ],
  "43784375337100": [
    "92inch",
    "White",
    "Lite Hyper P"
  ],
  "43784375369868": [
    "92inch",
    "White",
    "Lite Hyper PA"
  ],
  "43784375402636": [
    "92inch",
    "Black",
    "Lite Hyper"
  ],
  "43784375435404": [
    "92inch",
    "Black",
    "Lite Hyper A"
  ],
  "43784375468172": [
    "92inch",
    "Black",
    "Lite Hyper P"
  ],
  "43784375500940": [
    "92inch",
    "Black",
    "Lite Hyper PA"
  ],
  "43784375009420": [
    "100inch",
    "White",
    "Lite Hyper"
  ],
  "43784375042188": [
    "100inch",
    "White",
    "Lite Hyper A"
  ],
  "43784375074956": [
    "100inch",
    "White",
    "Lite Hyper P"
  ],
  "43784375107724": [
    "100inch",
    "White",
    "Lite Hyper PA"
  ],
  "43784375140492": [
    "100inch",
    "Black",
    "Lite Hyper"
  ],
  "43784375173260": [
    "100inch",
    "Black",
    "Lite Hyper A"
  ],
  "43784375206028": [
    "100inch",
    "Black",
    "Lite Hyper P"
  ],
  "43784375238796": [
    "100inch",
    "Black",
    "Lite Hyper PA"
  ],
  "43784374747276": [
    "110inch",
    "White",
    "Lite Hyper"
  ],
  "43784374780044": [
    "110inch",
    "White",
    "Lite Hyper A"
  ],
  "43784374812812": [
    "110inch",
    "White",
    "Lite Hyper P"
  ],
  "43784374845580": [
    "110inch",
    "White",
    "Lite Hyper PA"
  ],
  "43784374878348": [
    "110inch",
    "Black",
    "Lite Hyper"
  ],
  "43784374911116": [
    "110inch",
    "Black",
    "Lite Hyper A"
  ],
  "43784374943884": [
    "110inch",
    "Black",
    "Lite Hyper P"
  ],
  "43784374976652": [
    "110inch",
    "Black",
    "Lite Hyper PA"
  ],
  "43784374485132": [
    "120inch",
    "White",
    "Lite Hyper"
  ],
  "43784374517900": [
    "120inch",
    "White",
    "Lite Hyper A"
  ],
  "43784374550668": [
    "120inch",
    "White",
    "Lite Hyper P"
  ],
  "43784374583436": [
    "120inch",
    "White",
    "Lite Hyper PA"
  ],
  "43784374616204": [
    "120inch",
    "Black",
    "Lite Hyper"
  ],
  "43784374648972": [
    "120inch",
    "Black",
    "Lite Hyper A"
  ],
  "43784374681740": [
    "120inch",
    "Black",
    "Lite Hyper P"
  ],
  "43784374714508": [
    "120inch",
    "Black",
    "Lite Hyper PA"
  ],
  "43784374222988": [
    "130inch",
    "White",
    "Lite Hyper"
  ],
  "43784374255756": [
    "130inch",
    "White",
    "Lite Hyper A"
  ],
  "43784374288524": [
    "130inch",
    "White",
    "Lite Hyper P"
  ],
  "43784374321292": [
    "130inch",
    "White",
    "Lite Hyper PA"
  ],
  "43784374354060": [
    "130inch",
    "Black",
    "Lite Hyper"
  ],
  "43784374386828": [
    "130inch",
    "Black",
    "Lite Hyper A"
  ],
  "43784374419596": [
    "130inch",
    "Black",
    "Lite Hyper P"
  ],
  "43784374452364": [
    "130inch",
    "Black",
    "Lite Hyper PA"
  ],
  "43628431474828": [
    "150inch",
    "White",
    "Lite Hyper"
  ],
  "43628431507596": [
    "150inch",
    "White",
    "Lite Hyper A"
  ],
  "43628431540364": [
    "150inch",
    "White",
    "Lite Hyper P"
  ],
  "43628431573132": [
    "150inch",
    "White",
    "Lite Hyper PA"
  ],
  "43628431605900": [
    "150inch",
    "Black",
    "Lite Hyper"
  ],
  "43628431638668": [
    "150inch",
    "Black",
    "Lite Hyper A"
  ],
  "43628431671436": [
    "150inch",
    "Black",
    "Lite Hyper P"
  ],
  "43628431704204": [
    "150inch",
    "Black",
    "Lite Hyper PA"
  ],
  "54347186602124": [
    "100inch",
    "Air Shipping"
  ],
  "54347186634892": [
    "100inch",
    "Sea Shipping"
  ],
  "54347186667660": [
    "120inch",
    "Air Shipping"
  ],
  "54347186700428": [
    "120inch",
    "Sea Shipping"
  ],
  "47648100515980": [
    "100inch",
    "Obsidian ALR"
  ],
  "47648126304396": [
    "100inch",
    "Perforated Obsidian ALR"
  ],
  "47648100548748": [
    "120inch",
    "Obsidian ALR"
  ],
  "47648126337164": [
    "120inch",
    "Perforated Obsidian ALR"
  ],
  "47648100581516": [
    "130Inch",
    "Obsidian ALR"
  ],
  "47648126369932": [
    "130Inch",
    "Perforated Obsidian ALR"
  ],
  "47648100614284": [
    "150Inch",
    "Obsidian ALR"
  ],
  "47648126402700": [
    "150Inch",
    "Perforated Obsidian ALR"
  ],
  "51935236325516": [
    "170inch",
    "Obsidian ALR"
  ],
  "51935236358284": [
    "170inch",
    "Perforated Obsidian ALR"
  ],
  "51935236391052": [
    "180inch",
    "Obsidian ALR"
  ],
  "51935236423820": [
    "180inch",
    "Perforated Obsidian ALR"
  ],
  "51935236456588": [
    "200inch",
    "Obsidian ALR"
  ],
  "51935236489356": [
    "200inch",
    "Perforated Obsidian ALR"
  ],
  "34401610236044": [
    "84inch",
    "Black"
  ],
  "34401610268812": [
    "84inch",
    "White"
  ],
  "34401610301580": [
    "92inch",
    "Black"
  ],
  "34401610334348": [
    "92inch",
    "White"
  ],
  "34401610367116": [
    "100inch",
    "Black"
  ],
  "34401610399884": [
    "100inch",
    "White"
  ],
  "34401610432652": [
    "110inch",
    "Black"
  ],
  "34401610465420": [
    "110inch",
    "White"
  ],
  "34401610498188": [
    "120inch",
    "Black"
  ],
  "34401610530956": [
    "120inch",
    "White"
  ],
  "39524270538892": [
    "84inch",
    "Black",
    "Obsidian Long Focus ALR"
  ],
  "39524270604428": [
    "84inch",
    "White",
    "Obsidian Long Focus ALR"
  ],
  "39524270669964": [
    "92inch",
    "Black",
    "Obsidian Long Focus ALR"
  ],
  "39524270735500": [
    "92inch",
    "White",
    "Obsidian Long Focus ALR"
  ],
  "39524270801036": [
    "100inch",
    "Black",
    "Obsidian Long Focus ALR"
  ],
  "39524270866572": [
    "100inch",
    "White",
    "Obsidian Long Focus ALR"
  ],
  "39524270932108": [
    "110inch",
    "Black",
    "Obsidian Long Focus ALR"
  ],
  "39524270997644": [
    "110inch",
    "White",
    "Obsidian Long Focus ALR"
  ],
  "39524271063180": [
    "120inch",
    "Black",
    "Obsidian Long Focus ALR"
  ],
  "39524271128716": [
    "120inch",
    "White",
    "Obsidian Long Focus ALR"
  ],
  "40545904394380": [
    "135inch",
    "Black",
    "Obsidian Long Focus ALR"
  ],
  "40545904427148": [
    "135inch",
    "White",
    "Obsidian Long Focus ALR"
  ],
  "40545904459916": [
    "150inch",
    "Black",
    "Obsidian Long Focus ALR"
  ],
  "40545904492684": [
    "150inch",
    "White",
    "Obsidian Long Focus ALR"
  ],
  "44323393929356": [
    "160inch",
    "Black",
    "Obsidian Long Focus ALR"
  ],
  "44323393962124": [
    "160inch",
    "White",
    "Obsidian Long Focus ALR"
  ],
  "44323393994892": [
    "170inch",
    "Black",
    "Obsidian Long Focus ALR"
  ],
  "44323394027660": [
    "170inch",
    "White",
    "Obsidian Long Focus ALR"
  ],
  "44323394060428": [
    "180inch",
    "Black",
    "Obsidian Long Focus ALR"
  ],
  "44323394093196": [
    "180inch",
    "White",
    "Obsidian Long Focus ALR"
  ],
  "41568025968780": [
    "100Inch"
  ],
  "41568026001548": [
    "120Inch"
  ],
  "41568026034316": [
    "130Inch"
  ],
  "41568026067084": [
    "150Inch"
  ],
  "41571962323084": [
    "100Inch"
  ],
  "41571962355852": [
    "120Inch"
  ],
  "42648081203340": [
    "130Inch"
  ],
  "44133257511052": [
    "100inch",
    "Dark Gray"
  ],
  "44140647612556": [
    "100inch",
    "White"
  ],
  "44140647645324": [
    "100inch",
    "Coffee Brown"
  ],
  "44133257543820": [
    "120inch",
    "Dark Gray"
  ],
  "44140647678092": [
    "120inch",
    "White"
  ],
  "44140647710860": [
    "120inch",
    "Coffee Brown"
  ],
  "44133257576588": [
    "135inch",
    "Dark Gray"
  ],
  "44140647743628": [
    "135inch",
    "White"
  ],
  "44140647776396": [
    "135inch",
    "Coffee Brown"
  ],
  "44133257609356": [
    "150inch",
    "Dark Gray"
  ],
  "44140647809164": [
    "150inch",
    "White"
  ],
  "44140647841932": [
    "150inch",
    "Coffee Brown"
  ],
  "44133257642124": [
    "180inch",
    "Dark Gray"
  ],
  "44140647874700": [
    "180inch",
    "White"
  ],
  "44140647907468": [
    "180inch",
    "Coffee Brown"
  ],
  "44133257674892": [
    "200inch",
    "Dark Gray"
  ],
  "44140647940236": [
    "200inch",
    "White"
  ],
  "44140647973004": [
    "200inch",
    "Coffee Brown"
  ],
  "43325888725132": [
    "100Inch"
  ],
  "43325888757900": [
    "120Inch"
  ],
  "43325888790668": [
    "130Inch"
  ],
  "43324199927948": [
    "72inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324199960716": [
    "72inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324166766732": [
    "84inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324166799500": [
    "84inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324166832268": [
    "92inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324166865036": [
    "92inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324166897804": [
    "100inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324166930572": [
    "100inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324166963340": [
    "110inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324166996108": [
    "110inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324167028876": [
    "120inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43324167061644": [
    "120inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "45552497885324": [
    "100inch"
  ],
  "45552497918092": [
    "120inch"
  ],
  "44133249810572": [
    "130Inch"
  ],
  "44133249843340": [
    "150Inch"
  ],
  "54364694085772": [
    "100inch-Early Bird Price",
    "Air Shipping"
  ],
  "54364694118540": [
    "100inch-Early Bird Price",
    "Sea Shipping"
  ],
  "54364694151308": [
    "120inch-Early Bird Price",
    "Air Shipping"
  ],
  "54364694184076": [
    "120inch-Early Bird Price",
    "Sea Shipping"
  ],
  "40526914912396": [
    "72inch",
    "White",
    "Normal Black Border Design"
  ],
  "40526914977932": [
    "72inch",
    "Black",
    "Normal Black Border Design"
  ],
  "40526915043468": [
    "84inch",
    "White",
    "Normal Black Border Design"
  ],
  "40526915109004": [
    "84inch",
    "Black",
    "Normal Black Border Design"
  ],
  "40526915174540": [
    "92inch",
    "White",
    "Normal Black Border Design"
  ],
  "40526915240076": [
    "92inch",
    "Black",
    "Normal Black Border Design"
  ],
  "40526915305612": [
    "100inch",
    "White",
    "Normal Black Border Design"
  ],
  "40526915371148": [
    "100inch",
    "Black",
    "Normal Black Border Design"
  ],
  "40526915436684": [
    "110inch",
    "White",
    "Normal Black Border Design"
  ],
  "40526915502220": [
    "110inch",
    "Black",
    "Normal Black Border Design"
  ],
  "40526915567756": [
    "120inch",
    "White",
    "Normal Black Border Design"
  ],
  "40526915633292": [
    "120inch",
    "Black",
    "Normal Black Border Design"
  ],
  "41657085558924": [
    "72inch",
    "White"
  ],
  "42346918969484": [
    "72inch",
    "Black"
  ],
  "41657085591692": [
    "84inch",
    "White"
  ],
  "42346919002252": [
    "84inch",
    "Black"
  ],
  "41657085624460": [
    "92inch",
    "White"
  ],
  "42346919035020": [
    "92inch",
    "Black"
  ],
  "41657085657228": [
    "100inch",
    "White"
  ],
  "42346919067788": [
    "100inch",
    "Black"
  ],
  "41657085689996": [
    "110inch",
    "White"
  ],
  "42346919100556": [
    "110inch",
    "Black"
  ],
  "41657085722764": [
    "120inch",
    "White"
  ],
  "42346919133324": [
    "120inch",
    "Black"
  ],
  "41827008807052": [
    "135inch",
    "White"
  ],
  "42346919166092": [
    "135inch",
    "Black"
  ],
  "41827008839820": [
    "150inch",
    "White"
  ],
  "42346919198860": [
    "150inch",
    "Black"
  ],
  "44287507988620": [
    "160inch",
    "White"
  ],
  "44287508021388": [
    "160inch",
    "Black"
  ],
  "44287508054156": [
    "170inch",
    "White"
  ],
  "44287508086924": [
    "170inch",
    "Black"
  ],
  "44287508119692": [
    "180inch",
    "White"
  ],
  "44287508152460": [
    "180inch",
    "Black"
  ],
  "41502379868300": [
    "72inch",
    "White",
    "Black Border-PRO"
  ],
  "41508708089996": [
    "72inch",
    "White",
    "Black Border-PRO A"
  ],
  "44429978337420": [
    "72inch",
    "White",
    "Clear Border-PRO"
  ],
  "44429978370188": [
    "72inch",
    "White",
    "Clear Border-PRO A"
  ],
  "42346945544332": [
    "72inch",
    "Black",
    "Black Border-PRO"
  ],
  "42346945577100": [
    "72inch",
    "Black",
    "Black Border-PRO A"
  ],
  "44429978402956": [
    "72inch",
    "Black",
    "Clear Border-PRO"
  ],
  "44429978435724": [
    "72inch",
    "Black",
    "Clear Border-PRO A"
  ],
  "41502379933836": [
    "84inch",
    "White",
    "Black Border-PRO"
  ],
  "41508708286604": [
    "84inch",
    "White",
    "Black Border-PRO A"
  ],
  "44429978468492": [
    "84inch",
    "White",
    "Clear Border-PRO"
  ],
  "44429978501260": [
    "84inch",
    "White",
    "Clear Border-PRO A"
  ],
  "42346945609868": [
    "84inch",
    "Black",
    "Black Border-PRO"
  ],
  "42346945642636": [
    "84inch",
    "Black",
    "Black Border-PRO A"
  ],
  "44429978534028": [
    "84inch",
    "Black",
    "Clear Border-PRO"
  ],
  "44429978566796": [
    "84inch",
    "Black",
    "Clear Border-PRO A"
  ],
  "41502379999372": [
    "92inch",
    "White",
    "Black Border-PRO"
  ],
  "41508708483212": [
    "92inch",
    "White",
    "Black Border-PRO A"
  ],
  "44429978599564": [
    "92inch",
    "White",
    "Clear Border-PRO"
  ],
  "44429978632332": [
    "92inch",
    "White",
    "Clear Border-PRO A"
  ],
  "42346945675404": [
    "92inch",
    "Black",
    "Black Border-PRO"
  ],
  "42346945708172": [
    "92inch",
    "Black",
    "Black Border-PRO A"
  ],
  "44429978665100": [
    "92inch",
    "Black",
    "Clear Border-PRO"
  ],
  "44429978697868": [
    "92inch",
    "Black",
    "Clear Border-PRO A"
  ],
  "41502380064908": [
    "100inch",
    "White",
    "Black Border-PRO"
  ],
  "41508708679820": [
    "100inch",
    "White",
    "Black Border-PRO A"
  ],
  "44429978730636": [
    "100inch",
    "White",
    "Clear Border-PRO"
  ],
  "44429978763404": [
    "100inch",
    "White",
    "Clear Border-PRO A"
  ],
  "42346945740940": [
    "100inch",
    "Black",
    "Black Border-PRO"
  ],
  "42346945773708": [
    "100inch",
    "Black",
    "Black Border-PRO A"
  ],
  "44429978796172": [
    "100inch",
    "Black",
    "Clear Border-PRO"
  ],
  "44429978828940": [
    "100inch",
    "Black",
    "Clear Border-PRO A"
  ],
  "41502380130444": [
    "110inch",
    "White",
    "Black Border-PRO"
  ],
  "41508708876428": [
    "110inch",
    "White",
    "Black Border-PRO A"
  ],
  "44429978861708": [
    "110inch",
    "White",
    "Clear Border-PRO"
  ],
  "44429978894476": [
    "110inch",
    "White",
    "Clear Border-PRO A"
  ],
  "42346945806476": [
    "110inch",
    "Black",
    "Black Border-PRO"
  ],
  "42346945839244": [
    "110inch",
    "Black",
    "Black Border-PRO A"
  ],
  "44429978927244": [
    "110inch",
    "Black",
    "Clear Border-PRO"
  ],
  "44429978960012": [
    "110inch",
    "Black",
    "Clear Border-PRO A"
  ],
  "41502380195980": [
    "120inch",
    "White",
    "Black Border-PRO"
  ],
  "41508709073036": [
    "120inch",
    "White",
    "Black Border-PRO A"
  ],
  "44429978992780": [
    "120inch",
    "White",
    "Clear Border-PRO"
  ],
  "44429979025548": [
    "120inch",
    "White",
    "Clear Border-PRO A"
  ],
  "42346945872012": [
    "120inch",
    "Black",
    "Black Border-PRO"
  ],
  "42346945904780": [
    "120inch",
    "Black",
    "Black Border-PRO A"
  ],
  "44429979058316": [
    "120inch",
    "Black",
    "Clear Border-PRO"
  ],
  "44429979091084": [
    "120inch",
    "Black",
    "Clear Border-PRO A"
  ],
  "42703009611916": [
    "130inch",
    "White",
    "Black Border-PRO"
  ],
  "42703009644684": [
    "130inch",
    "White",
    "Black Border-PRO A"
  ],
  "44429979123852": [
    "130inch",
    "White",
    "Clear Border-PRO"
  ],
  "44429979156620": [
    "130inch",
    "White",
    "Clear Border-PRO A"
  ],
  "42703009677452": [
    "130inch",
    "Black",
    "Black Border-PRO"
  ],
  "42703009710220": [
    "130inch",
    "Black",
    "Black Border-PRO A"
  ],
  "44429979189388": [
    "130inch",
    "Black",
    "Clear Border-PRO"
  ],
  "44429979222156": [
    "130inch",
    "Black",
    "Clear Border-PRO A"
  ],
  "41657219481740": [
    "72inch",
    "White"
  ],
  "42346936893580": [
    "72inch",
    "Black"
  ],
  "41657219514508": [
    "84inch",
    "White"
  ],
  "42346936926348": [
    "84inch",
    "Black"
  ],
  "41657219547276": [
    "92inch",
    "White"
  ],
  "42346936959116": [
    "92inch",
    "Black"
  ],
  "41657219580044": [
    "100inch",
    "White"
  ],
  "42346936991884": [
    "100inch",
    "Black"
  ],
  "41657219612812": [
    "110inch",
    "White"
  ],
  "42346937024652": [
    "110inch",
    "Black"
  ],
  "41657219645580": [
    "120inch-All White Design",
    "White"
  ],
  "42346937057420": [
    "120inch-All White Design",
    "Black"
  ],
  "41827013066892": [
    "135inch",
    "White"
  ],
  "42346937090188": [
    "135inch",
    "Black"
  ],
  "41827013099660": [
    "150inch",
    "White"
  ],
  "42346937122956": [
    "150inch",
    "Black"
  ],
  "44287500451980": [
    "160inch",
    "White"
  ],
  "44287500484748": [
    "160inch",
    "Black"
  ],
  "44287500517516": [
    "170inch",
    "White"
  ],
  "44287500550284": [
    "170inch",
    "Black"
  ],
  "44287500583052": [
    "180inch",
    "White"
  ],
  "44287500615820": [
    "180inch",
    "Black"
  ],
  "54321565237388": [
    "100inch-Early Bird Price",
    "White"
  ],
  "54321565270156": [
    "100inch-Early Bird Price",
    "Black"
  ],
  "54321565302924": [
    "120inch-Early Bird Price",
    "White"
  ],
  "54321565335692": [
    "120inch-Early Bird Price",
    "Black"
  ],
  "54313327198348": [
    "100inch-Early Bird Price",
    "White"
  ],
  "54313327231116": [
    "100inch-Early Bird Price",
    "Black"
  ],
  "54313327263884": [
    "120inch-Early Bird Price",
    "White"
  ],
  "54313327296652": [
    "120inch-Early Bird Price",
    "Black"
  ],
  "34416713629836": [
    "84inch",
    "Black",
    "Black Border"
  ],
  "44425345433740": [
    "84inch",
    "Black",
    "Clear Border"
  ],
  "34416713662604": [
    "84inch",
    "White",
    "Black Border"
  ],
  "44425345466508": [
    "84inch",
    "White",
    "Clear Border"
  ],
  "34416713695372": [
    "92inch",
    "Black",
    "Black Border"
  ],
  "44425345499276": [
    "92inch",
    "Black",
    "Clear Border"
  ],
  "34416713728140": [
    "92inch",
    "White",
    "Black Border"
  ],
  "44425345532044": [
    "92inch",
    "White",
    "Clear Border"
  ],
  "34416713760908": [
    "100inch",
    "Black",
    "Black Border"
  ],
  "44425345564812": [
    "100inch",
    "Black",
    "Clear Border"
  ],
  "34416713793676": [
    "100inch",
    "White",
    "Black Border"
  ],
  "44425345597580": [
    "100inch",
    "White",
    "Clear Border"
  ],
  "34416713826444": [
    "110inch",
    "Black",
    "Black Border"
  ],
  "44425345630348": [
    "110inch",
    "Black",
    "Clear Border"
  ],
  "34416713859212": [
    "110inch",
    "White",
    "Black Border"
  ],
  "44425345663116": [
    "110inch",
    "White",
    "Clear Border"
  ],
  "34416713891980": [
    "120inch",
    "Black",
    "Black Border"
  ],
  "44425345695884": [
    "120inch",
    "Black",
    "Clear Border"
  ],
  "34416713924748": [
    "120inch",
    "White",
    "Black Border"
  ],
  "44425345728652": [
    "120inch",
    "White",
    "Clear Border"
  ],
  "42703004663948": [
    "130inch",
    "Black",
    "Black Border"
  ],
  "44425345761420": [
    "130inch",
    "Black",
    "Clear Border"
  ],
  "42703004696716": [
    "130inch",
    "White",
    "Black Border"
  ],
  "44425345794188": [
    "130inch",
    "White",
    "Clear Border"
  ],
  "34208586891404": [
    "84inch",
    "Black",
    "Black Border"
  ],
  "44425300181132": [
    "84inch",
    "Black",
    "Clear Border"
  ],
  "34208586924172": [
    "84inch",
    "White",
    "Black Border"
  ],
  "44425300213900": [
    "84inch",
    "White",
    "Clear Border"
  ],
  "34208586825868": [
    "92inch",
    "Black",
    "Black Border"
  ],
  "44425300115596": [
    "92inch",
    "Black",
    "Clear Border"
  ],
  "34208586858636": [
    "92inch",
    "White",
    "Black Border"
  ],
  "44425300148364": [
    "92inch",
    "White",
    "Clear Border"
  ],
  "34208586760332": [
    "100inch",
    "Black",
    "Black Border"
  ],
  "44425300050060": [
    "100inch",
    "Black",
    "Clear Border"
  ],
  "34208586793100": [
    "100inch",
    "White",
    "Black Border"
  ],
  "44425300082828": [
    "100inch",
    "White",
    "Clear Border"
  ],
  "34208586694796": [
    "110inch",
    "Black",
    "Black Border"
  ],
  "44425299984524": [
    "110inch",
    "Black",
    "Clear Border"
  ],
  "34208586727564": [
    "110inch",
    "White",
    "Black Border"
  ],
  "44425300017292": [
    "110inch",
    "White",
    "Clear Border"
  ],
  "34208586629260": [
    "120inch",
    "Black",
    "Black Border"
  ],
  "44425299918988": [
    "120inch",
    "Black",
    "Clear Border"
  ],
  "34208586662028": [
    "120inch",
    "White",
    "Black Border"
  ],
  "44425299951756": [
    "120inch",
    "White",
    "Clear Border"
  ],
  "42702968389772": [
    "130inch",
    "Black",
    "Black Border"
  ],
  "44425299853452": [
    "130inch",
    "Black",
    "Clear Border"
  ],
  "42702968422540": [
    "130inch",
    "White",
    "Black Border"
  ],
  "44425299886220": [
    "130inch",
    "White",
    "Clear Border"
  ],
  "34345215688844": [
    "84inch",
    "Black",
    "Black Border"
  ],
  "34345215721612": [
    "84inch",
    "White",
    "Black Border"
  ],
  "34345215623308": [
    "92inch",
    "Black",
    "Black Border"
  ],
  "34345215656076": [
    "92inch",
    "White",
    "Black Border"
  ],
  "34345215557772": [
    "100inch",
    "Black",
    "Black Border"
  ],
  "34345215590540": [
    "100inch",
    "White",
    "Black Border"
  ],
  "34345215492236": [
    "110inch",
    "Black",
    "Black Border"
  ],
  "34345215525004": [
    "110inch",
    "White",
    "Black Border"
  ],
  "34345215426700": [
    "120inch",
    "Black",
    "Black Border"
  ],
  "34345215459468": [
    "120inch",
    "White",
    "Black Border"
  ],
  "42702997356684": [
    "130inch",
    "Black",
    "Black Border"
  ],
  "42702997389452": [
    "130inch",
    "White",
    "Black Border"
  ],
  "39528995520652": [
    "84inch",
    "Black",
    "Black Border"
  ],
  "44425428926604": [
    "84inch",
    "Black",
    "Clear Border"
  ],
  "39528995553420": [
    "84inch",
    "White",
    "Black Border"
  ],
  "44425428959372": [
    "84inch",
    "White",
    "Clear Border"
  ],
  "39528995586188": [
    "92inch",
    "Black",
    "Black Border"
  ],
  "44425428992140": [
    "92inch",
    "Black",
    "Clear Border"
  ],
  "39528995618956": [
    "92inch",
    "White",
    "Black Border"
  ],
  "44425429024908": [
    "92inch",
    "White",
    "Clear Border"
  ],
  "39528995651724": [
    "100inch",
    "Black",
    "Black Border"
  ],
  "44425429057676": [
    "100inch",
    "Black",
    "Clear Border"
  ],
  "39528995684492": [
    "100inch",
    "White",
    "Black Border"
  ],
  "44425429090444": [
    "100inch",
    "White",
    "Clear Border"
  ],
  "39528995717260": [
    "110inch",
    "Black",
    "Black Border"
  ],
  "44425429123212": [
    "110inch",
    "Black",
    "Clear Border"
  ],
  "39528995750028": [
    "110inch",
    "White",
    "Black Border"
  ],
  "44425429155980": [
    "110inch",
    "White",
    "Clear Border"
  ],
  "39528995782796": [
    "120inch",
    "Black",
    "Black Border"
  ],
  "44425429188748": [
    "120inch",
    "Black",
    "Clear Border"
  ],
  "39528995815564": [
    "120inch",
    "White",
    "Black Border"
  ],
  "44425429221516": [
    "120inch",
    "White",
    "Clear Border"
  ],
  "42702978777228": [
    "130inch",
    "Black",
    "Black Border"
  ],
  "44425429254284": [
    "130inch",
    "Black",
    "Clear Border"
  ],
  "42702978809996": [
    "130inch",
    "White",
    "Black Border"
  ],
  "44425429287052": [
    "130inch",
    "White",
    "Clear Border"
  ],
  "40353359364236": [
    "72inch",
    "Black",
    "3D Obsidian Long Focus ALR"
  ],
  "40353359429772": [
    "72inch",
    "White",
    "3D Obsidian Long Focus ALR"
  ],
  "40353359495308": [
    "84inch",
    "Black",
    "3D Obsidian Long Focus ALR"
  ],
  "40353359560844": [
    "84inch",
    "White",
    "3D Obsidian Long Focus ALR"
  ],
  "40353359626380": [
    "92inch",
    "Black",
    "3D Obsidian Long Focus ALR"
  ],
  "40353359691916": [
    "92inch",
    "White",
    "3D Obsidian Long Focus ALR"
  ],
  "40353359757452": [
    "100inch",
    "Black",
    "3D Obsidian Long Focus ALR"
  ],
  "40353359822988": [
    "100inch",
    "White",
    "3D Obsidian Long Focus ALR"
  ],
  "40353359888524": [
    "110inch",
    "Black",
    "3D Obsidian Long Focus ALR"
  ],
  "40353359954060": [
    "110inch",
    "White",
    "3D Obsidian Long Focus ALR"
  ],
  "40353360019596": [
    "120inch",
    "Black",
    "3D Obsidian Long Focus ALR"
  ],
  "40353360085132": [
    "120inch",
    "White",
    "3D Obsidian Long Focus ALR"
  ],
  "40353360150668": [
    "135inch",
    "Black",
    "3D Obsidian Long Focus ALR"
  ],
  "40353360216204": [
    "135inch",
    "White",
    "3D Obsidian Long Focus ALR"
  ],
  "40353360281740": [
    "150inch",
    "Black",
    "3D Obsidian Long Focus ALR"
  ],
  "40353360347276": [
    "150inch",
    "White",
    "3D Obsidian Long Focus ALR"
  ],
  "39524233642124": [
    "72inch",
    "Black"
  ],
  "39524233707660": [
    "72inch",
    "White"
  ],
  "39524233773196": [
    "84inch",
    "Black"
  ],
  "39524233838732": [
    "84inch",
    "White"
  ],
  "39524233904268": [
    "92inch",
    "Black"
  ],
  "39524233969804": [
    "92inch",
    "White"
  ],
  "39524234035340": [
    "100inch",
    "Black"
  ],
  "39524234100876": [
    "100inch",
    "White"
  ],
  "39524234166412": [
    "110inch",
    "Black"
  ],
  "39524234231948": [
    "110inch",
    "White"
  ],
  "39524234297484": [
    "120inch",
    "Black"
  ],
  "39524234363020": [
    "120inch",
    "White"
  ],
  "39524234428556": [
    "135inch",
    "Black"
  ],
  "39524234494092": [
    "135inch",
    "White"
  ],
  "39524234559628": [
    "150inch",
    "Black"
  ],
  "39524234657932": [
    "150inch",
    "White"
  ],
  "34378551689356": [
    "72inch",
    "Black"
  ],
  "34378551722124": [
    "72inch",
    "White"
  ],
  "34378551754892": [
    "84inch",
    "Black"
  ],
  "34378551787660": [
    "84inch",
    "White"
  ],
  "34378551820428": [
    "92inch",
    "Black"
  ],
  "34378551853196": [
    "92inch",
    "White"
  ],
  "34378551885964": [
    "100inch",
    "Black"
  ],
  "34378551918732": [
    "100inch",
    "White"
  ],
  "34378551951500": [
    "110inch",
    "Black"
  ],
  "34378551984268": [
    "110inch",
    "White"
  ],
  "34378552017036": [
    "120inch",
    "Black"
  ],
  "34378552049804": [
    "120inch",
    "White"
  ],
  "42473468461196": [
    "135inch",
    "Black"
  ],
  "42473468493964": [
    "135inch",
    "White"
  ],
  "43847770669196": [
    "150inch",
    "Black"
  ],
  "43847770701964": [
    "150inch",
    "White"
  ],
  "43323783118988": [
    "72inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783151756": [
    "72inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783184524": [
    "84inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783217292": [
    "84inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783250060": [
    "92inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783282828": [
    "92inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783315596": [
    "100inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783348364": [
    "100inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783381132": [
    "110inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783413900": [
    "110inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783446668": [
    "120inch",
    "Black",
    "Enhanced Long Throw ALR Screen"
  ],
  "43323783479436": [
    "120inch",
    "White",
    "Enhanced Long Throw ALR Screen"
  ],
  "43781633409164": [
    "72inch",
    "White",
    "S Lite"
  ],
  "43781633441932": [
    "72inch",
    "White",
    "S Lite P"
  ],
  "43781633474700": [
    "72inch",
    "Black",
    "S Lite"
  ],
  "43781633507468": [
    "72inch",
    "Black",
    "S Lite P"
  ],
  "43781633540236": [
    "84inch",
    "White",
    "S Lite"
  ],
  "43781633573004": [
    "84inch",
    "White",
    "S Lite P"
  ],
  "43781633605772": [
    "84inch",
    "Black",
    "S Lite"
  ],
  "43781633638540": [
    "84inch",
    "Black",
    "S Lite P"
  ],
  "43781633671308": [
    "92inch",
    "White",
    "S Lite"
  ],
  "43781633704076": [
    "92inch",
    "White",
    "S Lite P"
  ],
  "43781633736844": [
    "92inch",
    "Black",
    "S Lite"
  ],
  "43781633769612": [
    "92inch",
    "Black",
    "S Lite P"
  ],
  "43781633802380": [
    "100inch",
    "White",
    "S Lite"
  ],
  "43781633835148": [
    "100inch",
    "White",
    "S Lite P"
  ],
  "43781633867916": [
    "100inch",
    "Black",
    "S Lite"
  ],
  "43781633900684": [
    "100inch",
    "Black",
    "S Lite P"
  ],
  "43781633933452": [
    "110inch",
    "White",
    "S Lite"
  ],
  "43781633966220": [
    "110inch",
    "White",
    "S Lite P"
  ],
  "43781633998988": [
    "110inch",
    "Black",
    "S Lite"
  ],
  "43781634031756": [
    "110inch",
    "Black",
    "S Lite P"
  ],
  "43781634064524": [
    "120inch",
    "White",
    "S Lite"
  ],
  "43781634097292": [
    "120inch",
    "White",
    "S Lite P"
  ],
  "43781634130060": [
    "120inch",
    "Black",
    "S Lite"
  ],
  "43781634162828": [
    "120inch",
    "Black",
    "S Lite P"
  ],
  "43781634195596": [
    "130inch",
    "White",
    "S Lite"
  ],
  "43781634228364": [
    "130inch",
    "White",
    "S Lite P"
  ],
  "43781634261132": [
    "130inch",
    "Black",
    "S Lite"
  ],
  "43781634293900": [
    "130inch",
    "Black",
    "S Lite P"
  ],
  "43533455556748": [
    "150inch",
    "White",
    "S Lite"
  ],
  "43628485574796": [
    "150inch",
    "White",
    "S Lite P"
  ],
  "43533455589516": [
    "150inch",
    "Black",
    "S Lite"
  ],
  "43628485607564": [
    "150inch",
    "Black",
    "S Lite P"
  ],
  "34087705018508": [
    "72inch",
    "Black"
  ],
  "34087705084044": [
    "84inch",
    "Black"
  ],
  "34087705149580": [
    "92inch",
    "Black"
  ],
  "34087705215116": [
    "100inch",
    "Black"
  ],
  "34087705280652": [
    "110inch",
    "Black"
  ],
  "34087705346188": [
    "120inch",
    "Black"
  ],
  "34196095926412": [
    "72inch",
    "White"
  ],
  "34196096123020": [
    "84inch",
    "White"
  ],
  "34196096155788": [
    "92inch",
    "White"
  ],
  "34196096254092": [
    "100inch",
    "White"
  ],
  "34196097433740": [
    "110inch",
    "White"
  ],
  "34196097499276": [
    "120inch",
    "White"
  ],
  "42702727381132": [
    "130inch",
    "Black"
  ],
  "42702727413900": [
    "130inch",
    "White"
  ],
  "34332407857292": [
    "72inch",
    "Black"
  ],
  "34332407890060": [
    "84inch",
    "Black"
  ],
  "34332407922828": [
    "92inch",
    "Black"
  ],
  "34332407955596": [
    "100inch",
    "Black"
  ],
  "34332407988364": [
    "110inch",
    "Black"
  ],
  "34332408021132": [
    "120inch",
    "Black"
  ],
  "34332408053900": [
    "72inch",
    "White"
  ],
  "34332408086668": [
    "84inch",
    "White"
  ],
  "34332408119436": [
    "92inch",
    "White"
  ],
  "34332408152204": [
    "100inch",
    "White"
  ],
  "34332408184972": [
    "110inch",
    "White"
  ],
  "34332408217740": [
    "120inch",
    "White"
  ],
  "42702743306380": [
    "130inch",
    "Black"
  ],
  "42702743339148": [
    "130inch",
    "White"
  ],
  "39524276142220": [
    "72inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39524276174988": [
    "72inch",
    "Black",
    "All White Design"
  ],
  "39524276207756": [
    "72inch",
    "White",
    "Normal Black Border Design"
  ],
  "39524276240524": [
    "72inch",
    "White",
    "All White Design"
  ],
  "39524276273292": [
    "84inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39524276306060": [
    "84inch",
    "Black",
    "All White Design"
  ],
  "39524276338828": [
    "84inch",
    "White",
    "Normal Black Border Design"
  ],
  "39524276371596": [
    "84inch",
    "White",
    "All White Design"
  ],
  "39524276404364": [
    "92inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39524276437132": [
    "92inch",
    "Black",
    "All White Design"
  ],
  "39524276469900": [
    "92inch",
    "White",
    "Normal Black Border Design"
  ],
  "39524276502668": [
    "92inch",
    "White",
    "All White Design"
  ],
  "39524276535436": [
    "100inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39524276568204": [
    "100inch",
    "Black",
    "All White Design"
  ],
  "39524276600972": [
    "100inch",
    "White",
    "Normal Black Border Design"
  ],
  "39524276633740": [
    "100inch",
    "White",
    "All White Design"
  ],
  "39524276666508": [
    "110inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39524276699276": [
    "110inch",
    "Black",
    "All White Design"
  ],
  "39524276732044": [
    "110inch",
    "White",
    "Normal Black Border Design"
  ],
  "39524276764812": [
    "110inch",
    "White",
    "All White Design"
  ],
  "39524276797580": [
    "120inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39524276830348": [
    "120inch",
    "Black",
    "All White Design"
  ],
  "39524276863116": [
    "120inch",
    "White",
    "Normal Black Border Design"
  ],
  "39524276895884": [
    "120inch",
    "White",
    "All White Design"
  ],
  "39524276928652": [
    "135inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39524276961420": [
    "135inch",
    "Black",
    "All White Design"
  ],
  "39524276994188": [
    "135inch",
    "White",
    "Normal Black Border Design"
  ],
  "39524277026956": [
    "135inch",
    "White",
    "All White Design"
  ],
  "39524277059724": [
    "150inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39524277092492": [
    "150inch",
    "Black",
    "All White Design"
  ],
  "39524277125260": [
    "150inch",
    "White",
    "Normal Black Border Design"
  ],
  "39524277158028": [
    "150inch",
    "White",
    "All White Design"
  ],
  "39525571362956": [
    "72inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525571395724": [
    "72inch",
    "White",
    "All White Design"
  ],
  "39525571428492": [
    "72inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525571461260": [
    "72inch",
    "Black",
    "All White Design"
  ],
  "39525571494028": [
    "84inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525571526796": [
    "84inch",
    "White",
    "All White Design"
  ],
  "39525571559564": [
    "84inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525571592332": [
    "84inch",
    "Black",
    "All White Design"
  ],
  "39525571625100": [
    "92inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525571657868": [
    "92inch",
    "White",
    "All White Design"
  ],
  "39525571690636": [
    "92inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525571723404": [
    "92inch",
    "Black",
    "All White Design"
  ],
  "39525571756172": [
    "100inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525571788940": [
    "100inch",
    "White",
    "All White Design"
  ],
  "39525571821708": [
    "100inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525571854476": [
    "100inch",
    "Black",
    "All White Design"
  ],
  "39525571887244": [
    "110inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525571920012": [
    "110inch",
    "White",
    "All White Design"
  ],
  "39525571952780": [
    "110inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525571985548": [
    "110inch",
    "Black",
    "All White Design"
  ],
  "39525572018316": [
    "120inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525572051084": [
    "120inch",
    "White",
    "All White Design"
  ],
  "39525572083852": [
    "120inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525572116620": [
    "120inch",
    "Black",
    "All White Design"
  ],
  "43857842471052": [
    "135inch",
    "White",
    "Normal Black Border Design"
  ],
  "43857842503820": [
    "135inch",
    "White",
    "All White Design"
  ],
  "43857842536588": [
    "135inch",
    "Black",
    "Normal Black Border Design"
  ],
  "43857842569356": [
    "135inch",
    "Black",
    "All White Design"
  ],
  "43857842602124": [
    "150inch",
    "White",
    "Normal Black Border Design"
  ],
  "43857842634892": [
    "150inch",
    "White",
    "All White Design"
  ],
  "43857842667660": [
    "150inch",
    "Black",
    "Normal Black Border Design"
  ],
  "43857842700428": [
    "150inch",
    "Black",
    "All White Design"
  ],
  "54267078049932": [
    "100inch-Early Bird Price",
    "Black"
  ],
  "54267078082700": [
    "100inch-Early Bird Price",
    "White"
  ],
  "54267078115468": [
    "120inch-Early Bird Price",
    "Black"
  ],
  "54267078148236": [
    "120inch-Early Bird Price",
    "White"
  ],
  "54245840519308": [
    "100inch-Early Bird Price",
    "Black"
  ],
  "54245840552076": [
    "100inch-Early Bird Price",
    "White"
  ],
  "54245840584844": [
    "120inch-Early Bird Price",
    "Black"
  ],
  "54245840617612": [
    "120inch-Early Bird Price",
    "White"
  ],
  "54309389303948": [
    "100inch-Early Bird Price",
    "White"
  ],
  "54309389336716": [
    "100inch-Early Bird Price",
    "Black"
  ],
  "54309389369484": [
    "120inch-Early Bird Price",
    "White"
  ],
  "54309389402252": [
    "120inch-Early Bird Price",
    "Black"
  ],
  "54297506840716": [
    "100inch-Early Bird Price",
    "White"
  ],
  "54302885937292": [
    "100inch-Early Bird Price",
    "Black"
  ],
  "54297506873484": [
    "120inch-Early Bird Price",
    "White"
  ],
  "54302885970060": [
    "120inch-Early Bird Price",
    "Black"
  ],
  "41558508732556": [
    "160inch",
    "Obsidian Long-Throw ALR",
    "White"
  ],
  "41558508765324": [
    "160inch",
    "Obsidian Long-Throw ALR",
    "Black"
  ],
  "41558508798092": [
    "160inch",
    "White Cinema",
    "White"
  ],
  "41558508830860": [
    "160inch",
    "White Cinema",
    "Black"
  ],
  "41558508863628": [
    "170inch",
    "Obsidian Long-Throw ALR",
    "White"
  ],
  "41558508896396": [
    "170inch",
    "Obsidian Long-Throw ALR",
    "Black"
  ],
  "41558508929164": [
    "170inch",
    "White Cinema",
    "White"
  ],
  "41558508961932": [
    "170inch",
    "White Cinema",
    "Black"
  ],
  "41558508994700": [
    "180inch",
    "Obsidian Long-Throw ALR",
    "White"
  ],
  "41558509027468": [
    "180inch",
    "Obsidian Long-Throw ALR",
    "Black"
  ],
  "41558509060236": [
    "180inch",
    "White Cinema",
    "White"
  ],
  "41558509093004": [
    "180inch",
    "White Cinema",
    "Black"
  ],
  "41558509256844": [
    "200inch",
    "Obsidian Long-Throw ALR",
    "White"
  ],
  "41558509289612": [
    "200inch",
    "Obsidian Long-Throw ALR",
    "Black"
  ],
  "41558509322380": [
    "200inch",
    "White Cinema",
    "White"
  ],
  "41558509355148": [
    "200inch",
    "White Cinema",
    "Black"
  ],
  "39525589549196": [
    "84inch",
    "Balck",
    "Normal Black Border Design"
  ],
  "39525589581964": [
    "84inch",
    "Balck",
    "All White Design"
  ],
  "39525589614732": [
    "84inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525589647500": [
    "84inch",
    "White",
    "All White Design"
  ],
  "39525589680268": [
    "92inch",
    "Balck",
    "Normal Black Border Design"
  ],
  "39525589713036": [
    "92inch",
    "Balck",
    "All White Design"
  ],
  "39525589745804": [
    "92inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525589778572": [
    "92inch",
    "White",
    "All White Design"
  ],
  "39525589811340": [
    "100inch",
    "Balck",
    "Normal Black Border Design"
  ],
  "39525589844108": [
    "100inch",
    "Balck",
    "All White Design"
  ],
  "39525589876876": [
    "100inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525589909644": [
    "100inch",
    "White",
    "All White Design"
  ],
  "39525589942412": [
    "110inch",
    "Balck",
    "Normal Black Border Design"
  ],
  "39525589975180": [
    "110inch",
    "Balck",
    "All White Design"
  ],
  "39525590007948": [
    "110inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525590040716": [
    "110inch",
    "White",
    "All White Design"
  ],
  "39525590073484": [
    "120inch",
    "Balck",
    "Normal Black Border Design"
  ],
  "39525590106252": [
    "120inch",
    "Balck",
    "All White Design"
  ],
  "39525590139020": [
    "120inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525590171788": [
    "120inch",
    "White",
    "All White Design"
  ],
  "39525586665612": [
    "84inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525586698380": [
    "84inch",
    "Black",
    "All White Design"
  ],
  "39525586731148": [
    "84inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525586763916": [
    "84inch",
    "White",
    "All White Design"
  ],
  "39525586796684": [
    "92inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525586829452": [
    "92inch",
    "Black",
    "All White Design"
  ],
  "39525586862220": [
    "92inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525586894988": [
    "92inch",
    "White",
    "All White Design"
  ],
  "39525586927756": [
    "100inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525586960524": [
    "100inch",
    "Black",
    "All White Design"
  ],
  "39525586993292": [
    "100inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525587026060": [
    "100inch",
    "White",
    "All White Design"
  ],
  "39525587058828": [
    "110inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525587091596": [
    "110inch",
    "Black",
    "All White Design"
  ],
  "39525587124364": [
    "110inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525587157132": [
    "110inch",
    "White",
    "All White Design"
  ],
  "39525587189900": [
    "120inch",
    "Black",
    "Normal Black Border Design"
  ],
  "39525587222668": [
    "120inch",
    "Black",
    "All White Design"
  ],
  "39525587255436": [
    "120inch",
    "White",
    "Normal Black Border Design"
  ],
  "39525587288204": [
    "120inch",
    "White",
    "All White Design"
  ],
  "42657756774540": [
    "135inch",
    "Black",
    "Normal Black Border Design"
  ],
  "42657756807308": [
    "135inch",
    "Black",
    "All White Design"
  ],
  "42657756840076": [
    "135inch",
    "White",
    "Normal Black Border Design"
  ],
  "42657756872844": [
    "135inch",
    "White",
    "All White Design"
  ],
  "43857728635020": [
    "150inch",
    "Black",
    "Normal Black Border Design"
  ],
  "43857728667788": [
    "150inch",
    "Black",
    "All White Design"
  ],
  "43857728700556": [
    "150inch",
    "White",
    "Normal Black Border Design"
  ],
  "43857728733324": [
    "150inch",
    "White",
    "All White Design"
  ],
  "44323467591820": [
    "160inch",
    "Black",
    "Normal Black Border Design"
  ],
  "44323467624588": [
    "160inch",
    "Black",
    "All White Design"
  ],
  "44323467657356": [
    "160inch",
    "White",
    "Normal Black Border Design"
  ],
  "44323467690124": [
    "160inch",
    "White",
    "All White Design"
  ],
  "44323467722892": [
    "170inch",
    "Black",
    "Normal Black Border Design"
  ],
  "44323467755660": [
    "170inch",
    "Black",
    "All White Design"
  ],
  "44323467788428": [
    "170inch",
    "White",
    "Normal Black Border Design"
  ],
  "44323467821196": [
    "170inch",
    "White",
    "All White Design"
  ],
  "44323467853964": [
    "180inch",
    "Black",
    "Normal Black Border Design"
  ],
  "44323467886732": [
    "180inch",
    "Black",
    "All White Design"
  ],
  "44323467919500": [
    "180inch",
    "White",
    "Normal Black Border Design"
  ],
  "44323467952268": [
    "180inch",
    "White",
    "All White Design"
  ]
};
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.ScreenFinderProductMedia = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  // Product JSON is the image authority. Never infer a housing colour from a
  // filename or reuse another product's picture when an exact image is absent.
  function imageUrl(value) {
    if (value && typeof value === 'object') value = value.src || value.url;
    if (typeof value !== 'string' || /\s/.test(value)) return null;
    if (value.indexOf('//') === 0) value = 'https:' + value;
    try {
      var url = new URL(value);
      if (url.protocol !== 'https:' || url.username || url.password || url.port || url.hash) return null;
      var officialCdn = url.hostname === 'cdn.shopify.com' && /^\/s\/files\/1\/0349\/5179\/0732\/(?:files|products)\//.test(url.pathname);
      var officialStore = url.hostname === 'vividstormscreen.com' && /^\/cdn\/shop\/(?:files|products)\//.test(url.pathname);
      return officialCdn || officialStore ? url.href : null;
    } catch (_) { return null; }
  }

  function normalized(value) { return String(value || '').trim().toLowerCase().replace(/\s+/g, ' '); }
  function optionsFor(variant) {
    return Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].filter(function (value) { return typeof value === 'string'; });
  }
  function sameOptions(a, b) {
    var left = optionsFor(a), right = optionsFor(b);
    return left.length > 0 && left.length === right.length && left.every(function (value, index) { return normalized(value) === normalized(right[index]); });
  }
  function sameImage(a, b) {
    if (!a || !b) return false;
    if (a.id && b.id && String(a.id) === String(b.id)) return true;
    var left = imageUrl(a), right = imageUrl(b);
    return !!left && left === right;
  }
  function belongsToProduct(image, productId) {
    return !image || typeof image !== 'object' || image.product_id === undefined || String(image.product_id) === String(productId);
  }
  function galleryContains(data, url) {
    return imageUrl(data.featured_image) === url || (Array.isArray(data.images) && data.images.some(function (image) { return imageUrl(image) === url; }));
  }
  function descriptor(url, kind, selected) {
    return { url: url, kind: kind, source: 'official_product_json', productId: String(selected.productId),
      variantId: kind === 'variantReference' ? String(selected.variantId) : null,
      housing: kind === 'variantReference' ? selected.housing || null : null,
      exactAppearance: kind === 'variantReference' };
  }
  function fromProductData(data, variant, selected) {
    if (!data || !variant || !selected || String(data.id) !== String(selected.productId) || data.handle !== selected.handle ||
        String(variant.id) !== String(selected.variantId) || !Array.isArray(data.variants) ||
        data.variants.filter(function (item) { return String(item.id) === String(selected.variantId); }).length !== 1) return null;

    var image = variant.featured_image;
    var variantUrl = imageUrl(image);
    // Some official variants are attached to the same dimensions chart across
    // Black, White and different border designs. That association is not proof
    // that a photograph depicts the selected colour or configuration.
    var referencedIds = image && Array.isArray(image.variant_ids) ? image.variant_ids.map(String) : [];
    var shared = data.variants.some(function (item) {
      return (referencedIds.indexOf(String(item.id)) >= 0 || sameImage(item.featured_image, image)) && !sameOptions(item, variant);
    });
    var unknownReference = referencedIds.some(function (id) { return !data.variants.some(function (item) { return String(item.id) === id; }); });
    var associated = image && typeof image === 'object' && referencedIds.indexOf(String(variant.id)) >= 0;
    if (variantUrl && associated && !shared && !unknownReference && belongsToProduct(image, selected.productId) && galleryContains(data, variantUrl)) {
      return descriptor(variantUrl, 'variantReference', selected);
    }

    var featuredUrl = belongsToProduct(data.featured_image, selected.productId) && imageUrl(data.featured_image);
    if (featuredUrl) return descriptor(featuredUrl, 'productReference', selected);
    var galleryUrl = Array.isArray(data.images) && data.images.map(function (item) { return belongsToProduct(item, selected.productId) && imageUrl(item); }).find(Boolean);
    return galleryUrl ? descriptor(galleryUrl, 'productReference', selected) : null;
  }
  return { imageUrl: imageUrl, fromProductData: fromProductData };
});

(function (root, factory) {
  var api = factory(root, root.ScreenFinderVariantOptions || (typeof require === 'function' ? require('./variant-options.json') : null),
    root.ScreenFinderProductMedia || (typeof require === 'function' ? require('./product-media.js') : null));
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.ScreenFinderLiveProduct = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function (global, expectedVariantOptions, productMedia) {
  'use strict';
  function unavailable(reason) { return { status: 'unavailable', reason: reason }; }
  function normalized(value) { return String(value || '').trim().toLowerCase().replace(/\s*:\s*$/, '').replace(/\s+/g, ' '); }
  function fail(reason) { var error = new Error(reason); error.reason = reason; throw error; }
  function rootPath(value) {
    return typeof value === 'string' && /^\/(?:[a-zA-Z0-9_-]+\/)*$/.test(value) ? value : null;
  }
  function currencyCode(value) {
    if (typeof value !== 'string' || !/^[A-Z]{3}$/.test(value)) return null;
    try {
      if (typeof Intl.supportedValuesOf === 'function' && Intl.supportedValuesOf('currency').indexOf(value) < 0) return null;
      new Intl.NumberFormat('en', { style: 'currency', currency: value });
    } catch (_) { return null; }
    return value;
  }
  function selection(product, state, housing) {
    if (!product || !state || !Number.isInteger(state.size) || state.size <= 0 ||
        product.availabilityMode !== 'standardVariant' || product.verificationStatus !== 'verified' ||
        product.customerVisible === false || product.recommendationEligible === false) return null;
    var mapping = product.variantMap && product.variantMap[String(state.size)];
    if (!mapping || !Array.isArray(mapping.variantIds)) return null;
    var houses = mapping.housingVariants || {};
    var variantId = housing ? houses[housing] : mapping.defaultVariantId;
    if (!variantId || !mapping.variantIds.some(function (id) { return String(id) === String(variantId); })) return null;
    var selectedHousing = housing || Object.keys(houses).find(function (key) { return String(houses[key]) === String(variantId); }) || null;
    var path = product.productPath;
    if (typeof path !== 'string' || !/^\/products\/[a-zA-Z0-9_-]+$/.test(path) || !/^\d+$/.test(String(product.shopifyProductId))) return null;
    return { productId: String(product.shopifyProductId), variantId: String(variantId), size: state.size,
      housing: selectedHousing, handle: path.slice('/products/'.length), path: path };
  }
  function imageUrl(value) {
    if (value && typeof value === 'object') value = value.src || value.url;
    if (typeof value !== 'string') return null;
    if (value.indexOf('//') === 0) value = 'https:' + value;
    return /^https:\/\/[^\s]+$/i.test(value) ? value : null;
  }
  function validateQuote(product, state, housing, data, context) {
    var selected = selection(product, state, housing);
    if (!selected) return unavailable('selection_unverified');
    if (!context || !rootPath(context.root) || !currencyCode(context.currency)) return unavailable('currency_unverified');
    if (!data || String(data.id) !== selected.productId || data.handle !== selected.handle) return unavailable('product_identity_mismatch');
    if (!Array.isArray(data.variants)) return unavailable('variant_missing');
    var variants = data.variants.filter(function (variant) { return String(variant.id) === selected.variantId; });
    if (variants.length !== 1) return unavailable('variant_missing');
    var variant = variants[0];
    var optionNames = Array.isArray(data.options) ? data.options.map(function (option) { return normalized(typeof option === 'string' ? option : option.name); }) : [];
    var expectedNames = (product.shopifyOptionNames || []).map(normalized);
    if (!expectedNames.length || optionNames.length !== expectedNames.length || optionNames.some(function (name, i) { return name !== expectedNames[i]; })) return unavailable('option_schema_mismatch');
    var values = Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].slice(0, optionNames.length);
    if (values.length !== optionNames.length || values.some(function (value) { return typeof value !== 'string' || !value.trim(); })) return unavailable('option_values_missing');
    var sizeIndex = optionNames.findIndex(function (name) { return /size|diagonal|digonal/.test(name); });
    var sizeMatch = sizeIndex >= 0 ? /^\s*(\d+(?:\.\d+)?)(?=\s|$|["'″（(]|in\b|inch)/i.exec(values[sizeIndex]) : null;
    if (!sizeMatch || Number(sizeMatch[1]) !== selected.size) return unavailable('size_mismatch');
    var housingIndex = optionNames.findIndex(function (name) { return /housing|^colou?r$/.test(name); });
    if (selected.housing && (housingIndex < 0 || normalized(values[housingIndex]) !== normalized(selected.housing))) return unavailable('housing_mismatch');
    var configurations = product.shopifyOptionValues || [];
    if (configurations.length && !values.some(function (value, i) {
      return i !== sizeIndex && i !== housingIndex && configurations.some(function (config) { return normalized(value) === normalized(config); });
    })) return unavailable('configuration_mismatch');
    var exactOptions = expectedVariantOptions && expectedVariantOptions[selected.variantId];
    if (!Array.isArray(exactOptions) || exactOptions.length !== values.length) return unavailable('variant_options_unverified');
    if (values.some(function (value, i) { return normalized(value) !== normalized(exactOptions[i]); })) return unavailable('variant_options_mismatch');
    if (!Number.isSafeInteger(variant.price) || variant.price < 0) return unavailable('price_invalid');
    if (typeof variant.available !== 'boolean') return unavailable('availability_unverified');
    var formatted;
    try {
      // Shopify Ajax monetary integers are scaled by 100 even for JPY/KRW.
      formatted = new Intl.NumberFormat(context.locale || undefined, { style: 'currency', currency: context.currency }).format(variant.price / 100);
    } catch (_) { return unavailable('format_unavailable'); }
    var media = productMedia && productMedia.fromProductData(data, variant, selected);
    return {
      status: 'ok', availabilityMode: 'standardVariant', verificationStatus: 'verified',
      productId: selected.productId, variantId: selected.variantId, size: selected.size, housing: selected.housing,
      priceMinor: variant.price, priceAmount: variant.price / 100, currency: context.currency, formattedPrice: formatted,
      available: variant.available, title: String(data.title || product.displayName), variantTitle: String(variant.title || ''),
      url: context.root + selected.path.slice(1) + '?variant=' + selected.variantId,
      image: imageUrl(variant.featured_image) || imageUrl(data.featured_image),
      media: media || null,
      fetchedAt: context.fetchedAt || Date.now(), priceScope: 'current_variant_selling_price'
    };
  }
  function create(options) {
    options = options || {};
    var fetcher = options.fetch || (global.fetch && global.fetch.bind(global));
    var resolvedRoot = rootPath(options.root || (global.Shopify && global.Shopify.routes && global.Shopify.routes.root));
    var expectedCurrency = options.currency;
    var timeoutMs = Number.isFinite(options.timeoutMs) && options.timeoutMs > 0 ? options.timeoutMs : 8000;
    var cacheMs = Number.isFinite(options.cacheMs) ? Math.max(0, Math.min(options.cacheMs, 15000)) : 0;
    var cache = new Map();
    async function request(path, signal) {
      if (signal.aborted) fail('aborted');
      var response = await fetcher(path, { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: signal });
      if (signal.aborted) fail('aborted');
      if (!response || !response.ok) fail('network_unavailable');
      // A redirect to a separate origin must never become a monetary authority.
      if (response.url && global.location && new URL(response.url, global.location.href).origin !== global.location.origin) fail('origin_mismatch');
      try { return await response.json(); } catch (_) { fail('response_invalid'); }
    }
    async function quote(product, state, housing, requestOptions) {
      var selected = selection(product, state, housing);
      if (!selected) return unavailable('selection_unverified');
      if (!resolvedRoot || typeof fetcher !== 'function') return unavailable('storefront_context_unavailable');
      if (expectedCurrency !== undefined && !currencyCode(expectedCurrency)) return unavailable('currency_unverified');
      var callerSignal = requestOptions && requestOptions.signal;
      if (callerSignal && callerSignal.aborted) return unavailable('aborted');
      var controller = new AbortController();
      var timer, onAbort;
      var stop = new Promise(function (_, reject) {
        timer = setTimeout(function () { controller.abort(); var error = new Error('timeout'); error.reason = 'timeout'; reject(error); }, timeoutMs);
        if (callerSignal) {
          onAbort = function () { controller.abort(); var error = new Error('aborted'); error.reason = 'aborted'; reject(error); };
          callerSignal.addEventListener('abort', onAbort, { once: true });
        }
      });
      async function load() {
        var before = await request(resolvedRoot + 'cart.js', controller.signal);
        var currency = currencyCode(before && before.currency);
        if (!currency || (expectedCurrency && expectedCurrency !== currency)) fail('currency_unverified');
        var key = resolvedRoot + selected.handle + ':' + currency;
        var cached = cache.get(key);
        var data, dataFetchedAt, freshProductRead = false;
        var cachedAge = cached ? Date.now() - cached.at : Infinity;
        if (cached && cacheMs && cachedAge >= 0 && cachedAge < cacheMs) {
          data = cached.data;
          dataFetchedAt = cached.at;
        } else {
          data = await request(resolvedRoot + 'products/' + selected.handle + '.js', controller.signal);
          dataFetchedAt = Date.now();
          freshProductRead = true;
        }
        var after = await request(resolvedRoot + 'cart.js', controller.signal);
        if (!after || after.currency !== currency) fail('currency_changed');
        var result = validateQuote(product, state, housing, data, { root: resolvedRoot, currency: currency, locale: options.locale, fetchedAt: dataFetchedAt });
        // Reusing JSON cannot make its price newer or extend the cache lifetime.
        if (result.status === 'ok' && cacheMs && freshProductRead) cache.set(key, { at: dataFetchedAt, data: data });
        return result;
      }
      try { return await Promise.race([load(), stop]); }
      catch (error) { return unavailable(error.reason || (controller.signal.aborted ? 'aborted' : 'network_unavailable')); }
      finally { clearTimeout(timer); if (callerSignal && onAbort) callerSignal.removeEventListener('abort', onAbort); }
    }
    return { quote: quote, clear: function () { cache.clear(); } };
  }
  function compare(a, b) {
    if (!a || !b || [a, b].some(function (q) {
      return q.status !== 'ok' || q.availabilityMode !== 'standardVariant' || q.verificationStatus !== 'verified' ||
        !q.available || !Number.isSafeInteger(q.priceMinor) || q.priceMinor < 0 || !Number.isInteger(q.size) || !currencyCode(q.currency);
    }) || a.currency !== b.currency || a.size !== b.size) return null;
    return { differenceMinor: a.priceMinor - b.priceMinor, differenceAmount: (a.priceMinor - b.priceMinor) / 100, currency: a.currency, size: a.size };
  }
  return { create: create, validateQuote: validateQuote, compare: compare };
});

(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.ScreenFinderPurchaseIntent = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var MAX_QUOTE_AGE_MS = 30000;

  function shopifyId(value) {
    if (typeof value === 'number' && (!Number.isSafeInteger(value) || value <= 0)) return null;
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    var id = String(value);
    return /^[1-9][0-9]*$/.test(id) ? id : null;
  }

  function housingValue(value) {
    if (value === null || value === undefined) return null;
    return typeof value === 'string' && value.trim() === value && value.length > 0 &&
      value.length <= 100 && !/[\u0000-\u001f\u007f]/.test(value) ? value : undefined;
  }

  function create(value) {
    if (!value || typeof value !== 'object') return null;
    var productId = shopifyId(value.productId);
    var variantId = shopifyId(value.variantId);
    var housing = housingValue(value.housing);
    if (typeof value.catalogId !== 'string' || !/^[a-z][a-z0-9_-]*$/.test(value.catalogId) ||
        !productId || !variantId || housing === undefined ||
        !Number.isSafeInteger(value.size) || value.size <= 0 ||
        !Number.isSafeInteger(value.revision) || value.revision < 0 ||
        ['en', 'zh-CN', 'ja'].indexOf(value.language) < 0) return null;
    return Object.freeze({
      catalogId: value.catalogId, productId: productId, variantId: variantId,
      size: value.size, housing: housing, revision: value.revision, language: value.language
    });
  }

  function validCurrency(value) {
    if (typeof value !== 'string' || !/^[A-Z]{3}$/.test(value)) return false;
    try {
      if (typeof Intl.supportedValuesOf === 'function' && Intl.supportedValuesOf('currency').indexOf(value) < 0) return false;
      new Intl.NumberFormat('en', { style: 'currency', currency: value });
      return true;
    } catch (_) { return false; }
  }

  function validDestination(url, product, variantId) {
    var path = product.productPath;
    if (typeof path !== 'string' || !/^\/products\/[A-Za-z0-9_-]+$/.test(path) || typeof url !== 'string') return false;
    var destination = path + '?variant=' + variantId;
    if (url.slice(-destination.length) !== destination) return false;
    // Quotes may include a Shopify language/market root, but never another origin,
    // traversal, fragments, or a second query parameter.
    var prefix = url.slice(0, url.length - destination.length);
    return /^(?:\/[A-Za-z0-9_-]+)*$/.test(prefix);
  }

  function canContinue(intent, context) {
    var selected = create(intent);
    if (!selected || !context) return false;
    var state = context.state;
    var product = context.product;
    var quote = context.quote;
    var handoff = context.handoff;
    var housing = housingValue(context.housing);
    var now = context.now === undefined ? Date.now() : context.now;
    if (!state || state.stage !== 'results' || state.revision !== selected.revision ||
        state.language !== selected.language || state.size !== selected.size ||
        housing === undefined || housing !== selected.housing ||
        !product || product.id !== selected.catalogId || shopifyId(product.shopifyProductId) !== selected.productId ||
        product.availabilityMode !== 'standardVariant' || product.verificationStatus !== 'verified' ||
        product.customerVisible === false || product.recommendationEligible === false ||
        !quote || quote.status !== 'ok' || quote.available !== true ||
        quote.availabilityMode !== 'standardVariant' || quote.verificationStatus !== 'verified' ||
        shopifyId(quote.productId) !== selected.productId || shopifyId(quote.variantId) !== selected.variantId ||
        quote.size !== selected.size || housingValue(quote.housing) !== selected.housing ||
        !validCurrency(quote.currency) || !Number.isSafeInteger(quote.priceMinor) || quote.priceMinor < 0 ||
        !Number.isFinite(now) || !Number.isFinite(quote.fetchedAt) || quote.fetchedAt <= 0 ||
        now < quote.fetchedAt || now - quote.fetchedAt > MAX_QUOTE_AGE_MS ||
        !handoff || handoff.exactSize !== true || shopifyId(handoff.variantId) !== selected.variantId ||
        !handoff.selectedOptions || handoff.selectedOptions.size !== selected.size ||
        housingValue(handoff.selectedOptions.housing) !== selected.housing) return false;

    var mapping = product.variantMap && product.variantMap[String(selected.size)];
    if (!mapping || !Array.isArray(mapping.variantIds) || !mapping.variantIds.some(function (id) {
      return shopifyId(id) === selected.variantId;
    })) return false;
    var mappedId = selected.housing === null ? mapping.defaultVariantId :
      mapping.housingVariants && Object.prototype.hasOwnProperty.call(mapping.housingVariants, selected.housing) && mapping.housingVariants[selected.housing];
    if (shopifyId(mappedId) !== selected.variantId) return false;
    return handoff.url === product.productPath + '?variant=' + selected.variantId && validDestination(quote.url, product, selected.variantId);
  }

  return Object.freeze({ create: create, canContinue: canContinue, MAX_QUOTE_AGE_MS: MAX_QUOTE_AGE_MS });
});

(function (root, factory) {
  var api = factory(root.ScreenFinderCatalog || (typeof require === 'function' ? require('./catalog.js') : null),
    root.ScreenFinderSizeGuide || (typeof require === 'function' ? require('./size-guide.js') : null));
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.ScreenFinderCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function (catalogModule, sizeGuide) {
  'use strict';

  if (!catalogModule) throw new Error('ScreenFinderCatalog is required');

  var DEPENDENCIES = Object.freeze({
    projectorType: ['location','outdoorSetup','viewingLight','installation','orientation','alignment','offsetMethod','sideViewing','speakerRequirement','size'],
    location: ['outdoorSetup','viewingLight','installation','orientation','alignment','offsetMethod','sideViewing','speakerRequirement','size'],
    viewingLight: ['installation','orientation','alignment','offsetMethod','sideViewing','speakerRequirement','size'],
    installation: ['orientation','alignment','offsetMethod','sideViewing','speakerRequirement','size'],
    orientation: ['speakerRequirement','size'],
    alignment: ['offsetMethod','speakerRequirement','size'],
    offsetMethod: ['speakerRequirement','size'],
    sideViewing: ['speakerRequirement','size'],
    speakerRequirement: ['size'],
    roomWidthMm: ['size'], viewingDistanceMm: [], size: []
  });

  var SIZE_OPTIONS = Object.freeze([72,84,92,100,110,120,130,135,150,160,170,180,200,'unknown']);
  var BRIGHTNESS_REFERENCE = Object.freeze({
    value: 2400, unit: 'ANSI_LUMENS', type: 'approximateExperienceGuidance', hardExclusion: false
  });

  function initialState() {
    return {
      revision: 0, language: 'en', stage: 'configure', step: 'projector',
      projectorInput: '', projectorModel: null, projectorType: null,
      location: null, outdoorSetup:null, viewingLight: null, installation: null,
      orientation: null, alignment: null, offsetMethod: null, sideViewing: null,
      speakerRequirement: null, audio: null, size: null, roomWidthMm:null,
      viewingDistanceMm:null, measurementUnit:'m', housing:null, changed: []
    };
  }

  function cloneState(state) {
    return Object.assign({}, initialState(), state || {}, {
      projectorModel: state && state.projectorModel ? Object.assign({}, state.projectorModel) : null,
      outdoorSetup: state && state.location === 'covered_outdoor' && state.outdoorSetup === 'sheltered_between_posts' ? 'sheltered_between_posts' : null,
      changed: state && state.changed ? state.changed.slice() : []
    });
  }

  function normalizeUrl(url) {
    try {
      var parsed = new URL(url, 'https://vividstormscreen.com');
      return (parsed.origin + parsed.pathname).replace(/\/$/, '').toLowerCase();
    } catch (error) {
      return String(url || '').split(/[?#]/)[0].replace(/\/$/, '').toLowerCase();
    }
  }

  function requiredSteps(state) {
    var steps = ['projector','location','viewingLight','installation'];
    if (state.projectorType === 'ust' && ['floor','drop','ceiling'].indexOf(state.installation) >= 0) steps.push('orientation');
    if (state.projectorType === 'long' && ['floor','drop','ceiling','frame'].indexOf(state.installation) >= 0) {
      steps.push('alignment');
      if (state.alignment === 'off_center') steps.push('offsetMethod');
    }
    if (state.projectorType === 'ust' && state.installation === 'frame') steps.push('sideViewing');
    steps.push('speakerRequirement','size','review');
    return steps;
  }

  function stepValue(state, step) {
    if (step === 'projector') return state.projectorType;
    if (step === 'review') return true;
    return state[step];
  }

  function firstMissingStep(state) {
    var steps = requiredSteps(state).filter(function (step) { return step !== 'review'; });
    for (var i = 0; i < steps.length; i += 1) {
      if (stepValue(state, steps[i]) === null || stepValue(state, steps[i]) === '') return steps[i];
    }
    return null;
  }

  function isReady(state) { return !firstMissingStep(state); }

  function nextStep(state, current) {
    var steps = requiredSteps(state);
    var index = steps.indexOf(current || state.step);
    return steps[Math.min(index + 1, steps.length - 1)];
  }

  function previousStep(state, current) {
    var steps = requiredSteps(state);
    var index = steps.indexOf(current || state.step);
    return steps[Math.max(index - 1, 0)];
  }

  function invalidate(next, key) {
    var changed = [];
    (DEPENDENCIES[key] || []).forEach(function (dependent) {
      if (next[dependent] !== null) changed.push(dependent);
      next[dependent] = null;
      if (dependent === 'speakerRequirement') next.audio = null;
    });
    return changed;
  }

  function applyAnswer(state, key, value) {
    var next = cloneState(state);
    if (key === 'outdoorSetup') value = next.location === 'covered_outdoor' && value === 'sheltered_between_posts' ? value : null;
    var changed = [];
    if (next[key] !== value) changed = invalidate(next, key);
    next[key] = value;
    next.stage = 'configure';
    next.revision += 1;
    next.changed = changed;
    return next;
  }

  function selectProjector(state, projector) {
    var next = cloneState(state);
    var changed = [];
    if (next.projectorType && next.projectorType !== projector.type) changed = invalidate(next, 'projectorType');
    next.projectorModel = Object.assign({}, projector);
    next.projectorInput = projector.fullName;
    next.projectorType = projector.type;
    next.stage = 'configure';
    next.revision += 1;
    next.changed = changed;
    next.step = 'projector';
    return next;
  }

  function selectManualProjectorType(state, type) {
    var next = applyAnswer(state, 'projectorType', type);
    next.projectorModel = null;
    // Keep a customer-provided model for support; a manual type does not verify it.
    next.projectorInput = state && state.projectorInput || '';
    next.step = 'projector';
    return next;
  }

  function editProjectorInput(state, value) {
    var next = cloneState(state);
    next.projectorInput = value;
    var exact = next.projectorModel && value.trim() === next.projectorModel.fullName;
    // Searching for another model replaces the previous explicit choice.
    // A query alone cannot retain a model-derived or formerly manual type.
    var replacingManualChoice = !next.projectorModel && next.projectorType !== null &&
      value.trim() !== '' && value !== state.projectorInput;
    if ((!exact && next.projectorModel) || replacingManualChoice) {
      next.projectorModel = null;
      next.changed = invalidate(next, 'projectorType');
      next.projectorType = null;
      next.revision += 1;
      next.stage = 'configure';
    }
    return next;
  }

  function clearProjector(state) {
    var next = cloneState(state);
    next.projectorModel = null;
    next.projectorInput = '';
    if (next.projectorType !== null) {
      next.changed = invalidate(next, 'projectorType');
      next.projectorType = null;
    }
    next.revision += 1;
    next.stage = 'configure';
    next.step = 'projector';
    return next;
  }

  function selectedAlignment(state) {
    if (state.projectorType !== 'long') return 'centered';
    if (state.alignment === 'centered') return 'centered';
    if (state.alignment === 'off_center') return state.offsetMethod;
    return state.alignment;
  }

  function orientationValue(state) {
    if (state.orientation === 'below_upright') return 'belowUpright';
    if (state.orientation === 'above_inverted') return 'aboveInverted';
    return state.orientation;
  }

  function speakerRequirementValue(state) {
    if (state.speakerRequirement) return state.speakerRequirement;
    if (state.audio === 'visible') return 'none';
    if (state.audio === 'behind') return 'imageAreaBehind';
    if (state.audio === 'not_sure') return 'unknown';
    return null;
  }

  function compatible(product, state) {
    var reasons = [];
    if (state.location === 'exposed_outdoor') reasons.push('unsupported_outdoor_exposure');
    if (state.location === 'covered_outdoor' && state.outdoorSetup !== 'sheltered_between_posts') reasons.push('outdoor_installation');
    if (!product.recommendationEligible) reasons.push('recommendation_ineligible');
    if (['discontinued','unverified'].indexOf(product.status) >= 0) reasons.push('product_status');
    if (state.projectorType !== 'unknown' && product.projectorTypes.indexOf(state.projectorType) < 0) reasons.push('projector_type');
    if (state.location !== 'not_sure' && product.locations.indexOf(state.location) < 0) reasons.push('location');
    if (state.viewingLight !== 'not_sure' && product.viewingConditions.indexOf(state.viewingLight) < 0) reasons.push('viewing_light');
    if (state.installation !== 'not_sure' && product.installation !== state.installation) reasons.push('installation');
    var speakerRequirement = speakerRequirementValue(state);
    if (speakerRequirement === 'lowerBorderBehind' && product.perforationArea !== 'lowerBorder') reasons.push('lower_border_perforation');
    if (speakerRequirement === 'imageAreaBehind' && product.perforationArea !== 'imageArea') reasons.push('image_area_perforation');
    if (state.sideViewing === 'wide' && product.sideViewingSuitability !== 'suitable') reasons.push('side_viewing');
    var orientation = orientationValue(state);
    if (state.projectorType === 'ust' && orientation && orientation !== 'not_sure' && product.orientation !== 'nonDirectional' && product.orientation !== orientation) reasons.push('orientation');
    var alignment = selectedAlignment(state);
    if (state.projectorType === 'long' && alignment && alignment !== 'not_sure' && product.alignmentMethods.indexOf(alignment) < 0) reasons.push('alignment');
    if (typeof state.size === 'number' && product.materialClass === 'blackGrid' && state.size > 130) reasons.push('black_grid_raw_material_limit');
    if (typeof state.size === 'number' && product.sizes.indexOf(state.size) < 0) reasons.push('unsupported_size');
    if (typeof state.size === 'number' && state.roomWidthMm > 0 && sizeGuide &&
        sizeGuide.widthFits(product, state.size, state.roomWidthMm) === false) reasons.push('room_width');
    return Array.from(new Set(reasons));
  }

  function availableSizes(state) {
    var probe = cloneState(state);
    probe.size = null;
    var sizes = new Set();
    catalogModule.products.forEach(function (product) {
      if (compatible(product, probe).length) return;
      product.sizes.forEach(function (size) {
        if (probe.roomWidthMm > 0 && sizeGuide && sizeGuide.widthFits(product,size,probe.roomWidthMm) === false) return;
        sizes.add(size);
      });
    });
    return Array.from(sizes).sort(function (a, b) { return a - b; });
  }

  function score(product, state) {
    var value = 100;
    if (state.viewingLight === 'bright' && product.materialType === 'alr') value += 20;
    if (state.viewingLight === 'dark' && product.materialClass === 'whiteCinema') value += 3;
    if (state.viewingLight === 'dark' && product.materialClass === 'blackGrid') value += 3;
    if (state.location !== 'indoor' && product.familyId === 'duraplus') value += 25;
    var speakerRequirement = speakerRequirementValue(state);
    if (speakerRequirement === 'lowerBorderBehind' && product.perforationArea === 'lowerBorder') value += 30;
    if (speakerRequirement === 'imageAreaBehind' && product.perforationArea === 'imageArea') value += 30;
    if (speakerRequirement === 'aestheticPreference' && product.perforationArea !== 'none') value += 12;
    if (speakerRequirement === 'none' && product.perforationArea !== 'none') value -= 2;
    if (state.sideViewing === 'wide' && product.materialClass === 'blackGrid') value += 8;
    if (state.sideViewing === 'wide' && product.materialClass === 'liteHyperDomesticGrid') value += 5;
    if (state.projectorType === 'long' && state.alignment === 'off_center' && state.offsetMethod === 'optical_shift') {
      if (product.materialClass === 'whiteCinema') value += 40;
      if (['longThrowAlr','longThrow3dAlr'].indexOf(product.materialClass) >= 0) value -= 10;
    }
    var brightness = state.projectorModel && Number(state.projectorModel.brightnessValue);
    if (state.projectorType === 'long' && state.viewingLight === 'bright' && Number.isFinite(brightness) && state.projectorModel.brightnessUnit === 'ANSI_LUMENS') {
      var guidance = Math.max(-6, Math.min(6, (brightness - BRIGHTNESS_REFERENCE.value) / 100));
      if (product.materialClass === 'longThrowAlr') value += guidance;
      if (product.materialClass === 'longThrow3dAlr') value -= guidance;
    }
    if (product.status === 'active') value += 5;
    if (product.status === 'preorder') value -= 25;
    if (product.status === 'clearance') value -= 1000;
    if (product.plus && state.size === 130) value += 35;
    if (['s_pro','pro','pro_a'].indexOf(product.id) >= 0) value += 3;
    return value;
  }

  function purchaseHandoff(product, state, housing) {
    if (!product || !state || typeof state.size !== 'number') return null;
    if (state.roomWidthMm > 0 && (!sizeGuide || sizeGuide.widthFits(product, state.size, state.roomWidthMm) !== true)) return null;
    if (product.availabilityMode !== 'standardVariant' || product.verificationStatus !== 'verified') return null;
    var sizeMap = product.variantMap && product.variantMap[String(state.size)];
    if (!sizeMap) return null;
    var variantId = housing ? sizeMap.housingVariants[housing] : sizeMap.defaultVariantId;
    if (!variantId) return null;
    var selectedHousing = housing || Object.keys(sizeMap.housingVariants).find(function (key) {
      return sizeMap.housingVariants[key] === variantId;
    }) || null;
    return {
      exactSize: true,
      variantId: String(variantId),
      url: product.productPath + '?variant=' + variantId,
      selectedOptions: {
        size: state.size,
        technicalVariant: product.technicalVariant,
        housing: selectedHousing
      }
    };
  }

  function criticalUnknowns(state) {
    var unresolved = [];
    if (state.projectorType === 'unknown') unresolved.push('projector_type');
    if (state.location === 'not_sure') unresolved.push('location');
    if (state.location === 'covered_outdoor' && state.outdoorSetup !== 'sheltered_between_posts') unresolved.push('outdoor_installation');
    if (state.viewingLight === 'not_sure') {
      unresolved.push(state.location === 'covered_outdoor' || state.location === 'exposed_outdoor' ? 'outdoor_after_sunset' : 'viewing_light');
    }
    if (state.viewingLight === 'outdoor_mixed') unresolved.push('outdoor_after_sunset');
    if (state.installation === 'not_sure') unresolved.push('installation');
    if (speakerRequirementValue(state) === 'unknown') unresolved.push('speaker_placement');
    if (state.size === 'unknown') unresolved.push('target_size');
    if (state.projectorType === 'ust' && state.orientation === 'not_sure') unresolved.push('projector_orientation');
    if (state.projectorType === 'long' && state.alignment === 'not_sure') unresolved.push('projection_alignment');
    if (state.projectorType === 'long' && state.alignment === 'off_center' && state.offsetMethod === 'not_sure') unresolved.push('offset_method');
    if (state.projectorType === 'long' && state.alignment === 'off_center' && state.offsetMethod === 'optical_shift') unresolved.push('side_projection_angle');
    if (state.projectorType === 'long' && state.projectorModel && state.projectorModel.brightnessValue && state.projectorModel.brightnessUnit !== 'ANSI_LUMENS') unresolved.push('brightness_unit');
    return unresolved;
  }

  function buildWarnings(state, products) {
    var warnings = [];
    if (products.length) warnings.push('live_product_confirmation');
    if (state.viewingLight !== 'dark' && products.some(function (product) { return product.materialClass === 'whiteCinema'; })) {
      if (state.location === 'indoor') warnings.push('white_room_light_sensitive');
      else if (state.location === 'covered_outdoor') warnings.push('outdoor_light_sensitive');
    }
    if (state.roomWidthMm > 0 && typeof state.size === 'number' && products.some(function (product) {
      return !sizeGuide || sizeGuide.widthFits(product,state.size,state.roomWidthMm) === null;
    })) warnings.push('width_confirmation');
    if (state.size === 'unknown') warnings.push('size_confirmation_required');
    if (state.projectorModel && state.projectorModel.lumens && !state.projectorModel.brightnessUnit) warnings.push('brightness_units_unverified');
    if (state.projectorModel && state.projectorModel.brightnessValue && state.projectorModel.brightnessUnit && state.projectorModel.brightnessUnit !== 'ANSI_LUMENS') warnings.push('brightness_units_incompatible');
    if (state.projectorModel && state.projectorModel.laser3) warnings.push('laser_material_confirmation');
    if (state.projectorType === 'long' && state.alignment === 'off_center' && state.offsetMethod === 'optical_shift') warnings.push('optical_shift_confirmation');
    if (state.projectorType === 'long' && state.alignment === 'off_center' && state.offsetMethod === 'optical_shift') warnings.push('side_projection_brightness_imbalance');
    if (state.projectorType === 'long' && state.alignment === 'off_center' && state.offsetMethod === 'digital_keystone') warnings.push('digital_keystone_confirmation');
    if (state.viewingLight === 'outdoor_mixed') warnings.push('outdoor_daylight_confirmation');
    if (products.some(function (product) { return product.status === 'preorder'; })) warnings.push('preorder_status');
    if (products.some(function (product) { return product.materialClass === 'blackGrid' && product.orientation === 'aboveInverted'; })) warnings.push('inverted_black_grid_no_overhead_rejection');
    return Array.from(new Set(warnings));
  }

  function distinctAlternative(candidate, lead, selected) {
    if (!lead) return true;
    if (candidate.product.familyId !== lead.product.familyId) return true;
    if (candidate.product.material !== lead.product.material) return true;
    if (candidate.product.perforationArea !== lead.product.perforationArea) return true;
    if (candidate.product.status !== lead.product.status) return true;
    return selected.length === 0;
  }

  function explanationFor(product, state) {
    var why = ['projector_' + state.projectorType, 'installation_' + state.installation, 'material_' + product.materialClass];
    if (typeof state.size === 'number') why.push('size_verified');
    var tradeoffByMaterial = {
      whiteCinema: 'tradeoff_white_cinema', blackGrid: 'tradeoff_black_grid',
      liteHyperDomesticGrid: 'tradeoff_lite_hyper', longThrowAlr: 'tradeoff_long_throw_alr',
      longThrow3dAlr: 'tradeoff_long_throw_3d_alr', fresnel: 'tradeoff_fresnel'
    };
    var tradeoff = product.familyId === 'duraplus' ? 'tradeoff_outdoor' :
      (product.status === 'preorder' ? 'tradeoff_preorder' : (tradeoffByMaterial[product.materialClass] || 'tradeoff_alr'));
    var tradeoffs = [
      'performance_' + product.materialClass,
      'brightness_' + product.brightnessPreference,
      'ambient_' + product.ambientLightUse,
      'price_' + product.pricePosition,
      'size_' + product.maxSize,
      'installation_' + product.installation
    ];
    if (product.materialClass === 'blackGrid' && product.orientation === 'aboveInverted') tradeoffs.push('inverted_black_grid_no_overhead_rejection');
    if (product.perforationArea === 'lowerBorder') tradeoffs.push('perforation_lower_border_only');
    if (product.perforationArea === 'imageArea') tradeoffs.push('perforation_image_area_audio_tradeoff');
    if (product.availabilityMode === 'customRequest') tradeoffs.push('custom_configuration_confirmation');
    var confirm = [];
    if (state.size === 'unknown') confirm.push('confirm_size');
    if (state.projectorModel && state.projectorModel.laser3) confirm.push('confirm_laser');
    if (state.projectorType === 'long' && state.alignment === 'off_center') confirm.push('confirm_alignment');
    if (product.status === 'preorder') confirm.push('confirm_preorder');
    if (!confirm.length) confirm.push('confirm_availability');
    if (state.location === 'covered_outdoor') confirm.push('confirm_outdoor_mounting');
    return { why: why, tradeoff: tradeoff, tradeoffs: tradeoffs, confirm: confirm };
  }

  function roleFor(product, state) {
    if (product.availabilityMode === 'customRequest') return 'requiresCustomConfiguration';
    if (product.materialClass === 'whiteCinema') return 'betterBrightnessLowerCost';
    if (product.materialClass === 'blackGrid') return state.viewingLight === 'bright' ? 'betterAmbientLight' : 'betterOccasionalAmbientLight';
    if (product.materialClass === 'liteHyperDomesticGrid') return 'betterLargerSizes';
    if (product.materialClass === 'longThrow3dAlr') return 'betterBrightnessGain';
    if (product.materialClass === 'longThrowAlr') return 'betterBlackLevelColor';
    if (product.materialClass === 'fresnel') return 'betterFrontalViewing';
    return 'compatibleForSetup';
  }

  function recommend(state, expectedRevision) {
    var snapshot = cloneState(state);
    var ready = isReady(snapshot) && snapshot.stage === 'review';
    var result = {
      stateRevision: snapshot.revision, ready: ready, outcome: 'incomplete',
      confidence: 'check', exactVariantSelected: false, leadMatch: null,
      alternatives: [], candidates: [], warnings: [], unresolved: [],
      assumptions: [], excludedProducts: [], explanationCodes: [],
      nextActions: ['edit_setup','start_over','ask_specialist']
    };
    if (expectedRevision !== undefined && expectedRevision !== snapshot.revision) {
      result.ready = false;
      result.outcome = 'stale';
      return result;
    }
    if (!ready) return result;

    // No catalog item is approved for a fully exposed outdoor installation.
    // Keep this guard independent of catalog locations for restored legacy states.
    if (snapshot.location === 'exposed_outdoor') {
      result.outcome = 'no_exact_match';
      result.explanationCodes = ['unsupported_outdoor_exposure'];
      return result;
    }

    // Choosing "help me choose" must not discard a known space restriction.
    // Compare with the same setup without width to distinguish a space failure
    // from another incompatible installation or material requirement.
    if (snapshot.roomWidthMm > 0 && snapshot.size === 'unknown' && !availableSizes(snapshot).length) {
      var withoutWidth = cloneState(snapshot);
      withoutWidth.roomWidthMm = null;
      if (availableSizes(withoutWidth).length) {
        result.outcome = 'no_exact_match';
        result.explanationCodes = ['room_width'];
        return result;
      }
    }

    var compatibleProducts = [];
    catalogModule.products.forEach(function (product) {
      var reasons = compatible(product, snapshot);
      if (reasons.length) result.excludedProducts.push({ id: product.id, reasons: reasons });
      else compatibleProducts.push({ product: product, score: score(product, snapshot),
        widthFit: sizeGuide && sizeGuide.widthAssessment(product, snapshot.size, snapshot.roomWidthMm) });
    });
    compatibleProducts.sort(function (a, b) {
      if (snapshot.roomWidthMm > 0 && typeof snapshot.size === 'number') {
        var aFits = a.widthFit && a.widthFit.status === 'fits' ? 1 : 0;
        var bFits = b.widthFit && b.widthFit.status === 'fits' ? 1 : 0;
        if (aFits !== bFits) return bFits - aFits;
      }
      return b.score - a.score || a.product.id.localeCompare(b.product.id);
    });

    var deduped = [];
    var ids = new Set();
    var identities = new Set();
    var urls = new Set();
    compatibleProducts.forEach(function (entry) {
      var url = entry.product.canonicalUrl ? normalizeUrl(entry.product.canonicalUrl) : null;
      if (ids.has(entry.product.id) || identities.has(entry.product.purchasableIdentity) || (url && urls.has(url))) return;
      ids.add(entry.product.id);
      identities.add(entry.product.purchasableIdentity);
      if (url) urls.add(url);
      deduped.push(entry);
    });

    result.unresolved = criticalUnknowns(snapshot);
    result.candidates = deduped.slice(0, 3);
    if (snapshot.roomWidthMm > 0 && typeof snapshot.size === 'number' && deduped.length && !deduped.some(function (entry) {
      return entry.widthFit && entry.widthFit.status === 'fits';
    })) result.unresolved.push('room_width');
    var criticalBeyondSize = result.unresolved.filter(function (item) { return item !== 'target_size'; });
    var digitalCheck = snapshot.projectorType === 'long' && snapshot.alignment === 'off_center' && snapshot.offsetMethod === 'digital_keystone';
    if (criticalBeyondSize.length || digitalCheck) {
      result.outcome = 'compatibility_check';
      result.warnings = buildWarnings(snapshot, deduped.map(function (entry) { return entry.product; }));
      result.assumptions = result.unresolved.slice();
      return result;
    }

    if (!deduped.length) {
      result.outcome = 'no_exact_match';
      result.explanationCodes = snapshot.viewingLight === 'outdoor_daylight' ? ['outdoor_daylight'] :
        (snapshot.roomWidthMm > 0 && result.excludedProducts.some(function (entry) { return entry.reasons.length === 1 && entry.reasons.indexOf('room_width') >= 0; }) ? ['room_width'] : ['constraints_no_match']);
      result.warnings = buildWarnings(snapshot, []);
      return result;
    }

    var leadIndex = deduped.findIndex(function (entry) { return entry.product.status !== 'clearance'; });
    if (leadIndex < 0) {
      result.outcome = 'compatibility_check';
      result.unresolved.push('clearance_only');
      return result;
    }
    result.leadMatch = deduped[leadIndex];
    result.leadMatch.rationale = explanationFor(result.leadMatch.product, snapshot);
    result.leadMatch.role = roleFor(result.leadMatch.product, snapshot);
    var alternatives = [];
    var remaining = deduped.filter(function (entry, index) { return index !== leadIndex; });
    function addAlternative(test) {
      if (alternatives.length >= 2) return;
      var entry = remaining.find(function (candidate) {
        return alternatives.indexOf(candidate) < 0 && test(candidate) && distinctAlternative(candidate, result.leadMatch, alternatives);
      });
      if (entry) {
        entry.rationale = explanationFor(entry.product, snapshot);
        entry.role = roleFor(entry.product, snapshot);
        alternatives.push(entry);
      }
    }
    // Show meaningful material choices before optional perforation upgrades.
    // Current availability is checked by the live-product client, not this snapshot.
    if (snapshot.projectorType === 'long' && snapshot.viewingLight === 'dark') {
      addAlternative(function (entry) { return entry.product.materialClass === 'longThrowAlr'; });
    }
    addAlternative(function (entry) { return entry.product.materialClass !== result.leadMatch.product.materialClass; });
    if (snapshot.installation !== 'frame') addAlternative(function (entry) { return entry.product.materialClass !== result.leadMatch.product.materialClass && !alternatives.some(function (selected) { return selected.product.materialClass === entry.product.materialClass; }); });
    addAlternative(function (entry) { return entry.product.status !== result.leadMatch.product.status; });
    addAlternative(function (entry) { return entry.product.perforationArea !== result.leadMatch.product.perforationArea; });
    addAlternative(function (entry) { return entry.product.familyId !== result.leadMatch.product.familyId; });
    result.alternatives = alternatives;
    result.warnings = buildWarnings(snapshot, [result.leadMatch].concat(alternatives).map(function (entry) { return entry.product; }));
    result.assumptions = result.unresolved.slice();
    result.exactVariantSelected = Boolean(purchaseHandoff(result.leadMatch.product, snapshot));
    result.confidence = snapshot.size === 'unknown' ? 'medium' : (snapshot.projectorModel && !snapshot.projectorModel.laser3 ? 'high' : 'medium');
    result.outcome = 'compatible';
    result.explanationCodes = result.leadMatch.rationale.why.concat([result.leadMatch.rationale.tradeoff]).concat(result.leadMatch.rationale.confirm);
    return result;
  }

  function searchProjectors(projectors, query, limit) {
    function normalized(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
    }
    var normalizedQuery = normalized(query);
    var terms = normalizedQuery.split(/\s+/).filter(Boolean);
    if (!terms.length) return [];
    return projectors.map(function (projector, index) {
      var fullName = normalized(projector.fullName);
      var model = normalized(projector.model);
      var brandModel = normalized(projector.brand + ' ' + projector.model);
      var text = normalized([projector.brand, projector.model, projector.fullName].concat(projector.keywords || []).join(' '));
      if (!terms.every(function (term) { return text.indexOf(term) >= 0; })) return null;
      var score = terms.length;
      if (normalizedQuery === fullName || normalizedQuery === brandModel) score += 1000;
      else if (normalizedQuery === model) score += 900;
      if (!terms.includes('pro') && /\bpro\b/.test(model)) score -= 100;
      if (terms.includes('pro') && /\bpro\b/.test(model)) score += 100;
      return { projector: projector, score: score, index: index };
    }).filter(Boolean).sort(function (a, b) {
      return b.score - a.score || a.index - b.index;
    }).slice(0, limit || 8).map(function (entry) { return entry.projector; });
  }

  function viewingChoices(location) {
    if (location === 'indoor') return ['bright','controlled','dark','not_sure'];
    if (location === 'covered_outdoor' || location === 'exposed_outdoor') return ['outdoor_night','outdoor_mixed','outdoor_daylight','not_sure'];
    return ['bright','controlled','dark','outdoor_night','outdoor_mixed','outdoor_daylight','not_sure'];
  }

  function enumerateReachableStates() {
    var states = [];
    // Retain legacy exposed_outdoor inputs in the safety audit even though the UI no longer offers them.
    ['ust','long','unknown'].forEach(function (projectorType) {
      ['indoor','covered_outdoor','exposed_outdoor','not_sure'].forEach(function (location) {
        viewingChoices(location).forEach(function (viewingLight) {
          ['floor','drop','ceiling','frame','not_sure'].forEach(function (installation) {
            var orientations = projectorType === 'ust' && ['floor','drop','ceiling'].indexOf(installation) >= 0 ? ['belowUpright','aboveInverted','not_sure'] : [null];
            var alignments = projectorType === 'long' && ['floor','drop','ceiling','frame'].indexOf(installation) >= 0 ? ['centered','off_center','not_sure'] : [null];
            orientations.forEach(function (orientation) {
              alignments.forEach(function (alignment) {
                var offsets = projectorType === 'long' && alignment === 'off_center' ? ['optical_shift','digital_keystone','not_sure'] : [null];
                offsets.forEach(function (offsetMethod) {
                  ['none','lowerBorderBehind','imageAreaBehind','movable','aestheticPreference','unknown'].forEach(function (speakerRequirement) {
                    SIZE_OPTIONS.forEach(function (size) {
                      var state = initialState();
                      Object.assign(state, {
                        revision: 1, projectorType: projectorType, location: location,
                        outdoorSetup: location === 'covered_outdoor' ? 'sheltered_between_posts' : null,
                        viewingLight: viewingLight, installation: installation,
                        orientation: orientation, alignment: alignment, offsetMethod: offsetMethod,
                        sideViewing: installation === 'frame' && projectorType === 'ust' ? 'standard' : null,
                        speakerRequirement: speakerRequirement, size: size, stage: 'review', step: 'review'
                      });
                      states.push(state);
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
    return states;
  }

  function reachabilityReport() {
    var eligible = catalogModule.products.filter(function (product) { return product.recommendationEligible && ['active','preorder','clearance'].indexOf(product.status) >= 0; });
    var reached = new Set();
    var states = enumerateReachableStates();
    states.forEach(function (state) {
      if (state.projectorType === 'unknown' || state.location === 'not_sure' || state.installation === 'not_sure' || state.speakerRequirement === 'unknown' || state.size === 'unknown') return;
      var result = recommend(state, state.revision);
      [result.leadMatch].concat(result.alternatives || []).filter(Boolean).forEach(function (entry) {
        reached.add(entry.product.id);
      });
    });
    var intentionallyExcluded = eligible.filter(function (product) { return !reached.has(product.id) && product.intentionalExclusion; }).map(function (product) { return product.id; });
    var accidentallyUnreachable = eligible.filter(function (product) { return !reached.has(product.id) && !product.intentionalExclusion; }).map(function (product) { return product.id; });
    return {
      eligible: eligible.length,
      reachable: eligible.filter(function (product) { return reached.has(product.id); }).map(function (product) { return product.id; }),
      intentionallyExcluded: intentionallyExcluded,
      accidentallyUnreachable: accidentallyUnreachable
    };
  }

  return Object.freeze({
    DEPENDENCIES: DEPENDENCIES, SIZE_OPTIONS: SIZE_OPTIONS, BRIGHTNESS_REFERENCE: BRIGHTNESS_REFERENCE,
    initialState: initialState, cloneState: cloneState, normalizeUrl: normalizeUrl,
    requiredSteps: requiredSteps, firstMissingStep: firstMissingStep, isReady: isReady,
    nextStep: nextStep, previousStep: previousStep, applyAnswer: applyAnswer,
    selectProjector: selectProjector, selectManualProjectorType: selectManualProjectorType,
    editProjectorInput: editProjectorInput, clearProjector: clearProjector,
    compatible: compatible, availableSizes: availableSizes, recommend: recommend, purchaseHandoff: purchaseHandoff, searchProjectors: searchProjectors,
    enumerateReachableStates: enumerateReachableStates, reachabilityReport: reachabilityReport,
    viewingChoices: viewingChoices
  });
});

(function () {
  'use strict';

  var Core = window.ScreenFinderCore;
  var Catalog = window.ScreenFinderCatalog;
  var Translations = window.ScreenFinderTranslations;
  var SizeGuide = window.ScreenFinderSizeGuide;
  var LiveProduct = window.ScreenFinderLiveProduct;
  var PurchaseIntent = window.ScreenFinderPurchaseIntent;
  var Projectors = window.ScreenFinderProjectors || [];
  if (!Core || !Catalog || !Translations) return;

  var STEP_KEYS = {
    projector:'stepProjector', location:'stepLocation', viewingLight:'stepViewingLight',
    installation:'stepInstallation', orientation:'stepOrientation', alignment:'stepAlignment',
    offsetMethod:'stepOffsetMethod', sideViewing:'stepSideViewing', speakerRequirement:'stepAudio', size:'stepSize', review:'stepReview'
  };
  var CONTACT_URL = '/pages/contact-us';
  var SCRIPT_URL = document.currentScript && document.currentScript.src;
  var FONT_ASSET_BASE = window.__vsfAssetBase || SCRIPT_URL || new URL('dist/',document.baseURI).toString();
  var instanceCount = 0;

  function fontAssetUrl(filename) {
    try { return new URL(filename, FONT_ASSET_BASE).toString(); }
    catch (error) { return filename; }
  }

  function ensureFonts(root) {
    if (!document.fonts || typeof window.FontFace !== 'function') {
      root.dataset.vsfFontStatus = 'fallback-font-api-unavailable';
      return;
    }
    function declared(family) {
      var normalized = family.toLowerCase().replace(/["']/g,'');
      return Array.from(document.fonts).some(function (face) {
        return String(face.family || '').toLowerCase().replace(/["']/g,'') === normalized;
      });
    }
    var interReady = document.fonts.check('16px "Inter"') && declared('Inter');
    var playfairReady = document.fonts.check('32px "Playfair Display"') && declared('Playfair Display');
    if (interReady && playfairReady) {
      root.dataset.vsfFontStatus = 'intended-theme-fonts';
      return;
    }
    if (!window.__vsfFontPromise) {
      var faces = [];
      if (!interReady) faces.push(new FontFace('Inter','url("' + fontAssetUrl('vsf-recommender-20-inter-400.woff2') + '")',{ weight:'400', style:'normal', display:'swap' }));
      if (!playfairReady) faces.push(new FontFace('Playfair Display','url("' + fontAssetUrl('vsf-recommender-20-playfair-500.woff2') + '")',{ weight:'500', style:'normal', display:'swap' }));
      window.__vsfFontPromise = Promise.all(faces.map(function (face) {
        return face.load().then(function (loaded) { document.fonts.add(loaded); });
      }));
    }
    window.__vsfFontPromise.then(function () {
      var ready = document.fonts.check('16px "Inter"') && document.fonts.check('32px "Playfair Display"');
      root.dataset.vsfFontStatus = ready ? 'intended-component-fonts' : 'fallback-font-check-failed';
    }).catch(function () { root.dataset.vsfFontStatus = 'fallback-font-load-failed'; });
  }

  function escapeHtml(value) {
    return String(value === null || value === undefined ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function icon(name) {
    var paths = {
      search:'<circle cx="11" cy="11" r="7"></circle><path d="m16.5 16.5 4 4"></path>',
      arrow:'<path d="M5 12h14"></path><path d="m14 7 5 5-5 5"></path>',
      back:'<path d="M19 12H5"></path><path d="m10 17-5-5 5-5"></path>',
      info:'<circle cx="12" cy="12" r="9"></circle><path d="M12 11v6"></path><path d="M12 7.5h.01"></path>'
    };
    return '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + paths[name] + '</svg>';
  }

  function createInstance(root) {
    if (root.__vsfDestroy) root.__vsfDestroy();
    if (!root.__vsfInstanceId) root.__vsfInstanceId = 'vsf-' + (++instanceCount);
    var state = Core.initialState();
    var activeOption = -1;
    var selectionLocked = false;
    var selectionTimer = null;
    var matches = [];
    var lastResult = null;
    var content = root.querySelector('[data-vsf-content]');
    var actions = root.querySelector('[data-vsf-actions]');
    var workspace = root.querySelector('[data-vsf-workspace]');
    var live = root.querySelector('[data-vsf-live]');
    var chatTouched = false;
    var measurementError = false;
    var sizeSelectionNotice = false;
    var quoteEpoch = 0;
    var quoteController = null;
    var quotes = {};
    var housingChoices = {};
    var speakerDetailsOpen = false;
    var helpOpen = false;
    var pendingPurchase = null;
    function purchaseNotice(key) {
      var node = root.querySelector('[data-vsf-purchase-status]');
      if (!node) return;
      node.hidden = !key;
      node.innerHTML = key ? '<span>' + escapeHtml(t(key)) + '</span>' + (pendingPurchase ?
        '<button type="button" class="vsf-edit" data-vsf-cancel-purchase>' + escapeHtml(t('cancelOpening')) + '</button>' : '') : '';
    }
    function cancelPurchase() { pendingPurchase = null; purchaseNotice(null); }
    function cancelQuotes() {
      quoteEpoch++;
      if (quoteController) quoteController.abort();
      quoteController = null;
      quotes = {};
    }
    function priceClient() {
      var route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (!route) {
        var contextNode = root.previousElementSibling;
        if (contextNode && contextNode.matches('[data-vsf-store-context]')) {
          try { route = JSON.parse(contextNode.textContent).root; if (route && route.slice(-1) !== '/') route += '/'; } catch (_) { route = null; }
        }
      }
      return LiveProduct.create({ root:route, locale:state.language, timeoutMs:8000 });
    }
    ensureFonts(root);

    function tidioApi() {
      return window.tidioChatApi && typeof window.tidioChatApi === 'object' ? window.tidioChatApi : null;
    }

    function syncChat() {
      var api = tidioApi();
      if (!api) return;
      var showOnDesktopResults = state.stage === 'results' && !window.matchMedia('(max-width: 720px)').matches;
      if (showOnDesktopResults && typeof api.show === 'function') api.show();
      else if (typeof api.hide === 'function') api.hide();
      chatTouched = true;
    }

    function onTidioReady() { syncChat(); }
    function onViewportChange() { syncChat(); }
    document.addEventListener('tidioChat-ready',onTidioReady);
    window.addEventListener('resize',onViewportChange);

    function clearSavedState() {
      try {
        if (!history.state || !history.state.vsfScreenFinder) return;
        var nextHistory = Object.assign({}, history.state);
        delete nextHistory.vsfScreenFinder;
        history.replaceState(nextHistory,'',window.location.href);
      } catch (error) { /* Embedded storefront history can be unavailable. */ }
    }

    function saveResultForBack() {
      try {
        history.replaceState(Object.assign({},history.state || {}, {
          vsfScreenFinder: { version:1, path:window.location.pathname, state:Core.cloneState(state), housingChoices:Object.assign({},housingChoices), helpOpen:helpOpen }
        }),'',window.location.href);
      } catch (error) { /* Navigation still works when history is unavailable. */ }
    }

    try {
      var saved = history.state && history.state.vsfScreenFinder;
      if (saved && saved.version === 1 && saved.path === window.location.pathname && saved.state && ['configure','review','results'].indexOf(saved.state.stage) >= 0) {
        state = Core.cloneState(saved.state);
        housingChoices = Object.assign({},saved.housingChoices || {});
        helpOpen = saved.helpOpen === true && state.stage !== 'results';
        if (state.stage === 'results') {
          var reviewState = Core.cloneState(Object.assign({},state,{ stage:'review', step:'review' }));
          lastResult = Core.recommend(reviewState,reviewState.revision);
        } else if (Core.requiredSteps(state).indexOf(state.step) < 0) {
          state.step = Core.firstMissingStep(state) || 'review';
          state.stage = state.step === 'review' ? 'review' : 'configure';
        }
        if (state.stage === 'results' && !lastResult.ready) {
          state = Core.initialState();
          lastResult = null;
          clearSavedState();
        }
      }
    } catch (error) { state = Core.initialState(); lastResult = null; }

    function t(key) {
      var locale = Translations[state.language] || Translations.en;
      return Object.prototype.hasOwnProperty.call(locale,key) ? locale[key] : Object.prototype.hasOwnProperty.call(Translations.en,key) ? Translations.en[key] : key;
    }

    function interpolate(value, data) {
      return Object.keys(data || {}).reduce(function (text, key) {
        return text.replace(new RegExp('\\{' + key + '\\}', 'g'), data[key]);
      }, value);
    }

    function announce(message) {
      live.textContent = '';
      requestAnimationFrame(function () { live.textContent = message; });
    }

    function labelForStep(step) { return t(STEP_KEYS[step]); }

    function updateChrome() {
      root.lang = state.language;
      root.__vsfState = Core.cloneState(state);
      root.classList.toggle('is-review', state.stage === 'review');
      root.classList.toggle('is-results', state.stage === 'results');
      root.dataset.vsfStep = state.stage === 'results' ? 'results' : state.step;
      root.querySelector('[data-vsf-finder-name]').textContent = t('finderName');
      root.querySelector('[data-vsf-language-label]').textContent = t('changeLanguage');
      root.querySelectorAll('[data-vsf-lang]').forEach(function (button) {
        var selected = button.dataset.vsfLang === state.language;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      workspace.classList.toggle('is-results', state.stage === 'results');
      renderProgress();
      renderSetupStrip();
      syncChat();
    }

    function renderProgress() {
      var activeStep = state.stage === 'results' ? 'review' : state.step;
      var currentGroup = state.step === 'projector' ? 0 : state.step === 'size' || activeStep === 'review' ? 2 : 1;
      root.querySelector('[data-vsf-progress-text]').textContent = activeStep === 'review' ? t('setupComplete') :
        interpolate(t('progressStages'), { current:currentGroup + 1 });
      root.querySelector('[data-vsf-progress-fill]').style.width = (activeStep === 'review' ? 100 : currentGroup / 3 * 100) + '%';
      var groups = [['projector','groupProjector'],['location','groupRoom'],['size','groupSize']];
      root.querySelector('[data-vsf-journey]').setAttribute('aria-label',t('yourSetup'));
      root.querySelector('[data-vsf-journey]').innerHTML = groups.map(function (group,index) {
        var enabled = index === 0 || (index === 1 && state.projectorType) || (index === 2 && state.speakerRequirement);
        return '<button type="button" class="vsf-journey-item' + (index === currentGroup ? ' is-current' : '') +
          '" data-vsf-edit-step="' + group[0] + '"' + (!enabled ? ' disabled' : '') +
          (index === currentGroup ? ' aria-current="step"' : '') + '><span class="vsf-journey-number" aria-hidden="true">' +
          (index + 1) + '</span><span>' + escapeHtml(t(group[1])) + '</span></button>';
      }).join('');
    }

    function renderSetupStrip() {
      var strip = root.querySelector('[data-vsf-setup-strip]');
      var rows = reviewRows().filter(function (row) {
        if (row[0] === 'projectorType') return !!state.projectorType && !state.projectorModel;
        if (row[0] === 'projector') return !!state.projectorModel;
        if (row[0] === 'projectorInput') return !!state.projectorInput && !state.projectorModel;
        if (row[0] === 'viewingDistance') return !!state.viewingDistanceMm;
        if (row[0] === 'roomWidth') return !!state.roomWidthMm;
        return state[row[0]] !== null && state[row[0]] !== undefined;
      });
      if (!rows.length) { strip.innerHTML = ''; return; }
      var buttons = rows.map(function (row) {
        return '<button type="button" class="vsf-setup-chip" data-vsf-edit-step="' + row[2] + '" aria-label="' +
          escapeHtml(interpolate(t('editAnswer'),{label:t(row[0])}) + ': ' + row[1]) + '"><span class="vsf-chip-label">' +
          escapeHtml(t(row[0])) + '</span><span>' + escapeHtml(row[1]) + '</span></button>';
      });
      var expanded = strip.querySelector('details') && strip.querySelector('details').open;
      strip.innerHTML = '<div class="vsf-setup-preview">' + buttons.slice(0,2).join('') + '</div>' +
        (buttons.length > 2 ? '<details class="vsf-setup-more"' + (expanded ? ' open' : '') + '><summary>' +
          escapeHtml(t('allChoices')) + ' <span>(' + buttons.length + ')</span></summary><div class="vsf-setup-all">' + buttons.slice(2).join('') + '</div></details>' : '');
    }

    function heading(kicker, title, body) {
      var copy = t(body);
      return '<h2 class="vsf-step-title" data-vsf-heading tabindex="-1">' + escapeHtml(t(title)) + '</h2>' +
        (copy ? '<p class="vsf-step-body">' + escapeHtml(copy) + '</p>' : '');
    }

    function option(category, value, title, description, selected, className) {
      var scene = category === 'location' ? {indoor:'vsf-recommender-20-indoor.webp',covered_outdoor:'vsf-recommender-20-covered.webp'}[value] : null;
      return '<button type="button" class="vsf-option' + (scene ? ' vsf-option--scene' : '') + (className ? ' ' + className : '') + (selected ? ' is-selected' : '') +
        '" data-vsf-answer data-category="' + category + '" data-value="' + value + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
        '<span class="vsf-option-copy"><span class="vsf-option-title">' +
        escapeHtml(t(title)) + '</span><span class="vsf-option-desc">' + escapeHtml(t(description)) +
        '</span></span><span class="vsf-option-arrow">' + icon('arrow') + '</span>' +
        (scene ? '<img class="vsf-option-scene" src="' + escapeHtml(fontAssetUrl(scene)) + '" width="960" height="640" alt="" decoding="async">' : '') + '</button>';
    }

    function note(copyKey) {
      return '<p class="vsf-note">' + icon('info') + '<span>' + escapeHtml(t(copyKey)) + '</span></p>';
    }

    function modelPanel() {
      if (!state.projectorModel) return '';
      return '<section class="vsf-model" aria-label="' + escapeHtml(t('verifiedModel')) + '"><div><p class="vsf-model-label">' +
        escapeHtml(t('selected')) + '</p><p class="vsf-model-name">' + escapeHtml(state.projectorModel.fullName) + '</p><p class="vsf-model-type">' +
        escapeHtml(t('type_' + state.projectorType)) + '</p></div><button type="button" class="vsf-edit" data-vsf-clear-projector>' + escapeHtml(t('clear')) + '</button></section>';
    }

    function renderProjector() {
      var inputId = root.__vsfInstanceId + '-projector-input';
      var listId = root.__vsfInstanceId + '-projector-list';
      content.innerHTML = '<div class="vsf-panel">' + heading('projectorKicker','projectorTitle','projectorBody') +
        '<div class="vsf-form vsf-form--search-primary"><label class="vsf-field-label" for="' + inputId + '">' + escapeHtml(t('projectorLabel')) + '</label>' +
        '<div class="vsf-combobox-wrap"><div class="vsf-search-row"><span class="vsf-search-icon">' + icon('search') + '</span>' +
        '<input class="vsf-input" id="' + inputId + '" data-vsf-projector-input type="text" autocomplete="off" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="' + listId +
        '" placeholder="' + escapeHtml(t('projectorPlaceholder')) + '" value="' + escapeHtml(state.projectorInput) + '">' +
        (state.projectorInput ? '<button class="vsf-clear" type="button" data-vsf-clear-projector aria-label="' + escapeHtml(t('clearProjector')) + '">' + escapeHtml(t('clear')) + '</button>' : '') +
        '</div><ul class="vsf-combobox" id="' + listId + '" role="listbox" aria-label="' + escapeHtml(t('openProductSearch')) + '" data-vsf-projector-list hidden></ul></div>' +
        modelPanel() + '<div class="vsf-divider">' + escapeHtml(t('chooseManual')) + '</div><div class="vsf-options vsf-options--manual">' +
        option('projectorType','ust','ust','ustDesc',state.projectorType === 'ust') +
        option('projectorType','long','long','longDesc',state.projectorType === 'long') +
        option('projectorType','unknown','unknownProjector','unknownProjectorDesc',state.projectorType === 'unknown') +
        '</div></div></div>';
    }

    function renderLocation() {
      content.innerHTML = '<div class="vsf-panel">' + heading('locationKicker','locationTitle','locationBody') +
        '<fieldset class="vsf-options vsf-options--locations"><legend class="vsf-sr-only">' + escapeHtml(t('locationTitle')) + '</legend>' +
        option('location','indoor','indoor','indoorDesc',state.location === 'indoor') +
        option('location','covered_outdoor','coveredOutdoor','coveredOutdoorDesc',state.location === 'covered_outdoor') +
        option('location','not_sure','notSureLocation','notSureLocationDesc',state.location === 'not_sure') +
        '</fieldset><p class="vsf-location-limit">' + escapeHtml(t('outdoorScopeNote')) + '</p></div>';
    }

    function renderViewingLight() {
      var definitions = {
        bright:['bright','brightDesc'], controlled:['controlled','controlledDesc'], dark:['dark','darkDesc'],
        outdoor_night:['outdoorNight','outdoorNightDesc'], outdoor_mixed:['outdoorMixed','outdoorMixedDesc'],
        outdoor_daylight:['outdoorDaylight','outdoorDaylightDesc'],
        not_sure:['notSureLight','notSureLightDesc']
      };
      var choices = Core.viewingChoices(state.location);
      content.innerHTML = '<div class="vsf-panel">' + heading('viewingKicker',state.location === 'covered_outdoor' ? 'outdoorViewingTitle' : 'viewingTitle','viewingBody') +
        '<fieldset class="vsf-options"><legend class="vsf-sr-only">' + escapeHtml(t('viewingTitle')) + '</legend>' +
        choices.map(function (value) { return option('viewingLight',value,definitions[value][0],definitions[value][1],state.viewingLight === value); }).join('') +
        '</fieldset></div>';
    }

    function renderInstallation() {
      var outdoor = state.location === 'covered_outdoor';
      var values = outdoor ? [
        ['drop','outdoorMounting','outdoorMountingDesc'],['not_sure','notSureInstallation','notSureInstallationDesc']
      ] : [
        ['floor','floor','floorDesc'],['drop','drop','dropDesc'],['ceiling','ceiling','ceilingDesc'],
        ['frame','frame','frameDesc'],['not_sure','notSureInstallation','notSureInstallationDesc']
      ];
      content.innerHTML = '<div class="vsf-panel">' + heading('installationKicker',outdoor ? 'outdoorMountingTitle' : 'installationTitle','installationBody') +
        '<fieldset class="vsf-options vsf-options--two"><legend class="vsf-sr-only">' + escapeHtml(t('installationTitle')) + '</legend>' +
        values.map(function (entry) { return option('installation',entry[0],entry[1],entry[2],state.installation === entry[0]); }).join('') +
        '</fieldset></div>';
    }

    function renderOrientation() {
      content.innerHTML = '<div class="vsf-panel">' + heading('orientationKicker','orientationTitle','orientationBody') +
        '<fieldset class="vsf-options"><legend class="vsf-sr-only">' + escapeHtml(t('orientationTitle')) + '</legend>' +
        option('orientation','belowUpright','belowUpright','belowUprightDesc',state.orientation === 'belowUpright') +
        option('orientation','aboveInverted','aboveInverted','aboveInvertedDesc',state.orientation === 'aboveInverted') +
        option('orientation','not_sure','notSureOrientation','notSureOrientationDesc',state.orientation === 'not_sure') +
        '</fieldset></div>';
    }

    function renderAlignment() {
      content.innerHTML = '<div class="vsf-panel">' + heading('alignmentKicker','alignmentTitle','alignmentBody') +
        '<fieldset class="vsf-options"><legend class="vsf-sr-only">' + escapeHtml(t('alignmentTitle')) + '</legend>' +
        option('alignment','centered','centered','centeredDesc',state.alignment === 'centered') +
        option('alignment','off_center','offCenter','offCenterDesc',state.alignment === 'off_center') +
        option('alignment','not_sure','notSureAlignment','notSureAlignmentDesc',state.alignment === 'not_sure') +
        '</fieldset></div>';
    }

    function renderOffsetMethod() {
      content.innerHTML = '<div class="vsf-panel">' + heading('offsetKicker','offsetTitle','offsetBody') +
        '<fieldset class="vsf-options"><legend class="vsf-sr-only">' + escapeHtml(t('offsetTitle')) + '</legend>' +
        option('offsetMethod','optical_shift','opticalShift','opticalShiftDesc',state.offsetMethod === 'optical_shift') +
        option('offsetMethod','digital_keystone','digitalKeystone','digitalKeystoneDesc',state.offsetMethod === 'digital_keystone') +
        option('offsetMethod','not_sure','notSureOffset','notSureOffsetDesc',state.offsetMethod === 'not_sure') +
        '</fieldset></div>';
    }

    function renderSideViewing() {
      content.innerHTML = '<div class="vsf-panel">' + heading('sideViewingKicker','sideViewingTitle','sideViewingBody') +
        '<fieldset class="vsf-options"><legend class="vsf-sr-only">' + escapeHtml(t('sideViewingTitle')) + '</legend>' +
        option('sideViewing','standard','sideViewingStandard','sideViewingStandardDesc',state.sideViewing === 'standard') +
        option('sideViewing','wide','sideViewingWide','sideViewingWideDesc',state.sideViewing === 'wide') +
        '</fieldset></div>';
    }

    function renderSpeakerRequirement() {
      var detailed = speakerDetailsOpen || ['lowerBorderBehind','imageAreaBehind','movable','aestheticPreference'].indexOf(state.speakerRequirement) >= 0;
      content.innerHTML = '<div class="vsf-panel">' + heading('audioKicker',detailed ? 'speakerPositionTitle' : 'audioTitle',detailed ? 'speakerPositionBody' : 'audioBody') +
        (detailed ? '<button type="button" class="vsf-edit" data-vsf-speaker-reset>' + escapeHtml(t('speakerChange')) + '</button>' : '') +
        '<fieldset class="vsf-options"><legend class="vsf-sr-only">' + escapeHtml(t(detailed ? 'speakerPositionTitle' : 'audioTitle')) + '</legend>' +
        (detailed ?
        option('speakerRequirement','lowerBorderBehind','speakerLowerBorder','speakerLowerBorderDesc',state.speakerRequirement === 'lowerBorderBehind') +
        option('speakerRequirement','imageAreaBehind','speakerImageArea','speakerImageAreaDesc',state.speakerRequirement === 'imageAreaBehind') +
        option('speakerRequirement','movable','speakerMovable','speakerMovableDesc',state.speakerRequirement === 'movable') +
        option('speakerRequirement','aestheticPreference','speakerAesthetic','speakerAestheticDesc',state.speakerRequirement === 'aestheticPreference') :
        option('speakerRequirement','none','speakerNone','speakerNoneDesc',state.speakerRequirement === 'none') +
        '<button type="button" class="vsf-option" data-vsf-speaker-details><span class="vsf-option-copy"><span class="vsf-option-title">' + escapeHtml(t('speakerBehindTitle')) +
        '</span><span class="vsf-option-desc">' + escapeHtml(t('speakerBehindDesc')) + '</span></span><span class="vsf-option-arrow">' + icon('arrow') + '</span></button>') +
        option('speakerRequirement','unknown','notSureAudio','notSureAudioDesc',state.speakerRequirement === 'unknown') +
        '</fieldset></div>';
    }

    function measurementText(mm) {
      if (!Number.isFinite(mm) || mm <= 0) return '';
      return String(mm / (state.measurementUnit === 'ft' ? 304.8 : 1000));
    }

    function measurementValue(field, multiplier) {
      if (field.value === field.dataset.vsfMeasurementDisplay) {
        return field.dataset.vsfMeasurementMm === '' ? null : Number(field.dataset.vsfMeasurementMm);
      }
      return field.value === '' ? null : Number(field.value) * multiplier;
    }

    function rememberMeasurement(field, mm) {
      field.dataset.vsfMeasurementDisplay = field.value;
      field.dataset.vsfMeasurementMm = mm === null ? '' : String(mm);
    }

    function dimensionText(mm) {
      if (!Number.isFinite(mm)) return '—';
      return state.measurementUnit === 'ft' ? (mm / 304.8).toFixed(2) + ' ft' : (mm / 1000).toFixed(3).replace(/0+$/,'').replace(/\.$/,'') + ' m';
    }

    function sizeHint() {
      if (!state.viewingDistanceMm && !state.roomWidthMm) return '';
      var sizes = Core.availableSizes(state);
      var guide = SizeGuide.recommend(sizes,state.viewingDistanceMm,state.roomWidthMm);
      if (!guide.options.length || guide.status === 'no_image_width_fit') {
        var withoutWidth = Core.cloneState(Object.assign({},state,{roomWidthMm:null}));
        var widthLimited = state.roomWidthMm && Core.availableSizes(withoutWidth).length > 0;
        return '<p class="vsf-size-hint">' + escapeHtml(t(widthLimited ? 'sizeNoSpace' : 'noSizesForSetup')) + '</p>';
      }
      var selected = guide.options.find(function (row) { return row.size === state.size; });
      return '<div class="vsf-size-hint" role="status">' +
        (guide.suggestedSize ? '<strong>' + escapeHtml(interpolate(t('sizeSuggested'),{size:guide.suggestedSize})) + '</strong>' : '') +
        (selected ? '<p>' + escapeHtml(t('imageWidth') + ': ≈ ' + dimensionText(selected.imageWidthMm)) + '</p>' : '') +
        '<p>' + escapeHtml(t('sizeReference')) + '</p></div>';
    }

    function renderSize() {
      var id = root.__vsfInstanceId;
      content.innerHTML = '<div class="vsf-panel">' + heading('sizeKicker','sizeTitle','sizeBody') +
        '<details class="vsf-size-helper" open' +
        '><summary>' + escapeHtml(t('sizeHelper')) + '</summary><p>' + escapeHtml(t('measureHelp')) + '</p>' +
        '<form data-vsf-measurements novalidate><div class="vsf-measure-fields"><label for="' + id + '-unit">' + escapeHtml(t('measurementUnit')) +
        '<select id="' + id + '-unit" data-vsf-unit><option value="m"' + (state.measurementUnit !== 'ft' ? ' selected' : '') + '>' + escapeHtml(t('metres')) +
        '</option><option value="ft"' + (state.measurementUnit === 'ft' ? ' selected' : '') + '>' + escapeHtml(t('feet')) + '</option></select></label>' +
        '<label for="' + id + '-distance">' + escapeHtml(t('viewingDistance')) + '<input id="' + id + '-distance" data-vsf-distance type="number" inputmode="decimal" min="0.01" step="any" value="' +
        measurementText(state.viewingDistanceMm) + '" placeholder="' + (state.measurementUnit === 'ft' ? '10' : '3') + '"></label><label for="' + id + '-width">' + escapeHtml(t('roomWidth')) + '<input id="' + id + '-width" data-vsf-width type="number" inputmode="decimal" min="0.01" step="any" placeholder="' + (state.measurementUnit === 'ft' ? '9' : '2.7') + '" value="' +
        measurementText(state.roomWidthMm) + '"></label></div><p data-vsf-measure-error role="alert"' + (!measurementError ? ' hidden' : '') + '>' + escapeHtml(t('measureInvalid')) + '</p>' +
        '<div class="vsf-helper-actions"><button type="submit" class="vsf-button">' + escapeHtml(t('calculateSize')) + '</button><button type="button" class="vsf-edit" data-vsf-clear-measurements>' + escapeHtml(t('clearMeasurements')) +
        '</button></div></form></details>' + sizeHint() +
        (sizeSelectionNotice ? '<p class="vsf-size-selection-notice" role="alert" tabindex="-1">' + escapeHtml(t('sizesUpdated')) + '</p>' : '') +
        '<fieldset class="vsf-options vsf-options--sizes"><legend class="vsf-sr-only">' + escapeHtml(t('sizeTitle')) + '</legend>' +
        Core.availableSizes(state).concat(['unknown']).map(function (size) {
          if (size === 'unknown') return option('size','unknown','sizeUnknown','sizeUnknownDesc',state.size === 'unknown','vsf-option--size-unknown');
          return option('size',String(size),String(size) + ' ' + t('sizeUnit'),'sizeOptionDesc',state.size === size,'vsf-option--size-number');
        }).join('') + '</fieldset>' + note('widthNote') + '</div>';
      rememberMeasurement(root.querySelector('[data-vsf-distance]'),state.viewingDistanceMm);
      rememberMeasurement(root.querySelector('[data-vsf-width]'),state.roomWidthMm);
    }

    function commitMeasurements() {
      var multiplier = root.querySelector('[data-vsf-unit]').value === 'ft' ? 304.8 : 1000;
      var fields = [root.querySelector('[data-vsf-distance]'),root.querySelector('[data-vsf-width]')];
      var values = fields.map(function (field) { return measurementValue(field,multiplier); });
      measurementError = fields.some(function (field,i) { return field.validity.badInput || (values[i] !== null && (!Number.isFinite(values[i]) || values[i] <= 0 || values[i] > 30000)); });
      var errorNode = root.querySelector('[data-vsf-measure-error]');
      errorNode.hidden = !measurementError;
      fields.forEach(function (field,i) { field.setAttribute('aria-invalid',measurementError && (field.validity.badInput || values[i] !== null && (values[i] <= 0 || values[i] > 30000 || !Number.isFinite(values[i]))) ? 'true' : 'false'); field.setAttribute('aria-describedby',root.__vsfInstanceId + '-measure-error'); });
      errorNode.id = root.__vsfInstanceId + '-measure-error';
      if (measurementError) {
        fields.find(function (field) { return field.getAttribute('aria-invalid') === 'true'; }).focus();
        announce(t('measureInvalid'));
        return false;
      }
      state.measurementUnit = multiplier === 304.8 ? 'ft' : 'm';
      if (state.roomWidthMm !== values[1]) state = Core.applyAnswer(state,'roomWidthMm',values[1]);
      if (state.viewingDistanceMm !== values[0]) state = Core.applyAnswer(state,'viewingDistanceMm',values[0]);
      return true;
    }

    function onMeasurements(event) {
      if (!event.target.matches('[data-vsf-measurements]')) return;
      event.preventDefault();
      if (!commitMeasurements()) return;
      sizeSelectionNotice = false;
      render({focus:false});
      var calculate = root.querySelector('[data-vsf-measurements] button[type="submit"]');
      if (calculate) calculate.focus();
      announce(t('calculateSize'));
    }

    function onChange(event) {
      if (event.target.matches('[data-vsf-unit]')) {
        var previous = state.measurementUnit === 'ft' ? 304.8 : 1000;
        var next = event.target.value === 'ft' ? 304.8 : 1000;
        ['[data-vsf-distance]','[data-vsf-width]'].forEach(function (selector) {
          var field = root.querySelector(selector);
          var mm = measurementValue(field,previous);
          field.value = mm === null ? '' : String(mm / next);
          rememberMeasurement(field,mm);
        });
        state.measurementUnit = event.target.value;
      }
      if (event.target.matches('[data-vsf-housing]')) {
        cancelPurchase();
        housingChoices[event.target.dataset.vsfHousing] = event.target.value;
        if (lastResult && lastResult.leadMatch && lastResult.leadMatch.product.id === event.target.dataset.vsfHousing) state.housing = event.target.value;
        refreshQuotes();
      }
      if (event.target.matches('[data-vsf-compare-housing]')) {
        cancelPurchase();
        resultEntries().forEach(function (entry) {
          var map = entry.product.variantMap && entry.product.variantMap[String(state.size)];
          if (map && Object.prototype.hasOwnProperty.call(map.housingVariants || {},event.target.value)) housingChoices[entry.product.id] = event.target.value;
        });
        state.housing = event.target.value;
        root.querySelectorAll('[data-vsf-housing]').forEach(function (node) { node.value = housingChoices[node.dataset.vsfHousing]; });
        refreshQuotes();
      }
    }

    function housingLabel(value) {
      var key = 'housing_' + value;
      var translated = t(key);
      return translated === key ? value : translated;
    }

    function valueLabel(key, value) {
      if (value === null || value === undefined) return '—';
      if (key === 'projectorType') return t('type_' + value);
      if (key === 'location') return t('loc_' + value);
      if (key === 'viewingLight') return t('light_' + value);
      if (key === 'installation') return state.location === 'covered_outdoor' && value === 'drop' ? t('outdoorMounting') : t('install_' + value);
      if (key === 'orientation') return t('orientation_' + value);
      if (key === 'alignment') return t('alignment_' + value);
      if (key === 'offsetMethod') return t('offset_' + value);
      if (key === 'sideViewing') return t('side_viewing_' + value);
      if (key === 'speakerRequirement') return t('speaker_' + value);
      if (key === 'size') return value === 'unknown' ? t('sizeUnknown') : value + ' ' + t('sizeUnit');
      return value || '—';
    }

    function reviewRows() {
      var rows = [];
      if (state.projectorModel) rows.push(['projector',state.projectorModel.fullName,'projector']);
      else if (state.projectorInput.trim()) rows.push(['projectorInput',state.projectorInput + ' · ' + t('projectorInputPending'),'projector']);
      if (state.projectorType) rows.push(['projectorType',valueLabel('projectorType',state.projectorType),'projector']);
      if (state.location) rows.push(['location',valueLabel('location',state.location),'location']);
      if (state.viewingLight) rows.push(['viewingLight',valueLabel('viewingLight',state.viewingLight),'viewingLight']);
      if (state.installation) rows.push(['installation',valueLabel('installation',state.installation),'installation']);
      if (state.orientation) rows.push(['orientation',valueLabel('orientation',state.orientation),'orientation']);
      if (state.alignment) rows.push(['alignment',valueLabel('alignment',state.alignment),'alignment']);
      if (state.offsetMethod) rows.push(['offsetMethod',valueLabel('offsetMethod',state.offsetMethod),'offsetMethod']);
      if (state.sideViewing) rows.push(['sideViewing',valueLabel('sideViewing',state.sideViewing),'sideViewing']);
      if (state.speakerRequirement) rows.push(['speakerRequirement',valueLabel('speakerRequirement',state.speakerRequirement),'speakerRequirement']);
      if (state.size) rows.push(['size',valueLabel('size',state.size),'size']);
      if (state.viewingDistanceMm) rows.push(['viewingDistance',dimensionText(state.viewingDistanceMm),'size']);
      if (state.roomWidthMm) rows.push(['roomWidth',dimensionText(state.roomWidthMm),'size']);
      return rows;
    }

    function renderReview() {
      if (!Core.isReady(state)) {
        state.step = Core.firstMissingStep(state);
        render();
        return;
      }
      state.stage = 'review';
      content.innerHTML = '<div class="vsf-panel">' + heading('reviewKicker','reviewTitle','reviewBody') +
        '<div class="vsf-review">' + reviewRows().map(function (row) {
          return '<div class="vsf-review-row"><span class="vsf-review-label">' + escapeHtml(t(row[0])) +
            '</span><span class="vsf-review-value">' + escapeHtml(row[1]) +
            '</span><button type="button" class="vsf-edit" data-vsf-edit-step="' + row[2] +
            '" aria-label="' + escapeHtml(interpolate(t('editAnswer'), { label:t(row[0]) })) + '">' + escapeHtml(t('edit')) + '</button></div>';
        }).join('') + '</div>' + note('reviewGuidance') + '</div>';
    }

    function setupSummary() {
      var projector = state.projectorModel ? state.projectorModel.fullName : valueLabel('projectorType',state.projectorType);
      return [projector,valueLabel('location',state.location),valueLabel('viewingLight',state.viewingLight),
        valueLabel('installation',state.installation),state.orientation ? valueLabel('orientation',state.orientation) : null,
        valueLabel('speakerRequirement',state.speakerRequirement),valueLabel('size',state.size)].filter(Boolean).join(' · ');
    }

    function trackedUrl(url, id) {
      try {
        var target = new URL(url, window.location.origin);
        target.searchParams.set('utm_source','screen_finder');
        target.searchParams.set('utm_medium','recommendation');
        target.searchParams.set('utm_campaign','product_truth_r03');
        target.searchParams.set('sf_product',id);
        target.searchParams.set('sf_revision',state.revision);
        if (target.origin === window.location.origin || String(url).charAt(0) === '/') {
          return target.pathname + target.search + target.hash;
        }
        return target.toString();
      } catch (error) { return url; }
    }

    function confidenceText(result) {
      if (result.confidence === 'high') return t('confidenceHigh');
      if (result.confidence === 'medium') return t('confidenceMedium');
      return t('confidenceCheck');
    }

    function confidenceReason(result) {
      if (!result || result.confidence !== 'medium') return '';
      var lead = result.leadMatch && result.leadMatch.product;
      if (!state.projectorModel) return t('confidenceProjectorModel');
      if ((result.unresolved || []).indexOf('brightness_unit') >= 0 ||
          (result.warnings || []).some(function (warning) { return warning === 'brightness_units_unverified' || warning === 'brightness_units_incompatible'; })) {
        return t('confidenceBrightnessUnit');
      }
      if (lead && lead.availabilityMode === 'customRequest') return t('confidenceCustomConfiguration');
      if (state.size === 'unknown') return t('confidenceTargetSize');
      return t('confidenceAvailability');
    }

    function statusText(product) { return t('status_' + product.status); }

    function whyText(product) {
      var materialFacts = {
        whiteCinema:'whyWhiteCinema', liteHyperDomesticGrid:'whyLiteHyper',
        longThrowAlr:'whyLongThrowAlr', longThrow3dAlr:'whyLongThrow3dAlr', fresnel:'whyFresnel'
      };
      var facts = [];
      if (product.id === 'duraplus') facts.push(t('whyOutdoor'));
      else if (product.materialClass === 'blackGrid') {
        facts.push(t(product.orientation === 'aboveInverted' ? 'whyBlackGridAbove' : 'whyBlackGridBelow'));
        if (product.orientation !== 'aboveInverted' && (state.viewingLight === 'bright' || state.viewingLight === 'controlled')) facts.push(t('whyBlackGridAmbient'));
      } else if (materialFacts[product.materialClass]) facts.push(t(materialFacts[product.materialClass]));
      else if (state.location === 'covered_outdoor') facts.push(t('whyOutdoor'));
      facts.push(interpolate(t(state.size === 'unknown' ? 'whyTargetSizePending' : 'whySelectedSize'), {
        size:valueLabel('size',state.size)
      }));
      facts.push(interpolate(t('whyInstallation'), { installation:valueLabel('installation',state.installation) }));
      return facts.join(' ');
    }

    function tradeoffText(entry) {
      return t(entry.rationale.tradeoff);
    }

    function confirmText(entry) {
      return entry.rationale.confirm.map(function (key) { return t(key); }).join(' ');
    }

    function supportHtml() {
      var summary = supportSummary();
      return '<div class="vsf-support"><p>' + escapeHtml(t('supportHelp')) + '</p><button type="button" class="vsf-edit" data-vsf-copy>' + escapeHtml(t('copySetup')) +
        '</button><a data-vsf-email href="mailto:support@vividstormscreen.com?subject=' + encodeURIComponent('Screen Finder configuration') + '&amp;body=' + encodeURIComponent(summary) + '">' + escapeHtml(t('emailSupport')) + '</a>' +
        '<p class="vsf-copy-status" data-vsf-copy-status role="status" hidden></p><details class="vsf-support-summary"><summary>' + escapeHtml(t('yourSetupText')) +
        '</summary><pre data-vsf-support-summary>' + escapeHtml(summary) + '</pre></details></div>';
    }

    function helpTopic() {
      if (!state.projectorType || state.projectorType === 'unknown') return 'helpProjector';
      if (state.location === 'covered_outdoor') return 'helpOutdoor';
      if (!state.location || state.location === 'not_sure' || !state.viewingLight || state.viewingLight === 'not_sure') return 'helpRoom';
      if (state.speakerRequirement === 'unknown') return 'helpAudio';
      return 'helpSpace';
    }

    function renderHelp() {
      content.innerHTML = '<div class="vsf-panel vsf-help-panel">' + heading('','earlyHelpTitle','earlyHelpBody') +
        '<p class="vsf-help-topic"><strong>' + escapeHtml(t('helpMissingTitle')) + '</strong> ' + escapeHtml(t(helpTopic())) + '</p>' +
        '<a class="vsf-button vsf-button--primary" data-vsf-specialist href="' + CONTACT_URL + '">' + escapeHtml(t('askSpecialist')) + '</a>' + supportHtml() + '</div>';
    }

    function supportSummary() {
      var rows = reviewRows().map(function (row) { return t(row[0]) + ': ' + row[1]; });
      Object.keys(quotes).forEach(function (id) {
        var q = quotes[id];
        var product = Catalog.products.find(function (p) { return p.id === id; });
        if (product && q.status === 'ok') rows.push(product.displayName + ': ' + q.size + '″ / ' + (q.housing || '') + ' / ' + q.currency + ' ' + q.formattedPrice + ' / variant ' + q.variantId);
      });
      return rows.join('\n');
    }

    function shortName(product) { return product.technicalVariant.split(' · ')[0]; }

    function practicalText(entry) {
      if (entry.product.id === 'duraplus') return t('whyOutdoor');
      var key = 'practical_' + entry.product.materialClass;
      return t(key) === key ? tradeoffText(entry) : t(key);
    }

    function widthInfo(entry) {
      var fit = entry.widthFit;
      if (!state.roomWidthMm || !fit) return { title:'', detail:'', pending:false, status:'' };
      var key = fit.status === 'fits' ? 'widthFits' : fit.status === 'recheck' ? 'widthRecheck' : 'widthUnverified';
      return { status:fit.status, pending:fit.status !== 'fits', title:t(key + 'Title'), detail:interpolate(t(key + 'Detail'), {
        room:dimensionText(fit.roomWidthMm), overall:dimensionText(fit.overallWidthMm), image:dimensionText(fit.imageWidthMm),
        tolerance:fit.toleranceMm + ' mm'
      }) };
    }

    function renderQuickComparison(entries) {
      if (entries.length < 2 || !Number.isInteger(state.size)) return '';
      var houses = entries.map(function (entry) {
        var map = entry.product.variantMap && entry.product.variantMap[String(state.size)];
        return Object.keys(map && map.housingVariants || {});
      }).reduce(function (common,next) { return common.filter(function (house) { return next.indexOf(house) >= 0; }); });
      return '<section class="vsf-quick-comparison" aria-label="' + escapeHtml(t('comparison')) + '"><div class="vsf-compare-header"><h3>' + escapeHtml(t('compareQuickTitle')) +
        '</h3>' + (houses.length > 1 ? '<label for="' + root.__vsfInstanceId + '-compare-housing">' + escapeHtml(t('compareHousing')) +
        '<select id="' + root.__vsfInstanceId + '-compare-housing" data-vsf-compare-housing>' + houses.map(function (house) {
          return '<option value="' + escapeHtml(house) + '"' + (house === housingChoices[entries[0].product.id] ? ' selected' : '') + '>' + escapeHtml(housingLabel(house)) + '</option>';
        }).join('') + '</select></label>' : '') + '</div><p>' + escapeHtml(t('compareQuickBody')) + '</p>' +
        '<div class="vsf-compare-rows">' + entries.map(function (entry) {
          var fit = widthInfo(entry);
          var dimensions = Number.isInteger(state.size) ? SizeGuide.dimensions(entry.product,state.size) : null;
          return '<button type="button" class="vsf-compare-row" data-vsf-jump-product="' + entry.product.id + '" aria-label="' + escapeHtml(interpolate(t('compareDetails'),{product:shortName(entry.product)})) +
            '"><span class="vsf-compare-name">' + escapeHtml(shortName(entry.product)) + '<span>' + escapeHtml(practicalText(entry)) + '</span></span>' +
            '<span class="vsf-compare-price" data-vsf-compare-price="' + entry.product.id + '">' + escapeHtml(t(Number.isInteger(state.size) ? 'comparePending' : 'priceNeedsSize')) +
            '</span><span class="vsf-compare-fit">' + escapeHtml(fit.title || (dimensions && dimensions.overallWidthMm ? t('overallWidth') + ' ' + dimensionText(dimensions.overallWidthMm) : t('widthUnverified'))) +
            '</span><span class="vsf-compare-link">' + escapeHtml(t('detailsAndFit')) + ' →</span></button>';
        }).join('') + '</div></section>';
    }

    function updateProductPhoto(product,q) {
      var node = root.querySelector('[data-vsf-photo="' + product.id + '"]');
      if (!node) return;
      node.hidden = true;
      node.innerHTML = '';
      if (!q.media || !q.media.url) return;
      node.innerHTML = '<img src="' + escapeHtml(q.media.url) + '" alt="' + escapeHtml(interpolate(t('photoAlt'),{product:shortName(product)})) +
        '" width="640" height="360" loading="lazy" decoding="async"><figcaption>' + escapeHtml(t('referencePhoto')) + '</figcaption>';
      node.querySelector('img').addEventListener('error',function () { node.hidden = true; });
      node.hidden = false;
    }

    function productDetails(entry,lead) {
      var product = entry.product;
      var mapping = product.variantMap && product.variantMap[String(state.size)];
      var houses = mapping ? Object.keys(mapping.housingVariants || {}) : [];
      if (!housingChoices[product.id] && lead && state.housing && houses.indexOf(state.housing) >= 0) housingChoices[product.id] = state.housing;
      if (houses.indexOf(housingChoices[product.id]) < 0) housingChoices[product.id] = (!lead && lastResult && lastResult.leadMatch && houses.indexOf(housingChoices[lastResult.leadMatch.product.id]) >= 0 ? housingChoices[lastResult.leadMatch.product.id] : null) || houses.find(function (house) { return mapping.housingVariants[house] === mapping.defaultVariantId; }) || houses[0] || null;
      var dimensions = typeof state.size === 'number' ? SizeGuide.dimensions(product,state.size) : null;
      var widthCopy = dimensions ? '<dl class="vsf-dimensions"><div><dt>' + escapeHtml(t('imageWidth')) + '</dt><dd>' +
        escapeHtml((dimensions.imageApproximate ? '≈ ' : '') + dimensionText(dimensions.imageWidthMm)) + '</dd></div>' +
        '<div><dt>' + escapeHtml(t('overallWidth')) + '</dt><dd>' + escapeHtml(dimensions.overallWidthMm ? dimensionText(dimensions.overallWidthMm) : t('widthUnverified')) + '</dd></div>' +
        '</dl>' : '';
      var id = root.__vsfInstanceId + '-housing-' + product.id;
      var technicalParts = product.technicalVariant.split(' · ');
      var fit = widthInfo(entry);
      return '<article class="' + (lead ? 'vsf-result-lead' : 'vsf-alternative') + '" data-vsf-card="' + escapeHtml(product.id) + '">' +
        '<p class="vsf-result-role">' + escapeHtml(fit.pending ? fit.title : t(lead ? 'recommendedOption' : entry.role)) + '</p>' +
        '<h3 class="vsf-product-title" id="' + root.__vsfInstanceId + '-product-' + product.id + '" tabindex="-1">' + escapeHtml(technicalParts[0]) + '</h3>' +
        '<p class="vsf-configuration">' + escapeHtml(valueLabel('size',state.size) + ' · ' + (technicalParts.slice(1).join(' · ') || valueLabel('installation',product.installation))) + '</p>' +
        '<figure class="vsf-product-photo" data-vsf-photo="' + escapeHtml(product.id) + '" hidden></figure>' +
        '<div class="vsf-price" data-vsf-price="' + escapeHtml(product.id) + '" aria-live="polite"><p>' + escapeHtml(t('priceLoading')) + '</p></div>' +
        '<p class="vsf-price-difference" data-vsf-difference="' + escapeHtml(product.id) + '"></p>' +
        widthCopy +
        (fit.title ? '<p class="vsf-fit-status" data-vsf-fit-status="' + fit.status + '"><strong>' + escapeHtml(fit.title) + '</strong><span>' + escapeHtml(fit.detail) + '</span></p>' : '') +
        (houses.length ? '<label class="vsf-housing-label" for="' + id + '">' + escapeHtml(t('housing')) + '<select id="' + id + '" data-vsf-housing="' + escapeHtml(product.id) + '">' + houses.map(function (house) {
          return '<option value="' + escapeHtml(house) + '"' + (housingChoices[product.id] === house ? ' selected' : '') + '>' + escapeHtml(housingLabel(house)) + '</option>';
        }).join('') + '</select></label>' : '') +
        '<p class="vsf-card-tradeoff">' + escapeHtml(practicalText(entry)) + '</p>' +
        '<details class="vsf-product-more"><summary>' + escapeHtml(t('detailsAndFit')) + '</summary><dl class="vsf-reasons"><div class="vsf-reason"><dt>' + escapeHtml(t('whyFits')) + '</dt><dd>' + escapeHtml(whyText(product)) +
        '</dd></div><div class="vsf-reason"><dt>' + escapeHtml(t('confirmBefore')) + '</dt><dd>' + escapeHtml(confirmText(entry)) +
        '</dd></div></dl><p class="vsf-width-note">' + escapeHtml(t(dimensions && dimensions.overallWidthMm ? 'widthNote' : 'widthPending')) + '</p></details>' +
        '<div class="vsf-result-actions" data-vsf-product-actions="' + escapeHtml(product.id) + '"></div></article>';
    }

    function checkState(result) {
      var missing = result.unresolved || [];
      var map = { projector_type:'projector', location:'location', viewing_light:'viewingLight', installation:'installation', speaker_placement:'speakerRequirement', target_size:'size', room_width:'size', projector_orientation:'orientation', projection_alignment:'alignment', offset_method:'offsetMethod', side_projection_angle:'alignment', outdoor_after_sunset:'viewingLight', outdoor_installation:'location' };
      var noMatch = result.outcome === 'no_exact_match';
      var candidates = result.candidates && result.candidates.length ? '<div class="vsf-check-candidates"><h3>' + escapeHtml(t('possibleOptions')) + '</h3><ul>' +
        Array.from(new Set(result.candidates.map(function (entry) { return entry.product.familyDisplayName; }))).map(function (name) { return '<li>' + escapeHtml(name) + '</li>'; }).join('') + '</ul></div>' : '';
      return '<section class="vsf-no-match"><p class="vsf-result-role">' + escapeHtml(t('quickCheckRole')) + '</p><h2 data-vsf-heading tabindex="-1">' +
        escapeHtml(t(noMatch ? 'noExactTitle' : 'checkTitle')) + '</h2><p>' + escapeHtml(noMatch ? t('explain_' + ((result.explanationCodes || [])[0] || 'constraints_no_match')) : t(missing.indexOf('outdoor_installation') >= 0 ? 'outdoorSetupCheck' : missing.indexOf('room_width') >= 0 ? 'widthCheckBody' : 'noExactBody')) + '</p>' +
        (!noMatch && missing.length ? '<dl class="vsf-check-list"><dt>' + escapeHtml(t('checkMissing')) + '</dt><dd>' + escapeHtml(missing.map(function (item) { return t(item === 'outdoor_installation' || item === 'room_width' ? item : STEP_KEYS[map[item]] || (item === 'brightness_unit' ? 'brightness' : item)); }).join(' · ')) + '</dd></dl>' : '') +
        candidates + '<div class="vsf-result-actions"><button type="button" class="vsf-button" ' +
        (!noMatch && map[missing[0]] ? 'data-vsf-edit-step="' + map[missing[0]] + '"' : 'data-vsf-edit-results') + '>' + escapeHtml(t('editSetup')) +
        '</button><a class="vsf-button vsf-button--primary" data-vsf-specialist href="' + CONTACT_URL + '">' + escapeHtml(t('askSpecialist')) + '</a></div></section>';
    }

    function resultEntries() {
      return lastResult && lastResult.outcome === 'compatible' && lastResult.leadMatch ? [lastResult.leadMatch].concat(lastResult.alternatives) : [];
    }

    function renderResults() {
      var result = lastResult;
      content.dataset.vsfOutcome = result && result.outcome || 'compatibility_check';
      var entries = resultEntries();
      var html = '<div class="vsf-panel">';
      if (!entries.length) html += checkState(result || {outcome:'compatibility_check',unresolved:[],candidates:[]});
      else {
        var cards = entries.map(function (entry,index) { return productDetails(entry,index === 0); }).join('');
        html += '<div class="vsf-results-intro"><div><h2 class="vsf-result-heading vsf-result-title" data-vsf-heading tabindex="-1">' + escapeHtml(t('resultTitle')) +
          '</h2><p class="vsf-comparison-note">' + escapeHtml(t('comparisonNote')) + '</p></div><button type="button" class="vsf-edit" data-vsf-edit-results>' + escapeHtml(t('editSetup')) + '</button></div>' +
          renderQuickComparison(entries) + '<p class="vsf-price-scope">' + escapeHtml(t('priceScope')) + '</p>' +
          '<div class="vsf-purchase-status" data-vsf-purchase-status role="status" tabindex="-1" hidden></div>' +
          '<section class="vsf-products" data-vsf-count="' + entries.length + '" aria-label="' + escapeHtml(t('comparison')) + '">' + cards + '</section>';
        var warnings = result.warnings.filter(function (warning) { return warning !== 'live_product_confirmation'; });
        if (warnings.length) html += '<div class="vsf-warnings">' + warnings.map(function (warning) { return '<p class="vsf-warning">' + escapeHtml(t('warning_' + warning)) + '</p>'; }).join('') + '</div>';
        html += '<button type="button" class="vsf-edit" data-vsf-refresh-prices>' + escapeHtml(t('retryPrice')) + '</button>';
      }
      content.innerHTML = html + supportHtml() + '<p class="vsf-result-disclaimer">' + escapeHtml(t('resultDisclaimer')) + '</p></div>';
    }

    function purchaseLink(product,q) {
      return '<a class="vsf-button vsf-button--primary" data-vsf-purchase-cta data-vsf-catalog-id="' + escapeHtml(product.id) + '" data-vsf-product-id="' + escapeHtml(q.productId) +
        '" data-vsf-variant-id="' + escapeHtml(q.variantId) + '" data-vsf-handoff-size="' + q.size + '" data-vsf-handoff-technical="' + escapeHtml(product.technicalVariant) + '" href="' + escapeHtml(trackedUrl(q.url,product.id)) + '">' + escapeHtml(interpolate(t('viewNamedConfiguration'),{product:shortName(product),size:q.size})) + '</a>';
    }

    function intentFor(product,q) {
      return PurchaseIntent && q && PurchaseIntent.create({catalogId:product.id,productId:q.productId,variantId:q.variantId,
        size:q.size,housing:q.housing,revision:state.revision,language:state.language});
    }

    function mayPurchase(product,q,intent) {
      return PurchaseIntent && PurchaseIntent.canContinue(intent || intentFor(product,q),{
        state:state, product:product, housing:housingChoices[product.id] || null, quote:q,
        handoff:Core.purchaseHandoff(product,state,housingChoices[product.id])
      });
    }

    function continuePurchase(product,q,epoch) {
      if (!pendingPurchase || pendingPurchase.epoch !== epoch || pendingPurchase.intent.catalogId !== product.id) return;
      var intent = pendingPurchase.intent;
      pendingPurchase = null;
      if (!mayPurchase(product,q,intent)) { purchaseNotice('purchaseFailed'); announce(t('purchaseFailed')); return; }
      saveResultForBack();
      window.location.assign(trackedUrl(q.url,product.id));
    }

    function refreshQuotes(intent) {
      cancelPurchase();
      cancelQuotes();
      var epoch = quoteEpoch;
      var entries = resultEntries();
      if (!entries.length || state.stage !== 'results') return;
      if (intent) {
        pendingPurchase = {intent:intent,epoch:epoch}; purchaseNotice('purchaseChecking');
        var notice = root.querySelector('[data-vsf-purchase-status]');
        if (notice) { notice.focus({preventScroll:true}); notice.scrollIntoView({block:'center',behavior:'instant'}); }
      }
      quoteController = new AbortController();
      var signal = quoteController.signal;
      var client = priceClient();
      var snapshot = Core.cloneState(state);
      root.querySelectorAll('[data-vsf-purchase-cta]').forEach(function (node) { node.remove(); });
      entries.forEach(function (entry) {
        var product = entry.product;
        var price = root.querySelector('[data-vsf-price="' + product.id + '"]');
        price.textContent = t(Number.isInteger(state.size) ? 'priceLoading' : 'priceNeedsSize');
        root.querySelector('[data-vsf-difference="' + product.id + '"]').textContent = '';
        var target = root.querySelector('[data-vsf-product-actions="' + product.id + '"]');
        target.innerHTML = '<a class="vsf-button" data-vsf-specialist href="' + CONTACT_URL + '">' + escapeHtml(t('askSpecialist')) + '</a>';
        if (!Number.isInteger(snapshot.size)) return;
        client.quote(product,snapshot,housingChoices[product.id],{signal:signal}).then(function (q) {
          if (signal.aborted || epoch !== quoteEpoch || state.stage !== 'results' || state.revision !== snapshot.revision) return;
          quotes[product.id] = q;
          if (q.status === 'ok') {
            price.innerHTML = '<span class="vsf-price-label">' + escapeHtml(t('currentPrice')) + '</span><strong>' + escapeHtml(q.formattedPrice) +
              '</strong><span class="vsf-price-currency">' + escapeHtml(q.currency + ' · ' + t(q.available ? 'liveAvailable' : 'liveSoldOut')) + '</span><span class="vsf-live-configuration">' + escapeHtml(q.variantTitle) + '</span>';
            var canBuy = mayPurchase(product,q);
            target.innerHTML = (canBuy ? purchaseLink(product,q) : '') + '<a class="vsf-button vsf-button--secondary" data-vsf-specialist href="' + CONTACT_URL + '">' + escapeHtml(t(q.available && state.roomWidthMm && !canBuy ? 'widthConfirmAction' : 'askSpecialist')) + '</a>';
            updateProductPhoto(product,q);
          } else {
            price.innerHTML = '<p>' + escapeHtml(product.availabilityMode === 'customRequest' ? t('customConfiguration') : t('priceUnavailable')) + '</p>';
            if (product.availabilityMode === 'standardVariant' && product.verificationStatus === 'verified' && product.productPath) target.insertAdjacentHTML('afterbegin','<a class="vsf-button" href="' + escapeHtml(trackedUrl(product.productPath,product.id)) + '">' + escapeHtml(t('viewProductDetails')) + '</a>');
          }
          updatePriceComparisons();
          var email = root.querySelector('[data-vsf-email]');
          if (email) email.href = 'mailto:support@vividstormscreen.com?subject=' + encodeURIComponent('Screen Finder configuration') + '&body=' + encodeURIComponent(supportSummary());
          var summaryNode = root.querySelector('[data-vsf-support-summary]');
          if (summaryNode) summaryNode.textContent = supportSummary();
          updateResultAction();
          continuePurchase(product,q,epoch);
        }).catch(function () {
          if (signal.aborted || epoch !== quoteEpoch) return;
          price.textContent = t('priceUnavailable');
          continuePurchase(product,null,epoch);
        });
      });
      updatePriceComparisons();
      updateResultAction();
    }

    function updatePriceComparisons() {
      var entries = resultEntries();
      if (!entries.length) return;
      var lead = quotes[entries[0].product.id];
      entries.forEach(function (entry,index) {
        var q = quotes[entry.product.id];
        var compared = LiveProduct.compare(q,lead);
        var node = root.querySelector('[data-vsf-difference="' + entry.product.id + '"]');
        if (node) node.textContent = '';
        if (index > 0 && node && compared && q.housing === lead.housing && entry.product.installation === entries[0].product.installation) {
          var formatted = new Intl.NumberFormat(state.language,{style:'currency',currency:q.currency}).format(Math.abs(compared.differenceAmount));
          node.textContent = compared.differenceMinor === 0 ? interpolate(t('priceEqual'),{product:shortName(entries[0].product)}) : interpolate(t('priceDifference'),{product:shortName(entries[0].product),amount:formatted,direction:t(compared.differenceMinor < 0 ? 'priceLess' : 'priceMore')});
        } else if (index > 0 && node && compared && q.housing !== lead.housing) node.textContent = t('compareDifferentHousing');
        var quick = root.querySelector('[data-vsf-compare-price="' + entry.product.id + '"]');
        if (quick) quick.innerHTML = q && q.status === 'ok' ? '<strong>' + escapeHtml(q.formattedPrice) + '</strong><span>' + escapeHtml(q.currency + ' · ' + (q.housing ? housingLabel(q.housing) + ' · ' : '') + t(q.available ? 'liveAvailable' : 'liveSoldOut')) + '</span>' +
          (node && node.textContent ? '<span class="vsf-compare-difference">' + escapeHtml(node.textContent) + '</span>' : '') : '<span>' + escapeHtml(t(q ? 'priceUnavailable' : Number.isInteger(state.size) ? 'comparePending' : 'priceNeedsSize')) + '</span>';
      });
      var globalHousing = root.querySelector('[data-vsf-compare-housing]');
      if (globalHousing) {
        var commonHousing = housingChoices[entries[0].product.id];
        var same = entries.every(function (entry) { return housingChoices[entry.product.id] === commonHousing; });
        var mixedOption = globalHousing.querySelector('[data-vsf-mixed-housing]');
        if (!same && !mixedOption) globalHousing.insertAdjacentHTML('afterbegin','<option data-vsf-mixed-housing value="" disabled>' + escapeHtml(t('compareDifferentHousing')) + '</option>');
        globalHousing.value = same ? commonHousing : '';
        if (same && mixedOption) mixedOption.remove();
      }
    }

    function updateResultAction() {
      if (state.stage !== 'results') return;
      root.querySelectorAll('[data-vsf-result-primary]').forEach(function (node) {
        node.innerHTML = '<a class="vsf-button" data-vsf-specialist href="' + CONTACT_URL + '">' + escapeHtml(t('askSpecialist')) + '</a>';
      });
    }

    function renderActions() {
      if (helpOpen && state.stage !== 'results') {
        actions.innerHTML = '<button type="button" class="vsf-back" data-vsf-close-help>' + icon('back') + escapeHtml(t('continueChoosing')) + '</button>';
        return;
      }
      if (state.stage === 'results') {
        actions.innerHTML = '<button type="button" class="vsf-edit" data-vsf-reset>' + escapeHtml(t('startOver')) + '</button><span data-vsf-result-primary></span>';
        updateResultAction();
        return;
      }
      var index = Core.requiredSteps(state).indexOf(state.step);
      actions.innerHTML = (index > 0 ? '<button type="button" class="vsf-back" data-vsf-back>' + icon('back') + escapeHtml(t('back')) + '</button>' : '<span></span>') +
        (state.step === 'review' ? '<button type="button" class="vsf-button vsf-button--primary" data-vsf-show-results>' + escapeHtml(t('seeMatches')) + '</button>' :
        '<button type="button" class="vsf-help-link" data-vsf-open-help>' + escapeHtml(t('needHelp')) + '</button>');
    }

    function stepValueForCurrent() {
      if (state.step === 'projector') return state.projectorType;
      if (state.step === 'review') return Core.isReady(state);
      return state[state.step];
    }

    function render(options) {
      options = options || {};
      cancelPurchase();
      cancelQuotes();
      updateChrome();
      if (state.stage !== 'results') delete content.dataset.vsfOutcome;
      if (helpOpen && state.stage !== 'results') renderHelp();
      else if (state.stage === 'results') renderResults();
      else if (state.step === 'projector') renderProjector();
      else if (state.step === 'location') renderLocation();
      else if (state.step === 'viewingLight') renderViewingLight();
      else if (state.step === 'installation') renderInstallation();
      else if (state.step === 'orientation') renderOrientation();
      else if (state.step === 'alignment') renderAlignment();
      else if (state.step === 'offsetMethod') renderOffsetMethod();
      else if (state.step === 'sideViewing') renderSideViewing();
      else if (state.step === 'speakerRequirement') renderSpeakerRequirement();
      else if (state.step === 'size') renderSize();
      else renderReview();
      renderActions();
      updateChrome();
      if (state.stage === 'results') refreshQuotes();
      if (options.focus !== false) requestAnimationFrame(function () {
        var headingNode = root.querySelector('[data-vsf-heading]');
        if (headingNode) {
          headingNode.focus({ preventScroll:true });
          if (options.scroll) root.querySelector('[data-vsf-shell]').scrollIntoView({block:'start',behavior:'instant'});
        }
      });
    }

    function goTo(step) {
      clearSavedState();
      state.step = step;
      state.stage = step === 'review' ? 'review' : 'configure';
      state.changed = [];
      helpOpen = false;
      speakerDetailsOpen = false;
      lastResult = null;
      render({scroll:true});
      announce(labelForStep(step));
    }

    function renderMatches(input) {
      var list = root.querySelector('[data-vsf-projector-list]');
      if (!list) return;
      matches = input.value.trim().length >= 2 ? Core.searchProjectors(Projectors,input.value,8) : [];
      activeOption = -1;
      input.setAttribute('aria-expanded',input.value.trim().length >= 2 ? 'true' : 'false');
      input.removeAttribute('aria-activedescendant');
      if (input.value.trim().length < 2) {
        list.hidden = true;
        list.innerHTML = '';
        return;
      }
      list.hidden = false;
      if (!matches.length) {
        list.innerHTML = '<li class="vsf-no-results" role="status">' + escapeHtml(t('noProjector')) + '</li>';
        return;
      }
      list.innerHTML = matches.map(function (projector,index) {
        return '<li class="vsf-combobox-option" id="' + root.__vsfInstanceId + '-projector-option-' + index +
          '" role="option" aria-selected="false" data-vsf-projector-index="' + index + '"><span class="vsf-combobox-name">' +
          escapeHtml(projector.fullName) + '</span><span class="vsf-combobox-meta"><span>' + escapeHtml(t('type_' + projector.type)) + '</span></span></li>';
      }).join('');
    }

    function setActiveOption(index) {
      var input = root.querySelector('[data-vsf-projector-input]');
      var options = Array.from(root.querySelectorAll('[data-vsf-projector-index]'));
      if (!options.length) return;
      activeOption = (index + options.length) % options.length;
      options.forEach(function (optionNode,optionIndex) {
        var active = optionIndex === activeOption;
        optionNode.classList.toggle('is-active',active);
        optionNode.setAttribute('aria-selected',active ? 'true' : 'false');
      });
      input.setAttribute('aria-activedescendant',options[activeOption].id);
      options[activeOption].scrollIntoView({ block:'nearest' });
    }

    function chooseProjector(index) {
      if (!matches[index] || selectionLocked) return;
      state = Core.selectProjector(state,matches[index]);
      advanceSelection(t('selected') + ': ' + state.projectorModel.fullName);
    }

    function showResults() {
      if (!Core.isReady(state)) { goTo(Core.firstMissingStep(state)); return; }
      clearSavedState();
      state.step = 'review';
      state.stage = 'review';
      lastResult = Core.recommend(state,state.revision);
      if (!lastResult.ready || lastResult.stateRevision !== state.revision) { announce(t('resultsChanged')); return; }
      state.stage = 'results';
      render({scroll:true});
      announce(t('resultTitle'));
    }

    function advanceSelection(message,offerHelp) {
      selectionLocked = true;
      root.dataset.vsfAdvancing = 'true';
      var next = Core.firstMissingStep(state) || 'review';
      if (next === 'review') showResults();
      else goTo(next);
      if (offerHelp && state.stage !== 'results') { helpOpen = true; render({scroll:true}); saveResultForBack(); }
      var currentHeading = root.querySelector('[data-vsf-heading]');
      announce(message + '. ' + (currentHeading ? currentHeading.textContent : labelForStep(state.step)));
      clearTimeout(selectionTimer);
      // A second tap at the same position must not select an unread answer on the new screen.
      selectionTimer = setTimeout(function () { selectionLocked = false; delete root.dataset.vsfAdvancing; },400);
    }

    function onInput(event) {
      if (event.target.matches('[data-vsf-projector-input]')) {
        state = Core.editProjectorInput(state,event.target.value);
        renderMatches(event.target);
        updateChrome();
        root.querySelectorAll('[data-category="projectorType"]').forEach(function (node) {
          node.classList.toggle('is-selected',node.dataset.value === state.projectorType);
          node.setAttribute('aria-pressed',node.dataset.value === state.projectorType ? 'true' : 'false');
        });
        if (!state.projectorModel) {
          var panel = root.querySelector('.vsf-model');
          if (panel) panel.remove();
        }
      }
    }

    function onKeydown(event) {
      if (!event.target.matches('[data-vsf-projector-input]')) return;
      var list = root.querySelector('[data-vsf-projector-list]');
      if (event.key === 'Escape') {
        list.hidden = true;
        event.target.setAttribute('aria-expanded','false');
        return;
      }
      if (!matches.length || list.hidden) return;
      if (event.key === 'ArrowDown') { event.preventDefault(); setActiveOption(activeOption + 1); }
      if (event.key === 'ArrowUp') { event.preventDefault(); setActiveOption(activeOption - 1); }
      if (event.key === 'Enter' && activeOption >= 0) { event.preventDefault(); chooseProjector(activeOption); }
    }

    function onOptionMouseDown(event) {
      // Keep combobox focus until click commits the option. Otherwise blur can
      // hide the list between a normal mouse press and release, losing click.
      // Selection stays on click so a drag or a cancelled press cannot choose.
      if (event.button === 0 && event.target.closest('[data-vsf-projector-index]')) event.preventDefault();
    }

    function onClick(event) {
      if (event.target.closest('[data-vsf-cancel-purchase]')) {
        cancelPurchase(); purchaseNotice('purchaseCancelled');
        root.querySelector('[data-vsf-purchase-status]').focus({preventScroll:true});
        announce(t('purchaseCancelled')); return;
      }
      var jump = event.target.closest('[data-vsf-jump-product]');
      if (jump) {
        cancelPurchase();
        var cardHeading = root.querySelector('#' + root.__vsfInstanceId + '-product-' + jump.dataset.vsfJumpProduct);
        if (cardHeading) { cardHeading.focus({preventScroll:true}); cardHeading.closest('article').scrollIntoView({block:'start',behavior:'instant'}); }
        return;
      }
      if (event.target.closest('[data-vsf-open-help]')) { helpOpen = true; render({scroll:true}); saveResultForBack(); return; }
      if (event.target.closest('[data-vsf-close-help]')) { helpOpen = false; clearSavedState(); render({scroll:true}); return; }
      if (event.target.closest('[data-vsf-speaker-details]')) { speakerDetailsOpen = true; render({scroll:true}); return; }
      if (event.target.closest('[data-vsf-speaker-reset]')) {
        state = Core.applyAnswer(state,'speakerRequirement',null); speakerDetailsOpen = false; render({scroll:true}); return;
      }
      if (event.target.closest('[data-vsf-clear-measurements]')) {
        state = Core.applyAnswer(state,'roomWidthMm',null);
        state = Core.applyAnswer(state,'viewingDistanceMm',null);
        measurementError = false;
        render();
        return;
      }
      if (event.target.closest('[data-vsf-refresh-prices]')) { refreshQuotes(); return; }
      if (event.target.closest('[data-vsf-copy]')) {
        cancelPurchase();
        saveResultForBack();
        var copyStatus = root.querySelector('[data-vsf-copy-status]');
        function copied(ok) {
          var key = ok ? 'copyReady' : 'copyFailedVisible';
          if (copyStatus && root.contains(copyStatus)) { copyStatus.hidden = false; copyStatus.textContent = t(key); }
          if (!ok) { var details = root.querySelector('.vsf-support-summary'); if (details) details.open = true; }
          announce(t(key));
        }
        if (!navigator.clipboard || !navigator.clipboard.writeText) { copied(false); return; }
        navigator.clipboard.writeText(supportSummary()).then(function () { copied(true); }).catch(function () { copied(false); });
        return;
      }
      if (event.target.closest('[data-vsf-email]')) { cancelPurchase(); saveResultForBack(); return; }
      var specialist = event.target.closest('[data-vsf-specialist]');
      if (specialist) {
        cancelPurchase();
        saveResultForBack();
        var api = tidioApi();
        if (api && typeof api.open === 'function') {
          event.preventDefault();
          if (typeof api.show === 'function') api.show();
          api.open();
          chatTouched = true;
        }
        return;
      }
      var purchase = event.target.closest('[data-vsf-purchase-cta]');
      if (purchase) {
        var quote = quotes[purchase.dataset.vsfCatalogId];
        var entry = resultEntries().find(function (item) { return item.product.id === purchase.dataset.vsfCatalogId; });
        var intent = entry && intentFor(entry.product,quote);
        var handoff = entry && Core.purchaseHandoff(entry.product,state,housingChoices[entry.product.id]);
        var sameLink = intent && intent.productId === purchase.dataset.vsfProductId && intent.variantId === purchase.dataset.vsfVariantId &&
          handoff && String(handoff.variantId) === intent.variantId && intent.size === state.size;
        if (!sameLink) { event.preventDefault(); cancelPurchase(); purchaseNotice('purchaseFailed'); announce(t('purchaseFailed')); return; }
        if (!mayPurchase(entry.product,quote,intent)) {
          event.preventDefault();
          var modified = event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0;
          refreshQuotes(modified ? null : intent);
          announce(t(modified ? 'priceLoading' : 'purchaseChecking'));
          return;
        }
        cancelPurchase();
        saveResultForBack();
        return;
      }
      var languageButton = event.target.closest('[data-vsf-lang]');
      if (languageButton) {
        state.language = languageButton.dataset.vsfLang;
        render({ focus:false });
        announce(t('langName'));
        return;
      }
      var projectorOption = event.target.closest('[data-vsf-projector-index]');
      if (projectorOption) {
        chooseProjector(parseInt(projectorOption.dataset.vsfProjectorIndex,10));
        return;
      }
      if (event.target.closest('[data-vsf-clear-projector]')) {
        state = Core.clearProjector(state);
        render();
        announce(t('clearProjector'));
        return;
      }
      var answer = event.target.closest('[data-vsf-answer]');
      if (answer) {
        if (selectionLocked) return;
        var category = answer.dataset.category;
        var value = answer.dataset.value;
        if (category === 'size' && !commitMeasurements()) return;
        if (category === 'size' && value !== 'unknown') value = parseInt(value,10);
        if (category === 'size' && value !== 'unknown' && Core.availableSizes(state).indexOf(value) < 0) {
          sizeSelectionNotice = true;
          render({focus:false});
          root.querySelector('.vsf-size-selection-notice').focus({preventScroll:true});
          announce(t('sizesUpdated'));
          return;
        }
        sizeSelectionNotice = false;
        if (category === 'projectorType') state = Core.selectManualProjectorType(state,value);
        else {
          state = Core.applyAnswer(state,category,value);
          if (category === 'location' && value === 'covered_outdoor') {
            var changed = state.changed;
            state = Core.applyAnswer(state,'outdoorSetup','sheltered_between_posts');
            state.changed = changed;
          }
        }
        advanceSelection(t('selected') + ': ' + valueLabel(category,value), category !== 'size' && (value === 'unknown' || value === 'not_sure' || value === 'outdoor_mixed'));
        return;
      }
      var editStep = event.target.closest('[data-vsf-edit-step]');
      if (editStep) { goTo(editStep.dataset.vsfEditStep); return; }
      if (event.target.closest('[data-vsf-back]')) { goTo(Core.previousStep(state,state.step)); return; }
      if (event.target.closest('[data-vsf-show-results]')) { showResults(); return; }
      if (event.target.closest('[data-vsf-edit-results]')) {
        clearSavedState();
        state.stage = 'review';
        state.step = 'review';
        lastResult = null;
        render();
        return;
      }
      if (event.target.closest('[data-vsf-reset]')) {
        clearSavedState();
        state = Core.initialState();
        housingChoices = {};
        helpOpen = false;
        speakerDetailsOpen = false;
        measurementError = false;
        sizeSelectionNotice = false;
        lastResult = null;
        render();
        announce(t('projectorTitle'));
      }
    }

    function onFocusOut(event) {
      if (!event.target.matches('[data-vsf-projector-input]')) return;
      var wrap = event.target.closest('.vsf-combobox-wrap');
      if (event.relatedTarget && wrap.contains(event.relatedTarget)) return;
      requestAnimationFrame(function () {
        if (!root.contains(document.activeElement) || !document.activeElement.closest('.vsf-combobox-wrap')) {
          var list = root.querySelector('[data-vsf-projector-list]');
          var input = root.querySelector('[data-vsf-projector-input]');
          if (list) list.hidden = true;
          if (input) input.setAttribute('aria-expanded','false');
        }
      });
    }

    function onPageShow() { if (state.stage === 'results') refreshQuotes(); }
    function onVisibility() { if (!document.hidden && state.stage === 'results' && !pendingPurchase) refreshQuotes(); }
    window.addEventListener('pageshow',onPageShow);
    document.addEventListener('visibilitychange',onVisibility);
    root.addEventListener('submit',onMeasurements);
    root.addEventListener('change',onChange);
    root.addEventListener('click',onClick);
    root.addEventListener('input',onInput);
    root.addEventListener('keydown',onKeydown);
    root.addEventListener('mousedown',onOptionMouseDown);
    root.addEventListener('focusout',onFocusOut);
    root.__vsfDestroy = function () {
      clearTimeout(selectionTimer);
      delete root.dataset.vsfAdvancing;
      cancelPurchase();
      cancelQuotes();
      window.removeEventListener('pageshow',onPageShow);
      document.removeEventListener('visibilitychange',onVisibility);
      root.removeEventListener('submit',onMeasurements);
      root.removeEventListener('change',onChange);
      root.removeEventListener('click',onClick);
      root.removeEventListener('input',onInput);
      root.removeEventListener('keydown',onKeydown);
      root.removeEventListener('mousedown',onOptionMouseDown);
      root.removeEventListener('focusout',onFocusOut);
      document.removeEventListener('tidioChat-ready',onTidioReady);
      window.removeEventListener('resize',onViewportChange);
      var api = tidioApi();
      if (chatTouched && api && typeof api.show === 'function') api.show();
      delete root.__vsfDestroy;
      delete root.__vsfState;
    };
    render({ focus:false });
    return root.__vsfDestroy;
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-vsf-root]').forEach(createInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',function () { init(document); }, { once:true });
  } else {
    init(document);
  }

  if (!window.__vsfSectionLoadHandler) {
    window.__vsfSectionLoadHandler = function (event) { init(event.target); };
    document.addEventListener('shopify:section:load',window.__vsfSectionLoadHandler);
  }
})();
